/* eslint-disable */
import React, {
  Fragment,
  Dispatch,
  useEffect,
  useRef,
} from "react";
import "./CreateEnquiry.css";
import LeaveEnquiryPopup from "./LeaveEnquiryPopup";
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import WarningIcon from "@material-ui/icons/Warning";
import IconButton from "@material-ui/core/IconButton";
import GetAppIcon from "@material-ui/icons/GetApp";
import DeleteIcon from "@material-ui/icons/Delete";
import FilterListIcon from "@material-ui/icons/FilterList";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { postLossSaleReasonList } from "../../store/actions/createUpdateEnquiry.actions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { useDispatch, useSelector } from "react-redux";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
// import Collapse from '@material-ui/core/Collapse';
import TableRow from '@material-ui/core/TableRow';
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import ImportDialog from "./ImportExcelDialog";
import ViewFavorite from "./viewFavorite";
import DialogTitle from '@material-ui/core/DialogTitle';
import OrderSummaryDialog from "./orderSummaryDialog";
import Tooltip from '@material-ui/core/Tooltip';
import Snackbar from "./../../common/components/CreatedEnquirySnackbar";
import XLSX from "xlsx";
import { searchProducts } from "../../store/actions/products.actions";
import { sendAnnouncmentToCustomer } from '../../store/actions/announcements.actions'
import FullscreenLoader from "./../../common/components/FullscreenLoader";
import NavigationPrompt from "react-router-navigation-prompt";
import DialogContent from '@material-ui/core/DialogContent';
import {
  createEnquiry,
  updateEnquiry,
  verifyEnquiry,
  getEnquiryDetails,
  placeOrder,
  verifyEnquiryQueueCheck,
  deleteLostSaleReport,
  getUniqueEnquirySessionId,
  setEnquiryId,
  selectedParts,
  sendZeroProductsEmail,
  getDLEmailByRegion,
  verifyQuotationQueueCheck,
  sendEmailProcurePart,
  getOrderLogs,
  sendEmailOrderLogs,
  getOrderLogsLatestCount,
  deleteInvalidParts,
  setOrderLogs,
  sendEmailWihtoutAnnexurePlaceOrder,
  sendEmailInvalidAnnexureQuantity,
  setCustomerChoosePopup
} from "../../store/actions/createUpdateEnquiry.actions";
import { useHistory, useLocation } from "react-router-dom";
import moment from "moment-timezone";
import _, { get } from "lodash";
import Countdown from "react-countdown";
import { RESTRICTED_ACCESS } from "../../constants/restrictedAccessConstants";
import AnnouncementIcon from "../../common/components/AnnouncementIcon";
import NotificationIcon from "../../common/components/NotificationIcon";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Dialog, FormControl, InputAdornment, InputLabel, OutlinedInput, Select } from "@material-ui/core";
import { createOrgIdBrandsMappingReverse, getNewBrand, getUniqueTimestamp, createOrgIdBrandsMapping } from "../../common/components/util";
import { getSellingPrice } from "../../helpers/commonmethod";
import DeleteDialog from "../../common/components/deleteDialog";
import MakePaymentDialog from "./MakePaymentDialog";
import OrderSummary from "./OrderSummary";
import { getCreditLimit } from "../../store/actions/creditLimit.actions";
import HelpIcon from "@material-ui/icons/Help";
import InfoIcon from "@material-ui/icons/Info";
import { requestSpecialPriceService } from "../../services/requestSpecialPrice.service";
import { getViewRequestStatusAPI, requestModifyData } from "../../store/actions/requestSpecialPrice.actions";
import ExpiredDialog from "./ExpiredDialog";
import ExpiredDialog24Hrs from "./ExpiredDialog24Hrs";
import EstimationPromtDialog from "./estimationPromtDialog";
import RequestQuotationDialog from "../Quotation/RequestQuotationDialog";
import ChooseCustomerDialog from "./ChooseCustomerDialog";
import { getCustomerDetailsByCustomerID, getDeliveryBlockReason, getFSECustomerList, storeSelectedCustomerData } from "../../store/actions/dealer.action";
import ShippingAddSelectionDialog from "./ShppingAddSelectionDialog";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ConfirmDialogEnquiry from "./ConfirmCreateEnquiryDialog";
import OrderLogDialog from "./OrderLogDialog";
import Badge from '@material-ui/core/Badge';
import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import ListItemText from '@material-ui/core/ListItemText';
import Menu, { MenuProps } from '@material-ui/core/Menu';
import SearchIcon from '@material-ui/icons/Search';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import Grid from '@material-ui/core/Grid';
import { withStyles } from "@material-ui/core/styles";
import { Close, Image } from '@material-ui/icons';
import Carousel from 'react-bootstrap/Carousel';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { userAccessControl } from "../LeftMenu/UserAccessControl";
import { getAllAnnexureList } from "../../store/actions/annexureParts.actions";
import LoadFromAnnexure from "./LoadFromAnnexure";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Paper from "@material-ui/core/Paper";
import FilterMenu from "./FilterMenu";
import { getPartIdInfo, getTechDocPartList } from "../../store/actions/oemOesProductTeam.action";
import { getProfile } from "../../store/actions/profile.action";


const CHECK_AVAILABILITY_BUTTON_TEXT = {
  NORMAL: 'Check Availability and Price',
  QUEUED: 'Queued for Verification',
  PROGRESS: 'Verification In Progress'
}

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    top: "250px ! important"
  },
})((props: MenuProps) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const useStyles = makeStyles((theme) => ({
  root: {
    // padding: '2px 4px',
    // display: "flex",
    // alignItems: "center",
    width: '100%',
  },
  container: {
    // maxHeight: 200,
    background: "#FFFFF",
  },
  dropDownHeight: {
    maxHeight: 400,
  },
  tblDealerTablecontainer: {
    maxHeight: 400,
    background: "#FFFFF",
  },
  icon: {
    float: "left",
    margin: "0 20px 20px 0",
    height: "100%",
    fill: "white",
  },
  iconMaterial: {
    margin: "5px",
    height: "100%",
    fill: "white",
  },
  iconForCustomer: {
    float: "left",
    margin: "25px 20px 20px 0",
    height: "100%",
    fill: "white",
  },
  icon1: {
    float: "left",
    margin: "0 20px 220px 0",
    height: "100%",
    fill: "white",
  },
  yes: {
    fontSize: '0.813rem',
    fontFamily: 'Nunito',
    fontWeight: 700,
    color: '#1A9FE0',
    textTransform: 'capitalize'
  },
  cancel: {
    fontSize: '0.813rem',
    fontFamily: 'Nunito',
    fontWeight: 700,
    color: '#919191',
    textTransform: 'capitalize'
  },
  logoutText: {
    color: '#616161',
    fontSize: '0.875rem',
    fontFamily: 'Nunito',
    fontWeight: 700,
    textTransform: 'inherit'
  },
  input: {
    flex: 1,
  },
  iconButton: {
    // padding: 10,
  },
  actionButton: {
    color: "#1a9fe0",
  },
  collapseBg: {
    background: "#FFFFF",
  },
  tableWidth: {
    minWidth: 170,
    // fontWeight: 600
  },
  collapseHeaderBg: {
    background: "rgba(17, 17, 17, 0.05)",
  },
  enquiryPop: {
    display: 'flex',
    margin: '10px 0px'
  },
  textRight: {
    textAlign: 'right'
  }
}));

let rowSummaryGlobalData: {
  brandCodeInfo: string;
  brandNameInfo: string;
  itemCountInfo: number;
  verificationDataInfo: any;
  brandCodeAsPerTheBrand: any;
}[] = [];

let globalSearchedPartsData: {
  filteredList: any[];
  validParts: any[];
  invalidParts: any[];
} = {
  filteredList: [],
  validParts: [],
  invalidParts: []
};

const formatMaterialGroup = (data: any) => {
  if (data) {
    return data.substring(0, 5).toUpperCase()
  } else {
    return "XXXXX"
  }
}

function Row(props: any) {
  const {
    availability,
    index,
    setcheckedAllBO,
    setcheckedAllNow,
    setChecked24hrs,
    isChangeCheckBox,
    enquiryAction,
    setisSelectedAll,
    brandCode,
    setbrandRefNumbers,
    brandRefNumbers,
    setDeliveryBlockReason,
    deliveryBlockReason,
    salesOffice,
    setSalesOffice,
    setproducts,
    setreferenceNumber,
    isAvailabiityChecked,
    isEnquirySaved,
    brandName,
    brandData,
    products,
    setIsQuantityUpdated,
    isSellingPriceData,
    markupPercentage,
    enquiryMapping,
    // enquiryMappingTPC,
    enquirySubBrand,
    isSpecialPrice,
    verificationData,
    spParts,
    isAvailabiityCheckedAtTime,
    isSPRModifyData,
    accessData,
    requestStatus,
    setDisableQuotation,
    selectedAccessType,
    handleOpenModal,
    isTBLAccess,
    handleOpenEnquiryGridImage,
    annexureEnquiry,
    columnPreferences
  } = props;
  const [open, setOpen] = React.useState(true);
  const { profileDetails }: any = useSelector((state: any) => state.profileDetails);
  const { getCustomerDetailsBySapId, ddlValues }: any = useSelector((state: any) => state.dealer);
  let customerTierType: any = '';
  if (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') {
    customerTierType = getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.customerTierType;
    userAccessControl(getCustomerDetailsBySapId?.data?.accessParameter, 'FSE')
  } else {
    customerTierType = get(profileDetails, 'data.data.customerInfo.customerTierType', '');
  }
  const collectionPoints = profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.collectionPointsOfOrder && profileDetails.data.data.collectionPointsOfOrder.collectionPoints;
  const [estmateTotal, setEstmateTotal] = React.useState<any>();
  const [requestedTotalType, setRequestedTotalType] = React.useState<any>();
  const [requestedCalculatedTotalType, setRequestedCalculatedTotalType] = React.useState<any>();
  const [requestedCaluclatedTotalPrice, setRequestedCaluclatedTotalPrice] = React.useState<any>();
  const { enquiryInfo, enquirySessionId, getOrderLogsDetails }: any = useSelector(
    (state: any) => state.createUpdateEnquiry
  );
  const { enquiryId }: any = useSelector(
    (state: any) => state.createUpdateEnquiry
  );

  const isColumnVisible = (colName: string) => {
    if (enquiryAction === 'view') {
      return true
    }
    const priceColumns = [
      'NSP (Incl. VAT)',
      'RSP',
      'Amt',
      'NSP (Excl. VAT)',
      'BOP'
    ];

    const availabilityColumns = [
      'NOW',
      'BO',
      '24Hrs'
    ];

    const checkVisibility = (colList?: string[], targetName?: string) => {
      if (Array.isArray(colList)) {
        if (!colList || colList.length === 0) return true;
        return colList.includes(targetName || '');
      }
      return true;
    };

    // Price columns
    if (priceColumns.includes(colName)) {
      return checkVisibility(columnPreferences?.priceColumnVisibility, colName);
    }

    // Availability columns
    if (availabilityColumns.includes(colName)) {
      return checkVisibility(columnPreferences?.availabilityColumnVisibility, colName);
    }

    // Default columns
    return checkVisibility(columnPreferences?.visibleColumns, colName);
  };


  // const annexureEnquiry =
  //   sessionStorage.getItem('userType') !== 'FSE' &&
  //     window.location.pathname === '/annexurecreateenquiry'
  //     ? 'true' :
  //     sessionStorage.getItem('userType') !== 'FSE' &&
  //       window.location.pathname === '/createenquiry'
  //       ? ''
  //       : sessionStorage.getItem('annexureEnquiry');
  // const annexureEnquiry = sessionStorage.getItem('annexureEnquiry');
  const customerTypeAccess = get(profileDetails, 'data.data.basicInfo.customerTypeAccess', '');
  useEffect(() => {
    let checkedTotal: any
    let reqType: any
    let checkedCalculatedTotal: any
    let checkedReqType: any

    if (verificationData && verificationData.data && verificationData.data.length > 0) {
      verificationData.data.map((data: any) => {
        reqType = data && data?.specialPriceRequestType
        checkedTotal = data && data?.specialRequestOfferedTotalPricePercentage
        checkedCalculatedTotal = data && data?.specialRequestOfferedTotalPriceCalculated
        checkedReqType = data && data?.specialRequestOfferedTotalPriceCurrency
      })
    }

    setRequestedTotalType(reqType);
    setEstmateTotal(checkedTotal);
    setRequestedCaluclatedTotalPrice(checkedCalculatedTotal);
    setRequestedCalculatedTotalType(checkedReqType);
  }, [verificationData])

  const getParts = (item: any) => {
    let allBrand: any = []
    allBrand = [...allBrand, item]
  }

  const getAmtValue = (item: any) => {
    let total = 0.00;
    let isAvail = false;

    const safeFloat = (value: any) => {
      return value !== undefined && value !== null && value !== '' && value !== 'NaN' && !isNaN(parseFloat(value))
        ? parseFloat(value)
        : 0;
    };

    if (isAvailabiityCheckedAtTime) {
      const now = moment();
      const start = moment(new Date(isAvailabiityCheckedAtTime));
      const minutes = Math.abs(moment.duration(start.diff(now)).asMinutes());
      isAvail = minutes <= 5;
    }

    if (item.nowAvailabilityChecked) {
      if (
        enquiryAction === 'view' &&
        isAvailabiityChecked &&
        requestStatus === 'Approved' &&
        item.nowApprovedPrice
      ) {
        total += safeFloat(item.nowAvailability) * safeFloat(item.nowApprovedPrice);
      } else {
        if (
          requestedTotalType === 'part' &&
          item.isSpecialPriceRequestPart &&
          requestStatus === 'Approved' &&
          item.isRejected === false &&
          isAvailabiityChecked &&
          isAvail
        ) {
          if (item.nowOfferedPriceType === 'byPercentage') {
            total += safeFloat(item.nowAvailability) * safeFloat(item.nowOfferedCalculatedPrice);
          } else if (item.nowOfferedPriceType === 'byCurrency') {
            total += safeFloat(item.nowAvailability) * safeFloat(item.nowOfferedPrice);
          } else {
            total += safeFloat(item.nowAvailability) * safeFloat(item.nsp);
          }
        } else if (
          requestedTotalType === 'total' &&
          isAvailabiityChecked &&
          item.nsp &&
          item.nowAvailability &&
          item.isSpecialPriced === false &&
          requestStatus === 'Approved' &&
          isAvail
        ) {
          if (requestedCalculatedTotalType === 'By AED') {
            const value = safeFloat(requestedCaluclatedTotalPrice.replace('%', '').replace('-', ''));
            const newNsp = safeFloat(item.nsp) - ((value * safeFloat(item.nsp)) / 100);
            total += safeFloat(item.nowAvailability) * newNsp;
          } else if (requestedCalculatedTotalType === 'By %') {
            const nsp1 = (safeFloat(estmateTotal) * safeFloat(item.nsp)) / 100;
            const newNsp = safeFloat(item.nsp) - nsp1;
            total += safeFloat(item.nowAvailability) * newNsp;
          }
        } else {
          total += safeFloat(item.nowAvailability) * safeFloat(item.nsp);
        }
      }
    }

    // 24 hrs logic
    if (
      customerTierType &&
      ['workshop', 'tpcdealer'].includes(customerTierType.toLowerCase()) &&
      item.hrs24AvailabilityChecked &&
      item.hrs24Availability &&
      item.nsp
    ) {
      total += safeFloat(item.hrs24Availability) * safeFloat(item.nsp);
    }

    // Air Availability
    if (
      item.airAvailabilityChecked &&
      // customerTierType &&
      // !["workshop", "tpcdealer"].includes(customerTierType.toLowerCase()) &&
      annexureEnquiry !== 'true'
    ) {
      if (
        enquiryAction === 'view' &&
        isAvailabiityChecked &&
        requestStatus === 'Approved' &&
        item.airApprovedPrice
      ) {
        total += safeFloat(item.airAvailability) * safeFloat(item.airApprovedPrice);
      } else {
        if (
          requestedTotalType === 'part' &&
          item.isSpecialPriceRequestPart &&
          requestStatus === 'Approved' &&
          item.isRejected === false &&
          isAvailabiityChecked &&
          isAvail
        ) {
          if (item.airOfferedPriceType === 'byPercentage') {
            total += safeFloat(item.airAvailability) * safeFloat(item.airOfferedCalculatedPrice);
          } else if (item.airOfferedPriceType === 'byCurrency') {
            total += safeFloat(item.airAvailability) * safeFloat(item.airOfferedPrice);
          } else {
            total += safeFloat(item.airAvailability) * safeFloat(item.aop);
          }
        } else if (
          requestedTotalType === 'total' &&
          isAvailabiityChecked &&
          isAvail &&
          item.aop &&
          item.airAvailability &&
          item.isSpecialPriced === false &&
          requestStatus === 'Approved'
        ) {
          if (requestedCalculatedTotalType === 'By AED') {
            const value = safeFloat(requestedCaluclatedTotalPrice.replace('%', '').replace('-', ''));
            const newAop = safeFloat(item.aop) - ((value * safeFloat(item.aop)) / 100);
            total += safeFloat(item.airAvailability) * newAop;
          } else if (requestedCalculatedTotalType === 'By %') {
            const bop1 = (safeFloat(estmateTotal) * safeFloat(item.aop)) / 100;
            const newAop = safeFloat(item.aop) - bop1;
            total += safeFloat(item.airAvailability) * newAop;
          }
        } else {
          total += safeFloat(item.airAvailability) * safeFloat(item.aop);
        }
      }
    }

    return total;
  };


  const isBluelegend = (ele: any) => {
    let airPrice: any = ele.airOfferedPriceType == "byCurrency" ? parseFloat(ele.airOfferedPrice) : parseFloat(ele.airOfferedCalculatedPrice)
    let nowPrice: any = ele.nowOfferedPriceType == "byCurrency" ? parseFloat(ele.nowOfferedPrice) : parseFloat(ele.nowOfferedCalculatedPrice)
    if (ele.nowAvailabilityChecked && ele.airAvailabilityChecked) {
      if (((parseFloat(ele.nspev)) > parseFloat(nowPrice)) || (parseFloat(ele.aop) > airPrice)) {
        return true;
      } else {
        return false;
      }
    } else if (ele.nowAvailabilityChecked) {
      if ((parseFloat(ele.nspev) > nowPrice)) {
        return true;
      } else {
        return false;
      }
    } else if (ele.airAvailabilityChecked) {
      if ((parseFloat(ele.aop) > airPrice)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  const getNSPEVValue = (item: any) => {
    // let data = spParts.filter((sp: any) => sp.nowEnquiryItemNumber == item.nowEnquiryItemNumber)
    let nspev: any = 0.00;
    if (enquiryAction === 'view' && item.nowApprovedPrice && item.nowApprovedPrice !== '' && item.nowApprovedPrice !== 'NaN') {
      nspev = (parseFloat(getSellingPrice(item.nowApprovedPrice, isSellingPriceData, markupPercentage)).toFixed(2))
    } else {
      if (isAvailabiityChecked && requestedTotalType === "part" && item.isSpecialPriceRequestPart && item["nowAvailability"] && requestStatus === 'Approved') {
        if (item.nowOfferedPriceType == 'byPercentage' && item["nowOfferedCalculatedPrice"] && item["nowOfferedCalculatedPrice"] !== '' && item["nowOfferedCalculatedPrice"] !== 'NaN') {
          nspev = parseFloat(getSellingPrice(item["nowOfferedCalculatedPrice"], isSellingPriceData, markupPercentage)).toFixed(2);
        } else if (item.nowOfferedPriceType == 'byCurrency' && item["nowOfferedPrice"] && item["nowOfferedPrice"] !== '' && item["nowOfferedPrice"] !== 'NaN') {
          nspev = parseFloat(getSellingPrice(item["nowOfferedPrice"], isSellingPriceData, markupPercentage)).toFixed(2);
        } else {
          nspev = (parseFloat(getSellingPrice(item["nspev"], isSellingPriceData, markupPercentage)).toFixed(2))
        }
      } else if (requestedTotalType === "total" && isAvailabiityChecked && item["nspev"] && item["nowAvailability"] && item.isSpecialPriced === false &&
        requestStatus === 'Approved') {
        if (requestedCalculatedTotalType === "By AED") {

          let value: any = requestedCaluclatedTotalPrice.replace("%", "").replace("-", "");
          let addedValue: any = (parseFloat(value) * item["nspev"]) / 100;
          nspev = (parseFloat(getSellingPrice((parseFloat(item["nspev"]) - parseFloat(addedValue)), isSellingPriceData, markupPercentage)).toFixed(2))
          // nspev = (parseFloat(getSellingPrice((parseFloat(requestedCaluclatedTotalPrice.replace("%", "").replace("-", "")) * item["nspev"]) / 100, isSellingPriceData, markupPercentage)).toFixed(2))
        }
        if (requestedCalculatedTotalType === "By %") {
          let addedValue: any = (parseFloat(estmateTotal) * item["nspev"]) / 100;
          nspev = (parseFloat(getSellingPrice((parseFloat(item["nspev"]) - parseFloat(addedValue)), isSellingPriceData, markupPercentage)).toFixed(2))
        }
      } else if (isAvailabiityChecked && item["nspev"]) {
        nspev = (parseFloat(getSellingPrice(item["nspev"], isSellingPriceData, markupPercentage)).toFixed(2))
      }
    }
    return nspev;
  }

  const getNSPValue = (item: any) => {
    let nsp: any = 0.00;
    /* Code for adding 5% margin to nsp(exclusive vat) and returing nap value is special price approved ->  Bhargavi */
    if (enquiryAction === 'view' && item.nowApprovedPrice && item.nowApprovedPrice !== '' && item.nowApprovedPrice !== 'NaN') {
      let nspev = getNSPEVValue(item);
      let addedValue: any = (nspev * 5) / 100;
      nsp = (parseFloat(getSellingPrice((parseFloat(nspev) + parseFloat(addedValue)), isSellingPriceData, markupPercentage)).toFixed(2))
    } else {
      if (isAvailabiityChecked && requestStatus === 'Approved' && item["nowAvailability"] && item.isSpecialPriced === false) {
        let nspev = getNSPEVValue(item);
        let addedValue: any = (nspev * 5) / 100;
        nsp = (parseFloat(getSellingPrice((parseFloat(nspev) + parseFloat(addedValue)), isSellingPriceData, markupPercentage)).toFixed(2))
      } else if (isAvailabiityChecked && item["nsp"]) {
        nsp = (parseFloat(getSellingPrice(item["nsp"], isSellingPriceData, markupPercentage)).toFixed(2))
      }
    }
    return nsp;
  }

  const getBOPValue = (item: any) => {
    let bop: any = 0.00;
    if (enquiryAction === 'view' && item.airApprovedPrice && item.airApprovedPrice !== '' && item.airApprovedPrice !== 'NaN') {
      bop = (parseFloat(getSellingPrice(item.airApprovedPrice, isSellingPriceData, markupPercentage)).toFixed(2))
    } else {
      if (isAvailabiityChecked && requestedTotalType === "part" && item.isSpecialPriceRequestPart && item["airAvailability"] && requestStatus === 'Approved' && item.isRejected == false) {
        if (item.airOfferedPriceType == 'byPercentage' && item["airOfferedCalculatedPrice"] && item["airOfferedCalculatedPrice"] !== '' && item["airOfferedCalculatedPrice"] !== 'NaN') {
          bop = parseFloat(getSellingPrice(item["airOfferedCalculatedPrice"], isSellingPriceData, markupPercentage)).toFixed(2);
        } else if (item.airOfferedPriceType == 'byCurrency' && item["airOfferedPrice"] && item["airOfferedPrice"] !== '' && item["airOfferedPrice"] !== 'NaN') {
          bop = parseFloat(getSellingPrice(item["airOfferedPrice"], isSellingPriceData, markupPercentage)).toFixed(2);
        } else {
          bop = (parseFloat(getSellingPrice(item["aop"], isSellingPriceData, markupPercentage)).toFixed(2))
        }
      } else if (requestedTotalType === "total" && isAvailabiityChecked && item["aop"] && item["airAvailability"] && item.isSpecialPriced === false &&
        requestStatus === 'Approved') {
        if (requestedCalculatedTotalType === "By AED") {

          let value: any = requestedCaluclatedTotalPrice.replace("%", "").replace("-", "");
          let addedValue: any = (parseFloat(value) * item["aop"]) / 100;
          bop = (parseFloat(getSellingPrice((item["aop"] - parseFloat(addedValue)), isSellingPriceData, markupPercentage)).toFixed(2));

          // bop = (parseFloat(getSellingPrice((parseFloat(requestedCaluclatedTotalPrice.replace("%", "").replace("-", "")) * item["aop"]) / 100, isSellingPriceData, markupPercentage)).toFixed(2));
        }
        if (requestedCalculatedTotalType === "By %") {
          let addedValue: any = (item["aop"] * parseFloat(estmateTotal)) / 100;
          bop = (parseFloat(getSellingPrice((item["aop"] - parseFloat(addedValue)), isSellingPriceData, markupPercentage)).toFixed(2));
        }
      } else if (isAvailabiityChecked && item["aop"]) {
        bop = (parseFloat(getSellingPrice(item["aop"], isSellingPriceData, markupPercentage)).toFixed(2))
      }
    }
    return bop;
  }

  function isDisabledBo(item: any) {
    if (item.nowAvailabilityChecked && isAvailabiityChecked && item.isSpecialPriced == false) {
      if (item.nowAvailability !== item.spNowAvailability) {
        return false
      }
    }
    return true;
  }

  function getDDLCode(title: any, ddl: any) {
    let array: any;
    if (ddl && ddl.length > 0) {
      array = ddl.filter((d: any) => d?.title === title)
    }
    if (array && array.length > 0) return array[0].value
  }

  function is24hrExist() {
    if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && products && products.length > 0) {
      return products.some((obj: any) => obj.hrs24AvailabilityChecked === true);
    }
  }

  // const brandNameData: any = {
  //   "Toyota": "Al Futtaim Motors",
  //   "TE": "Trading Enterprises",
  //   "OES": (customerTierType && customerTierType.toLowerCase() === "workshop") || (customerTierType && customerTierType.toLowerCase() === "tpcdealer") ? "Tradepoint" : 'ALAC',
  //   "Honda": "Honda",
  //   "Te": "Trading Enterprises",
  // }

  // const FinalVerifiedinternalNumber: any = verificationData &&
  //   verificationData.data &&
  //   verificationData.data.length > 0 &&
  //   verificationData.data.map((ele: any, i: any) => {
  //     return {
  //       "make":
  //         ele.materialGroupCode === "AMPTB" &&
  //           (customerTierType === 'TBL Dealer' ||
  //             customerTypeAccess.includes("TBL Dealer") ||
  //             customerTierType === 'Dealer' ||
  //             customerTypeAccess.includes("dealer"))
  //           ? 'ALAC Tyres & Batteries'
  //           : ele.materialGroupCode === "ALPOE" &&
  //             (customerTierType === 'TBL Dealer' ||
  //               customerTypeAccess.includes("TBL Dealer") ||
  //               customerTierType === 'Dealer' ||
  //               customerTypeAccess.includes("dealer"))
  //             ? 'ALAC AfterMarket Parts'
  //             : ele && ele.make,
  //       "subEnquiryId": ele && ele.enquiryNumber,
  //     };
  //   });

  // const ViewInternalNumber: any = enquiryInfo &&
  //   enquiryInfo.data &&
  //   enquiryInfo.data.data &&
  //   enquiryInfo.data.data.map((ele: any, i: any) => {
  //     return {
  //       "make":
  //         ele.materialGroupCode === "AMPTB" &&
  //           (customerTierType === 'TBL Dealer' ||
  //             customerTypeAccess.includes("TBL Dealer") ||
  //             customerTierType === 'Dealer' ||
  //             customerTypeAccess.includes("dealer"))
  //           ? 'ALAC Tyres & Batteries'
  //           : ele.materialGroupCode === "ALPOE" &&
  //             (customerTierType === 'TBL Dealer' ||
  //               customerTypeAccess.includes("TBL Dealer") ||
  //               customerTierType === 'Dealer' ||
  //               customerTypeAccess.includes("dealer"))
  //             ? 'ALAC AfterMarket Parts'
  //             : ele && ele.make,
  //       "subEnquiryId": ele && ele?.enquiryNumber,
  //     };
  //   });

  // let status: any = sessionStorage.getItem('enquiry-current-status');
  // let id: any
  // let newVerifiedId: any

  // if (
  //   verificationData &&
  //   verificationData.data &&
  //   verificationData.data.length > 0
  // ) {
  //   const subEnquiryId: any = FinalVerifiedinternalNumber ? FinalVerifiedinternalNumber : "";
  //   id = subEnquiryId.filter((ele: any, i: any) => {
  //     // For TBL Dealer/Dealer customer types with non-standard brands
  //     if (customerTierType === 'TBL Dealer' ||
  //       customerTypeAccess.includes("TBL Dealer") ||
  //       customerTierType === 'Dealer' ||
  //       customerTypeAccess.includes("dealer")) {
  //       // Check if brand is NOT in the brandNameData mapping (like BYD)
  //       if (!brandNameData[ele.make]) {
  //         return ele?.make === brandName;
  //       }
  //       // For mapped brands (Toyota, TE, Honda, OES), use the mapping
  //       return brandNameData[ele.make] === brandName;
  //     }

  //     // For all other customer types (Fleet, Government, Workshop, etc.)
  //     // Use brandNameData mapping if available, otherwise direct match
  //     if (brandNameData[ele.make]) {
  //       return brandNameData[ele.make] === brandName;
  //     }
  //     // Direct match for unmapped brands
  //     return ele?.make === brandName;
  //   });
  // } else {
  // }

  // if (
  //   enquiryInfo &&
  //   enquiryInfo.data &&
  //   enquiryInfo.data.data &&
  //   enquiryInfo.data.data.length > 0
  // ) {
  //   const viewInternalID: any = ViewInternalNumber ? ViewInternalNumber : "";
  //   let brandNameforOES: any = customerTierType === 'tpcdealer' ? 'Tradepoint' : brandName;

  //   id = viewInternalID.filter((ele: any, i: any) => {
  //     // For TBL Dealer/Dealer customer types with non-standard brands
  //     if (customerTierType === 'TBL Dealer' ||
  //       customerTypeAccess.includes("TBL Dealer") ||
  //       customerTierType === 'Dealer' ||
  //       customerTypeAccess.includes("dealer")) {
  //       // Check if brand is NOT in the brandNameData mapping (like BYD)
  //       if (!brandNameData[ele.make]) {
  //         return ele?.make === brandNameforOES;
  //       }
  //       // For mapped brands (Toyota, TE, Honda, OES), use the mapping
  //       return brandNameData[ele.make] === brandNameforOES;
  //     }

  //     // For all other customer types (Fleet, Government, Workshop, etc.)
  //     // Use brandNameData mapping if available, otherwise direct match
  //     if (brandNameData[ele.make]) {
  //       return brandNameData[ele.make] === brandNameforOES;
  //     }
  //     // Direct match for unmapped brands
  //     return ele?.make === brandNameforOES;
  //   });
  // } else {
  // }

  // const internalNumber: any = enquiryInfo && enquiryInfo.data && enquiryInfo.data.data && enquiryInfo.data.data.filter((ele: any, i: any) => {
  //   return brandNameData[ele.make] === brandName
  // });


  return (
    <React.Fragment>
      {
        brandData && brandData.length === 0 && products && products.length > 0 && (
          <TableRow className="MuiPaper-elevation1">
            <TableCell
              colSpan={100}
              align="center"
              style={{ textAlign: "center" }}
              className="py-5 MuiPaper-elevation1"
            >
              No parts found
            </TableCell>
          </TableRow>
        )
      }

      {/* <TableRow className={"tableRowPanelsCreateEnquiry"}>
        <TableCell className="p-0" colSpan={12}>
          <Collapse in={open} timeout="auto" unmountOnExit></Collapse>
        </TableCell>
      </TableRow> */}
      {
        open &&
        brandData &&
        brandData.map((item: any, i: any) => {
          getParts(item);
          if (!isAvailabiityChecked || (isAvailabiityChecked && (availability === "All" ||
            (availability === "Now" && item.nowAvailability && !item.airAvailability) ||
            (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && availability === "24" && item.hrs24Availability && !item.nowAvailability && !item.airAvailability) ||
            (availability === "BO" && item.airAvailability)))
          ) {
            return (
              <TableRow
                key={item.id}
                className={`MuiTable-root parts-list tableRowCreateEnquiry
                ${item.isParentPart ? 'enquiry-row-header' : item.isChildPart ? 'enquiry-row-child' : ''}
                ${item.isSuperseeded && annexureEnquiry !== 'true' ? 'superseededRow' : ''}
                ${!item.isValid ? 'invalidRowClass' : item.isRowGreyed ? 'disabledRow' : ''}`
                }
              >
                {/* <TableRow className={`${item.isSuperseeded ? "superseededRow" : ""} ${!item.isValid ? "tableRowCreateEnquiry invalidRowClass" : item.isRowGreyed ? "disabledRow" : "tableRowCreateEnquiry"}`}> */}
                <TableCell className="pr-0">
                  {!item.isSuperseeded ? (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <input
                        type="checkbox"
                        style={{ marginRight: '6px' }}
                        disabled={customerTierType && customerTierType === "Dealer" &&
                          (((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") && (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true) && !isSPRModifyData) ? true : false)}
                        checked={item.selected ? true : false}
                        onChange={() => {
                          if (item.materialGroup && item.materialGroup === '' || !item.materialGroup) {
                            if (isAvailabiityChecked || isEnquirySaved) {
                            } else {
                              if (enquiryAction !== "view") {
                                let productsTemp: any = JSON.parse(JSON.stringify(products));
                                productsTemp[item.actualIndex]["selected"] = !item.selected;
                                setproducts([...productsTemp]);
                                setisSelectedAll(false);
                              }
                            }
                          } else {
                            if (enquiryAction !== "view") {
                              let productsTemp: any = JSON.parse(
                                JSON.stringify(products)
                              );
                              productsTemp[item.actualIndex]["selected"] =
                                !item.selected;
                              setproducts([...productsTemp]);
                              setisSelectedAll(false);
                            }
                          }
                        }}
                      />
                      <strong className="font-9 px-2" style={{ marginRight: '8px' }}>{index + 1}</strong>

                      {(customerTierType?.toLowerCase() === "tbl dealer" || customerTierType === "Dealer") &&
                        item?.accessTyres &&
                        brandName === "ALAC Tyres & Batteries" &&
                        item.imageUrls?.[0] && (
                          <div
                            onClick={() => handleOpenEnquiryGridImage(item)}
                            style={{
                              width: '20px',
                              height: '25px',
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                            title="Click to view tyre image"
                          >
                            <img
                              src={item.imageUrls[0]}
                              alt="tyre"
                              onError={(e) => {
                                e.currentTarget.style.display = 'none'; // Hide image if it fails to load
                              }}
                              style={{
                                maxHeight: '40px',  // limit max height
                                height: 'auto',     // keep aspect ratio height
                                maxWidth: '40px',   // max width limit
                                width: 'auto',      // keep aspect ratio width
                                objectFit: 'contain',
                                border: '1px solid #ccc',
                              }}
                            />
                          </div>
                        )}
                    </div>
                  ) : (
                    annexureEnquiry === 'true' ? null :
                      <span style={{ display: 'flex', alignItems: 'center' }}>
                        <ArrowRightAltIcon />
                        <strong className="px-1 font-9">{index + 1}</strong>
                      </span>
                  )}
                </TableCell>
                <TableCell className={(customerTierType && customerTierType.toLowerCase() === 'tbl dealer' || customerTierType === "Dealer") && selectedAccessType === "Tyres" || selectedAccessType === "Parts" ? "px-4" : ""}>
                  <div className="innergreyLabelTable position-relative">
                    {" "}
                    {item.isProcurementPart && (
                      <Tooltip title="Material cannot be procured from external supplier" placement="top">
                        <span className="dotlegendItemProcCreateEnquiry mt-n1"></span>
                      </Tooltip>
                    )}
                    {item.isSpecialPriced && customerTierType && customerTierType.toLowerCase() !== "fleet" && customerTierType.toLowerCase() !== "government" && (
                      <span className="dotlegendItemCreateEnquiry"></span>
                    )}
                    {item.isRejected && requestStatus === 'Approved' && customerTierType.toLowerCase() !== "fleet" && customerTierType.toLowerCase() !== "government" && (
                      <span className=" dotlegendItemRedCreateEnquiry mt-n1"></span>
                    )}
                    {!item.isSpecialPriced && (item.nowRequestPrice && item.nowRequestPrice !== '' && item.nowRequestPrice !== 'NaN' || item.airRequestPrice && item.airRequestPrice !== '' && item.airRequestPrice !== 'NaN') && requestStatus === 'Approved' && customerTierType.toLowerCase() !== "fleet" && customerTierType.toLowerCase() !== "government" && (
                      <>
                        {isBluelegend(item) && !item.isRejected && item.isSpecialPriceRequestPart ? (
                          <span className="dotlegendItemBlueCreateEnquiry m-n1"></span>
                        ) :
                          ((isBluelegend(item) == false)) && item.isSpecialPriceRequestPart && !item.isRejected && customerTierType.toLowerCase() !== "fleet" && customerTierType.toLowerCase() !== "government" ? (
                            <span className=" dotlegendItemRedCreateEnquiry m-n1"></span>
                          ) : ''}
                      </>
                    )}
                    {/* {item.isRejected == false && item.isSpecialPriceRequestPart && requestStatus === 'Approved' && (
                      <span className="dotlegendItemBlueCreateEnquiry"></span>
                    )} */}
                    {" "}
                    {/* {item.superceededPartIndicator && (
                      <span className="dotlegendItemCreateEnquirySupersede"></span>
                    )}{" "} */}
                    {item.productId}
                  </div>
                  <div className="greyLabelTable partNumberYextTable">
                    {item.productIdDescription}
                  </div>
                  {annexureEnquiry === 'true' && item.error && <span className="quantity-error">{item.error}</span>}
                  {annexureEnquiry === 'true' && item.successMessage && <span className="quantity-success">{item.successMessage}</span>}
                </TableCell>
                <TableCell className="font-10 font-weight-700 text-444">
                  {/* {console.log(item, enquiryMapping, enquiryMapping, getNewBrand(enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`]))} */}
                  {/* {enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`]}{item.oesSubBrandName} */}
                  {item.materialGroup ? (item.isParentPart || item.isChildPart) && item.brandName ? (<>{item.brandName}<div className="font-10">{item.type === 'OEM' ? '' : item.type === 'afterMarket' ? '(Aftermarket)' : item.type ? `(${item.type})` : '(Aftermarket)'}</div></>)
                    :
                    enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] === 'OES' && item && item.oesSubBrandName !== '' ? item.oesSubBrandName :
                      enquirySubBrand[`${formatMaterialGroup(item.materialGroup)}`] ? enquirySubBrand[`${formatMaterialGroup(item.materialGroup)}`] :
                        item?.subBrandName?.trim() ? item.subBrandName :
                          customerTierType && customerTierType.toLowerCase() !== "tpcdealer" ? (
                            <>
                              {enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] === 'OES' && (customerTierType && (customerTierType.toLowerCase() !== "workshop")) ? 'ALAC' : getNewBrand(enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`])}
                            </>
                          ) : (
                            <>
                              {getNewBrand(enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`])}
                              <div className="font-10">{item.type ? `(${item.type.toUpperCase()})` : ''}</div>
                            </>
                          ) : <>
                    <div>{item.brandName}</div>
                    <div className="font-10">{item.type === 'OEM' ? '' : item.type === 'afterMarket' ? '(Aftermarket)' : item.type ? `(${item.type})` : '(Aftermarket)'}</div>
                  </>}
                  {/* {getNewBrand(enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`])} */}
                </TableCell>
                <TableCell className="pl-0 pr-0">
                  <div className="row" style={{ margin: 0, alignItems: "center" }}>
                    {/* Qty Input */}
                    <div
                      className={
                        sessionStorage.getItem('userType') === 'FSE' ||
                          (customerTierType && customerTierType.toLowerCase() === 'tbl dealer')
                          ? 'col-3 d-flex justify-content-center align-items-center'
                          : 'col-4 d-flex justify-content-center align-items-center'
                      }
                    >
                      {!item.isSuperseeded && (
                        <input
                          type="text"
                          disabled={customerTierType && customerTierType === "Dealer" &&
                            (((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") &&
                              (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true) && !isSPRModifyData) ? true : false)}
                          onChange={(e: any) => {
                            if (enquiryAction !== "view") {

                              const productIndex = products.findIndex(
                                (p: any) =>
                                  p.productId === item.productId &&
                                  p.seq === item.seq &&
                                  p.materialGroup === item.materialGroup
                              );

                              if (productIndex === -1) {
                                console.error("Product not found", item);
                                return;
                              }

                              let productsTemp: any = JSON.parse(JSON.stringify(products));
                              const value = e.target.value.trim();
                              const itemCopy = { ...item };
                              let error = "";
                              let sm = "";
                              const isValidQty = value !== "" && !isNaN(Number(value));
                              const qty: any = isValidQty ? Number(value) : null;

                              if (annexureEnquiry === "true" && isValidQty) {
                                const tierRanges = itemCopy.annexureDetails?.quantityTierRange;
                                const tier1Min = parseInt(tierRanges?.tier_1?.minQty || "0");
                                const tier3MaxRaw = tierRanges?.tier_3?.maxQty;
                                const tier3Max = parseInt(tier3MaxRaw || "99999");
                                const nowQty = parseInt(item.nowAvailability || "0");

                                const getTierNumber = (q: number): number => {
                                  if (!tierRanges) return 0;

                                  for (const tierKey of ["tier_3", "tier_2", "tier_1"]) {
                                    const min = parseInt(tierRanges[tierKey]?.minQty || "0");
                                    const max = parseInt(tierRanges[tierKey]?.maxQty || "0");

                                    if (q >= min && q <= max) {
                                      return parseInt(tierKey.split("_")[1]);
                                    }
                                  }
                                  return 0;
                                };

                                getTierNumber(parseInt(item.quantity || "0"));
                                getTierNumber(qty);

                                if (qty < tier1Min || qty === 0) {
                                  error = `Min Order Qty should be ${tier1Min}`;
                                }

                                if (qty > tier3Max) {
                                  error = tier3MaxRaw
                                    ? `Max Order Qty should be ${tier3Max}`
                                    : `Max Order Qty should be 99999`;
                                }

                                productsTemp[productIndex].quantity = Number(value);
                                productsTemp[productIndex].error = error;
                                productsTemp[productIndex].successMessage = sm;
                                productsTemp[productIndex].isInvalid = !!error && isValidQty;
                                productsTemp[productIndex].isRowGreyed = !!error && isValidQty;

                                if (productsTemp[productIndex].isRowGreyed) {
                                  productsTemp[productIndex].nowAvailabilityChecked = false;
                                }

                                setIsQuantityUpdated(true);
                                setDisableQuotation(true);
                                setproducts([...productsTemp]);
                              }
                              else if (isTBLAccess()) {

                                let inputValue = e.target.value;
                                let numericValue = parseInt(inputValue);

                                const stockPercentage = parseFloat(item.stockPercentage);
                                const soh = item.soh || 0;

                                const calculatedStockQty =
                                  soh && stockPercentage > 0
                                    ? soh === 1
                                      ? 0
                                      : Math.floor(soh - (soh * stockPercentage) / 100)
                                    : soh;

                                const stockQty = calculatedStockQty > 0 ? calculatedStockQty : 1;

                                if (inputValue === "") {
                                  productsTemp[productIndex].quantity = "";
                                  delete productsTemp[productIndex].stockError;
                                }
                                else if (/^[+]?\d+$/.test(inputValue)) {

                                  if (numericValue >= 1 && numericValue <= stockQty) {
                                    productsTemp[productIndex].quantity = numericValue;
                                    delete productsTemp[productIndex].stockError;
                                  } else {
                                    productsTemp[productIndex].quantity = inputValue;

                                    if (item.accessTyres) {
                                      productsTemp[productIndex].stockError =
                                        `Cannot exceed stock quantity of ${stockQty}`;
                                    }
                                  }
                                } else {
                                  return;
                                }

                                setIsQuantityUpdated(true);
                                setDisableQuotation(true);
                                productsTemp[productIndex].quantity = inputValue;
                                setproducts([...productsTemp]);
                              }
                              else {

                                let qtyValue =
                                  e.target.value &&
                                    parseInt(e.target.value) &&
                                    /^[+]?\d+([.]\d+)?$/.test(e.target.value) &&
                                    parseInt(e.target.value) >= 1
                                    ? parseInt(e.target.value)
                                    : "";

                                setIsQuantityUpdated(true);
                                setDisableQuotation(true);

                                productsTemp[productIndex].quantity = qtyValue;

                                setproducts([...productsTemp]);
                              }
                            }
                          }}
                          value={item.quantity}
                          maxLength={annexureEnquiry === 'true' ? 6 : 5}
                          className={`cardCommon mr-1 smallcircularinputFiled ${!item.quantity || !parseInt(item.quantity)
                            ? "error-border-input"
                            : ""
                            }`}
                          placeholder=""
                        />
                      )}
                    </div>
                    {/* Avl */}
                    <div
                      className={
                        (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre')
                          && (customerTierType && customerTierType.toLowerCase() === 'tbl dealer')
                          ? 'col-3 d-flex justify-content-center align-items-center'
                          : 'col-3 d-flex justify-content-center align-items-center'
                      }
                    >
                      <span className="font-11 font-weight-700">
                        {isAvailabiityChecked && item["nowAvailability"] && item["hrs24Availability"] && item["nowAvailability"]
                          ? parseInt(isAvailabiityChecked && item["nowAvailability"] && item["nowAvailability"]) +
                          parseInt(isAvailabiityChecked && item["hrs24Availability"] && item["hrs24Availability"])
                          : isAvailabiityChecked && item["nowAvailability"] ? item["nowAvailability"] :
                            isAvailabiityChecked && item["hrs24Availability"] ? item["hrs24Availability"] : "0"}
                      </span>
                    </div>
                    {/* SOH (FSE only) */}
                    {
                      sessionStorage.getItem('userType') === 'FSE' && (
                        <div className="col-3 d-flex justify-content-center align-items-center">
                          <span className="font-11 font-weight-700">
                            {item.soh || '0'}
                          </span>
                        </div>
                      )
                    }
                    {/* MOQ for Dealer/TBL Dealer */}
                    {
                      ((customerTierType && customerTierType.toLowerCase() === 'tbl dealer') || customerTierType === "Dealer") &&
                      isTBLAccess() &&
                      annexureEnquiry !== 'true' && (
                        <div
                          className={
                            sessionStorage.getItem('userType') === 'FSE' ||
                              (customerTierType && customerTierType.toLowerCase() === 'tbl dealer')
                              ? 'col-3 d-flex justify-content-center align-items-center'
                              : 'col-4 d-flex justify-content-center align-items-center'
                          }
                        >
                          <span className="font-11 font-weight-700">
                            {isAvailabiityChecked && item["nowAvailability"] ? item["nowAvailability"] : ''}
                          </span>
                        </div>
                      )
                    }
                  </div >
                  {/* )
                  } */}
                  {
                    item.stockError && (
                      <div style={{ color: "red", fontSize: "12px", marginTop: "2px" }}>
                        {item.stockError}
                      </div>
                    )
                  }
                </TableCell >
                {isColumnVisible('RSP') && isColumnVisible('Price') && (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') && getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.customerTierType === "Government" || getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.customerTierType === "Fleet" ?
                  <TableCell className="font-10 font-weight-700 text-444">{isAvailabiityChecked && item["rsp"] ? item["rsp"] : "XX.XX"}</TableCell>
                  : ""
                }
                {
                  isColumnVisible('NSP (Incl. VAT)') && isColumnVisible('Price') && (
                    <TableCell className="font-10 font-weight-700 text-444">
                      {annexureEnquiry === 'true' ? 'XX.XX' : getNSPValue(item)}
                    </TableCell>
                  )
                }
                {/* {isAvailabiityChecked && item["nsp"] ? parseFloat(getSellingPrice(item["nsp"], isSellingPriceData, markupPercentage)).toFixed(2) : "0.00"}</td> */}
                {
                  isColumnVisible('Amt') && isColumnVisible('Price') && (
                    <TableCell className="font-10 font-weight-700 text-444">{isAvailabiityChecked ? parseFloat(getSellingPrice(getAmtValue(item), isSellingPriceData, markupPercentage)).toFixed(2) : "0.00"}</TableCell>
                  )
                }
                {
                  isColumnVisible('NSP (Excl. VAT)') && isColumnVisible('Price') && (
                    <TableCell className="font-10 font-weight-700 text-444">{getNSPEVValue(item)}</TableCell>
                  )
                }
                {/* {isAvailabiityChecked && item["nspev"] ? parseFloat(getSellingPrice(item["nspev"], isSellingPriceData, markupPercentage)).toFixed(2) : "0.00"}</td> */}
                {
                  isColumnVisible('BOP') && isColumnVisible('Price') && (
                    <>
                      {(annexureEnquiry === 'true' || window.location.pathname.includes('annexure')) ? null : (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer")) ?
                        <TableCell className="partNumberYextTable font-10 font-weight-700 text-444">{isAvailabiityChecked && item["aop"] ? parseFloat(getSellingPrice(item["aop"], isSellingPriceData, markupPercentage)).toFixed(2) : "0.00"}</TableCell> :
                        <TableCell className="font-10 font-weight-700 text-444">
                          {getBOPValue(item)}
                        </TableCell>
                      }
                    </>
                  )
                }
                {/* {(isColumnVisible('Year') && annexureEnquiry === 'true') ? null : (customerTierType && customerTierType.toLowerCase() === 'tbl dealer' || customerTierType === "Dealer") && */}
                {
                  annexureEnquiry === 'true' || window.location.pathname.includes('annexure') ? null : (customerTierType && customerTierType.toLowerCase() === 'tbl dealer' || customerTierType === "Dealer") &&
                    isTBLAccess() && (
                      <TableCell className="font-10 font-weight-700 text-444">
                        {item.attributes?.find((attr: any) => attr.name === 'batchYear')?.value || '-'}
                      </TableCell>
                    )
                }
                {
                  isColumnVisible('Availability') && (
                    <TableCell className="">
                      <div className="row no-gutters pr-1">
                        {isColumnVisible('NOW') && (
                          <div className="innergreyLabelTable col-4 pr-1">
                            <input type="checkbox"
                              disabled={item.isRowGreyed ? true : item.materialGroup && item.materialGroup !== '' ? (customerTierType && customerTierType === "Dealer" &&
                                (((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") && (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true) && !isSPRModifyData) ? true : false)) : false}                        // disabled={item.isSuperseeded}
                              checked={item.nowAvailabilityChecked ? true : false}
                              onChange={() => {
                                if (enquiryAction !== "view" && item.nowAvailability) {

                                  const productIndex = products.findIndex(
                                    (p: any) =>
                                      p.productId === item.productId &&
                                      p.seq === item.seq
                                  );
                                  if (productIndex !== -1) {
                                    const productsTemp = [...products];

                                    productsTemp[productIndex] = {
                                      ...productsTemp[productIndex],
                                      nowAvailabilityChecked:
                                        !productsTemp[productIndex].nowAvailabilityChecked,
                                    };

                                    setproducts(productsTemp);
                                    isChangeCheckBox(true);
                                    setcheckedAllNow(false);
                                  }
                                }
                              }}
                            />{" "}
                            {isAvailabiityChecked && item["nowAvailability"]
                              ? item["nowAvailability"]
                              : "0"}
                          </div>
                        )}

                        {isColumnVisible('24Hrs') && (
                          <>
                            {customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") ?
                              <div className="innergreyLabelTable col-4">
                                <input type="checkbox"
                                  checked={item.hrs24AvailabilityChecked ? true : false}
                                  onChange={() => {
                                    if (enquiryAction !== "view" && item.hrs24Availability) {

                                      const productIndex = products.findIndex(
                                        (p: any) =>
                                          p.productId === item.productId &&
                                          p.seq === item.seq
                                      );

                                      if (productIndex !== -1) {
                                        const productsTemp = [...products];

                                        productsTemp[productIndex] = {
                                          ...productsTemp[productIndex],
                                          hrs24AvailabilityChecked:
                                            !productsTemp[productIndex].hrs24AvailabilityChecked,
                                        };

                                        setproducts(productsTemp);
                                        isChangeCheckBox(true);
                                        setChecked24hrs(false);
                                      }
                                    }
                                  }}
                                />
                                {" "}
                                {isAvailabiityChecked && item["hrs24Availability"]
                                  ? item["hrs24Availability"]
                                  : "0"}
                              </div>
                              : ""}
                          </>
                        )}
                        {isColumnVisible('BO') && (
                          <>
                            {annexureEnquiry === 'true' ? '' : ((customerTierType && customerTierType.toLowerCase() === 'tbl dealer' || customerTierType === "Dealer") && sessionStorage.getItem('userType') !== 'FSE') && brandName === "ALAC Tyres & Batteries" ? '' : (
                              <div className={customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") ? "disableInnergreyLabelTable col-4" : "innergreyLabelTable col-4"}>
                                <input type="checkbox"
                                  disabled={
                                    (isDisabledBo(item) &&
                                      ((accessData?.data?.isRequestPlacedForEnquiry === true) &&
                                        !isSPRModifyData) == false
                                      ? false
                                      : item.isSuperseeded) ||
                                    customerTierType?.toLowerCase() === "workshop" ||
                                    customerTierType?.toLowerCase() === "tpcdealer" ||
                                    (customerTierType === "Dealer" &&
                                      accessData?.data?.isRequestPlacedForEnquiry === true &&
                                      !isSPRModifyData)
                                  }
                                  // disabled={sessionStorage.getItem('userType') === 'FSE' ? true : (isDisabledBo(item) && ((accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true) && !isSPRModifyData) == false ? false : item.isSuperseeded) || customerTierType && customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer" || customerTierType && customerTierType === "Dealer" &&
                                  //   (((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") && (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true) && !isSPRModifyData) ? true : false)}
                                  checked={
                                    item.airAvailabilityChecked
                                  }
                                  //  checked={sessionStorage.getItem('userType') === 'FSE' ? false : (item.airAvailabilityChecked && customerTierType && (customerTierType.toLowerCase() !== "workshop" || customerTierType.toLowerCase() === "tpcdealer")) ? true : false}
                                  onChange={() => {
                                    if (enquiryAction !== "view" && item.airAvailability) {

                                      const productIndex = products.findIndex(
                                        (p: any) =>
                                          p.productId === item.productId &&
                                          p.seq === item.seq
                                      );

                                      if (productIndex !== -1) {
                                        const productsTemp = [...products];

                                        productsTemp[productIndex] = {
                                          ...productsTemp[productIndex],
                                          airAvailabilityChecked:
                                            !productsTemp[productIndex].airAvailabilityChecked,
                                        };

                                        setproducts(productsTemp);
                                        isChangeCheckBox(true);
                                        setcheckedAllBO(false);
                                      }
                                    }
                                  }}
                                />{" "}
                                {isAvailabiityChecked && item["airAvailability"]
                                  ? item["airAvailability"]
                                  : "0"}
                              </div>
                            )}
                          </>
                        )}

                      </div>
                    </TableCell>
                  )
                }
                {
                  isColumnVisible('Dimension') && (
                    <TableCell className="">
                      <div className="innergreyLabelTable">
                        {item.isValid
                          ? `${parseInt(item.dimensions.length)}x${parseInt(
                            item.dimensions.width
                          )}x${parseInt(item.dimensions.height)} | ${item.dimensions.grossWeight ? parseFloat(item.dimensions.grossWeight).toFixed(2) : '-'}`
                          : "-"}
                      </div>
                    </TableCell>
                  )
                }
                {
                  isColumnVisible('Volume') && (
                    <TableCell className="">
                      <div className="innergreyLabelTable">
                        {item.isValid
                          ? `${parseFloat(item.dimensions.volume).toFixed(3)} cm`
                          : "-"}
                        <sup>3</sup>
                      </div>
                    </TableCell>
                  )
                }
              </TableRow >
            );
          } else {
            return null;
          }
        })
      }
    </React.Fragment >
  );
}

const Dashboard: React.FC = () => {
  const MAX_PARTS = 750;
  const MAX_TYRE_PARTS = 99;
  const classes = useStyles();
  const history: any = useHistory();
  const location: any = useLocation();
  const { dealerDetails, ddlValues, getCustomerDetailsBySapId }: any = useSelector((state: any) => state.dealer);
  const { isSellingPriceData, profileDetails }: any = useSelector((state: any) => state.profileDetails);
  const brandAccess =
    sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre'
      ? getCustomerDetailsBySapId?.data?.controlAccessOfBrand
      : get(profileDetails, 'data.data.customerInfo.controlAccessOfBrand', []);
  let inputRefs: any = [];
  const [products, setproducts] = React.useState<any>([]);
  const [productsDataForSpecialRequest, setProductsDataForSpecialRequest] = React.useState<any>([]);
  const [zeroProducts, setZeroProducts] = React.useState<any>([]);
  const [isZeroPricePopup, openZeroPricePopup] = React.useState(false);
  const [hideZeroMessage, setHideZeroMessage] = React.useState(false);
  const [isBackOrder, setIsBackorder] = React.useState(false);
  const [isQuantityUpdated, setIsQuantityUpdated] = React.useState(false);
  const [isCopy, setCopy] = React.useState(false);
  const [orderTotal, setorderTotal] = React.useState<any>(0);
  const dispatch: Dispatch<any> = useDispatch();
  const [isEnquiryStarted, setIsEnquiryStarted] = React.useState(false);
  const [showExitPopup, setShowExitPopup] = React.useState(false);
  const [nextPath, setNextPath] = React.useState<string>("");
  const isCustomerUser = (): boolean => {
    const type = sessionStorage.getItem("userType") || "";
    return type !== "FSE" && type !== "sre";
  };

  const [productId, setproductId] = React.useState("");
  const [isQueue, setIsQueue] = React.useState(false);
  const [quantity, setquantity] = React.useState<any>('');
  const [isAvailabiityChecked, setisAvailabiityChecked] = React.useState(false);
  const [isTyrePartsSearchSuccessFully, setIsTyrePartsSearchSuccessFully] = React.useState(false);
  const viewEnquiry: any = sessionStorage.getItem("viewEnquiry");
  const [isTyrePartsAddedtoGrid, setIsTyrePartsAddedtoGrid] = React.useState(false);
  const [isDisableQuotation, setDisableQuotation] = React.useState(false);
  const [isEstimatedTotalIsLess, setIsEstimatedTotalIsLess] = React.useState(false);
  const [placeorderEnabled, setplaceorderEnabled] = React.useState(false);
  const [isTimmerExpired, setIsTimmerExpired] = React.useState(false);
  const [isAvailabiityCheckedAtTime, setisAvailabiityCheckedAtTime] =
    React.useState<any>(null);
  const [openEnquiry, setOpenEnquiry] = React.useState(false);
  const [isEnquirySaved, setisEnquirySaved] = React.useState(false);
  const [estTotal, setEstimatedTotal] = React.useState<any>(0);
  const [enquiryData, setenquiryData] = React.useState<any>(null);
  const [getVerifyData, setGetVerifyData] = React.useState<any>(null);
  const [successMessage, setSuccessMessage] = React.useState<any>(null);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [openSnackbarType, setOpenSnackbarType] = React.useState("");
  const [openOrderSummary, setOpenOrderSummary] = React.useState(false);
  const [isAdminsetDefaultAddress, setIsAdminSetDefaultAddress] = React.useState(false);
  const [isUpdateMode, setisUpdateMode] = React.useState(false);
  const [isOESOEM, setIsOESOEM] = React.useState(false);
  const [isSelectedAll, setisSelectedAll] = React.useState(false);
  const [orderQueued, setorderQueued] = React.useState(false);
  const [annexureErrorPopUp, setOpenAnnexureErrorPopup] = React.useState(false);
  const [isSpecialPrice, setIsSpecialPrice] = React.useState('');
  const [enquiryAction, setenquiryAction] = React.useState("");
  const [orderType, setOrderType] = React.useState("");
  const [individualPrice, setIndividialPrice] = React.useState([]);
  const [spParts, setSpParts] = React.useState([]);
  const [requestSPData, setRequestSPData] = React.useState<any>();
  const [isSpEnquiry, setIsSpEnquiry] = React.useState<boolean>(false);
  const [referenceNumber, setreferenceNumber] = React.useState("");
  const [openErrorSnackbar, setOpenErrorSnackbar] = React.useState(false);
  const [changeData, setchangeData] = React.useState<any>(null);
  const [deliveryType, setDeliveryType] = React.useState<any>('DLV');
  const [changingDeliveryTypeColor, setChangingDeliveryTypeColor] = React.useState<any>("white");
  const [isValid, setIsValid] = React.useState<boolean>(true);
  const [selectedDeliveryTypeError, setSelectedDeliveryTypeError] = React.useState(false);
  const [verificationData, setVerificationData] = React.useState<any>();
  const { brandsList, selectedCustomerData }: any = useSelector((state: any) => state.dealer);
  const orgIdBrandsMapping = createOrgIdBrandsMapping(brandsList?.data || []);
  const [invalidSelectedDeliveryType, setInvalidSelectedDeliveryType] = React.useState(false);
  const [confirmDialog, setConfirmDialog] = React.useState(false);
  const IBorganizationIds = get(profileDetails, 'data.data.customerInfo.organizationIds', []);
  const [orderCreatedBy, setOrderCreatedBy] = React.useState(
    sessionStorage.getItem("orderCreatedBy") || ""
  );
  const { enquiryInfo, enquirySessionId
    , getOrderLogsDetails
  }: any = useSelector(
    (state: any) => state.createUpdateEnquiry
  );
  const has2431 = IBorganizationIds?.some(
    (org: any) => org.organizationId === "2431"
  );

  const has2428 = IBorganizationIds?.some(
    (org: any) => org.organizationId === "2428"
  );
  // const orgIdBrandsMappingReverse = brandAccess?.reduce(
  //   (acc: any, brand: any) => {
  //     acc[brand.name] = brand.code;
  //     return acc;
  //   },
  //   {}
  // );
  useEffect(() => {
    const enquiryOrgId = enquiryInfo?.data?.data?.[0]?.orgId;

    const orderCreatedBy =
      enquiryOrgId === "2431" || (has2431 && !has2428)
        ? "MA"
        : enquiryOrgId === "2428" || (has2428 && !has2431)
          ? "AA"
          : "";

    if (orderCreatedBy) {
      setOrderCreatedBy(orderCreatedBy);

      sessionStorage.setItem("orderCreatedBy", orderCreatedBy);
      sessionStorage.setItem("finalOrderCreated", orderCreatedBy);
    }
  }, [enquiryInfo, has2431, has2428]);

  // const [brandRefNumbers, setbrandRefNumbers] = React.useState<any>({
  //   "2001": "",
  //   "2002": "",
  //   "2003": "",
  //   "2380": "",
  //   "2195": "",
  //   "2092": "",
  // });
  // const [deliveryBlockReason, setDeliveryBlockReason] = React.useState<any>({
  //   "2001": {
  //     deliveryBlockReason: '',
  //     deliveryBlockReasonCode: ''
  //   },
  //   "2002": {
  //     deliveryBlockReason: '',
  //     deliveryBlockReasonCode: ''
  //   },
  //   "2003": {
  //     deliveryBlockReason: '',
  //     deliveryBlockReasonCode: ''
  //   },
  //   "2092": {
  //     deliveryBlockReason: '',
  //     deliveryBlockReasonCode: ''
  //   },
  //   "2380": {
  //     deliveryBlockReason: '',
  //     deliveryBlockReasonCode: ''
  //   },
  //   "2195": {
  //     deliveryBlockReason: '',
  //     deliveryBlockReasonCode: ''
  //   },
  //   "2295": {
  //     deliveryBlockReason: '',
  //     deliveryBlockReasonCode: ''
  //   },
  // });
  const buildBrandBasedState = (
    brands: any[],
  ) => {
    const state: any = {};

    brands.forEach((brand) => {
      if (brand.code) {
        state[brand.code] = {
          deliveryBlockReason: '',
          deliveryBlockReasonCode: ''
        };
      }
    });

    return state;
  };

  const buildBrandRefNumbers = (
    brands: any[],
  ) => {
    const state: any = {};

    brands.forEach((brand) => {
      if (brand.code) {
        state[brand.code] = '';
      }
    });
    return state;
  };



  const [deliveryBlockReason, setDeliveryBlockReason] =
    React.useState<any>({});

  const [brandRefNumbers, setbrandRefNumbers] =
    React.useState<any>({});

  React.useEffect(() => {
    if (!brandAccess || brandAccess.length == 0) return;

    const refState = buildBrandRefNumbers(brandAccess || []);
    const deliveryState = buildBrandBasedState(brandAccess || []);

    setbrandRefNumbers(refState);
    setDeliveryBlockReason(deliveryState);

  }, [brandAccess]);
  React.useEffect(() => {
    if (!referenceNumber || !brandAccess?.length) return;

    const updatedState: any = {};

    brandAccess.forEach((brand: any) => {
      if (brand.code) {
        updatedState[brand.code] = referenceNumber;
      }
    });

    setbrandRefNumbers(updatedState);
  }, [referenceNumber, brandAccess]);

  const [oesBrandAccess, setOesBrandAccess] = React.useState(false);

  interface ColumnPreferences {
    visibleColumns: string[];
    brandFilter: string[];
    priceColumnVisibility: string[];
    availabilityColumnVisibility: string[];
    alternatePartsToggle: boolean;
  }

  const [columnPreferences, setColumnPreferences] = React.useState<ColumnPreferences>({
    visibleColumns: [],
    brandFilter: [],
    priceColumnVisibility: [],
    availabilityColumnVisibility: [],
    alternatePartsToggle: true
  });

  const [salesOffice, setSalesOffice] = React.useState("");
  const [salesOfficeError, setSalesOfficeError] = React.useState<any>(false);
  const [availability, setAvailability] = React.useState("All");
  const [procuredPart, setprocuredPart] = React.useState<any>([]);
  const [materialNotExtendedPart, setMaterialNotExtendedPart] = React.useState<any>([]);
  // SAP only reports Material Not Extended once per part, and that can happen during a live
  // Tyre search's automatic verify — before the part is even added to the enquiry, when we
  // deliberately don't show the popup. This ref persists that one-time flag across the
  // session so it can still be surfaced later, once the part is actually added and the user
  // clicks Check Availability and Price.
  const capturedMaterialNotExtendedIds = React.useRef<string[]>([]);
  const [invalidParts, setInvalidParts] = React.useState<any>([]);
  const [removedProductsLength, setRemovedProductsLength] = React.useState<any>(0)
  const [isCountOfMaterialNotExtendedParts, setCountOfMaterialNotExtendedParts] = React.useState<any>(0)
  const [callAPI, setIscallAPI] = React.useState<any>(true);
  const [isInvalidPartsExist, setIsInvalidPartsExist] = React.useState<any>(false);
  const [procuredPartExist, setIsProcuredPartExist] = React.useState<boolean>(false);
  const [materialNotExtendedExist, setIsMaterialNotExtendedExist] = React.useState<boolean>(false);
  const [showBackOrderConfirmation, setshowBackOrderConfirmation] = React.useState<any>(false);
  const [isInsufficientCredit, setIsInsufficientCredit] = React.useState<any>(false);
  const [isInsufficientCreditExist, setIsInsufficientCreditExist] = React.useState<any>(false);
  const [showInsufficientCreditPopup, setShowInsufficientCreditPopup] = React.useState<any>(false);
  const [showPlaceOrderConfirmationPopup, setShowPlaceOrderConfirmationPopup] = React.useState<any>(false);
  const [actualProductLength, setActualProductLength] = React.useState<any>();

  const enquiryNumber = get(enquiryInfo, 'data[0].enquiryNumber', '');
  const [openDialog, setOpenDialog] = React.useState(false);

  const { enquiryId }: any = useSelector(
    (state: any) => state.createUpdateEnquiry
  );
  const { getTBLPartsDetails }: any = useSelector(
    (state: any) => state.createUpdateEnquiry
  );

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [searchText, setSearchText] = React.useState<any>('');
  const [tyreParts, setTyreParts] = React.useState<any>([]);
  const [isQuantityIssue, setIsQuantityIssue] = React.useState<Boolean>(false);
  const [tyrePartSelectAll, setTyrePartSelectAll] = React.useState<boolean>(true);
  const [checkedRows, setCheckedRows] = React.useState<any>({});
  const [searchBypartNumber, setSearchBypartNumber] = React.useState("");
  const [openStyleMenu, setOpenStyleMenu] = React.useState<boolean>(false);
  const [quantities, setQuantities] = React.useState<any>({});
  const { getAllAnnexureListData }: any = useSelector((state: any) => state.annexure)
  const { productsData } = useSelector((state: any) => state.products);
  const [isPlaceOrderIsNotDone, setIsPlaceOrderIsNotDone] = React.useState(false);
  const [showFilterMenu, setShowFilterMenu] = React.useState(false);

  const getPreferences = async () => {
    let data: any;
    if (sessionStorage.getItem('userType') === 'FSE') {
      const kamEmail = sessionStorage.getItem('email');
      data = await dispatch(getProfile(kamEmail, 'fse'));
      // data = await profileservice.getProfile(kamEmail, 'fse');
      if (data && data.data) {
        setColumnPreferences(data?.data?.basicInfo?.enquiryGridPreferences)
      }
    } else {
      const b2cUid: any = sessionStorage.getItem('userId');
      const userType: any = sessionStorage.getItem('userType');
      // data = await profileservice.getProfile(b2cUid, userType);
      data = await dispatch(getProfile(b2cUid, userType));
      if (data && data.data) {
        setColumnPreferences(data?.data?.basicInfo?.enquiryGridPreferences)
      }
    }
  }

  const hideFilterMenu = (response: any) => {
    if (response?.data?.success) {
      setShowFilterMenu(false);
      setSuccessMessage('Data Saved Successfully');
      setOpenErrorSnackbar(false);
      setOpenSnackbar(true);
      getPreferences();
    } else {
      setSuccessMessage('Something Went Wrong');
      setOpenErrorSnackbar(true);
      setOpenSnackbar(true);
    }
  }

  const handleClose = () => {
    setAnchorEl(null);
    setSearchBypartNumber("");
  };


  let getOrderLogsDetails1: any = {}

  const getOrderLogsData = (enquiryDetails: any) => {
    const allOrderLogs: any = enquiryDetails?.data.flatMap((e: any) => e.orderLogs || []);
    getOrderLogsDetails1 = { data: allOrderLogs }
    dispatch(setOrderLogs(getOrderLogsDetails1));
  }

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleClickOpen = () => {
    setOpenDialog(true);
  };

  const [orderData, setorderData] = React.useState<any>(null);
  const [checkedAllNow, setcheckedAllNow] = React.useState<any>(false);
  const [checked24hrs, setChecked24hrs] = React.useState<any>(false);
  const [checkedAllBO, setcheckedAllBO] = React.useState<any>(false);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [changeCheckBox, isChangeCheckBox] = React.useState<any>(false);
  const [dlEmails, setDlEmails] = React.useState<string>("");
  const [importOes, setOes] = React.useState(false);
  const [openSpecialPrice, setOpenSpecialPrice] = React.useState<any>(false)
  const [checkAvailabilityButtonText, setCheckAvailabilityButtonText] = React.useState<any>('Check Availability and Price');
  const { favoritesList }: any = useSelector((state: any) => state.favorites);
  const { materialGroups }: any = useSelector((state: any) => state.materialGroups);
  let materialGroupsData = get(materialGroups, 'data.data', null);
  let materialGroupsDataOriginal = get(materialGroups, 'data.data', null);
  let materialGroupsDataTPC = get(materialGroups, 'data.data', null);

  const { requestAccessData, viewSpecialPriceDetails, isSPRModifyData }: any = useSelector((state: any) => state.requestSpecialPrice);
  const { viewingFromOrderHistory }: any = useSelector((state: any) => state.orderHistory)
  const markupPercentage = get(profileDetails, 'data.data.customerInfo.markupPercentage', false);
  const annexureMonthlyOrderLimit = get(profileDetails, 'data.data.customerInfo.annexureMonthlyOrderLimit', false);
  const annexureMonthlyOrderLimitConfig = get(profileDetails, 'data.data.customerInfo.annexureMonthlyOrderLimitConfig', {});
  const companyBrands: any = (dealerDetails && dealerDetails.data && dealerDetails.data.data && dealerDetails.data.data) ? dealerDetails.data.data.organizationIds : null;
  const brandIds = companyBrands && companyBrands.map((id: any) => id.organizationId);
  let deliveryTypeData: any;
  if (sessionStorage.getItem('userType') !== 'FSE' && sessionStorage.getItem('userType') !== 'sre') {
    deliveryTypeData = profileDetails?.data?.data?.customerInfo?.deliveryType;
  }
  const userRole = profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo && profileDetails.data.data.basicInfo.userType

  // const getValidPricingTiers = (brandAccess: any[], brandPricingTier: any[]) => {
  //   const uniqueAccess = Array.from(
  //     new Map(brandAccess.map(item => [item.salesOrganization, item])).values()
  //   );

  //   const accessSet = new Set(uniqueAccess.map(item => item.salesOrganization));

  //   return brandPricingTier.filter(tier => accessSet.has(tier.brand));
  // };

  const brandPricingTier = useRef<any[]>([]);

  // brandPricingTier.current = sessionStorage.getItem('userType') === 'FSE'
  //   ? getCustomerDetailsBySapId?.data?.brandPricingTier
  //   : profileDetails?.data?.data?.customerInfo?.brandPricingTier;


  const rawBrandPricingTier =
    sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre'
      ? getCustomerDetailsBySapId?.data?.brandPricingTier
      : profileDetails?.data?.data?.customerInfo?.brandPricingTier;


  let customerAccountType: any = sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre'
    ? getCustomerDetailsBySapId?.data?.customerAccountType
    : get(profileDetails, 'data.data.customerInfo.customerAccountType', '');


  // ✅ Assign only valid tiers
  brandPricingTier.current = rawBrandPricingTier || []


  const companyCurrencyType = profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.companyCurrencyType ? profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.companyCurrencyType : 'AED'
  const webApplicationLoginId: any = sessionStorage.getItem("webApplicationLoginId");
  const currentTier = sessionStorage.getItem('currentTier');
  const [accessData, setAccessData] = React.useState<any>();
  const { enquiryList, enquiryStatus } = useSelector((state: any) => state.orderEnquiry);
  const { accessControlBrandsData }: any = useSelector((state: any) => state.onboard);
  const [userMasterId, setUserMasterId] = React.useState<any>();
  const [requestStatus, setRequestStatus] = React.useState<any>();
  const [estmateTotal, setEstmateTotal] = React.useState<any>();
  const [requestedTotalType, setRequestedTotalType] = React.useState<any>();
  const [requestedCalculatedTotalType, setRequestedCalculatedTotalType] = React.useState<any>();
  const [requestedCaluclatedTotalPrice, setRequestedCaluclatedTotalPrice] = React.useState<any>();
  const [showApproveDialog, setshowApproveDialog] = React.useState<boolean>(false);
  const [showExpired24Hrs, setShowExpired24Hrs] = React.useState<boolean>(false);
  const [showReorderEnquiry, setShowReorderEnquiry] = React.useState<boolean>(false);
  const [copyCreateEnquiry, setCopyCreateEnquiry] = React.useState(false);
  const [isViewingFromOrderHistory, setViewigFromOrderHistory] = React.useState<boolean>(false);
  const [showRequestQuotationDialog, setShowRequestQuotationDialog] = React.useState<boolean>(false);
  const [statusSuccessChecked, setStatusSuccessChecked] = React.useState<boolean>(false);
  const [requestQuotationStatusChecked, setRequestQuotationStatusChecked] = React.useState<boolean>(false);
  const [masterIDData, setMasterIDData] = React.useState<any>();
  const [quotation, setQuotation] = React.useState<any>(false)
  const [isDeleted, setIsDelted] = React.useState(false);
  const userType: any = (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo && profileDetails.data.data.basicInfo?.userType) || "";
  const [multipleAddressData, setMultipleAddressData] = React.useState<any>('');
  const [collectionAddressData, setCollectionAddressData] = React.useState<any>();
  const [changingAddressTypeColor, setChangingAddressTypeColor] = React.useState<any>("white");
  const [addressId, setAddressId] = React.useState<any>();
  const [shiftToPartyId, setShiftToPartyId] = React.useState<any>();
  const [openChooseCustomerDialog, setOpenChooseCustomerDialog] = React.useState(false);
  const [openShippingAddDialog, setOpenShippingAddDialog] = React.useState(false);
  const [showConfirmDialogPopup, setShowConfirmDialogPopup] = React.useState<boolean>(false);
  const [openOrderLogPopup, setOpenOrderLogPopup] = React.useState(false);
  const [exitLoading, setExitLoading] = React.useState(false);
  const isCustomer = isCustomerUser();
  const unblockRef = useRef<any>(null);

  const handleExitSubmit = async (data: any) => {
    setExitLoading(true);
    const productMap = new Map(
      products?.map((prod: any) => [prod.productId, prod])
    );

    const enquiryDetails =
      enquiryData?.map((enquiry: any) => ({
        enquiryNumber: enquiry.enquiryNumber,
        make: enquiry.make,
        products:
          enquiry.products?.map((item: any) => {
            const matchedProduct = productMap.get(item.productId);
            const source = matchedProduct || item;

            return {
              quantity: source.quantity || 1,
              productId: source.productId,
              productIdDescription: source.productIdDescription,
              nsp: source.nspev || 0,
              materialGroup: source.materialGroup,
              orgId: "",
              nowAvailability: source.nowAvailability || 0,
              hrs24Availability: source.hrs24Availability || 0,
              airAvailability: source.airAvailability || 0
            };
          }) || []
      })) || [];
    const finalPayload = {
      enqId:
        enquiryData &&
          Array.isArray(enquiryData) &&
          enquiryData.length > 0 &&
          enquiryData[0].B2bEnquiryId
          ? enquiryData[0].B2bEnquiryId
          : "",
      assignedKam: get(profileDetails, 'data.data.basicInfo.assignedKamAndFse[0].assignKam', ""),
      enquiryDetails: enquiryDetails,
      estimatedTotal: parseFloat(getSellingPrice(getEstimatedTotal(isAvailabiityChecked, true), isSellingPriceData, markupPercentage)).toFixed(2),
      customerId: enquiryData?.[0]?.customerId || "",
      customerName: enquiryData?.[0]?.customerName || "",
      sessionDetails: {
        webApplicationLoginId: webApplicationLoginId,
        clientIPAddress: sessionStorage.getItem("clientIp")
      },

      customerInputs: {
        inputs: data.reasons,
        other: data.otherReason
      },

      userName: firstName,
      userId: sessionStorage.getItem("userId"),
      customerType: sessionStorage.getItem("userType")
    };
    try {
      await dispatch(postLossSaleReasonList(finalPayload));
      setShowExitPopup(false);
      setIsEnquiryStarted(false);

      // ✅ IMPORTANT: unblock navigation
      if (unblockRef.current) {
        unblockRef.current();
      }
      // ✅ Then navigate
      history.push(nextPath);
    } catch (error) {
      console.error("Exit Submit Error:", error);
    } finally {
      setExitLoading(false);
    }
  };

  let collectionPoints: any = profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.collectionPointsOfOrder && profileDetails.data.data.customerInfo.collectionPointsOfOrder.collectionPoints;
  if (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') {
    collectionPoints = getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.collectionPointsOfOrder && getCustomerDetailsBySapId.data.collectionPointsOfOrder.collectionPoints;
    userAccessControl(getCustomerDetailsBySapId?.data?.accessParameter, 'FSE')
    // setCollectionAddressData(collectionPoints && collectionPoints.length > 0 && collectionPoints[0].defineTPCounter)
  } else {
    collectionPoints = profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.collectionPointsOfOrder && profileDetails.data.data.customerInfo.collectionPointsOfOrder.collectionPoints;
  }

  let sapCustomerId: any = _.get(profileDetails, "data.data.basicInfo.sapCustomerId", "");
  if (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') {
    sapCustomerId = getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.sapCustomerId
  }

  let pricingTier: any = '';
  if (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') {
    pricingTier = getCustomerDetailsBySapId?.data?.pricingTier;
  } else {
    pricingTier = get(profileDetails, 'data.data.customerInfo.pricingTier', '');
  }
  // let tblDealerAccess: any = [
  //   ...(sessionStorage.getItem('userType') === 'FSE'
  //     ? (getCustomerDetailsBySapId?.data?.featureAccesses?.length > 0
  //       ? getCustomerDetailsBySapId?.data?.featureAccesses
  //       : [])
  //     : (profileDetails?.data?.data?.customerInfo?.featureAccesses || []))
  // ].sort((a, b) => a.localeCompare(b));
  let featureAccessibility: any = sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ?
    getCustomerDetailsBySapId?.data?.accessParameter?.[0]?.featureAccessibility :
    profileDetails?.data?.data?.accessParameter?.featureAccessibility

  const shipToPartyFeatureAccess = sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ? true : get(profileDetails, 'data.data.customerInfo.shipToPartyFeatureAccess', '');
  const [newAddressData, setAddressData] = React.useState(sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ? getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.addresses
    : get(
      profileDetails,
      "data.data.customerInfo.addresses",
      ""
    ));

  const [customerTierType, setCustomerTierType] = React.useState(sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ? getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.customerTierType
    : get(profileDetails, 'data.data.customerInfo.customerTierType', ''));
  const customerTypeAccess = get(profileDetails, 'data.data.basicInfo.customerTypeAccess', '');
  const [openBrandEnquiryinfo, setOpenBrandEnquiryinfo] = React.useState(true);
  const [isOrderEnquiryCreated, setIsOrderEnquiryCreated] = React.useState<boolean>(false);
  const [onClickOfChangeButton, setOnClickOfChangeButton] = React.useState(false);
  const getChoosenCustomerName: any = sessionStorage.getItem("CompanyName");
  const getChoosenCustomerSapCustomerId = sessionStorage.getItem('selectedSapCustomerId');
  const getSelectedOrderType = sessionStorage.getItem('finalOrderType') ? sessionStorage.getItem('finalOrderType') : sessionStorage.getItem('orderType');
  const getSelectedSO = sessionStorage.getItem('finalSelectOffice') ? sessionStorage.getItem('finalSelectOffice') : sessionStorage.getItem('selectOffice');
  const getSelectedOfficeTitle = sessionStorage.getItem('selectedOfficeTitle');
  const getFinalOrderType: any = sessionStorage.getItem('finalOrderType');
  const getFinalSelectOffice: any = sessionStorage.getItem('finalSelectOffice');
  const getOrderCreatedBy: any = sessionStorage.getItem('orderCreatedBy');
  const getOrderCreatedByTitle = sessionStorage.getItem('orderCreatedByTitle');
  const selectedSAPIDCustomerType = getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.customerTierType;
  const [getCustomerNameonView, setGetCustomerNameonView] = React.useState<any>('');
  const [getCustomerSapIdonView, setGetCustomerSapIdonView] = React.useState<any>('');
  const companyCurrencyTypeByFSE =
    ['undefined', 'null', '', null, undefined].includes(sessionStorage.getItem('companyCurrencyType') as any)
      ? 'AED'
      : sessionStorage.getItem('companyCurrencyType');

  const isTpcDealer = profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.isTpcDealer;
  const [confirmOrderChecked, setConfirmOrderChecked] = React.useState<boolean>(false);
  const TPCRegionDetails = profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.TPCRegionDetails;
  const [getLatestOrderCount, setGetLatestOrderCount] = React.useState(false);
  const [subEnquiriesData, setSubEnquiriesData] = React.useState<any>([]);
  const [isDisableOrderLogButton, setIsDisableOrderLogButton] = React.useState<any>(false);
  const resetOrderLogCount: any = sessionStorage.getItem('reset-the-orderlog-count');
  const [orderLogBadgeCount, setOrderLogBadgeCount] = React.useState<any>();
  const [showDropdown, setShowDropdown] = React.useState<boolean>(false);
  const dropdownRef = React.useRef<HTMLDivElement>(null);
  const [addedTyreParts, setAddedTyreParts] = React.useState<boolean>(false);
  const [isTyrePartsSearch, setIsTyrePartsSearch] = React.useState<boolean>(false);
  let isAllSelected: any = tyreParts && tyreParts.every((row: any) => checkedRows[row.partNumber]);
  let selectedCount: any = Object.values(checkedRows).filter((isChecked) => isChecked).length;
  const annexureEnquiry =
    window.location.pathname === '/annexurecreateenquiry'
      ? 'true' :
      window.location.pathname === '/createenquiry'
        ? ''
        : sessionStorage.getItem('annexureEnquiry');

  //      const annexureEnquiry: any =
  // sessionStorage.getItem('userType') !== 'FSE' &&
  //   window.location.pathname === '/annexurecreateenquiry'
  //   ? 'true' :
  //   sessionStorage.getItem('userType') !== 'FSE' &&
  //     window.location.pathname === '/createenquiry'
  //     ? ''
  //     : sessionStorage.getItem('annexureEnquiry');
  const isAnnexurePartAccess = get(profileDetails, 'data.data.customerInfo.isAnnexurePartAccess', '');
  const [showSearchBar, setShowSearchBar] = React.useState(false);
  const [searchByPartNo, setSearchByPartNo] = React.useState("");
  const [brandSummaryState, setBrandSummaryState] = React.useState<any[]>([]);
  const salesOrganizationArray = profileDetails?.data?.data?.customerInfo?.controlAccessOfBrand;
  const getBrandDisplayName = (code: string) => {
    const brand = accessControlBrandsData?.data?.find(
      (item: any) => item.code === code
    );

    return brand?.displayName || code;
  };

  // Check for the required salesOrganization and make
  const hasOESOrg = Array.isArray(salesOrganizationArray) &&
    salesOrganizationArray.some(
      org => org.salesOrganization === "2195" && org.make === "OES"
    );

  const oesSalesOrgState = hasOESOrg; // will be false if not found, true if found

  const handleToggleSearch = () => {
    setOpenEnquiry(false);
    setShowSearchBar((prev) => !prev);
  };

  const handleClearSearch = () => {
    setSearchByPartNo("");
  };

  const prevPathRef = useRef<string | null>(null);
  const b2bUserIdFSESelectedCustomer: any = sessionStorage.getItem('b2bUserIdFSESelectedCustomer');
  const showCreateChangeEnquiry = sessionStorage.getItem('userType') === 'FSE' ? true : !sessionStorage.getItem('restrictFeat')?.includes(RESTRICTED_ACCESS.CREATE_CHANGE_ENQUIRY);
  //<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< EXISTING CODE >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  // let enquiryMappingReverse: any = {};

  // materialGroupsData && Array.isArray(materialGroupsData) && materialGroupsData.forEach((group: any) => {
  //   enquiryMappingReverse[group.make] = group.materialGroup.toString();
  // })

  // let enquiryMapping: any = {};

  // materialGroupsData && Array.isArray(materialGroupsData) && materialGroupsData.forEach((group: any) => {
  //   group.materialGroup.forEach((item: any) => {
  //     enquiryMapping[item] = group.make;
  //   })
  // })

  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> NEW CODE >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  useEffect(() => {
    dispatch(selectedParts(products, parseFloat(getSellingPrice(getViewEstimatedTotal(), isSellingPriceData, markupPercentage)).toFixed(2), enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].B2bEnquiryId ? enquiryData[0].B2bEnquiryId : ""));
    // let isSpecialPrice = false
    // products.forEach((ele: any) => {
    //   if (ele.hasOwnProperty("selected")) {
    //     if (ele.selected) {
    //       isSpecialPrice = true
    //     }
    //   }
    // })
    // if (isSpecialPrice) {
    //   setSpecialPrice(true)
    // } else if (isSpecialPrice === false) {
    //   setSpecialPrice(false)
    // }
  }, [products])

  useEffect(() => {
    if (!isEnquiryStarted || !isCustomer) return;
    unblockRef.current = history.block((tx: any) => {
      if (["/requestspecialprice", "/quotation", "/viewrequeststatus"].includes(tx.pathname)) {
        return;
      }
      setNextPath(tx.pathname);
      setShowExitPopup(true);
      return false;
    });

    return () => {
      if (unblockRef.current) {
        unblockRef.current();
      }
    };
  }, [isEnquiryStarted, isCustomer]);

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (isEnquiryStarted && isCustomer) {
        e.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isEnquiryStarted, isCustomer]);

  useEffect(() => {
    if (checkedRows && Object.keys(checkedRows)?.length > 0) {
      selectedCount = Object.values(checkedRows).filter((isChecked) => isChecked).length;
    }
  }, [checkedRows])

  const deleteCall = async (enquiryId: any) => {
    await deleteProblemParts(enquiryId ? enquiryId : enquiryData && enquiryData.length > 0 && enquiryData[0].B2bEnquiryId, invalidParts, false);
  }

  useEffect(() => {
    if (((enquiryId && callAPI) || (invalidParts && invalidParts.length > 0 && callAPI)) && enquiryAction !== 'view') {
      if (removedProductsLength !== invalidParts.length) {
        deleteCall(enquiryId ? enquiryId : enquiryData && enquiryData.length > 0 && enquiryData[0].B2bEnquiryId)
        // deleteProblemParts(enquiryId ? enquiryId : enquiryData && enquiryData.length > 0 && enquiryData[0].B2bEnquiryId, invalidParts, false);
      }
    }
  }, [enquiryId, invalidParts]);

  useEffect(() => {
    if (viewEnquiry === "true") {
      setIsTyrePartsSearchSuccessFully(true);
      setIsTyrePartsAddedtoGrid(true);
    }
    let isAddedFromDashboard = sessionStorage.getItem('isAddedFromDashboard');
    if (isAddedFromDashboard === 'true') {
      setSelectedAccessType("Parts")
    }
  }, []);

  const assignedBrandRef = useRef<any[]>([]);
  const customerTierTypeRef = useRef<string | null>(null);
  const iamMap = useRef<boolean | null>(false);

  useEffect(() => {
    const customerTierType = sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre'
      ? getCustomerDetailsBySapId?.data?.customerTierType
      : get(profileDetails, 'data.data.customerInfo.customerTierType', '');

    const customerTypeAccess = sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre'
      ? [getCustomerDetailsBySapId?.data?.customerTierType]
      : [];

    customerAccountType = sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre'
      ? getCustomerDetailsBySapId?.data?.customerAccountType
      : get(profileDetails, 'data.data.customerInfo.customerAccountType', '');

    featureAccessibility = sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ?
      getCustomerDetailsBySapId?.data?.accessParameter?.[0]?.featureAccessibility :
      profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.accessParameter && profileDetails.data.data.accessParameter.featureAccessibility

    const iamMappingFeature = featureAccessibility?.find((ele: any) => ele.featureCode === "IAM_MAP");
    if (iamMappingFeature?.value === true && annexureEnquiry !== 'true') {
      iamMap.current = true;
      setIsOESOEM(true);
    } else if (iamMappingFeature?.value === false) {
      iamMap.current = false;
      setIsOESOEM(false);
    }

    // Check if should validate OES brand access for TBL Dealer/Dealer users (FSE or Customer)
    if (customerTierType === 'TBL Dealer' ||
      customerTypeAccess.includes("TBL Dealer") ||
      customerTierType === 'Dealer' ||
      customerTypeAccess.includes("Dealer")) {

      if (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') {
        // For FSE users, check in brandAccess
        const brandAccess = getCustomerDetailsBySapId?.data?.controlAccessOfBrand;
        if (Array.isArray(brandAccess)) {
          const hasOESBrand = brandAccess.some(
            brand => brand.salesOrganization === "2195" && brand.make === "OES"
          );
          setOesBrandAccess(!hasOESBrand); // Set true if OES brand is NOT present
        } else {
          setOesBrandAccess(true); // No brand access means no OES
        }
      } else {
        // For Customer users, check in salesOrganization
        const salesOrganization = get(profileDetails, 'data.data.customerInfo.controlAccessOfBrand', []);
        if (Array.isArray(salesOrganization)) {
          const hasOESBrand = salesOrganization.some(
            org => org.salesOrganization === "2195" && org.make === "OES"
          );
          setOesBrandAccess(!hasOESBrand); // Set true if OES brand is NOT present
        } else {
          setOesBrandAccess(true); // No sales organization means no OES
        }
      }
    } else {
      setOesBrandAccess(false); // Not applicable for other customer types
    }

    if ((sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') && getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.addresses && !openShippingAddDialog) {
      const userType = sessionStorage.getItem('userType');
      if (userType === 'FSE' || userType === 'sre' && getCustomerDetailsBySapId?.data) {
        dispatch(storeSelectedCustomerData(getCustomerDetailsBySapId?.data))
        assignedBrandRef.current = getCustomerDetailsBySapId?.data?.controlAccessOfBrand || [];
        if (getCustomerDetailsBySapId?.data?.pricingTier) {
          sessionStorage.setItem('pricingTier', getCustomerDetailsBySapId.data.pricingTier);
        }
        if (getCustomerDetailsBySapId?.data?.accessParameter &&
          getCustomerDetailsBySapId.data.accessParameter.length > 0 &&
          getCustomerDetailsBySapId.data.accessParameter[0].b2bUserId) {
          sessionStorage.setItem('b2bUserIdFSESelectedCustomer', getCustomerDetailsBySapId.data.accessParameter[0].b2bUserId);
        }
        customerTierTypeRef.current = getCustomerDetailsBySapId?.data?.customerTierType || null;
        featureAccessibility = getCustomerDetailsBySapId?.data?.accessParameter && getCustomerDetailsBySapId?.data?.accessParameter?.length > 0 ? getCustomerDetailsBySapId?.data?.accessParameter[0]?.featureAccessibility : [];
        const iamMappingFeature = featureAccessibility?.find((ele: any) => ele.featureCode === "IAM_MAP");
        if (iamMappingFeature?.value === true && annexureEnquiry !== 'true') {
          iamMap.current = true;
          setIsOESOEM(true);
        } else if (iamMappingFeature?.value === false) {
          iamMap.current = false;
          setIsOESOEM(false);
        }
        pricingTier = getCustomerDetailsBySapId?.data?.pricingTier;
        brandPricingTier.current = getCustomerDetailsBySapId?.data?.brandPricingTier;
        // tblDealerAccess = (
        //   sessionStorage.getItem('userType') === 'FSE'
        //     ? (getCustomerDetailsBySapId?.data?.featureAccesses?.length > 0
        //       ? getCustomerDetailsBySapId?.data?.featureAccesses
        //       : [])
        //     : (profileDetails?.data?.data?.customerInfo?.featureAccesses || [])
        // )?.slice().sort((a: any, b: any) => a.localeCompare(b));
        // setSelectedAccessType(isTBLAccess() ? "Tyres" : "Parts")
      } else {
        assignedBrandRef.current = get(profileDetails, 'data.data.customerInfo.controlAccessOfBrand', []);
        customerTierTypeRef.current = get(profileDetails, 'data.data.customerInfo.customerTierType', null);
      }
      userAccessControl(getCustomerDetailsBySapId?.data?.accessParameter, 'FSE')
      if (window.location.pathname.includes('viewenquiry') && !openChooseCustomerDialog && getCustomerDetailsBySapId && multipleAddressData && multipleAddressData !== '' && getCustomerDetailsBySapId.data) {
        let isAddressExist: any = getCustomerDetailsBySapId.data.addresses.some((obj: any) => obj.shiftToPartyCustomerNumber === multipleAddressData)
        if (isAddressExist) {
          setAddressData(sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ? getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.addresses
            : get(
              profileDetails,
              "data.data.customerInfo.addresses",
              ""
            ));
        } else {
          let address = {
            shiftToPartyCustomerNumber: multipleAddressData
          }
          setAddressData([...getCustomerDetailsBySapId?.data?.addresses, address])
          let e = { target: { value: address?.shiftToPartyCustomerNumber } }
          handleChangeAddress(e)
        }
      } else {
        setAddressData(sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ? getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.addresses
          : get(
            profileDetails,
            "data.data.customerInfo.addresses",
            ""
          ));
      }
    }
    setCustomerTierType(sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ? getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.customerTierType
      : get(profileDetails, 'data.data.customerInfo.customerTierType', ''));
    if (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') {
      sessionStorage.setItem('customerId', getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.sapCustomerId)
      sessionStorage.setItem('customerName', getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.companyName)
    }
  }, [getCustomerDetailsBySapId, multipleAddressData, profileDetails])

  const isShowSPR = () => {
    if ((currentTier && currentTier.toLowerCase() === 'gold') || (currentTier && currentTier.toLowerCase() === 'platinum') || (currentTier && currentTier.toLowerCase() === 'elite')) {
      return true;
    } else {
      return false;
    }
  }

  useEffect(() => {
    if (products.length !== actualProductLength && !isAvailabiityChecked) {
      setDisableQuotation(true);
    } else {
      setDisableQuotation(false);
    }
  }, [products, actualProductLength])

  useEffect(() => {
    if (sessionStorage.getItem('userType') !== 'FSE' && sessionStorage.getItem('userType') !== 'sre') {
      setDeliveryType(deliveryTypeData);
    }
  }, [deliveryTypeData])

  useEffect(() => {
    if (!enquirySessionId) {
      getUniqueEnquirySessionId(getUniqueTimestamp());
    }
  }, [enquirySessionId])

  useEffect(() => {
    let id: any
    enquiryList && enquiryList.data && Array.isArray(enquiryList.data.data) && enquiryList.data.data && enquiryList.data.data.length > 0 && (
      <>
        {enquiryList.data.data.map((enquiry: any, index: any) => {
          return (
            id = sessionStorage.setItem("current-enquiry-no", enquiry.masterId)
          );
        })}
      </>
    )
    setUserMasterId(id)
  }, [enquiryList]);

  const getOrderLogCount = (orderLogs: any) => {
    let totalUnreadCount = 0;
    orderLogs && orderLogs.data.forEach((entry: any) => {
      // totalUnreadCount += entry.unReadCount ? entry.unReadCount : entry.count;
      totalUnreadCount += entry?.unReadCount;
    });
    return totalUnreadCount;
  }

  useEffect(() => {
    if (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo) {
      // if (history.location.pathname !== "/viewenquiry") {
      //   dispatch(getCreditLimit(sapCustomerId, webApplicationLoginId));
      // }
      if ((customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer")) || (profileDetails.data.data.customerInfo && (profileDetails.data.data.customerInfo.customerTierType === 'Workshop' || profileDetails.data.data.customerInfo.customerTierType === 'tpcdealer'))) {
        getDLEmailByRegionResult()
      }
      if (profileDetails && profileDetails?.data?.data?.basicInfo) {

        // new code start

        const prefs = profileDetails.data.data.basicInfo.enquiryGridPreferences;

        const COLUMNS = ["Price", "Availability", "Dimension", "Volume"];
        const PRICES = ["NSP (Incl. VAT)", "Amt", "NSP (Excl. VAT)", "BOP", "RSP"];
        const AVAILABILITY = ["NOW", "BO", "24Hrs"];

        let BRANDS: string[] = [];
        if (rowSummaryGlobalData?.length > 0) {
          BRANDS = rowSummaryGlobalData.map((item: any) => item.brandNameInfo);
        }

        const filteredPrices =
          annexureEnquiry === "true"
            ? PRICES.filter((p) => p !== "BOP" && p !== "RSP")
            : PRICES;

        const filteredAvailability =
          annexureEnquiry === "true"
            ? AVAILABILITY.filter((a) => a !== "BO" && a !== "24Hrs")
            : !isTpcWorkshop()
              ? AVAILABILITY.filter((a) => a !== "24Hrs")
              : AVAILABILITY;

        // 🟢 Only apply prefs if they have something, else fallback
        const data: ColumnPreferences = {
          visibleColumns:
            prefs?.visibleColumns?.length > 0 ? prefs.visibleColumns : COLUMNS,
          brandFilter: prefs?.brandFilter?.length > 0 ? prefs.brandFilter : BRANDS,
          priceColumnVisibility:
            prefs?.priceColumnVisibility?.length > 0
              ? prefs.priceColumnVisibility
              : filteredPrices,
          availabilityColumnVisibility:
            prefs?.availabilityColumnVisibility?.length > 0
              ? prefs.availabilityColumnVisibility
              : filteredAvailability,
          alternatePartsToggle:
            prefs?.alternatePartsToggle !== undefined
              ? prefs.alternatePartsToggle
              : true,
        };
        setColumnPreferences(data);
      }
    }
    if (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') {
      if (ddlValues && ddlValues.data && ddlValues.data.data && ddlValues.data.data.deliveryBlockReason && ddlValues.data.data.deliveryBlockReason.length > 0) {
      } else {
        dispatch(getDeliveryBlockReason());
      }
    }
  }, [profileDetails])

  function is24hrExist() {
    if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && products && products.length > 0) {
      return products.some((obj: any) => obj.hrs24AvailabilityChecked === true);
    }
  }

  useEffect(() => {
    let viewingFromid: any = viewingFromOrderHistory && viewingFromOrderHistory.data && viewingFromOrderHistory.data && viewingFromOrderHistory.data.id
    let b2bId: any = enquiryData && enquiryData[0] && enquiryData[0].B2bEnquiryId && enquiryData[0].B2bEnquiryId;
    // viewingFromid === b2bId &&
    if (enquiryAction === "view" && viewingFromOrderHistory && viewingFromOrderHistory.data && viewingFromOrderHistory.data && viewingFromOrderHistory.data.isViewingFromOrderHistory) {
      setViewigFromOrderHistory(true)
    } else {
      setViewigFromOrderHistory(false)
    }
  }, [viewingFromOrderHistory, enquiryData && enquiryData[0] && enquiryData[0].B2bEnquiryId && enquiryData[0].B2bEnquiryId])

  const getDLEmailByRegionResult = async () => {
    let DLEmailByRegionResult: any = await dispatch(getDLEmailByRegion(region))
    if (!_.isEmpty(DLEmailByRegionResult.data)) {
      let emailList: Array<any> = DLEmailByRegionResult.data
      let emails: Array<any> = emailList.map(el => el.partsAdvisoreEmail);
      setDlEmails(emails.toString())
    }
  }

  useEffect(() => {
    if (verificationData &&
      verificationData.data &&
      Array.isArray(verificationData.data) &&
      verificationData.data.length > 0) {
      getEstimatedTotalSap(true, verificationData);
      setGetVerifyData(verificationData);
    }
  }, [verificationData])

  let enquiryMappingReverse: any = {};
  let temp: any = []
  let tempTPC: any = []

  // if (customerTierType && customerTierType.toLowerCase() === 'tpcdealer') {
  //   if (materialGroupsDataTPC !== null) {
  //     if (materialGroupsData !== null) {
  //       for (let item of materialGroupsData) {
  //         // if (item.make != "OES") {
  //         tempTPC.push(item)
  //         // }
  //       }
  //     }
  //   }
  // }
  if (customerTierType) {
    if (materialGroupsData !== null) {
      for (let item of materialGroupsData) {
        // if (item.make != "OES") {
        temp.push(item)
        // }
      }
    }
  } else if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer")) {
    let selectedBrand: any;
    if (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') {
      if (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo && profileDetails.data.data.basicInfo.organizationIds)
        selectedBrand = getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.controlAccessOfBrand
      if (getCustomerDetailsBySapId?.data?.pricingTier) {
        sessionStorage.setItem('pricingTier', getCustomerDetailsBySapId.data.pricingTier);
      }
      if (getCustomerDetailsBySapId?.data?.accessParameter &&
        getCustomerDetailsBySapId.data.accessParameter.length > 0 &&
        getCustomerDetailsBySapId.data.accessParameter[0].b2bUserId) {
        sessionStorage.setItem('b2bUserIdFSESelectedCustomer', getCustomerDetailsBySapId.data.accessParameter[0].b2bUserId);
      }
    } else {
      if (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.selectedBrand)
        selectedBrand = profileDetails?.data?.data?.customerInfo?.selectedBrand
    }

    // if (sessionStorage.getItem('userType') === 'FSE') {
    // if (selectedBrand && selectedBrand.length == 1 && (selectedBrand[0].organizationId === "2195" || selectedBrand[0].salesOrganization === '2195')) {
    if (!_.isEmpty(materialGroupsData)) {
      temp = materialGroupsData;
      // if (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') {
      //   // if (selectedBrand && selectedBrand.length == 1 && (selectedBrand[0].organizationId === "2195" || selectedBrand[0].salesOrganization === '2195')) {
      //   let brand = _.filter(materialGroupsData, (i) => {
      //     return i.orgId !== '2003'
      //   });
      //   if (!_.isEmpty(brand)) {
      //     temp = brand;
      //   }
      //   let mergeMaterialGroup: any = [];
      //   for (let i of temp) {
      //     mergeMaterialGroup = mergeMaterialGroup.concat(i.materialGroup)
      //   }
      //   let finalMaterialGroup = [{
      //     displayName: "Tradepoint",
      //     make: "OES",
      //     materialGroup: mergeMaterialGroup,
      //     orgId: "2195"
      //   }]
      //   temp = finalMaterialGroup
      // } else {
      //   if (selectedBrand && selectedBrand.length == 1 && selectedBrand[0].organizationId === "2195") {
      //     let brand = _.filter(materialGroupsData, (i) => {
      //       return i.orgId == "2195"
      //     });
      //     if (!_.isEmpty(brand)) {
      //       temp.push(brand[0])
      //     }
      //   } else if (true) {
      //     // selectedBrand ?? [];
      //     if (Array.isArray(selectedBrand)) {
      //       for (let item of selectedBrand) {
      //         let brand = _.filter(materialGroupsData, (i) => {
      //           return i.orgId == item.organizationId
      //         });
      //         if (!_.isEmpty(brand)) {
      //           temp.push(brand[0])
      //         }
      //       }
      //     }
      //     let mergeMaterialGroup: any = [];
      //     for (let i of temp) {
      //       mergeMaterialGroup = mergeMaterialGroup.concat(i.materialGroup)
      //     }
      //     let finalMaterialGroup = [{
      //       displayName: "Tradepoint",
      //       make: "OES",
      //       materialGroup: mergeMaterialGroup,
      //       orgId: "2195"
      //     }]
      //     temp = finalMaterialGroup
      //   }
    }
    let mergeMaterialGroup: any = [];
    for (let i of temp) {
      mergeMaterialGroup = mergeMaterialGroup.concat(i.materialGroup)
    }
    let finalMaterialGroup = [{
      displayName: "Tradepoint",
      make: "OES",
      materialGroup: mergeMaterialGroup,
      orgId: ""
    }]
    temp = finalMaterialGroup
  }
  if (temp && temp.length > 0) {
    materialGroupsData = temp;
  }

  materialGroupsData && Array.isArray(materialGroupsData) && materialGroupsData.forEach((group: any) => {
    enquiryMappingReverse[group?.code] = group?.materialGroup?.toString();
  })

  let enquiryMapping: any = {};
  let enquirySubBrand: any = {};
  // let enquiryMapping: any = {};
  materialGroupsData && Array.isArray(materialGroupsData) && materialGroupsData.forEach((group: any) => {
    // if ((customerTierType && (customerTierType.toLowerCase() === "tbl dealer" || customerTierType.toLowerCase() === "dealer"))) {
    //   if (Array.isArray(group?.materialGroup)) {
    //     group.materialGroup.forEach((item: any) => {
    //       if (item === 'ALPOE') {
    //         enquiryMapping[item] = 'OESParts';
    //       } else if (item === 'AMPTB') {
    //         enquiryMapping[item] = 'OESTyres';
    //       } else {
    //         enquiryMapping[item] = group?.make;
    //       }
    //     });
    //   }
    // } else {
    group?.materialGroup.forEach((item: any) => {
      enquiryMapping[item] = group?.code;
    })
    // }
  })

  // enquirySubBrand = materialGroupsData && Array.isArray(materialGroupsData) && materialGroupsData.reduce((acc, item) => {
  //   return { ...acc, ...item.materialGroupforSubbrand };
  // }, {});

  if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer")) {
    enquirySubBrand = materialGroupsDataOriginal?.reduce((acc: any, item: any) => {
      if (item.materialGroupforSubbrand) {
        Object.assign(acc, item.materialGroupforSubbrand);
      }
      return acc;
    }, {});
  } else {
    enquirySubBrand = materialGroupsData?.reduce((acc: any, item: any) => {
      if (item.materialGroupforSubbrand) {
        Object.assign(acc, item.materialGroupforSubbrand);
      }
      return acc;
    }, {});
  }


  // materialGroupsDataTPC && Array.isArray(materialGroupsDataTPC) && materialGroupsDataTPC.forEach((group: any) => {
  //   group.materialGroup.forEach((item: any) => {
  //     enquiryMapping[item] = group.make;
  //   })
  // })

  // materialGroupsDataTPC &&
  //   Array.isArray(materialGroupsDataTPC) &&
  //   materialGroupsDataTPC.forEach((group: any) => {
  //     Array.isArray(group.materialGroup) &&
  //       group.materialGroup.forEach((item: any) => {
  //         enquiryMapping[item] = group.code;
  //       });
  //   });

  const b2bUserId = get(profileDetails, 'data.data.basicInfo.b2bUserId', "");

  let assignedBrandsData: any = [];
  let address: any = [];
  let addressData: any = [];
  if (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') {
    if (getCustomerDetailsBySapId?.data?.pricingTier) {
      sessionStorage.setItem('pricingTier', getCustomerDetailsBySapId.data.pricingTier);
    }
    if (getCustomerDetailsBySapId?.data?.accessParameter &&
      getCustomerDetailsBySapId.data.accessParameter.length > 0 &&
      getCustomerDetailsBySapId.data.accessParameter[0].b2bUserId) {
      sessionStorage.setItem('b2bUserIdFSESelectedCustomer', getCustomerDetailsBySapId.data.accessParameter[0].b2bUserId);
    }
    assignedBrandsData = getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.controlAccessOfBrand
    address = getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.addresses
    addressData = getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.addresses
  } else {
    assignedBrandsData = get(
      profileDetails,
      "data.data.customerInfo.controlAccessOfBrand",
      []
    );
    address = get(
      profileDetails,
      "data.data.customerInfo.addresses",
      ""
    );
    addressData = get(
      profileDetails,
      "data.data.customerInfo.addresses",
      ""
    );
  }

  const firstName = get(
    profileDetails,
    "data.data.basicInfo.firstName",
    ""
  );

  const adminId = get(
    profileDetails,
    "data.data.basicInfo.adminId",
    ""
  );

  const lastName = get(
    profileDetails,
    "data.data.basicInfo.lastName",
    ""
  );

  const region = get(
    profileDetails,
    "data.data.basicInfo.region",
    ""
  );

  const b2cUserId = get(
    profileDetails,
    "data.data.basicInfo.b2cUserId",
    ""
  );

  const firstAddress = addressData && addressData.length > 0 && addressData.find((ele: any) => ele.firstAddress === true && ele.dafault === true)

  if (address && typeof address != 'string') {
    if (typeof address == 'object') {
      let data = enquiryInfo && enquiryInfo.data && enquiryInfo.data.data && enquiryInfo.data.data.length > 0 && enquiryInfo.data.data[0].shiftToPartyCustomerNumber ? address.find((item: any) => item.shiftToPartyCustomerNumber === enquiryInfo.data.data[0].shiftToPartyCustomerNumber) : address.find((item: any) => item.firstAddress)
      if (data) {
        address = `${data.shiftToPartyCustomerNumber}, ${data.transportationZone ? `${data.transportationZone},` : ''} ${data.location ? `${data.location},` : data.companyName ? `${data.companyName},` : ''} ${data.city ? `${data.city},` : ''} ${data.streetName}`
        // `${data.streetName}, ${data.region}, ${data.city}, ${data.country} ,${data.postalCode}`
      } else {
        address = ``
      }
    } else {
      address = ""
    }
  }

  const defaultAddressId = profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.defaultAddressId && profileDetails.data.data.customerInfo.defaultAddressId;
  const handleAvailabilityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAvailability(event.target.value);
  };



  useEffect(() => {
    if (enquiryAction === 'view' || enquiryAction === 'update') {
      setOpenEnquiry(true);
      if (enquiryInfo && enquiryInfo.data && enquiryInfo.data.data && enquiryInfo.data.data.length > 0) {

        // dispatch(getEnquiryDetails(customerTierType,
        //   enquiryInfo.data.data[0].B2bEnquiryId,
        //   (enquiryAction === "view" && orderType !== "Cancelled") ? true : false, false
        // ));

        // dispatch(getOrderLogs(enquiryInfo.data.data[0].B2bEnquiryId));

        setMultipleAddressData(enquiryInfo.data.data[0].hasOwnProperty('shiftToPartyCustomerNumber') ? enquiryInfo.data.data[0].shiftToPartyCustomerNumber : enquiryInfo.data.data[0].customerId);
        setCollectionAddressData(collectionPoints && collectionPoints.length > 0 && collectionPoints[0].defineTPCounter)
        if (!customerTierType) {
          if (enquiryInfo.data.data[0].customerType === 'int. business') {
            setCustomerTierType("Int. Business");
          } else {
            if (enquiryInfo.data.data[0].customerType) {
              setCustomerTierType(enquiryInfo.data.data[0].customerType.charAt(0).toUpperCase() + enquiryInfo.data.data[0].customerType.slice(1));
            }
          }
        }
      }
    } else {
      let defaultAddress = addressData && addressData.length > 0 && addressData.find((ele: any) => ele.id === defaultAddressId)
      let firstAddresses = addressData && addressData.length > 0 && addressData.find((ele: any) => ele.firstAddress === true && ele.dafault === true)
      if (customerTierType && customerTierType.toLowerCase() !== "workshop" && customerTierType.toLowerCase() !== "tpcdealer") {
        if (defaultAddress && defaultAddress.shiftToPartyCustomerNumber)
          setMultipleAddressData(defaultAddress && defaultAddress.shiftToPartyCustomerNumber);
      }
      // if (profileDetails && profileDetails?.data?.data?.basicInfo?.enquiryGridPreferences) {
      //   setColumnPreferences(profileDetails?.data?.data?.basicInfo?.enquiryGridPreferences)
      // }
      if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && deliveryType === "DLV") {
        if (defaultAddress && defaultAddress.shiftToPartyCustomerNumber)
          setMultipleAddressData(defaultAddress && defaultAddress.shiftToPartyCustomerNumber);
      } else if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && deliveryType === "SELF-PIC") {
        setMultipleAddressData(firstAddresses && firstAddresses.shiftToPartyCustomerNumber);
        setCollectionAddressData(collectionPoints && collectionPoints.length > 0 && collectionPoints[0].defineTPCounter)
      }
    }
  }, [enquiryAction, profileDetails, getCustomerDetailsBySapId, enquiryInfo])

  useEffect(() => {
    if (enquiryAction === 'view' || enquiryAction === 'update') {
      if (enquiryInfo && enquiryInfo.data && enquiryInfo.data.data && enquiryInfo.data.data.length > 0) {
        enquiryInfo && enquiryInfo.data && enquiryInfo.data.data && enquiryInfo.data.data.map((ele: any) => {
          setGetCustomerNameonView(ele && ele.customerName);
          setGetCustomerSapIdonView(ele && ele.customerId);
          sessionStorage.setItem("CompanyName", ele && ele.customerName);
          sessionStorage.setItem("selectedSapCustomerId", ele && ele.customerId);
          sessionStorage.setItem("orderCreatedBy", ele && ele.salesData && ele.salesData.orderCreatedFor);
          sessionStorage.setItem("selectedOfficeTitle", ele && ele.salesData && ele.salesData.salesOffice);
          sessionStorage.setItem("selectOffice", ele && ele.salesData && ele.salesData.salesOffice);
          sessionStorage.setItem("orderType", ele && ele.salesData && ele.salesData.orderType);
          sessionStorage.setItem("customerTypeofCustomer", ele && ele.customerType && ele.customerType.toLowerCase());
          sessionStorage.setItem('teSalesOffice', ele && ele.salesData && ele.salesData.salesOffice)
        })
      }
    }
  }, [enquiryAction, enquiryInfo, profileDetails])

  const handleopenCloseOrderSummary = (open?: any) => {
    setOpenOrderSummary(open ? true : false);
    setIsEnquiryStarted(false);
    open && window.history.replaceState(null, "", "/ordersummarypayment");
  };

  const handleopenCloseSnackbar = (open?: any) => {
    setOpenSnackbar(open ? true : false);
  };

  const handleCloseSpecialPrice = () => {
    // setOpenSpecialPrice(false);
  }

  const handleChangeDeliveryType = (e: any) => {
    setDeliveryType(e.target.value);
    if (e.target.value === "SELF-PIC") {
      setCollectionAddressData(collectionPoints && collectionPoints.length > 0 && collectionPoints[0].defineTPCounter)
    }
    setChangingDeliveryTypeColor("blanchedalmond")
    setTimeout(() => {
      setChangingDeliveryTypeColor("white")
    }, 3000);
  }

  React.useEffect(() => {
    setShowFilterMenu(false)
    dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
    if (sessionStorage.getItem('isCopyandCreate') === 'true') {
      checkSessionStorage(true);
    } else {
      checkSessionStorage();
      setMasterIDData(null);
      setStatusSuccessChecked(false);
      return () => {
        dispatch(requestModifyData(false))
      }
    }
  }, [location.pathname]);

  // function getRemovedProducts(enquiryDetailsData: any) {
  //   if (!enquiryDetailsData || !Array.isArray(enquiryDetailsData)) {
  //     return null; // Return null if the structure is invalid
  //   }

  //   for (const item of enquiryDetailsData) {
  //     if (item.removedProducts && Array.isArray(item.removedProducts) && item.removedProducts.length > 0) {
  //       return item.removedProducts; // Return the first matching removedProducts
  //     }
  //   }
  // }

  function getRemovedProducts(enquiryDetailsData: any) {
    if (!enquiryDetailsData || !Array.isArray(enquiryDetailsData)) {
      return null; // Return null if the structure is invalid
    }

    let largestObject: any = null; // To store the object with the largest removedProducts array
    let maxLength = 0; // To keep track of the largest length

    for (const item of enquiryDetailsData) {
      if (item.removedProducts && Array.isArray(item.removedProducts)) {
        if (item.removedProducts.length > maxLength) {
          maxLength = item.removedProducts.length;
          largestObject = item.removedProducts; // Update the largest object
        }
      }
    }

    if (largestObject) {
      // Tyre parts that were searched but never "Add to Order Enquiry"-ed are not real
      // problem/invalid parts — keep them out of invalidParts so they never trigger the
      // delete-invalid-parts API and never render as "Material Not Extended" in the grid.
      const notYetAddedTyreProductIds = new Set(
        products
          .filter((p: any) => p.accessTyres === true && p.isAddToEnquiry === false)
          .map((p: any) => p.productId)
      );
      if (notYetAddedTyreProductIds.size > 0) {
        largestObject = largestObject.filter((item: any) => !notYetAddedTyreProductIds.has(item.productId));
      }
    }

    return largestObject; // Return the object with the largest removedProducts
  }

  const deleteProblemParts = async (b2bEnquiryId: any, invalidp?: any, isManualDelete: any = false) => {
    let parts: any = invalidp;
    if (!isManualDelete) {
      parts = invalidp && invalidp.length > 0 ? invalidp : [...invalidParts];
    }

    // Never send searched-but-not-yet-added-to-enquiry tyre parts (accessTyres && isAddToEnquiry
    // === false) to the delete-invalid-parts API — they are not real invalid/problem parts.
    const notYetAddedTyreProductIds = new Set(
      products
        .filter((p: any) => p.accessTyres === true && p.isAddToEnquiry === false)
        .map((p: any) => p.productId)
    );
    if (notYetAddedTyreProductIds.size > 0) {
      parts = parts.filter((item: any) => !notYetAddedTyreProductIds.has(item.productId));
    }

    let removedProduct: any;
    if (annexureEnquiry === 'true') {
      removedProduct = parts.map((data: any) => (
        {
          quantity: data.quantity,
          invalidMaterialGroup: data.invalidMaterialGroup,
          isAnnexureEnquiry: data.annexureDetails ? true : false,
          searchPartNumber: data.searchPartNumber,
          isParentPart: data.isParentPart,
          isChildPart: data.isChildPart,
          brandName: data.brandName,
          type: data.type,
          productId: data.productId,
          isZeroPrice: isAvailabiityChecked ? (data.nsp && data.nsp === "0.00") || (data.nsp && parseFloat(data.nsp) === 0) ? true : false : false,
          noAccessToBrand: data.isMaterialNotExtended ? false : !data.invalidMaterialGroup ? false : `${enquiryMapping[`${formatMaterialGroup(data.invalidMaterialGroup)}`]}` !== 'undefined' ? true : true,
          enquiryReferenceNumber: data.enquiryReferenceNumber !== '' ? data.enquiryReferenceNumber : referenceNumber,
          action: "D",
          isValid: false,
          error: data?.error ? data.error : '',
          status: data.isMaterialNotExtended
            ? 'Material Not Extended to Plant'
            : !data.invalidMaterialGroup
              ? 'Does not belong to Annexure/Core Products list' : enquiryMapping[formatMaterialGroup(data.invalidMaterialGroup)] !== undefined
                ? (
                  isTBLAccess() &&
                  enquiryMapping[formatMaterialGroup(data.invalidMaterialGroup)] === 'TBL'
                )
                  ? 'Tyres and Batteries Article'
                  : `No access to ${getBrandDisplayName(
                    enquiryMapping[
                    formatMaterialGroup(data.invalidMaterialGroup)
                    ]
                  )} Brand`
                : 'No access to Brand',
          productIdDescription: data.productIdDescription,
          orgId: "",
          seq: data.seq ? data.seq : data.actualIndex,
          isManualDelete: isManualDelete
        }));
    } else {
      removedProduct = parts.map((data: any) => (
        {
          quantity: data.quantity,
          invalidMaterialGroup: data.invalidMaterialGroup,
          productId: data.productId,
          searchPartNumber: data.searchPartNumber,
          isParentPart: data.isParentPart,
          isChildPart: data.isChildPart,
          brandName: data.brandName,
          type: data.type,
          isZeroPrice: isAvailabiityChecked ? (data.nsp && data.nsp === "0.00") || (data.nsp && parseFloat(data.nsp) === 0) ? true : false : false,
          noAccessToBrand: data.isMaterialNotExtended ? false : !data.invalidMaterialGroup ? false : `${enquiryMapping[`${formatMaterialGroup(data.invalidMaterialGroup)}`]}` !== 'undefined' ? true : true,
          enquiryReferenceNumber: data.enquiryReferenceNumber !== '' ? data.enquiryReferenceNumber : referenceNumber,
          action: "D",
          isValid: false,
          status: data.isMaterialNotExtended
            ? 'Material Not Extended to Plant'
            : !data.invalidMaterialGroup
              ? 'Invalid Part' : enquiryMapping[formatMaterialGroup(data.invalidMaterialGroup)] !== undefined
                ? (
                  isTBLAccess() &&
                  enquiryMapping[formatMaterialGroup(data.invalidMaterialGroup)] === 'TBL'
                )
                  ? 'Tyres and Batteries Article'
                  : `No access to ${getBrandDisplayName(
                    enquiryMapping[
                    formatMaterialGroup(data.invalidMaterialGroup)
                    ]
                  )} Brand`
                : 'No access to Brand',
          productIdDescription: data.productIdDescription,
          orgId: "",
          seq: data.seq ? data.seq : data.actualIndex,
          isManualDelete: isManualDelete
        }));
    }

    let uniqueProducts: any;
    if (removedProduct && removedProduct.length > 0) {
      // Remove duplicates based on seq and productId
      uniqueProducts = removedProduct.filter((product: any, index: any, self: any) =>
        index === self.findIndex((p: any) =>
          p.seq === product.seq && p.productId === product.productId
        )
      );
      // Remove items where isZeroPrice is true
      uniqueProducts = uniqueProducts.filter((product: any) => !product.isZeroPrice);
    }
    let payload: any = {
      "b2bEnquiryId": enquiryId ? enquiryId : b2bEnquiryId,
      "removedProduct": uniqueProducts,
      "sessionDetails": {
        "clientIPAddress": sessionStorage.getItem('clientIp'),
        "webApplicationLoginId": sessionStorage.getItem('webApplicationLoginId'),
      }
    }
    if ((b2bEnquiryId || enquiryId) && uniqueProducts && uniqueProducts?.length > 0) {
      await dispatch(deleteInvalidParts(payload));
      // let savedData: any = await dispatch(getEnquiryDetails(customerTierType,
      //   enquiryId ? enquiryId : b2bEnquiryId ? b2bEnquiryId : enquiryData &&
      //     Array.isArray(enquiryData) &&
      //     enquiryData.length > 0 &&
      //     enquiryData[0].B2bEnquiryId
      //     ? enquiryData[0].B2bEnquiryId
      //     : enquiryId,
      //   (enquiryAction === "view" && orderType !== "Cancelled") ? true : false, false
      // ));
      setIscallAPI(false);
      dispatch(setEnquiryId(null));
      // if (savedData && savedData.data && savedData.data.data && savedData.data.data.length > 0 && savedData.data.data[0].removedProducts) {
      //   setRemovedProductsLength(savedData.data.data[0].removedProducts.length)
      //   setInvalidParts([...savedData.data.data[0].removedProducts]);
      //   // setIscallAPI(false);
      // }
    }
  }

  const sendOrderLogsEmail = async (selectedItems: any) => {
    let data: any = {
      "webApplicationLoginId": sessionStorage.getItem('webApplicationLoginId'),
      selectedOrderLogs: selectedItems,
      "sessionDetails": {
        "clientIPAddress": sessionStorage.getItem('clientIp'),
        "webApplicationLoginId": sessionStorage.getItem('webApplicationLoginId'),
      },
      "userName": firstName,
      "userId": b2cUserId,
      "enquirySessionId": `b2bLSR${enquirySessionId}`,
      "customerType": customerTierType,
      "b2bEnquiryId": enquiryData &&
        Array.isArray(enquiryData) &&
        enquiryData.length > 0 &&
        enquiryData[0].B2bEnquiryId,
      "masterReferenceNumber": enquiryData &&
        Array.isArray(enquiryData) &&
        enquiryData.length > 0 &&
        enquiryData[0].masterReferenceNumber || referenceNumber,
      "customerId": sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ? sessionStorage.getItem("selectedSapCustomerId") : sessionStorage.getItem('customerId'),
      "customerName": sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ? sessionStorage.getItem("CompanyName") : sessionStorage.getItem('customerName')
    }
    let res: any = await dispatch(sendEmailOrderLogs(data));
    if (res && res.error) {
      setOpenSnackbarType("error");
      setOpenErrorSnackbar(true);
      setSuccessMessage(res.error && typeof res.error === 'string' ? res.error : res.message && typeof res.message === 'string' ? res.message : 'Error to send email');
      handleopenCloseSnackbar(true);
    } else {
      setSuccessMessage(res && res.message && typeof res.message.message == 'string' ? res.message.message : 'Email sent successfully');
      setOpenErrorSnackbar(false);
      handleopenCloseSnackbar(true);
    }
  }


  const isFSEDealerView =
    (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') && customerTypeAccess.includes('dealer');

  const isUpdateEnquiry = sessionStorage.getItem('isUpdateEnquiry') ?? '';

  function getSendMailFlag() {
    /* always fetch fresh value */
    return sessionStorage.getItem('sendMailIsUpdateEnquiry') ?? '';
  }

  function buildAnnexureData(
    products: Array<{
      annexureDetails?: { partNumber?: string; brand?: string };
      products?: Array<{ annexureDetails?: { partNumber?: string; brand?: string } }>;
    }>
  ): Array<{ partNumber: string; brand: string }> {
    let source: Array<{ annexureDetails?: { partNumber?: string; brand?: string } }> = [];

    if (products?.length) {
      source = Array.isArray(products[0]?.products)
        ? (products as any).flatMap((e: any) => e.products ?? [])
        : products;
    }
    if (!source.length && Array.isArray(enquiryData) && enquiryData.length) {
      source = enquiryData.flatMap((e: any) => e.products ?? []);
    }

    return source.reduce<Array<{ partNumber: string; brand: string }>>((acc, p) => {
      const ad = p.annexureDetails;
      if (ad?.partNumber && ad?.brand) {
        acc.push({ partNumber: ad.partNumber.trim(), brand: ad.brand.trim().toUpperCase() });
      }
      return acc;
    }, []);
  }

  const emailSentRef = React.useRef(false);
  const timerIdRef = React.useRef<NodeJS.Timeout | null>(null);
  const annexureRef = React.useRef<{ partNumber: string; brand: string }[]>([]);
  const firstRenderRef = React.useRef(true);
  const isSwitchEnquiryRef = useRef(false);

  useEffect(() => {
    const currentPath = window.location.pathname.toLowerCase();
    const prevPath = prevPathRef.current;

    // Check if switching between createEnquiry and annexureCreateEnquiry
    if (
      (currentPath.includes("createenquiry") &&
        prevPath?.includes("annexurecreateenquiry")) ||
      (currentPath.includes("annexurecreateenquiry") &&
        prevPath?.includes("createenquiry"))
    ) {
      resetData();
      isSwitchEnquiryRef.current = true; // mark switch as happened
    }

    // Store current path for next render
    prevPathRef.current = currentPath;
  }, [window.location.pathname]);

  React.useEffect(() => {
    const orderPlaced =
      orderData && (typeof orderData !== 'object' ? true : Object.keys(orderData).length > 0);
    if (orderPlaced) {
      clearTimeout(timerIdRef.current!);
      timerIdRef.current = null;
      emailSentRef.current = true;
    }
  }, [orderData]);

  React.useEffect(() => {
    if (viewEnquiry === 'true') return;
    if (isFSEDealerView) return;

    const inDealerAnnexureFlow =
      annexureEnquiry === 'true' && isAnnexurePartAccess && (customerTierType === 'Dealer' || customerTypeAccess.includes('dealer'));
    if (!inDealerAnnexureFlow) return;

    if (!isAvailabiityChecked) return;
    if (orderData !== null && Object.keys(orderData ?? {}).length) return;
    if (!isAvailabiityCheckedAtTime) return;

    if (!annexureRef.current.length) annexureRef.current = buildAnnexureData(products);
    if (!annexureRef.current.length) return;

    const EXPIRY_MS = 5 * 60_000;
    const startMs = isAvailabiityCheckedAtTime.getTime();
    const elapsed = Date.now() - startMs;

    if (elapsed >= EXPIRY_MS) {
      sendMail();
      return;
    }

    if (!timerIdRef.current) timerIdRef.current = setTimeout(sendMail, EXPIRY_MS - elapsed);

    const beforeUnload = () => sendMail();
    window.addEventListener('beforeunload', beforeUnload);
    return () => window.removeEventListener('beforeunload', beforeUnload);
  }, [
    viewEnquiry,
    isFSEDealerView,
    isAvailabiityChecked,
    orderData,
    isAnnexurePartAccess,
    customerTierType,
    annexureEnquiry,
    products,
    enquiryData,
    isAvailabiityCheckedAtTime,
  ]);

  React.useEffect(() => {
    if (firstRenderRef.current) {
      firstRenderRef.current = false;
      return;
    }

    const orderIsEmpty = !orderData || Object.keys(orderData ?? {}).length === 0;

    if (!annexureRef.current.length) annexureRef.current = buildAnnexureData(products);

    if (
      !emailSentRef.current &&
      viewEnquiry !== 'true' &&
      !isFSEDealerView &&
      orderIsEmpty &&
      annexureRef.current.length &&
      (isUpdateEnquiry !== 'true' || getSendMailFlag() === 'true')
    ) {
      sendMail();
    }
  }, [location.key]);

  React.useEffect(() => {
    return () => {
      clearTimeout(timerIdRef.current!);
      sendMail();
    };
  }, []);

  function sendMail() {
    if (emailSentRef.current) return;
    if (viewEnquiry === 'true') return;
    if (isFSEDealerView) return;
    if (orderData !== null && Object.keys(orderData ?? {}).length) return;
    if (!annexureRef.current.length) annexureRef.current = buildAnnexureData(products);
    if (!annexureRef.current.length) return;
    if (isUpdateEnquiry === 'true' && getSendMailFlag() !== 'true') return;

    emailSentRef.current = true;

    sendEmailAnnexurePartsWithoutPlacedOrder({ annexureData: annexureRef.current });
  }

  const sendEmailAnnexurePartsWithoutPlacedOrder = async ({
    annexureData,
  }: {
    annexureData: { partNumber: string; brand: string }[];
  }) => {
    await dispatch(
      sendEmailWihtoutAnnexurePlaceOrder({
        webApplicationLoginId: sessionStorage.getItem('webApplicationLoginId'),
        annexureData,
        enquiryNumber: sessionStorage.getItem('Current-Enquiry-No'),
        customerId:
          sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre'
            ? sessionStorage.getItem('selectedSapCustomerId')
            : sessionStorage.getItem('customerId'),
        customerName:
          sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre'
            ? sessionStorage.getItem('CompanyName')
            : sessionStorage.getItem('customerName'),
      })
    );
  };

  const handleChangeAddress = (e: any) => {
    setMultipleAddressData(e.target.value);
    setCollectionAddressData(e.target.value);
    setChangingAddressTypeColor("blanchedalmond")
    setTimeout(() => {
      setChangingAddressTypeColor("white");
    }, 3000);
  }

  const getSelectedAddress = () => {
    if (multipleAddressData && multipleAddressData !== '' && newAddressData && newAddressData.length > 0) {
      let data: any = newAddressData.find((add: any) => add?.shiftToPartyCustomerNumber === multipleAddressData);
      if (data && Object.keys(data).length > 1)
        return `${data?.shiftToPartyCustomerNumber}, ${data?.transportationZone ? `${data?.transportationZone},` : ''} ${data?.location ? `${data?.location},` : data.companyName ? `${data.companyName},` : ''} ${data.city ? `${data?.city},` : ''} ${data?.streetName}`
    }
  }

  // React.useEffect(() => {
  //   checkSessionStorage();
  //   return () => {
  //     dispatch(requestModifyData(false))
  //   }
  // }, [location.pathname, getCustomerDetailsBySapId]);

  const showImportExcel = sessionStorage.getItem('userType') === 'FSE' ? true : !sessionStorage.getItem('restrictFeat')?.includes(RESTRICTED_ACCESS.UPLOAD_ENQUIRY_EXCEL);

  const checkSessionStorage = async (iscopyandCreate?: any) => {
    if (iscopyandCreate || copyCreateEnquiry) {
      if (sessionStorage.getItem("partsData")) {
        let productsTemp: any = [];
        let partsData = sessionStorage.getItem("partsData");
        // sessionStorage.setItem("partsData", "")
        if (partsData) {
          partsData = JSON.parse(partsData);
          if (customerTierType && customerTierType !== '') {
            if (Array.isArray(partsData)) {
              partsData.map((item) => {
                if (item.productId && item.productId.toString().trim()) {
                  let validParts: any = productsTemp && productsTemp.length > 0 ? productsTemp.filter((p: any) => p.isValid === true) : [];
                  if (validParts && validParts.length < MAX_PARTS) {
                    productsTemp.push({
                      productId: item.productId ? item.productId.toString().trim() : "",
                      quantity:
                        item.quantity && parseInt(item.quantity)
                          ? parseInt(item.quantity)
                          : 1,
                    });
                  } else {
                    setOpenSnackbarType("error");
                    setOpenErrorSnackbar(true);
                    setSuccessMessage('You can upload a maximum of only 750 valid lines');
                    handleopenCloseSnackbar(true);
                    // alert('error')
                  }
                }
              });
              if ((isOESOEM || iamMap.current) && annexureEnquiry !== 'true') {
                commonInsertionLogicIAMMapping(productsTemp, false, true);
              } else {
                commonInsertionLogic(productsTemp, false, true);
              }
            }
          } else {
            if (sessionStorage.getItem('userType') === 'FSE' || userType === "FSE" || sessionStorage.getItem('userType') === 'sre') {
              let cusData: any = await dispatch(getCustomerDetailsByCustomerID(enquiryData && enquiryData.length > 0 && enquiryData[0].customerId))
              sessionStorage.setItem("companyCurrencyType", cusData && cusData.data && cusData.data.companyCurrencyType)
              if (cusData && cusData.data && cusData.data.customerTierType) {
                if (Array.isArray(partsData)) {
                  partsData.map((item) => {
                    if (item.productId && item.productId.toString().trim()) {
                      productsTemp.push({
                        productId: item.productId ? item.productId.toString().trim() : "",
                        quantity:
                          item.quantity && parseInt(item.quantity)
                            ? parseInt(item.quantity)
                            : 1,
                      });
                    }
                  });
                  if ((isOESOEM || iamMap.current) && annexureEnquiry !== 'true') {
                    commonInsertionLogicIAMMapping(productsTemp, false, true, cusData.data.customerTierType);
                  } else {
                    commonInsertionLogic(productsTemp, false, true, cusData.data.customerTierType);
                  }
                }
              }
            } else {
              if (Array.isArray(partsData)) {
                partsData.map((item) => {
                  if (item.productId && item.productId.toString().trim()) {
                    let validParts: any = productsTemp && productsTemp.length > 0 ? productsTemp.filter((p: any) => p.isValid === true) : [];
                    if (validParts && validParts.length < MAX_PARTS) {
                      productsTemp.push({
                        productId: item.productId ? item.productId.toString().trim() : "",
                        quantity:
                          item.quantity && parseInt(item.quantity)
                            ? parseInt(item.quantity)
                            : 1,
                      });
                    } else {
                      setOpenSnackbarType("error");
                      setOpenErrorSnackbar(true);
                      setSuccessMessage('You can upload a maximum of only 750 valid lines');
                      handleopenCloseSnackbar(true);
                    }
                  }
                });
                if ((isOESOEM || iamMap.current) && annexureEnquiry !== 'true') {
                  commonInsertionLogicIAMMapping(productsTemp, false, true);
                } else {
                  commonInsertionLogic(productsTemp, false, true);
                }
              }
            }
          }
        }
        // sessionStorage.setItem("partsData", "");
      }
    } else {
      if (profileDetails && profileDetails?.data?.data?.customerInfo?.deliveryType === 'SELF-PIC') {
        setDeliveryType(profileDetails?.data?.data?.customerInfo?.deliveryType)
        setCollectionAddressData(collectionPoints && collectionPoints.length > 0 && collectionPoints[0].defineTPCounter)
      } else if (profileDetails && profileDetails?.data?.data?.customerInfo?.deliveryType === 'DLV') {
        setDeliveryType('DLV')
      }
      let enquiryDataExisting: any = sessionStorage.getItem("enquiryModeDetails");
      if (sessionStorage.getItem('isImportFromOES') === 'true' && (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') && !enquiryDataExisting) {
        if (sessionStorage.getItem('isUpdate') !== 'true' && sessionStorage.getItem('isUpdate') !== '') {
          if (!openChooseCustomerDialog) {
            setOpenChooseCustomerDialog(true);
          }
        }
        if (sessionStorage.getItem("partsData") && getChoosenCustomerName !== '' && getChoosenCustomerSapCustomerId !== '') {
          // if (sessionStorage.getItem("partsData")) {
          let productsTemp: any = JSON.parse(JSON.stringify(products));
          let partsData = sessionStorage.getItem("partsData");
          sessionStorage.setItem("partsData", "")
          if (partsData) {
            partsData = JSON.parse(partsData);
            if (Array.isArray(partsData)) {
              partsData.map((item) => {
                if (item.productId && item.productId.toString().trim()) {
                  productsTemp.push({
                    productId: item.productId ? item.productId.toString().trim() : "",
                    quantity:
                      item.quantity && parseInt(item.quantity)
                        ? parseInt(item.quantity)
                        : 1,
                  });
                }
              });
              if ((isOESOEM || iamMap.current) && annexureEnquiry !== 'true') {
                commonInsertionLogicIAMMapping(productsTemp);
              } else {
                commonInsertionLogic(productsTemp);
              }
            }
          }
          sessionStorage.setItem("partsData", "");
        }
      } else {
        let enquiryDataExisting: any = sessionStorage.getItem("enquiryModeDetails");
        sessionStorage.setItem("enquiryModeDetails", "");
        if (enquiryDataExisting && JSON.parse(enquiryDataExisting)) {
          setAddedTyreParts(true);
          enquiryDataExisting = JSON.parse(enquiryDataExisting);
          setenquiryAction(enquiryDataExisting.mode);
          setOrderType(enquiryDataExisting.orderType);
          setQuotation(enquiryDataExisting && enquiryDataExisting.quotation && JSON.parse(enquiryDataExisting.quotation) ? true : false)
          setproducts([]);
          let savedData: any = await dispatch(
            getEnquiryDetails(customerTierType, enquiryDataExisting.masterId,
              (enquiryDataExisting && enquiryDataExisting.mode && enquiryDataExisting.mode === "view" && enquiryDataExisting && enquiryDataExisting.orderType && enquiryDataExisting.orderType !== "Cancelled") ? true : false, enquiryDataExisting && enquiryDataExisting.quotation ? true : false)
          );
          await getOrderLogsData(savedData?.data);
          let rmpro: any = await getRemovedProducts(savedData?.data?.data);
          const invalidRemovedProducts = rmpro?.filter((item: any) => item.isValid === false)
            || savedData?.data?.data[0]?.removedProducts?.filter((item: any) => item.isValid === false)
            || [];

          setInvalidParts(invalidRemovedProducts);
          setRemovedProductsLength(invalidRemovedProducts.length);
          // enquiry changed in case of problem parts start
          let hasEnquiryChanged;
          if (savedData.data && savedData.data.data && savedData.data.data.length > 0 && (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') && enquiryAction !== "view") {
            hasEnquiryChanged = savedData.data.data.some((item: any) => item.status && (item.status.toLowerCase() === "enquiry changed"));
          }
          if ((hasEnquiryChanged || sessionStorage.getItem("isProblemParts") === "true") && (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') && enquiryAction !== "view") {
            const productIds = savedData.data.data.flatMap((item: any) =>
              item.products.filter((product: any) => product.isMaterialNotExtended && product.productId)
                .map((product: any) => product.productId));
            if (productIds && productIds.length > 0) {
              setMaterialNotExtendedPart(productIds);
              openZeroPricePopup(true);
              // if (selectedAccessType !== "Parts" && isTyrePartsSearchSuccessFully === true && isTyrePartsAddedtoGrid === true && customerTierType && customerTierType.toLowerCase() === 'tbl dealer') {
              //   setisAvailabiityChecked(true);
              // } else if (selectedAccessType === "Parts" && customerTierType && customerTierType.toLowerCase() === 'tbl dealer') {
              //   setisAvailabiityChecked(true);
              // } else if (customerTierType && customerTierType.toLowerCase() !== "tbl dealer") {
              //   setisAvailabiityChecked(true);
              // }
              setisAvailabiityChecked(true);
              setIsQueue(false);
              setCheckAvailabilityButtonText(CHECK_AVAILABILITY_BUTTON_TEXT.NORMAL)
            }
          }
          // enquiry changed in case of problem parts end

          if (savedData.data && savedData.data.data && savedData.data.data.length > 0 && savedData.data.data[0].status && savedData.data.data[0].status === "Verification Completed" && (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') && sessionStorage.getItem('updateAPICall') === "true" && enquiryAction !== "view") {
            setLoading(true);
            setIsQueue(false);
            if (savedData.data.data[0].deliveryType === 'Onsite Delivery') {
              setDeliveryType('DLV')
            }
            if (savedData.data.data[0].deliveryType === 'Self Pickup') {
              setDeliveryType('SELF-PIC')
              setCollectionAddressData(collectionPoints && collectionPoints.length > 0 && collectionPoints[0].defineTPCounter)
            }
            let enquiryDetailsQueueCheckData: any = await dispatch(verifyEnquiryQueueCheck(savedData.data.data[0].customerType || customerTierType, savedData.data.data[0].B2bEnquiryId, savedData.data.data[0].customerId));
            let verificationData: any = []
            let hasConfirmationData = true;
            if (enquiryDetailsQueueCheckData && Array.isArray(enquiryDetailsQueueCheckData.data)) {
              setLoading(false);
              enquiryDetailsQueueCheckData.data.map((item: any) => {
                if (item && item.confirmations && Array.isArray(item.confirmations) && item.confirmations.length > 0) {
                  verificationData.push({
                    verifiedData: item
                  })
                } else {
                  hasConfirmationData = false;
                }
              })
            }
            if (hasConfirmationData || (verificationData && verificationData.length > 0)) {
              await enquiryDataToEditMode(savedData && savedData.data && savedData.data.data, true, false, enquiryDataExisting.mode);
              // if (selectedAccessType !== "Parts" && isTyrePartsSearchSuccessFully === true && isTyrePartsAddedtoGrid === true && customerTierType && customerTierType.toLowerCase() === 'tbl dealer') {
              //   setisAvailabiityChecked(true);
              // } else if (selectedAccessType === "Parts" && customerTierType && customerTierType.toLowerCase() === 'tbl dealer') {
              //   setisAvailabiityChecked(true);
              // } else if (customerTierType && customerTierType.toLowerCase() !== "tbl dealer") {
              //   setisAvailabiityChecked(true);
              // }
              setisAvailabiityChecked(true);
              setDisableQuotation(false);
              setorderQueued(false);
              setIsTimmerExpired(false); // Reset the expired flag to allow timer restart
              setisAvailabiityCheckedAtTime(new Date()); // Reset the timer start time
              await verifyEnquiryDataToEditMode(verificationData, savedData.data.data, false, true, null, true);
              setLoading(false);
              // await updateOnly(savedData.data.data[0].products, undefined, undefined, savedData.data.data);
            }

            // Additional required if not remove
            if (savedData.data.data.length > 0 && (savedData.data.data[0].shiftToPartyCustomerNumber || savedData.data.data[0].customerId)) {
              setMultipleAddressData(savedData.data.data[0].hasOwnProperty('shiftToPartyCustomerNumber') ? savedData.data.data[0].shiftToPartyCustomerNumber : savedData.data.data[0].customerId)
            } else {
              let firstAddresses = addressData && addressData.length > 0 && addressData.find((ele: any) => ele.firstAddress === true && ele.dafault === true)
              setMultipleAddressData(firstAddresses && firstAddresses.shiftToPartyCustomerNumber);
            }
            dispatch(getUniqueEnquirySessionId(savedData && savedData.data && savedData.data.data && savedData.data.data.length > 0 && savedData.data.data[0].b2bLostSalesReportId ? savedData.data.data[0].b2bLostSalesReportId : getUniqueTimestamp()));
            setenquiryData(savedData?.data?.data);
            await getOrderLogsData(savedData.data);
            // let orderLogCount: any = 0;

            // savedData.data.data.forEach((ele: any) => {
            //   if (ele && ele.orderLogs) {
            //     const { orderLogs } = ele
            //     orderLogCount += orderLogs?.unReadCount
            //   }
            // })
            // setOrderLogBadgeCount(orderLogCount);
            setGetVerifyData(savedData)

            // Additional required if not remove

          } else {
            let sum: any = 0;
            let alength: any = 0;
            let individualPrice: any = [];
            if (savedData.data && savedData.data.data && savedData.data.data.length > 0) {
              if (enquiryDataExisting.mode === "view" && (sessionStorage.getItem('userType') === 'FSE' || userType === "FSE" || sessionStorage.getItem('userType') === 'sre')) {
                let savedUserData: any = await dispatch(getCustomerDetailsByCustomerID(savedData.data.data[0].customerId));
                sessionStorage.setItem("companyCurrencyType", savedUserData && savedUserData.data && savedUserData.data.companyCurrencyType)
              }
              if (savedData.data.data[0].deliveryType === 'Onsite Delivery') {
                setDeliveryType('DLV')
              }
              if (savedData.data.data[0].deliveryType === 'Self Pickup') {
                setDeliveryType('SELF-PIC')
                setCollectionAddressData(collectionPoints && collectionPoints.length > 0 && collectionPoints[0].defineTPCounter)
              }
              savedData.data.data.map((data: any) => {
                if (data && data.estimatedTotal) {
                  individualPrice.push({ salesoffice: data.salesoffice, total: data.estimatedTotal })
                  sum = parseFloat(sum) + parseFloat(data.estimatedTotal)
                }
                if (data && data.products) {
                  alength = alength + data.products.length;
                }
              });
              if (savedData.data.data.length > 0 && (savedData.data.data[0].shiftToPartyCustomerNumber || savedData.data.data[0].customerId)) {
                setMultipleAddressData(savedData.data.data[0].hasOwnProperty('shiftToPartyCustomerNumber') ? savedData.data.data[0].shiftToPartyCustomerNumber : savedData.data.data[0].customerId)
              } else {
                let firstAddresses = addressData && addressData.length > 0 && addressData.find((ele: any) => ele.firstAddress === true && ele.dafault === true)
                setMultipleAddressData(firstAddresses && firstAddresses.shiftToPartyCustomerNumber);
              }
              setEstimatedTotal(sum);
              setIndividialPrice(individualPrice)
              setActualProductLength(alength);
            }
            await enquiryDataToEditMode(savedData && savedData.data && savedData.data.data, true, false, enquiryDataExisting.mode);
            setisAvailabiityChecked(true);
            setLoading(false);
            dispatch(getUniqueEnquirySessionId(savedData && savedData.data && savedData.data.data && savedData.data.data.length > 0 && savedData.data.data[0].b2bLostSalesReportId ? savedData.data.data[0].b2bLostSalesReportId : getUniqueTimestamp()));
            setenquiryData(savedData?.data?.data);
            setGetVerifyData(savedData)
          }
        } else if (sessionStorage.getItem("partsData")) {
          let productsTemp: any = JSON.parse(JSON.stringify(products));
          let partsData = sessionStorage.getItem("partsData");
          sessionStorage.setItem("partsData", "")
          if (partsData) {
            partsData = JSON.parse(partsData);
            if (Array.isArray(partsData)) {
              partsData.map((item) => {
                if (item.productId && item.productId.toString().trim()) {
                  let validParts: any = productsTemp && productsTemp.length > 0 ? productsTemp.filter((p: any) => p.isValid === true) : [];
                  if (validParts && validParts.length < MAX_PARTS) {
                    productsTemp.push({
                      productId: item.productId ? item.productId.toString().trim() : "",
                      quantity:
                        item.quantity && parseInt(item.quantity)
                          ? parseInt(item.quantity)
                          : 1,
                    });
                  } else {
                    setOpenSnackbarType("error");
                    setOpenErrorSnackbar(true);
                    setSuccessMessage('You can upload a maximum of only 750 valid lines');
                    handleopenCloseSnackbar(true);
                  }
                }
              });
              if ((isOESOEM || iamMap.current) && annexureEnquiry !== 'true') {
                commonInsertionLogicIAMMapping(productsTemp);
              } else {
                commonInsertionLogic(productsTemp);
              }
            }
          }
          sessionStorage.setItem("partsData", "");
        }
      }
    }
  };

  const getCounter = () => {
    if (isAvailabiityCheckedAtTime) {
      const now = moment(new Date());
      const start = moment(new Date(isAvailabiityCheckedAtTime));
      const duration: any = moment.duration(start.diff(now));
      const minutes: any = Math.abs(duration.asMinutes());
      if (!isAvailabiityCheckedAtTime || (minutes && minutes > 5)) {
        return (
          <>
            <br />
            <span className="text-danger px-2">(Availability Expired)</span>
          </>
        );
      } else {
        return (
          <>
            <br />
            {isTimmerExpired === true ? "" : (
              <span>
                <p
                  className="pt-1 px-2"
                  style={{ fontSize: "12px", color: "#6c757d" }}
                >
                  Please submit your order in{" "}
                  <span
                    style={{
                      backgroundColor: "#212529",
                      background: "#5a5a5a",
                      color: "#fff",
                      padding: "2px 10px",
                      borderRadius: "4px",
                      fontWeight: "bold",
                    }}
                  >
                    <Countdown
                      date={isAvailabiityCheckedAtTime.getTime() + 300000}
                      renderer={renderer}
                    />
                  </span>
                </p>
              </span>
            )}
          </>
        );
      }
    } else {
      return null;
    }
  };

  const renderer = ({ minutes, seconds, completed }: any) => {
    if (completed) {
      setplaceorderEnabled(false);
      setIsTimmerExpired(true);
      return (
        <>
          <br />
          <span className="text-danger px-2">(Availability Expired)</span>
        </>
      );
    } else {
      // Existing logic retained
      if (procuredPart && procuredPart.length > 0) {
        setisAvailabiityChecked(true);
        setplaceorderEnabled(true);
      } else {
        setisAvailabiityChecked(true);
        setplaceorderEnabled(true);
      }
      const formattedMinutes = String(minutes).padStart(2, '0');
      const formattedSeconds = String(seconds).padStart(2, '0');
      return <span>{formattedMinutes}:{formattedSeconds} mins</span>;
    }
  };

  const handleopenCloseConfirmPopup = (open?: any) => {
    setConfirmDialog(open ? true : false);
  };

  // const isProcurementPartExist = () => {
  //   let data: any = [];
  //   if (products && products.length > 0 && procuredPart && procuredPart.length > 0) {
  //     products.map((p: any) => {
  //       if (procuredPart.includes(p.id)) data.push(true)
  //     })
  //   }
  //   if (data && data.length > 0) {
  //   }
  // }

  useEffect(() => {
    history.listen((location: any) => {
      if (history.action === 'PUSH') {
        setorderData(null);
        setVerificationData(null);
        setcheckedAllNow(false);
        setIsBackorder(false);
        setIsQuantityUpdated(false);
        setRemovedProductsLength(0);
        setIsInvalidPartsExist(false);
        setChecked24hrs(false);
        setIscallAPI(false);
        setcheckedAllBO(false);
        setproducts([]);
        setActualProductLength(0)
        setInvalidParts([]);
        setSearchBypartNumber('');
        setSelectedPartImages([]);
        setCheckedRows([]);
        setShowDropdown(false);
        setenquiryData(null);
        setMaterialNotExtendedPart([]);
        setproductId("");
        setorderTotal(0);
        setquantity('');
        setorderQueued(false)
        setisAvailabiityChecked(false);
        setIsTyrePartsAddedtoGrid(false);
        setIsTyrePartsSearchSuccessFully(false);
        setCheckAvailabilityButtonText(CHECK_AVAILABILITY_BUTTON_TEXT.NORMAL)
        setisAvailabiityCheckedAtTime(null);
        setisEnquirySaved(false);
        setGetVerifyData(null);
        setSuccessMessage(null);
        setOpenSnackbar(false);
        openZeroPricePopup(false);
        setZeroProducts([]);
        setOpenSnackbarType("");
        setOpenOrderSummary(false);
        setisUpdateMode(false);
        setisSelectedAll(false);
        setenquiryAction("");
        setreferenceNumber("");
        setDeliveryType(deliveryTypeData);
        setchangeData(null);
        setSalesOffice("");
        sessionStorage.setItem('teSalesOffice', "");
        setAvailability("All");
        setprocuredPart([]);
        setEstimatedTotal(0);
        setIndividialPrice([]);
        setMultipleAddressData('');
        setCollectionAddressData('');
        setShowFilterMenu(false);
      }
    })
    return () => {
    }
  }, [])


  const resetData = () => {
    setorderData(null);
    setcheckedAllNow(false);
    setVerificationData(null);
    setChecked24hrs(false);
    setSearchBypartNumber('');
    setShowFilterMenu(false);
    setSelectedPartImages([]);
    setCheckedRows([]);
    setShowDropdown(false);
    setcheckedAllBO(false);
    setIscallAPI(false);
    setIsBackorder(false);
    setIsQuantityUpdated(false);
    setRemovedProductsLength(0);
    setIsInvalidPartsExist(false);
    isChangeCheckBox(false);
    setMasterIDData(null);
    setStatusSuccessChecked(false);
    setproducts([]);
    // sessionStorage.setItem("CompanyName", '');
    // sessionStorage.setItem("selectedSapCustomerId", '');
    setActualProductLength(0);
    setInvalidParts([]);
    setproductId("");
    setorderTotal(0);
    setquantity('');
    setorderQueued(false)
    setisAvailabiityChecked(false);
    setIsTyrePartsAddedtoGrid(false);
    setIsTyrePartsSearchSuccessFully(false);
    setCheckAvailabilityButtonText(CHECK_AVAILABILITY_BUTTON_TEXT.NORMAL)
    setisAvailabiityCheckedAtTime(null);
    setisEnquirySaved(false);
    setenquiryData(null);
    setGetVerifyData(null);
    setSuccessMessage(null);
    setOpenSnackbar(false);
    openZeroPricePopup(false);
    setZeroProducts([]);
    setOpenSnackbarType("");
    setOpenOrderSummary(false);
    setisUpdateMode(false);
    setisSelectedAll(false);
    setenquiryAction("");
    setreferenceNumber("");
    setDeliveryType(deliveryTypeData);
    setchangeData(null);
    setSalesOffice("");
    sessionStorage.setItem('teSalesOffice', "");
    setAvailability("All");
    setprocuredPart([]);
    setEstimatedTotal(0);
    setIndividialPrice([]);
    setMaterialNotExtendedPart([]);

  }

  // const commonInsertionLogic = async (jsonData: any, fetchFromRedux?: any, isCopyandcreate?: any, tierType?: any, isCreateNew?: any, isAddToEnquiry?: any) => {
  //   let negativeValuesPresent = false;
  //   if (jsonData && Array.isArray(jsonData) && jsonData.length > 0) {
  //     let orgsAssignedToUser = "";
  //     if (assignedBrandsData && Array.isArray(assignedBrandsData)) {
  //       assignedBrandsData.map((item: any) => {
  //         if (item.salesOrganization) {
  //           orgsAssignedToUser += enquiryMappingReverse[`${orgIdBrandsMapping[`${item.salesOrganization}`]}`] + ",";
  //         }
  //       });
  //     }
  //     let tempData: any = jsonData.filter(
  //       (item: any) => item.productId && item.productId.trim()
  //     );
  //     if (isCopyandcreate) {
  //       if (customerTierType && (customerTierType.toLowerCase() === "tbl dealer" || customerTierType === 'Dealer')) {
  //         let orgArray = orgsAssignedToUser.split(',').filter(Boolean); // removes empty strings
  //         if (!tblDealerAccess.includes('Tyres') && tblDealerAccess.length === 1) {
  //           orgArray = orgArray.filter(org => org !== 'AMPTB'); // ✅ remove AMPTB if Tyres not included
  //         } else if (!tblDealerAccess.includes('Parts') && tblDealerAccess.length === 1) {
  //           orgArray = orgArray.filter(org => org === 'AMPTB'); // ✅ remove ALPOE if Parts not included
  //         }
  //         // Remove duplicates and convert back to comma-separated string
  //         orgsAssignedToUser = [...new Set(orgArray)].join(',') + ',';
  //       }
  //     } else {
  //       if (customerTierType && customerTierType.toLowerCase() === "tbl dealer" || customerTierType === 'Dealer') {
  //         let orgArray = orgsAssignedToUser.split(',').filter(Boolean); // removes empty strings
  //         if (selectedAccessType === 'Tyres' && sessionStorage.getItem('isAddedFromDashboard') === 'false') {
  //           orgArray = orgArray.filter(org => org === 'AMPTB');
  //         } else if (selectedAccessType === 'Parts' || sessionStorage.getItem('isAddedFromDashboard') === 'true') {
  //           orgArray = orgArray.filter(org => org !== 'AMPTB');
  //         }
  //         // Remove duplicates and convert back to comma-separated string
  //         orgsAssignedToUser = [...new Set(orgArray)].join(',') + ',';
  //       }
  //     }

  //     let partsList: any = tempData.map((item: any) => {
  //       return item.productId.trim();
  //     });
  //     let searchProduct: any = [];
  //     tempData.map((item: any) => {
  //       searchProduct.push({ productId: item.productId.trim(), quantity: item.quantity })
  //     })
  //     let apiData: any = await dispatch(searchProducts(customerTierType ? customerTierType : tierType, partsList, enquirySessionId, firstName, sapCustomerId, b2bUserId, searchProduct, region));
  //     let reduxData: any = sessionStorage.getItem("tempProducts");
  //     let productsTemp: any = isCreateNew ? [] : isCopyandcreate ? [] : JSON.parse(
  //       JSON.stringify(
  //         fetchFromRedux && reduxData ? JSON.parse(reduxData) : products
  //       )
  //     );
  //     jsonData.map((item: any) => {
  //       let isInvalidBrand = "";
  //       let isPresent: any =
  //         apiData && apiData.data && apiData.data.length > 0
  //           ? apiData.data.find((responsePart: any) => {
  //             if (responsePart && item.productId && responsePart.productId && responsePart?.productId?.trim()?.toUpperCase() === item.productId.trim().toUpperCase()) {
  //               isInvalidBrand = responsePart?.attributes?.materialGroup?.value;
  //             }
  //             return (
  //               responsePart?.productId?.trim()?.toUpperCase() === item.productId.trim().toUpperCase() &&
  //               formatMaterialGroup(responsePart?.attributes?.materialGroup?.value) &&
  //               orgsAssignedToUser.includes(formatMaterialGroup(responsePart?.attributes?.materialGroup?.value))
  //             );
  //           })
  //           : null;
  //       if (
  //         !(
  //           item.quantity &&
  //           parseInt(item.quantity) &&
  //           parseInt(item.quantity) >= 1
  //         )
  //       ) {
  //         negativeValuesPresent = true;
  //       }
  //       if (
  //         item.quantity &&
  //         parseInt(item.quantity) &&
  //         parseInt(item.quantity) >= 1 &&
  //         item.productId &&
  //         item.productId.trim() &&
  //         productsTemp &&
  //         Array.isArray(productsTemp)
  //       ) {
  //         let containsItem = false;
  //         // productsTemp.map((product: any) => {
  //         //   if (
  //         //     product.productId &&
  //         //     item.productId.trim() &&
  //         //     product.productId === item.productId.trim()
  //         //   ) {
  //         //     product.quantity +=
  //         //       item.quantity && parseInt(item.quantity)
  //         //         ? parseInt(item.quantity) >= 1
  //         //           ? parseInt(item.quantity)
  //         //           : 0
  //         //         : 0;
  //         //     product.quantity = product.quantity && product.quantity.toString() && parseInt(product.quantity.toString().slice(0, 5))
  //         //     containsItem = false;
  //         //   }
  //         //   return product;
  //         // });
  //         if (!containsItem) {
  //           let validParts: any = productsTemp && productsTemp.length > 0 ? productsTemp.filter((p: any) => p.isValid === true) : [];
  //           const mergedArray = [...productsTemp, ...invalidParts];
  //           const seqNumbers = mergedArray.map(obj => obj.seq);
  //           const filteredSeqNumbers = seqNumbers.filter(num => typeof num === 'number' && !isNaN(num));
  //           const maxSeq = filteredSeqNumbers.length === 0 ? seqNumbers.length : Math.max(...filteredSeqNumbers);
  //           const startingSerialNumber = isAvailabiityChecked || invalidParts && invalidParts.length > 0 ? maxSeq + 1 : productsTemp.length + 1;
  //           if (validParts && validParts.length < MAX_PARTS) {
  //             let productId = isPresent && isPresent.productId ? isPresent.productId : item.productId.trim();
  //             productsTemp.push({
  //               quantity:
  //                 item.quantity &&
  //                   parseInt(item.quantity) &&
  //                   parseInt(item.quantity) >= 1
  //                   ? parseInt(item.quantity)
  //                   : 1,
  //               seq: startingSerialNumber,
  //               invalidMaterialGroup: isInvalidBrand ? isInvalidBrand : "",
  //               imageUrls: item.imageUrls && item.imageUrls.length > 0 ? item.imageUrls : getTyreImages(productId, getTBLPartsDetails),
  //               productId: productId,
  //               materialGroup:
  //                 isPresent &&
  //                   isPresent.attributes &&
  //                   isPresent.attributes.materialGroup
  //                   ? isPresent.attributes.materialGroup.value.toUpperCase()
  //                   : "",
  //               productIdDescription:
  //                 isPresent && isPresent.description
  //                   ? isPresent.description["EN"]
  //                   : "",
  //               productCost: 0,
  //               oesSubBrandName: isPresent &&
  //                 isPresent.attributes &&
  //                 isPresent.attributes.productHierarchy
  //                 ? isPresent.attributes.productHierarchy.value
  //                 : "",
  //               currency: sessionStorage.getItem('userType') === 'FSE' ? `${companyCurrencyTypeByFSE}` : customerTierType === "Int. Business" ? `${companyCurrencyType}` : 'AED',
  //               unitOfMeasure:
  //                 isPresent &&
  //                   isPresent.attributes &&
  //                   isPresent.attributes.unitOfMeasure
  //                   ? isPresent.attributes.unitOfMeasure.value
  //                   : "",
  //               VAT: "",
  //               orgId:  "",
  //               accessTyres: selectedAccessType === "Tyres" ? true : false,
  //               accessParts: selectedAccessType === "Parts" ? true : false,
  //               enquiryReferenceNumber: referenceNumber ? referenceNumber : "",
  //               isAddToEnquiry: isAddToEnquiry === false ? false : true,
  //               isSpecialPriced: false,
  //               isSpecialPriceRequestPart: false,
  //               isRejected: false,
  //               nowAvailability: 0,
  //               nowAvailabilityChecked: false,
  //               hrs24Availability: 0,
  //               hrs24AvailabilityChecked: false,
  //               airAvailability: 0,
  //               airAvailabilityChecked: false,
  //               action: "I",
  //               dimensions: {
  //                 height:
  //                   isPresent &&
  //                     isPresent.attributes &&
  //                     isPresent.attributes.height
  //                     ? isPresent.attributes.height.value
  //                     : "",
  //                 width:
  //                   isPresent &&
  //                     isPresent.attributes &&
  //                     isPresent.attributes.width
  //                     ? isPresent.attributes.width.value
  //                     : "",
  //                 length:
  //                   isPresent &&
  //                     isPresent.attributes &&
  //                     isPresent.attributes.length
  //                     ? isPresent.attributes.length.value
  //                     : "",
  //                 volume:
  //                   isPresent &&
  //                     isPresent.attributes &&
  //                     isPresent.attributes.volume
  //                     ? isPresent.attributes.volume.value
  //                     : "",
  //                 grossWeight: isPresent &&
  //                   isPresent.attributes &&
  //                   isPresent.attributes.grossWeight
  //                   ? isPresent.attributes.grossWeight.value
  //                   : "",
  //                 batchYear: isPresent &&
  //                   isPresent.attributes &&
  //                   isPresent.attributes.batchYear
  //                   ? isPresent.attributes.batchYear.value
  //                   : "",
  //               },
  //               attributes: [
  //                 {
  //                   name: "height",
  //                   value:
  //                     isPresent &&
  //                       isPresent.attributes &&
  //                       isPresent.attributes.height
  //                       ? isPresent.attributes.height.value
  //                       : "",
  //                 },
  //                 {
  //                   name: "width",
  //                   value:
  //                     isPresent &&
  //                       isPresent.attributes &&
  //                       isPresent.attributes.width
  //                       ? isPresent.attributes.width.value
  //                       : "",
  //                 },
  //                 {
  //                   name: "length",
  //                   value:
  //                     isPresent &&
  //                       isPresent.attributes &&
  //                       isPresent.attributes.length
  //                       ? isPresent.attributes.length.value
  //                       : "",
  //                 },
  //                 {
  //                   name: "grossWeight",
  //                   value:
  //                     isPresent &&
  //                       isPresent.attributes &&
  //                       isPresent.attributes.grossWeight
  //                       ? isPresent.attributes.grossWeight.value
  //                       : "",
  //                 },
  //                 {
  //                   name: "batchYear",
  //                   value:
  //                     isPresent &&
  //                       isPresent.attributes &&
  //                       isPresent.attributes.batchYear
  //                       ? isPresent.attributes.batchYear.value
  //                       : "",
  //                 },
  //                 {
  //                   name: "volume",
  //                   value:
  //                     isPresent &&
  //                       isPresent.attributes &&
  //                       isPresent.attributes.volume
  //                       ? isPresent.attributes.volume.value
  //                       : "",
  //                 },
  //               ],
  //               plant: "",
  //               nowEnquiryItemNumber: isPresent && isPresent.nowEnquiryItemNumber ? isPresent.nowEnquiryItemNumber : '',
  //               nowProposedItemNumber: "",
  //               // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 24 HRS CODE <<<<<<<<<<<<<<<<<<<<<<<<<<<
  //               hrs24EnquiryItemNumber: isPresent && isPresent.hrs24EnquiryItemNumber ? isPresent.hrs24EnquiryItemNumber : '',
  //               hrs24ProposedItemNumber: "",
  //               // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  //               airEnquiryItemNumber: isPresent && isPresent.airEnquiryItemNumber ? isPresent.airEnquiryItemNumber : '',
  //               airProposedItemNumber: "",
  //               isValid:
  //                 isPresent && isPresent.attributes.materialGroup &&
  //                   isPresent.attributes.materialGroup.value &&
  //                   enquiryMapping[`${formatMaterialGroup(isPresent.attributes.materialGroup.value.toUpperCase())}`]
  //                   ? true
  //                   : false,
  //             });
  //           } else {
  //             setOpenSnackbarType("error");
  //             setOpenErrorSnackbar(true);
  //             setSuccessMessage('You can upload a maximum of only 750 valid lines');
  //             handleopenCloseSnackbar(true);
  //           }
  //         }
  //       } else {
  //         negativeValuesPresent = true;
  //       }
  //     });
  //     let inValidPartsData = productsTemp && productsTemp.length > 0 ? productsTemp.filter((p: any) => p.isValid === false) : [];
  //     inValidPartsData.forEach((part: any, index: any) => {
  //       const actualIndex = productsTemp.findIndex((item: any) => item === part);
  //       part.actualIndex = actualIndex;
  //     });
  //     if (apiData && apiData.data && apiData.data.length > 0) {
  //       setIscallAPI(false);
  //     } else {
  //       setIscallAPI(true);
  //     }

  //     let combinedArray: any = isCopyandcreate ? inValidPartsData : [...inValidPartsData, ...invalidParts];
  //     let uniqueMap = new Map();
  //     combinedArray.forEach((item: any) => {
  //       // Generate a key based on the 'seq' value or the whole object if 'seq' is undefined
  //       let key = item.seq !== undefined ? item.seq.toString() : JSON.stringify(item);

  //       // If the key is not already in the map, add the item
  //       if (!uniqueMap.has(key)) {
  //         uniqueMap.set(key, item);
  //       }
  //     });

  //     // Create an array of unique objects
  //     combinedArray = Array.from(uniqueMap.values());
  //     // Sort the array based on the 'seq' property
  //     combinedArray.sort((a: any, b: any) => {
  //       if (a.seq !== undefined && b.seq !== undefined) {
  //         return a.seq - b.seq; // Sort based on 'seq' if both are defined
  //       } else if (a.seq !== undefined) {
  //         return -1; // 'a' has 'seq', so it should come before 'b'
  //       } else if (b.seq !== undefined) {
  //         return 1; // 'b' has 'seq', so it should come before 'a'
  //       } else {
  //         return 0; // Both 'a' and 'b' have no 'seq', maintain their relative order
  //       }
  //     });


  //     // let seqMap = new Map();
  //     // combinedArray.forEach(item => {
  //     //   if (!seqMap.has(item.seq)) {
  //     //     seqMap.set(item.seq, item);
  //     //   }
  //     // });

  //     // // Get values from the map to retrieve unique items based on 'seq'
  //     // combinedArray = Array.from(seqMap.values());
  //     // combinedArray.sort((a: any, b: any) => a.seq - b.seq);
  //     setInvalidParts(combinedArray);

  //     setproducts(JSON.parse(JSON.stringify(productsTemp)));
  //     if (isCopyandcreate) {
  //     } else {
  //       if ((customerTierType && customerTierType.toLowerCase() === 'tbl dealer' || customerTierType === "Dealer") && selectedAccessType === "Tyres") {
  //         saveUpdateEnquiry(isAddToEnquiry ? false : true, null, productsTemp, isAddToEnquiry);
  //       }
  //     }
  //     // setisAvailabiityChecked(false);
  //   }

  //   if (negativeValuesPresent) {
  //     setOpenSnackbarType("error");
  //     setSuccessMessage(
  //       `Negative quantity values were ignored during the import`
  //     );
  //     handleopenCloseSnackbar(true);
  //   }
  //   // setTimeout(() => {
  //   setproductId("");
  //   setquantity('');


  //   // }, 1000);
  // };

  const hasAlternateParts = (productId: any, data: any) => {
    let hasAlternates = false;
    let alternateParts: any = [];

    // Find the part that has searchParts: true
    let searchPart = data.find((part: any) => part.productId === productId);

    if (!searchPart) {
      return { hasAlternates, alternateParts }; // No primary part found
    }

    let searchPartNumber = productId;
    // Check if any other parts have this part number in searchPartNumber field
    data.forEach((part: any) => {
      if (part.searchParts === false && part.searchPartNumber === searchPartNumber) {
        hasAlternates = true;
        alternateParts.push(part.productId);
      }
    });
    return { hasAlternates, alternateParts };
  }

  function sortParts(data: any[]) {
    if (!Array.isArray(data) || data.length === 0) {
      return data; // Return as is if input is empty or not an array
    }

    let hasParentOrChild = data.some((item) => item.isParentPart || item.isChildPart);

    if (!hasParentOrChild) {
      return data; // Return as is if no parent-child structure exists
    }

    let parentMap = new Map<string, { parent: any | null; children: any[] }>();
    let sortedData: any[] = [];
    let standaloneParts: any[] = [];

    // Group data by parent productId
    data.forEach((item) => {
      if (item.isParentPart) {
        parentMap.set(item.productId, { parent: item, children: [] });
      } else if (item.isChildPart && item.searchPartNumber) {
        if (!parentMap.has(item.searchPartNumber)) {
          parentMap.set(item.searchPartNumber, { parent: null, children: [] });
        }
        parentMap.get(item.searchPartNumber)!.children.push(item);
      } else {
        standaloneParts.push(item); // Items that are neither parent nor child
      }
    });

    // Sort and push parents along with children
    parentMap.forEach(({ parent, children }) => {
      if (parent) {
        sortedData.push(parent);
      }
      sortedData.push(
        ...children.sort((a, b) => (a.materialGroup ? 0 : 1) - (b.materialGroup ? 0 : 1))
      );
    });

    // Add standalone parts at the end
    sortedData.push(...standaloneParts);
    return sortedData;
  }

  const [currentSeq, setCurrentSeq] = React.useState(1);

  const isTBLAccess = () => {
    return brandAccess?.some((item: any) => item.code === "TBL");
  };

  const isOnlyTBLAccess = () => {
    return (
      brandAccess?.length === 1 &&
      brandAccess[0]?.code === "TBL"
    );
  };

  const isPartsAccess = () => {
    return brandAccess?.some((item: any) => item.code !== "TBL");
  };

  // ---------------------------NEW CODE FOR THE COMMONINERSATION LOGIC--------------------------
  const norm = (s: string) => s.replace(/[\s-]/g, "").toUpperCase();
  const isAnnexurePart = (partNo: string) => {
    if (partNo && getAllAnnexureListData) {
      const annexureList = getAllAnnexureListData?.data?.data?.productData || [];
      return annexureList.some((p: any) => norm(p.partNumber) === norm(partNo));
    }
  };
  const commonInsertionLogic = async (
    jsonData: any,
    fetchFromRedux?: any,
    isCopyandcreate?: any,
    tierType?: any,
    isCreateNew?: any,
    isAddToEnquiry?: any,
    tyres?: any
  ) => {
    if (!Array.isArray(jsonData) || jsonData.length === 0) return;
    let negativeValuesPresent = false;
    if (jsonData && Array.isArray(jsonData) && jsonData.length > 0) {
      let orgsAssignedToUser = "";
      if ((assignedBrandsData && Array.isArray(assignedBrandsData)) || (assignedBrandRef.current && Array.isArray(assignedBrandRef.current))) {
        let ass: any = assignedBrandsData ? assignedBrandsData : assignedBrandRef.current
        ass.map((item: any) => {
          if (item.code) {
            orgsAssignedToUser +=
              enquiryMappingReverse[
              `${item.code}`
              ] + ",";
          }
        });
      }
      let tempData: any = jsonData.filter(
        (item: any) => item.productId && item.productId.trim()
      );
      if (isCopyandcreate) {
        if (
          customerTierType &&
          annexureEnquiry !== "true"
        ) {
          let orgArray = orgsAssignedToUser.split(",").filter(Boolean);
          if (!isTBLAccess() && isPartsAccess()) {
            orgArray = orgArray.filter((org) => org !== "AMPTB");
          } else if (!isPartsAccess() && isOnlyTBLAccess()) {
            orgArray = orgArray.filter((org) => org === "AMPTB");
          }
          orgsAssignedToUser = [...new Set(orgArray)].join(",") + ",";
        }
      } else {
        if (
          customerTierType &&
          annexureEnquiry !== "true"
        ) {
          let orgArray = orgsAssignedToUser.split(",").filter(Boolean);
          if (
            selectedAccessType === "Tyres" &&
            sessionStorage.getItem("isAddedFromDashboard") === "false"
          )
            orgArray = orgArray.filter((org) => org === "AMPTB");
          else if (
            selectedAccessType === "Parts" ||
            sessionStorage.getItem("isAddedFromDashboard") === "true"
          )
            orgArray = orgArray.filter((org) => org !== "AMPTB");
          orgsAssignedToUser = [...new Set(orgArray)].join(",") + ",";
        }
      }

      let partsList = tempData.map((i: any) => i.productId.trim());
      let searchProduct = tempData.map((i: any) => ({
        productId: i.productId.trim(),
        quantity: i.quantity,
      }));
      const apiData: any = await dispatch(
        searchProducts(
          customerTierType ? customerTierType : tierType,
          partsList,
          enquirySessionId,
          firstName,
          sapCustomerId,
          b2bUserId,
          searchProduct,
          region,
          annexureEnquiry === 'true' ? true : false
        )
      );

      let reduxData: any = sessionStorage.getItem("tempProducts");
      let productsTemp: any = isCreateNew
        ? []
        : isCopyandcreate
          ? []
          : JSON.parse(
            JSON.stringify(fetchFromRedux && reduxData ? JSON.parse(reduxData) : products)
          );

      // New Tyre search: mark parts left over from the previous search (searched but never
      // "Add to Order Enquiry"-ed) with action "D" so they're removed from the enquiry via the
      // normal update-enquiry call and dropped from the grid, instead of accumulating alongside
      // the new search's results.
      if (tyres && isAddToEnquiry === false && selectedAccessType === "Tyres") {
        const staleTyreProductIds = productsTemp
          .filter((p: any) => p.accessTyres === true && p.isAddToEnquiry === false)
          .map((p: any) => p.productId);
        productsTemp = productsTemp.map((p: any) =>
          // Strip isMaterialNotExtended here — this is an abandoned/replaced search result
          // being cleaned up, not a genuine Material Not Extended removal. Sending action "D"
          // together with isMaterialNotExtended: true makes the backend treat it as a real MNE
          // deletion (order log entry + pushed into removedProducts), showing it red in the
          // grid even though it was never added to the enquiry.
          p.accessTyres === true && p.isAddToEnquiry === false ? { ...p, action: "D", isMaterialNotExtended: false } : p
        );
        clearMaterialNotExtendedTracking(staleTyreProductIds);
      }

      const newInvalidParts: any[] = [];
      tempData.map((item: any) => {
        let isInvalidBrand = "";
        // let isPresent: any =
        //   apiData && apiData.data && apiData.data.length > 0
        //     ? apiData.data.find((responsePart: any) => {
        //       if (responsePart && item.productId && responsePart.productId && responsePart?.productId?.trim()?.toUpperCase() === item.productId.trim().toUpperCase()) {
        //         isInvalidBrand = responsePart?.attributes?.materialGroup?.value;
        //       }
        //       return (
        //         responsePart?.productId?.trim()?.toUpperCase() === item.productId.trim().toUpperCase() &&
        //         formatMaterialGroup(responsePart?.attributes?.materialGroup?.value) &&
        //         orgsAssignedToUser.includes(formatMaterialGroup(responsePart?.attributes?.materialGroup?.value))
        //       );
        //     })
        //     : null;


        const inputProductId = item.productId?.trim()?.toUpperCase();

        let isPresent: any = Array.isArray(apiData?.data) && apiData.data.length > 0
          ? apiData.data.find((responsePart: any) => {
            const responseProductId = responsePart?.productId?.trim()?.toUpperCase();
            const materialGroupVal = responsePart?.attributes?.materialGroup?.value ?? '';
            const formattedGroup = formatMaterialGroup(materialGroupVal ?? '');

            // Set isInvalidBrand if productId matches
            if (responseProductId === inputProductId) {
              isInvalidBrand = materialGroupVal;
            }

            // Return match only if both productId and org match
            return (
              responseProductId === inputProductId &&
              formattedGroup &&
              orgsAssignedToUser.includes(formattedGroup)
            );
          })
          : null;

        if (!(item.quantity && parseInt(item.quantity) >= 1))
          negativeValuesPresent = true;

        if (
          item.quantity &&
          parseInt(item.quantity) >= 1 &&
          item.productId?.trim()
        ) {
          let validParts = productsTemp.filter((p: any) => p.isValid);
          if (validParts.length >= MAX_PARTS) {
            setOpenSnackbarType("error");
            setOpenErrorSnackbar(true);
            //PROD- TEMP- FIXES- 750 CONVERTED TO 99
            setSuccessMessage('You can upload a maximum of only 750 valid lines');
            handleopenCloseSnackbar(true);
            return;
          }

          // Get max seq from productsTemp
          const maxSeqInProducts = productsTemp.length
            ? Math.max(...productsTemp.map((p: any) => p.seq || 0))
            : 0;

          // If invalidParts/newInvalidParts also carry seq, include them:
          const maxSeqInInvalid = invalidParts.length
            ? Math.max(...invalidParts.map((p: any) => p.seq || 0))
            : 0;

          const maxSeqInNewInvalid = newInvalidParts.length
            ? Math.max(...newInvalidParts.map((p: any) => p.seq || 0))
            : 0;

          // Final max
          const maxSeq = Math.max(maxSeqInProducts, maxSeqInInvalid, maxSeqInNewInvalid);

          // Assign new seq
          const seq = maxSeq + 1;

          // const seq = productsTemp.length + invalidParts.length + newInvalidParts.length + 1;
          const finalId = isPresent?.productId || item.productId.trim();
          const brandKey = enquiryMapping[formatMaterialGroup(isPresent?.attributes?.materialGroup?.value?.toUpperCase())];
          const orgId = '';
          // brandPricingTier = sessionStorage.getItem("userType") === "FSE" ? getCustomerDetailsBySapId?.data?.brandPricingTier : profileDetails?.data?.data?.customerInfo?.brandPricingTier;
          let annexureMatch: any;
          /* ----- Dealer‑Annexure logic --------------------------- */
          let error = "";
          let sm = "";
          let isInvalid = false;
          let isRowGreyed = false;
          if ((customerTierType === "Dealer" || customerTypeAccess.includes("dealer")) && annexureEnquiry === "true"
          ) {
            annexureMatch =
              getAllAnnexureListData?.data?.data?.productData?.find(
                (annexure: any) =>
                  norm(annexure.partNumber) === norm(item.productId)
              );

            if (!annexureMatch) {
              error = "Does not belong to Annexure/Core Products list";
              isInvalid = true;
              isRowGreyed = true;

            } else {

              const allowedTiers = ["gold", "platinum", "elite"];
              const brandTierObj = brandPricingTier.current?.[0];
              const extractedTier = brandTierObj?.tier
                ?.split("-")
                .pop()
                ?.trim()
                .toLowerCase();

              if (!extractedTier || !allowedTiers.includes(extractedTier)) {
                error = "Access denied. Kindly purchase the Part from the regular Order Enquiry";
                isInvalid = true;
                isRowGreyed = true;

              } else {
                const tier1MinQty = parseInt(
                  annexureMatch?.quantityTierRange?.tier_1?.minQty || "0"
                );
                const inputQty = parseInt(item.quantity);
                if (inputQty < tier1MinQty) {
                  error = `Min Order Qty should be ${tier1MinQty}`;
                  sm = "";
                  isInvalid = true;
                  isRowGreyed = true;
                }
              }
            }
          }


          /* ----- build the row object --------------------------- */
          const rowData = {
            quantity: parseInt(item.quantity) >= 1 ? parseInt(item.quantity) : 1,
            seq,
            invalidMaterialGroup: isInvalidBrand,
            imageUrls:
              item.imageUrls?.length
                ? item.imageUrls
                : getTyreImages(finalId, getTBLPartsDetails),
            stockPercentage: item.stockPercentage ? item.stockPercentage : getTyreStockPercentage(finalId, getTBLPartsDetails),
            productId: finalId,
            materialGroup:
              isPresent?.attributes?.materialGroup?.value?.toUpperCase() || "",
            productIdDescription: isPresent?.description?.EN || "",
            productCost: 0,
            annexureDetails: annexureMatch,
            nowAnxPrice: getNowwAnxPrice(item, annexureEnquiry, null, annexureMatch, orgId),
            oesSubBrandName: isPresent?.attributes?.productHierarchy?.value || "",
            subBrandName: isPresent?.attributes?.productHierarchy?.value || "",
            currency:
              sessionStorage.getItem("userType") === "FSE" || sessionStorage.getItem("userType") === "sre"
                ? `${companyCurrencyTypeByFSE}`
                : customerTierType === "Int. Business"
                  ? `${companyCurrencyType}`
                  : "AED",
            unitOfMeasure: isPresent?.attributes?.unitOfMeasure?.value || "",
            VAT: "",
            orgId: "",
            accessTyres: selectedAccessType === "Tyres",
            accessParts: selectedAccessType === "Parts",
            enquiryReferenceNumber: referenceNumber !== '' ? referenceNumber : tempRef || "",
            isAddToEnquiry: isAddToEnquiry !== false,
            isSpecialPriced: false,
            isSpecialPriceRequestPart: false,
            isRejected: false,
            nowAvailability: 0,
            nowAvailabilityChecked: false,
            hrs24Availability: 0,
            hrs24AvailabilityChecked: false,
            airAvailability: 0,
            airAvailabilityChecked: false,
            action: "I",
            dimensions: {
              height: isPresent?.attributes?.height?.value || "",
              width: isPresent?.attributes?.width?.value || "",
              length: isPresent?.attributes?.length?.value || "",
              volume: isPresent?.attributes?.volume?.value || "",
              grossWeight: isPresent?.attributes?.grossWeight?.value || "",
              batchYear: isPresent?.attributes?.batchYear?.value || "",
            },
            attributes: [],
            plant: "",
            nowEnquiryItemNumber: isPresent?.nowEnquiryItemNumber || "",
            nowProposedItemNumber: "",
            hrs24EnquiryItemNumber: isPresent?.hrs24EnquiryItemNumber || "",
            hrs24ProposedItemNumber: "",
            airEnquiryItemNumber: isPresent?.airEnquiryItemNumber || "",
            airProposedItemNumber: "",
            isValid: isInvalid && annexureEnquiry === 'true' && (error.includes('Does not belong to') || error.includes('Access denied')) ? false :
              isPresent &&
                isPresent.attributes?.materialGroup?.value &&
                enquiryMapping[
                `${formatMaterialGroup(
                  isPresent.attributes.materialGroup.value.toUpperCase()
                )}`
                ]
                ? true
                : false,
            error,
            isInvalid,
            isRowGreyed,
            successMessage: sm,
          };

          /* ----- keep invalid rows out of productsTemp ---------- */
          // if (isInvalid) {
          //   newInvalidParts.push(rowData);
          // } else {
          productsTemp.push(rowData);
          // }
        }
      });
      if (isAddToEnquiry === false) {
        const validProductIds = new Set(
          productsTemp
            .filter((p: any) => p.isValid && p.accessTyres)
            .map((p: any) => p.productId)
        );

        const updatedTyreParts = tyres.filter((tyre: any) =>
          validProductIds.has(tyre.partNumber)
        );

        // const updatedTyreParts = tyres.filter((tyre: any) => {
        //   // Check if there's a matching invalid & accessTyres product
        //   const match = productsTemp.find((p: any) =>
        //     p.productId === tyre.partNumber &&
        //     p.isValid === true &&
        //     p.accessTyres === true
        //   );

        //   return match;
        // });
        setTyreParts(updatedTyreParts);
        const newCheckedState: any = {};
        updatedTyreParts.forEach((row: any) => {
          newCheckedState[row.partNumber] = true;
        });
        setCheckedRows(newCheckedState);
        isAllSelected = updatedTyreParts && updatedTyreParts.every((row: any) => newCheckedState[row.partNumber]);
        selectedCount = Object.values(newCheckedState).filter((isChecked) => isChecked).length;
      }
      if (isAddToEnquiry === false) {
        productsTemp = productsTemp.filter((p: any) => {
          // Keep the record if it's either valid OR not a tyre part
          return !(p.isValid === false && p.accessTyres === true);
        });
      }
      let inValidPartsData = productsTemp.filter((p: any) => !p.isValid);
      let filteredInvalidPartsData = inValidPartsData.filter((part: any) => {
        return !(part.accessTyres === true && part.isAddToEnquiry === false);
      });
      // let inValidPartsData = productsTemp && productsTemp.length > 0 ? productsTemp.filter((p: any) => p.isValid === false) : [];
      filteredInvalidPartsData.forEach((part: any, index: any) => {
        const actualIndex = productsTemp.findIndex((item: any) => item === part);
        part.actualIndex = actualIndex;
      });
      if (apiData && apiData.data && apiData.data.length > 0) {
        setIscallAPI(false);
      } else {
        setIscallAPI(true);
      }

      let combinedArray: any = isCopyandcreate ? filteredInvalidPartsData : [...filteredInvalidPartsData, ...invalidParts];
      let uniqueMap = new Map();
      combinedArray.forEach((item: any) => {
        // Generate a key based on the 'seq' value or the whole object if 'seq' is undefined
        let key = item.seq !== undefined ? item.seq.toString() : JSON.stringify(item);

        // If the key is not already in the map, add the item
        if (!uniqueMap.has(key)) {
          uniqueMap.set(key, item);
        }
      });

      // Create an array of unique objects
      combinedArray = Array.from(uniqueMap.values());
      // Sort the array based on the 'seq' property
      combinedArray.sort((a: any, b: any) => {
        if (a.seq !== undefined && b.seq !== undefined) {
          return a.seq - b.seq; // Sort based on 'seq' if both are defined
        } else if (a.seq !== undefined) {
          return -1; // 'a' has 'seq', so it should come before 'b'
        } else if (b.seq !== undefined) {
          return 1; // 'b' has 'seq', so it should come before 'a'
        } else {
          return 0; // Both 'a' and 'b' have no 'seq', maintain their relative order
        }
      });

      setInvalidParts(combinedArray);
      setproducts(JSON.parse(JSON.stringify(productsTemp)));

      if (apiData?.data?.length) setIscallAPI(false);
      else setIscallAPI(true);

      if (!isCopyandcreate) {
        if (
          customerTierType &&
          annexureEnquiry !== "true" &&
          selectedAccessType === "Tyres"
        ) {
          saveUpdateEnquiry(
            isAddToEnquiry ? false : true,
            null,
            productsTemp,
            isAddToEnquiry
          );
        }
      }
    }

    if (negativeValuesPresent) {
      setOpenSnackbarType("error");
      setSuccessMessage("Negative quantity values were ignored during the import");
      handleopenCloseSnackbar(true);
    }

    setproductId("");
    setquantity("");
  };


  const commonInsertionLogicIAMMapping = async (jsonData: any, fetchFromRedux?: any, isCopyandcreate?: any, tierType?: any, isCreateNew?: any, isAddToEnquiry?: any, tyres?: any) => {
    let negativeValuesPresent = false;
    if (jsonData && Array.isArray(jsonData) && jsonData.length > 0) {
      let orgsAssignedToUser = "";
      if (assignedBrandsData && Array.isArray(assignedBrandsData)) {
        assignedBrandsData.map((item: any) => {
          if (item.code) {
            orgsAssignedToUser += enquiryMappingReverse[
              `${item.code}`
            ] + ",";
          }
        });
      }

      let tempData: any;
      tempData = jsonData.filter((item: any) => item.productId && item.productId.toString().trim());

      if (isCopyandcreate) {
        if (
          customerTierType &&
          annexureEnquiry !== "true"
        ) {
          let orgArray = orgsAssignedToUser.split(",").filter(Boolean);
          if (!isTBLAccess() && isPartsAccess()) {
            orgArray = orgArray.filter((org) => org !== "AMPTB");
          } else if (!isPartsAccess() && isOnlyTBLAccess()) {
            orgArray = orgArray.filter((org) => org === "AMPTB");
          }
          orgsAssignedToUser = [...new Set(orgArray)].join(",") + ",";
        }
      } else {
        if (
          customerTierType &&
          annexureEnquiry !== "true"
        ) {
          let orgArray = orgsAssignedToUser.split(",").filter(Boolean);
          if (
            selectedAccessType === "Tyres" &&
            sessionStorage.getItem("isAddedFromDashboard") === "false"
          )
            orgArray = orgArray.filter((org) => org === "AMPTB");
          else if (
            selectedAccessType === "Parts" ||
            sessionStorage.getItem("isAddedFromDashboard") === "true"
          )
            orgArray = orgArray.filter((org) => org !== "AMPTB");
          orgsAssignedToUser = [...new Set(orgArray)].join(",") + ",";
        }
      }

      // Extract the main part numbers from input objects
      let inputPartNumbers: string[] = tempData.map((item: any) => item.productId ? item.productId.toString().trim() : '');
      let mainPart: any;
      // Get cross-referenced parts
      let xcrossrefParts: any = await dispatch(getPartIdInfo(inputPartNumbers));
      if (xcrossrefParts && xcrossrefParts.data && xcrossrefParts.data.length > 0) {
        const matchedParts: any[] = [];
        const processedParts = new Set<string>();

        for (const partNumber of inputPartNumbers) {
          const mainPart = tempData.find((item: any) => item.productId === partNumber);
          const xrefData = xcrossrefParts.data.find((xref: any) => xref.Part_Number === partNumber);
          // Skip if type is OEM
          if (mainPart && (xrefData?.type !== "OEM" || xrefData?.searchParts === true) && !processedParts.has(partNumber)) {
            matchedParts.push({
              ...mainPart,
              productIdDescription: xrefData?.Product_Group_Description || "",
              searchPartNumber: xrefData?.searchPartNumber || "",
              searchParts: xrefData?.searchParts || false,
              brandName: xrefData?.OES_Aftermarket_Brand || '',
              type: xrefData?.type || ''
            });
            processedParts.add(partNumber);
          }

          // Process cross-referenced parts
          for (const xref of xcrossrefParts.data) {
            if (
              xref.searchPartNumber === partNumber &&
              !processedParts.has(xref.Part_Number) &&
              (xref.type !== "OEM" || xref.searchParts === true)
            ) {
              matchedParts.push({
                productId: xref.Part_Number,
                productIdDescription: xref.Product_Group_Description,
                searchPartNumber: xref.searchPartNumber,
                quantity: mainPart?.quantity || 1,
                searchParts: xref.searchParts,
                brandName: xref.OES_Aftermarket_Brand || '',
                type: xref.type || ''
              });
              processedParts.add(xref.Part_Number);
            }
          }
        }

        // Remove duplicates from tempData
        tempData = tempData.filter((item: any) => !processedParts.has(item.productId));
        // Merge updated data
        tempData = [...matchedParts, ...tempData];
      }
      // Tecdoc Parts Processing
      // let getTecdocPartsPayload = jsonData.map((item: any) => ({
      //   "getArticles": {
      //     "articleCountry": "AE",
      //     "provider": 23767,
      //     "searchQuery": item.productId,
      //     "searchType": 3,
      //     "lang": "en",
      //     "perPage": 100,
      //     "page": 1,
      //     "includeAll": true
      //   }
      // }));

      // let allArticlesData: any[] = [];
      // let processedTecDocParts = new Set<string>();

      // let crossrefTecDocPartsPromises = jsonData.map(async (item: any, i: any) => {
      //   let currentPayload = { ...getTecdocPartsPayload[i] };

      //   let crossrefParts: any = await dispatch(getTechDocPartList(currentPayload));

      //   if (crossrefParts && crossrefParts.data && crossrefParts.data.length > 0) {
      //     allArticlesData = allArticlesData.concat(crossrefParts.data);
      //   }
      //   return crossrefParts;
      // });

      // let allCrossRefParts = await Promise.all(crossrefTecDocPartsPromises);
      // // Add unique cross-referenced TecDoc parts to tempData
      // if (allCrossRefParts && allCrossRefParts.length > 0) {
      //   for (const crossRefData of allCrossRefParts) {
      //     if (crossRefData && crossRefData.data && crossRefData.data.length > 0) {
      //       for (const item of crossRefData.data) {
      //         if (item.Part_Number && !processedTecDocParts.has(item.Part_Number)) {
      //           tempData.push({
      //             productId: item.Part_Number,
      //             quantity: mainPart?.quantity ? mainPart?.quantity : 1,
      //             productIdDescription: item.Product_Group_Description || "",
      //             searchPartNumber: item.searchPartNumber.trim(),
      //             searchParts: item.searchParts || false,
      //             brandName: item.mfrName
      //           });
      //           processedTecDocParts.add(item.Part_Number);
      //         }
      //       }
      //     }
      //   }
      // }
      // Remove duplicates from tempData
      const uniqueTempData = new Map<string, any>();
      tempData.forEach((item: any) => {
        if (!uniqueTempData.has(item.productId)) {
          uniqueTempData.set(item.productId, item);
        }
      });

      tempData = Array.from(uniqueTempData.values());
      // Prepare final lists


      let partsList: any = tempData.map((item: any) => item.productId.toString().trim());

      let searchProduct: any = tempData.map((item: any) => ({
        productId: item.productId.toString().trim(),
        quantity: item.quantity
      }));
      const newInvalidParts: any[] = [];
      let apiData: any = await dispatch(searchProducts(customerTierType ? customerTierType : tierType, partsList, enquirySessionId, firstName, sapCustomerId, b2bUserId, searchProduct, region));
      let reduxData: any = sessionStorage.getItem("tempProducts");
      let productsTemp: any = isCreateNew ? [] : isCopyandcreate ? [] : JSON.parse(
        JSON.stringify(
          fetchFromRedux && reduxData ? JSON.parse(reduxData) : products
        )
      );

      // New Tyre search: mark parts left over from the previous search (searched but never
      // "Add to Order Enquiry"-ed) with action "D" so they're removed from the enquiry via the
      // normal update-enquiry call and dropped from the grid, instead of accumulating alongside
      // the new search's results.
      if (tyres && isAddToEnquiry === false && selectedAccessType === "Tyres") {
        const staleTyreProductIds = productsTemp
          .filter((p: any) => p.accessTyres === true && p.isAddToEnquiry === false)
          .map((p: any) => p.productId);
        productsTemp = productsTemp.map((p: any) =>
          // Strip isMaterialNotExtended here — this is an abandoned/replaced search result
          // being cleaned up, not a genuine Material Not Extended removal. Sending action "D"
          // together with isMaterialNotExtended: true makes the backend treat it as a real MNE
          // deletion (order log entry + pushed into removedProducts), showing it red in the
          // grid even though it was never added to the enquiry.
          p.accessTyres === true && p.isAddToEnquiry === false ? { ...p, action: "D", isMaterialNotExtended: false } : p
        );
        clearMaterialNotExtendedTracking(staleTyreProductIds);
      }

      await tempData.map((item: any) => {
        let isInvalidBrand = "";
        let isPresent: any =
          apiData && apiData.data && apiData.data.length > 0
            ? apiData.data.find((responsePart: any) => {
              if (responsePart && item.productId && responsePart.productId && responsePart?.productId?.trim()?.toUpperCase() === item.productId.toString().trim().toUpperCase()) {
                isInvalidBrand = responsePart?.attributes?.materialGroup?.value;
                // isInvalidBrand = hasAlternateParts(item.productId, tempData).hasAlternates ? responsePart?.attributes?.materialGroup?.value ? responsePart?.attributes?.materialGroup?.value : true : responsePart?.attributes?.materialGroup?.value;
              }
              return (
                responsePart?.productId?.trim()?.toUpperCase() === item.productId.toString().trim().toUpperCase() &&
                formatMaterialGroup(responsePart?.attributes?.materialGroup?.value) &&
                orgsAssignedToUser.includes(formatMaterialGroup(responsePart?.attributes?.materialGroup?.value))
              );
            })
            : null;
        if (
          !(
            item.quantity &&
            parseInt(item.quantity) &&
            parseInt(item.quantity) >= 1
          )
        ) {
          negativeValuesPresent = true;
        }
        if (
          item.quantity &&
          parseInt(item.quantity) &&
          parseInt(item.quantity) >= 1 &&
          item.productId &&
          item.productId.toString().trim() &&
          productsTemp &&
          Array.isArray(productsTemp)
        ) {
          let containsItem = false;
          if (!containsItem) {
            let validParts: any = productsTemp && productsTemp.length > 0 ? productsTemp.filter((p: any) => p.isValid === true) : [];
            const mergedArray = [...productsTemp, ...invalidParts];


            // Get max seq from productsTemp
            const maxSeqInProducts = productsTemp.length
              ? Math.max(...productsTemp.map((p: any) => p.seq || 0))
              : 0;

            // If invalidParts/newInvalidParts also carry seq, include them:
            const maxSeqInInvalid = invalidParts.length
              ? Math.max(...invalidParts.map((p: any) => p.seq || 0))
              : 0;

            const maxSeqInNewInvalid = newInvalidParts.length
              ? Math.max(...newInvalidParts.map((p: any) => p.seq || 0))
              : 0;

            // Final max
            const maxSeq = Math.max(maxSeqInProducts, maxSeqInInvalid, maxSeqInNewInvalid);

            // Assign new seq
            const seq = maxSeq + 1;

            // const seq = productsTemp.length + invalidParts.length + newInvalidParts.length + 1;
            const finalId = isPresent?.productId || item.productId.trim();
            // brandPricingTier = sessionStorage.getItem("userType") === "FSE" ? getCustomerDetailsBySapId?.data?.brandPricingTier : profileDetails?.data?.data?.customerInfo?.brandPricingTier;


            // Once all sequence numbers are assigned, update the state with the final sequence
            setCurrentSeq(seq); // This ensures the currentSeq will be incremented correctly

            // Proceed with your logic to check validParts
            if (validParts && validParts.length < MAX_PARTS) {
              // Push the new item with the correct seq value into productsTemp
              productsTemp.push({
                quantity:
                  item.quantity &&
                    parseInt(item.quantity) &&
                    parseInt(item.quantity) >= 1
                    ? parseInt(item.quantity)
                    : 1,
                seq, // Assign the current sequence number

                invalidMaterialGroup: isInvalidBrand ? isInvalidBrand : "",
                isParentPart: item.searchParts && hasAlternateParts(item.productId, tempData).hasAlternates ? true : false,
                isChildPart: item.searchParts === false && item.searchPartNumber !== '' ? true : false,
                searchPartNumber: item.searchPartNumber,
                imageUrls:
                  item.imageUrls?.length
                    ? item.imageUrls
                    : getTyreImages(finalId, getTBLPartsDetails),
                stockPercentage: item.stockPercentage ? item.stockPercentage : getTyreStockPercentage(finalId, getTBLPartsDetails),
                productId: finalId,
                materialGroup:
                  isPresent?.attributes?.materialGroup?.value?.toUpperCase() || "",
                productIdDescription: isPresent?.description?.EN || "",
                productCost: 0,
                oesSubBrandName: isPresent?.attributes?.productHierarchy?.value || "",
                subBrandName: isPresent?.attributes?.productHierarchy?.value || "",
                brandName: item.brandName ? item.brandName : undefined,
                type: item.type ? item.type : undefined,
                currency:
                  sessionStorage.getItem("userType") === "FSE"
                    ? `${companyCurrencyTypeByFSE}`
                    : customerTierType === "Int. Business"
                      ? `${companyCurrencyType}`
                      : "AED",
                unitOfMeasure: isPresent?.attributes?.unitOfMeasure?.value || "",
                VAT: "",
                orgId: "",
                accessTyres: selectedAccessType === "Tyres",
                accessParts: selectedAccessType === "Parts",
                enquiryReferenceNumber: referenceNumber !== '' ? referenceNumber : tempRef || "",
                isAddToEnquiry: isAddToEnquiry !== false,
                isSpecialPriced: false,
                isSpecialPriceRequestPart: false,
                isRejected: false,
                nowAvailability: 0,
                nowAvailabilityChecked: false,
                hrs24Availability: 0,
                hrs24AvailabilityChecked: false,
                airAvailability: 0,
                airAvailabilityChecked: false,
                action: "I",
                dimensions: {
                  height: isPresent?.attributes?.height?.value || "",
                  width: isPresent?.attributes?.width?.value || "",
                  length: isPresent?.attributes?.length?.value || "",
                  volume: isPresent?.attributes?.volume?.value || "",
                  grossWeight: isPresent?.attributes?.grossWeight?.value || "",
                  batchYear: isPresent?.attributes?.batchYear?.value || "",
                },
                attributes: [
                  {
                    name: "height",
                    value:
                      isPresent &&
                        isPresent.attributes &&
                        isPresent.attributes.height
                        ? isPresent.attributes.height.value
                        : "",
                  },
                  {
                    name: "width",
                    value:
                      isPresent &&
                        isPresent.attributes &&
                        isPresent.attributes.width
                        ? isPresent.attributes.width.value
                        : "",
                  },
                  {
                    name: "length",
                    value:
                      isPresent &&
                        isPresent.attributes &&
                        isPresent.attributes.length
                        ? isPresent.attributes.length.value
                        : "",
                  },
                  {
                    name: "grossWeight",
                    value:
                      isPresent &&
                        isPresent.attributes &&
                        isPresent.attributes.grossWeight
                        ? isPresent.attributes.grossWeight.value
                        : "",
                  },
                  {
                    name: "volume",
                    value:
                      isPresent &&
                        isPresent.attributes &&
                        isPresent.attributes.volume
                        ? isPresent.attributes.volume.value
                        : "",
                  },
                ],
                plant: "",
                nowEnquiryItemNumber: isPresent?.nowEnquiryItemNumber || "",
                nowProposedItemNumber: "",
                hrs24EnquiryItemNumber: isPresent?.hrs24EnquiryItemNumber || "",
                hrs24ProposedItemNumber: "",
                airEnquiryItemNumber: isPresent?.airEnquiryItemNumber || "",
                airProposedItemNumber: "",
                isValid:
                  isPresent && isPresent.attributes.materialGroup &&
                    isPresent.attributes.materialGroup.value &&
                    enquiryMapping[`${formatMaterialGroup(isPresent.attributes.materialGroup.value.toUpperCase())}`]
                    ? true
                    : false,
              });
              // Increment the sequence for the next part
              setCurrentSeq(seq + 1);
            } else {
              setOpenSnackbarType("error");
              setOpenErrorSnackbar(true);
              setSuccessMessage('You can upload a maximum of only 750 valid lines');
              handleopenCloseSnackbar(true);
            }
          }
        } else {
          negativeValuesPresent = true;
        }
      });


      if (isAddToEnquiry === false) {
        const validProductIds = new Set(
          productsTemp
            .filter((p: any) => p.isValid && p.accessTyres)
            .map((p: any) => p.productId)
        );

        const updatedTyreParts = tyres.filter((tyre: any) =>
          validProductIds.has(tyre.partNumber)
        );

        // const updatedTyreParts = tyres.filter((tyre: any) => {
        //   // Check if there's a matching invalid & accessTyres product
        //   const match = productsTemp.find((p: any) =>
        //     p.productId === tyre.partNumber &&
        //     p.isValid === true &&
        //     p.accessTyres === true
        //   );

        //   return match;
        // });
        setTyreParts(updatedTyreParts);
        const newCheckedState: any = {};
        updatedTyreParts.forEach((row: any) => {
          newCheckedState[row.partNumber] = true;
        });
        setCheckedRows(newCheckedState);
        isAllSelected = updatedTyreParts && updatedTyreParts.every((row: any) => newCheckedState[row.partNumber]);
        selectedCount = Object.values(newCheckedState).filter((isChecked) => isChecked).length;
      }
      if (isAddToEnquiry === false) {
        productsTemp = productsTemp.filter((p: any) => {
          // Keep the record if it's either valid OR not a tyre part
          return !(p.isValid === false && p.accessTyres === true);
        });
      }
      let inValidPartsData =
        productsTemp && productsTemp.length > 0
          ? productsTemp.filter(
            (p: any) =>
              (p.isValid === false || p.materialGroup === "") &&
              jsonData.some(
                (j: any) => j.productId === p.productId
              )
          )
          : [];
      let filteredInvalidPartsData = inValidPartsData.filter((part: any) => {
        return !(part.accessTyres === true && part.isAddToEnquiry === false);
      });
      // let inValidPartsData = productsTemp && productsTemp.length > 0 ? productsTemp.filter((p: any) => p.isValid === false) : [];
      filteredInvalidPartsData.forEach((part: any, index: any) => {
        const actualIndex = productsTemp.findIndex((item: any) => item === part);
        part.actualIndex = actualIndex;
      });
      productsTemp = await productsTemp && productsTemp.length > 0 ? productsTemp.filter((p: any) => (p.isValid === true && p.isParentPart === true) || p.isValid === true) : [];
      if (apiData && apiData.data && apiData.data.length > 0) {
        setIscallAPI(false);
      } else {
        setIscallAPI(true);
      }

      let combinedArray: any = isCopyandcreate ? filteredInvalidPartsData : [...filteredInvalidPartsData, ...invalidParts];
      let uniqueMap = new Map();
      combinedArray.forEach((item: any) => {
        // Generate a key based on the 'seq' value or the whole object if 'seq' is undefined
        let key = item.seq !== undefined ? item.seq.toString() : JSON.stringify(item);

        // If the key is not already in the map, add the item
        if (!uniqueMap.has(key)) {
          uniqueMap.set(key, item);
        }
      });

      // Create an array of unique objects
      combinedArray = Array.from(uniqueMap.values());
      // Sort the array based on the 'seq' property
      combinedArray.sort((a: any, b: any) => {
        if (a.seq !== undefined && b.seq !== undefined) {
          return a.seq - b.seq; // Sort based on 'seq' if both are defined
        } else if (a.seq !== undefined) {
          return -1; // 'a' has 'seq', so it should come before 'b'
        } else if (b.seq !== undefined) {
          return 1; // 'b' has 'seq', so it should come before 'a'
        } else {
          return 0; // Both 'a' and 'b' have no 'seq', maintain their relative order
        }
      });

      setInvalidParts(combinedArray);
      setproducts(JSON.parse(JSON.stringify(productsTemp)));

      if (apiData?.data?.length) setIscallAPI(false);
      else setIscallAPI(true);

      if (!isCopyandcreate) {
        if (
          customerTierType &&
          annexureEnquiry !== "true" &&
          selectedAccessType === "Tyres"
        ) {
          saveUpdateEnquiry(
            isAddToEnquiry ? false : true,
            null,
            productsTemp,
            isAddToEnquiry
          );
        }
      }

      if (negativeValuesPresent) {
        setOpenSnackbarType("error");
        setSuccessMessage(
          `Negative quantity values were ignored during the import`
        );
        handleopenCloseSnackbar(true);
      }
      // setTimeout(() => {
      setproductId("");
      setquantity('');
      // }, 1000);
    };
  }

  const commonInsertionLogicforOES = async (jsonData: any, oesproducts: any) => {
    let negativeValuesPresent = false;
    if (jsonData && Array.isArray(jsonData) && jsonData.length > 0) {
      let orgsAssignedToUser = "";
      if (assignedBrandsData && Array.isArray(assignedBrandsData)) {
        assignedBrandsData.map((item: any) => {
          if (item.code) {
            orgsAssignedToUser += enquiryMappingReverse[
              `${item.code}`
            ] + ",";
          }
        });
      }
      let tempData = jsonData.filter(
        (item: any) => item.productId && item.productId.trim()
      );
      let partsList: any = tempData.map((item) => {
        return item.productId.trim();
      });
      let searchProduct: any = [];
      tempData.map(item => {
        searchProduct.push({ productId: item.productId.trim(), quantity: item.quantity })
      })
      let apiData: any = await dispatch(searchProducts(customerTierType, partsList, enquirySessionId, firstName, sapCustomerId, b2bUserId, searchProduct, region));
      let reduxData: any = sessionStorage.getItem("tempProducts");
      let productsTemp: any = JSON.parse(
        JSON.stringify(oesproducts)
      );
      jsonData.map((item: any) => {
        let isInvalidBrand = "";
        let isPresent: any =
          apiData && apiData.data && apiData.data.length > 0
            ? apiData.data.find((responsePart: any) => {
              if (responsePart && item.productId && responsePart.productId && responsePart?.productId?.trim()?.toUpperCase() === item.productId.trim().toUpperCase()) {
                isInvalidBrand = responsePart?.attributes?.materialGroup?.value;
              }
              return (
                responsePart?.productId?.trim()?.toUpperCase() === item.productId.trim().toUpperCase() &&
                formatMaterialGroup(responsePart?.attributes?.materialGroup?.value) &&
                orgsAssignedToUser.includes(formatMaterialGroup(responsePart?.attributes?.materialGroup?.value))
              );
            })
            : null;
        if (
          !(
            item.quantity &&
            parseInt(item.quantity) &&
            parseInt(item.quantity) >= 1
          )
        ) {
          negativeValuesPresent = true;
        }
        if (
          item.quantity &&
          parseInt(item.quantity) &&
          parseInt(item.quantity) >= 1 &&
          item.productId &&
          item.productId.trim() &&
          productsTemp &&
          Array.isArray(productsTemp)
        ) {
          let containsItem = false;
          // productsTemp.map((product: any) => {
          //   if (
          //     product.productId &&
          //     item.productId.trim() &&
          //     product.productId === item.productId.trim()
          //   ) {
          //     product.quantity +=
          //       item.quantity && parseInt(item.quantity)
          //         ? parseInt(item.quantity) >= 1
          //           ? parseInt(item.quantity)
          //           : 0
          //         : 0;
          //     product.quantity = product.quantity && product.quantity.toString() && parseInt(product.quantity.toString().slice(0, 5))
          //     containsItem = false;
          //   }
          //   return product;
          // });
          if (!containsItem) {
            let validParts: any = productsTemp && productsTemp.length > 0 ? productsTemp.filter((p: any) => p.isValid === true) : [];
            if (validParts && validParts.length < MAX_PARTS) {
              let productId = isPresent && isPresent.productId ? isPresent.productId : item.productId.trim();
              productsTemp.push({
                quantity:
                  item.quantity &&
                    parseInt(item.quantity) &&
                    parseInt(item.quantity) >= 1
                    ? parseInt(item.quantity)
                    : 1,
                invalidMaterialGroup: isInvalidBrand ? isInvalidBrand : "",
                imageUrls: item.imageUrls && item.imageUrls.length > 0 ? item.imageUrls : getTyreImages(productId, getTBLPartsDetails),
                stockPercentage: item.stockPercentage ? item.stockPercentage : getTyreStockPercentage(productId, getTBLPartsDetails),
                productId: productId,
                materialGroup:
                  isPresent &&
                    isPresent.attributes &&
                    isPresent.attributes.materialGroup
                    ? isPresent.attributes.materialGroup.value.toUpperCase()
                    : "",
                productIdDescription:
                  isPresent && isPresent.description
                    ? isPresent.description["EN"]
                    : "",
                productCost: 0,
                currency: sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem("userType") === "sre" ? `${companyCurrencyTypeByFSE}` : customerTierType === "Int. Business" ? `${companyCurrencyType}` : 'AED',
                oesSubBrandName: isPresent &&
                  isPresent.attributes &&
                  isPresent.attributes.productHierarchy
                  ? isPresent.attributes.productHierarchy.value
                  : "",
                unitOfMeasure:
                  isPresent &&
                    isPresent.attributes &&
                    isPresent.attributes.unitOfMeasure
                    ? isPresent.attributes.unitOfMeasure.value
                    : "",
                VAT: "",
                orgId: "",
                accessTyres: selectedAccessType === "Tyres",
                accessParts: selectedAccessType === "Parts",
                enquiryReferenceNumber: referenceNumber ? referenceNumber : "",
                isSpecialPriced: false,
                isSpecialPriceRequestPart: false,
                isRejected: false,
                nowAvailability: 0,
                nowAvailabilityChecked: false,
                airAvailability: 0,
                airAvailabilityChecked: false,
                action: "I",
                dimensions: {
                  height:
                    isPresent &&
                      isPresent.attributes &&
                      isPresent.attributes.height
                      ? isPresent.attributes.height.value
                      : "",
                  width:
                    isPresent &&
                      isPresent.attributes &&
                      isPresent.attributes.width
                      ? isPresent.attributes.width.value
                      : "",
                  length:
                    isPresent &&
                      isPresent.attributes &&
                      isPresent.attributes.length
                      ? isPresent.attributes.length.value
                      : "",
                  volume:
                    isPresent &&
                      isPresent.attributes &&
                      isPresent.attributes.volume
                      ? isPresent.attributes.volume.value
                      : "",
                  grossWeight: isPresent &&
                    isPresent.attributes &&
                    isPresent.attributes.grossWeight
                    ? isPresent.attributes.grossWeight.value
                    : "",
                  batchYear: isPresent &&
                    isPresent.attributes &&
                    isPresent.attributes.batchYear
                    ? isPresent.attributes.batchYear.value
                    : ""
                },
                attributes: [
                  {
                    name: "height",
                    value:
                      isPresent &&
                        isPresent.attributes &&
                        isPresent.attributes.height
                        ? isPresent.attributes.height.value
                        : "",
                  },
                  {
                    name: "width",
                    value:
                      isPresent &&
                        isPresent.attributes &&
                        isPresent.attributes.width
                        ? isPresent.attributes.width.value
                        : "",
                  },
                  {
                    name: "length",
                    value:
                      isPresent &&
                        isPresent.attributes &&
                        isPresent.attributes.length
                        ? isPresent.attributes.length.value
                        : "",
                  },
                  {
                    name: "grossWeight",
                    value:
                      isPresent &&
                        isPresent.attributes &&
                        isPresent.attributes.grossWeight
                        ? isPresent.attributes.grossWeight.value
                        : "",
                  },
                  {
                    name: "volume",
                    value:
                      isPresent &&
                        isPresent.attributes &&
                        isPresent.attributes.volume
                        ? isPresent.attributes.volume.value
                        : "",
                  },
                ],
                plant: "",
                nowEnquiryItemNumber: isPresent && isPresent.nowEnquiryItemNumber ? isPresent.nowEnquiryItemNumber : '',
                nowProposedItemNumber: "",
                airEnquiryItemNumber: isPresent && isPresent.airEnquiryItemNumber ? isPresent.airEnquiryItemNumber : '',
                airProposedItemNumber: "",
                isValid:
                  isPresent && isPresent.attributes.materialGroup &&
                    isPresent.attributes.materialGroup.value &&
                    enquiryMapping[`${formatMaterialGroup(isPresent.attributes.materialGroup.value.toUpperCase())}`]
                    ? true
                    : false,
              });
            } else {
              setOpenSnackbarType("error");
              setOpenErrorSnackbar(true);
              setSuccessMessage('You can upload a maximum of only 750 valid lines');
              handleopenCloseSnackbar(true);
            }
          }
        } else {
          negativeValuesPresent = true;
        }
      });
      setproducts(JSON.parse(JSON.stringify(productsTemp)));
      // setisAvailabiityChecked(false);
    }
    if (negativeValuesPresent) {
      setOpenSnackbarType("error");
      setOpenErrorSnackbar(true);
      setSuccessMessage(
        `Negative quantity values were ignored during the import`
      );
      handleopenCloseSnackbar(true);
    }
    // setTimeout(() => {
    setproductId("");
    setquantity('');
    // }, 1000);
  };

  const getTyreImages = (productId: any, partsDetils: any) => {
    let productData = partsDetils?.data?.[0]?.parts;
    if (productData) {
      let filterData = productData.filter((item: any) => item.partNumber === productId);
      return filterData?.[0]?.['imageUrls'] || [];
    }
    return [];
  }

  const getTyreStockPercentage = (productId: any, partsDetils: any) => {
    let productData = partsDetils?.data?.[0]?.parts;
    if (productData) {
      let filterData = productData.filter((item: any) => item.partNumber === productId);
      return filterData?.[0]?.stockPercentage || 0;
    }
    return 0;
  }


  const getExportNSPEVValue = (item: any) => {
    // let data = spParts.filter((sp: any) => sp.nowEnquiryItemNumber == item.nowEnquiryItemNumber)
    let nspev: any = 0.00;
    if (enquiryAction === 'view' && item.nowApprovedPrice && item.nowApprovedPrice !== '' && item.nowApprovedPrice !== 'NaN') {
      nspev = (parseFloat(getSellingPrice(item.nowApprovedPrice, isSellingPriceData, markupPercentage)).toFixed(2))
    } else {
      if (isAvailabiityChecked && requestedTotalType === "part" && item.isSpecialPriceRequestPart && item["nowAvailability"] && requestStatus === 'Approved') {
        if (item.nowOfferedPriceType == 'byPercentage' && item["nowOfferedCalculatedPrice"] && item["nowOfferedCalculatedPrice"] !== '' && item["nowOfferedCalculatedPrice"] !== 'NaN') {
          nspev = parseFloat(getSellingPrice(item["nowOfferedCalculatedPrice"], isSellingPriceData, markupPercentage)).toFixed(2);
        } else if (item.nowOfferedPriceType == 'byCurrency' && item["nowOfferedPrice"] && item["nowOfferedPrice"] !== '' && item["nowOfferedPrice"] !== 'NaN') {
          nspev = parseFloat(getSellingPrice(item["nowOfferedPrice"], isSellingPriceData, markupPercentage)).toFixed(2);
        } else {
          nspev = (parseFloat(getSellingPrice(item["nspev"], isSellingPriceData, markupPercentage)).toFixed(2))
        }
      } else if (requestedTotalType === "total" && isAvailabiityChecked && item["nspev"] && item["nowAvailability"] && item.isSpecialPriced === false &&
        requestStatus === 'Approved') {
        if (requestedCalculatedTotalType === "By AED") {

          let value: any = requestedCaluclatedTotalPrice.replace("%", "").replace("-", "");
          let addedValue: any = (parseFloat(value) * item["nspev"]) / 100;
          nspev = (parseFloat(getSellingPrice((parseFloat(item["nspev"]) - parseFloat(addedValue)), isSellingPriceData, markupPercentage)).toFixed(2))
          // nspev = (parseFloat(getSellingPrice((parseFloat(requestedCaluclatedTotalPrice.replace("%", "").replace("-", "")) * item["nspev"]) / 100, isSellingPriceData, markupPercentage)).toFixed(2))
        }
        if (requestedCalculatedTotalType === "By %") {
          let addedValue: any = (parseFloat(estmateTotal) * item["nspev"]) / 100;
          nspev = (parseFloat(getSellingPrice((parseFloat(item["nspev"]) - parseFloat(addedValue)), isSellingPriceData, markupPercentage)).toFixed(2))
        }
      } else if (isAvailabiityChecked && item["nspev"]) {
        nspev = (parseFloat(getSellingPrice(item["nspev"], isSellingPriceData, markupPercentage)).toFixed(2))
      }
    }
    return Number(nspev);
  }

  const getExportNSPValue = (item: any) => {
    let nsp: any = 0.00;
    /* Code for adding 5% margin to nsp(exclusive vat) and returing nap value is special price approved ->  Bhargavi */
    if (enquiryAction === 'view' && item.nowApprovedPrice && item.nowApprovedPrice !== '' && item.nowApprovedPrice !== 'NaN') {
      let nspev: any = getExportNSPEVValue(item);
      let addedValue: any = (nspev * 5) / 100;
      nsp = (parseFloat(getSellingPrice((parseFloat(nspev) + parseFloat(addedValue)), isSellingPriceData, markupPercentage)).toFixed(2))
    } else {
      if (isAvailabiityChecked && requestStatus === 'Approved' && item["nowAvailability"] && item.isSpecialPriced === false) {
        let nspev: any = getExportNSPEVValue(item);
        let addedValue: any = (nspev * 5) / 100;
        nsp = (parseFloat(getSellingPrice((parseFloat(nspev) + parseFloat(addedValue)), isSellingPriceData, markupPercentage)).toFixed(2))
      } else if (isAvailabiityChecked && item["nsp"]) {
        nsp = (parseFloat(getSellingPrice(item["nsp"], isSellingPriceData, markupPercentage)).toFixed(2))
      }
    }
    return Number(nsp);
  }

  const getExportBOPValue = (item: any) => {
    let bop: any = 0.00;
    if (enquiryAction === 'view' && item.airApprovedPrice && item.airApprovedPrice !== '' && item.airApprovedPrice !== 'NaN') {
      bop = (parseFloat(getSellingPrice(item.airApprovedPrice, isSellingPriceData, markupPercentage)).toFixed(2))
    } else {
      if (isAvailabiityChecked && requestedTotalType === "part" && item.isSpecialPriceRequestPart && item["airAvailability"] && requestStatus === 'Approved' && item.isRejected == false) {
        if (item.airOfferedPriceType == 'byPercentage' && item["airOfferedCalculatedPrice"] && item["airOfferedCalculatedPrice"] !== '' && item["airOfferedCalculatedPrice"] !== 'NaN') {
          bop = parseFloat(getSellingPrice(item["airOfferedCalculatedPrice"], isSellingPriceData, markupPercentage)).toFixed(2);
        } else if (item.airOfferedPriceType == 'byCurrency' && item["airOfferedPrice"] && item["airOfferedPrice"] !== '' && item["airOfferedPrice"] !== 'NaN') {
          bop = parseFloat(getSellingPrice(item["airOfferedPrice"], isSellingPriceData, markupPercentage)).toFixed(2);
        } else {
          bop = (parseFloat(getSellingPrice(item["aop"], isSellingPriceData, markupPercentage)).toFixed(2))
        }
      } else if (requestedTotalType === "total" && isAvailabiityChecked && item["aop"] && item["airAvailability"] && item.isSpecialPriced === false &&
        requestStatus === 'Approved') {
        if (requestedCalculatedTotalType === "By AED") {

          let value: any = requestedCaluclatedTotalPrice.replace("%", "").replace("-", "");
          let addedValue: any = (parseFloat(value) * item["aop"]) / 100;
          bop = (parseFloat(getSellingPrice((item["aop"] - parseFloat(addedValue)), isSellingPriceData, markupPercentage)).toFixed(2));

          // bop = (parseFloat(getSellingPrice((parseFloat(requestedCaluclatedTotalPrice.replace("%", "").replace("-", "")) * item["aop"]) / 100, isSellingPriceData, markupPercentage)).toFixed(2));
        }
        if (requestedCalculatedTotalType === "By %") {
          let addedValue: any = (item["aop"] * parseFloat(estmateTotal)) / 100;
          bop = (parseFloat(getSellingPrice((item["aop"] - parseFloat(addedValue)), isSellingPriceData, markupPercentage)).toFixed(2));
        }
      } else if (isAvailabiityChecked && item["aop"]) {
        bop = (parseFloat(getSellingPrice(item["aop"], isSellingPriceData, markupPercentage)).toFixed(2))
      }
    }
    return Number(bop);
  }

  const getAmtValue = (item: any) => {
    let total = 0.00;
    if (item && item.nowAvailabilityChecked && item.nowAvailability && item.nsp) {
      if (requestStatus === 'Approved') {
        let nsp1: any = getExportNSPValue(item);
        total += parseFloat(item.nowAvailability) * parseFloat(nsp1);
      } else {
        total += parseFloat(item.nowAvailability) * parseFloat(item.nsp);
      }
    }
    // <<<<<<<<<<< 24 hrs >>>>>>>>>>>>>>>>>>>>> NEW CODE <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
    if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && item && item.hrs24AvailabilityChecked && item.hrs24Availability && item.nsp) {
      total += parseFloat(item.hrs24Availability) * parseFloat(item.nsp);
    }
    // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    // if (customerTierType && (customerTierType.toLowerCase() !== "workshop" && customerTierType.toLowerCase() !== "tpcdealer") && item && item.airAvailabilityChecked && item.airAvailability && item.aop) {    // enabled FSE BO place order 03/06/26
    if (item && item.airAvailabilityChecked && item.airAvailability && item.aop) {
      if (requestStatus === 'Approved') {
        let aop1: any = getExportBOPValue(item);
        total += parseFloat(item.airAvailability) * parseFloat(aop1);
      } else {
        total += parseFloat(item.airAvailability) * parseFloat(item.aop);
      }
    }
    return total
  }

  function exportTablesToExcel(): void {
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    const tables: NodeListOf<HTMLTableElement> = document.querySelectorAll<HTMLTableElement>("table");

    // ─── helpers ───────────────────────────────────────────────────────────────
    const normalize = (text: string | null): string =>
      (text || "").toLowerCase().replace(/\s+/g, " ").trim();

    const isSrHeader = (text: string | null): boolean =>
      /^sr(\.|) ?no\.?$/i.test(text || "") ||
      /^serial(\.|) ?no\.?$/i.test(text || "") ||
      /^#$/i.test(text || "");

    const allRowsFirstCellAreNumbers = (tbl: HTMLTableElement): boolean => {
      const rows = tbl.querySelectorAll<HTMLTableRowElement>("tbody tr");
      return (
        rows.length > 0 &&
        Array.from(rows).every((row) => {
          const firstCellText =
            row.querySelector<HTMLTableCellElement>("td")?.textContent?.trim() || "";
          return /^\d+$/.test(firstCellText);
        })
      );
    };

    const isRowWithData = (rowElement: HTMLTableRowElement, partNoColumnIndex: number): boolean => {
      const cells = Array.from(rowElement.querySelectorAll<HTMLTableCellElement>("td"));
      if (partNoColumnIndex >= 0 && cells[partNoColumnIndex]) {
        const partNoCell = cells[partNoColumnIndex];
        const partNoContent = splitCellContent(partNoCell);
        const partNoText = partNoContent[0]?.trim() || "";
        if (partNoText && partNoText !== "" && !/^\s*$/.test(partNoText)) {
          return true;
        }
      }
      return cells.some(cell => {
        const text = cell.textContent?.trim() || "";
        return text && text !== "" && !/^\s*\d*\s*$/.test(text);
      });
    };

    const splitCellContent = (cell: HTMLTableCellElement | undefined): string[] => {
      if (!cell) return [];
      const html = cell.innerHTML
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<\/div>|<\/p>/gi, "\n");
      const raw = html.replace(/<[^>]+>/g, "");
      return raw
        .replace(/\u00A0/g, " ")
        .split(/\n+/)
        .map((s) => s.trim())
        .filter(Boolean);
    };

    const parseQtyAvlMoqSohFromCell = (
      cell: HTMLTableCellElement | undefined,
      rowIndex: number,
      headerText: string
    ): { qty: string; avl: string; moq: string; soh: string } => {
      if (!cell) return { qty: "", avl: "", moq: "", soh: "" };
      const normalizedHeader = headerText.toLowerCase().replace(/\s+/g, "");
      const hasSohInHeader = normalizedHeader.includes("soh");
      const hasMoqInHeader = normalizedHeader.includes("moq");
      let qty = "";
      let avl = "";
      let moq = "";
      let soh = "";
      const input = cell.querySelector("input");
      if (input && "value" in input) {
        qty = (input as HTMLInputElement).value;
      }
      const spans = cell.querySelectorAll("span");
      const spanValues: string[] = [];
      spans.forEach((span) => {
        const spanText = span.textContent?.trim() || "";
        if (spanText !== "") spanValues.push(spanText);
      });
      if (hasSohInHeader && hasMoqInHeader) {
        if (spanValues.length >= 1) avl = spanValues[0];
        if (spanValues.length >= 2) soh = spanValues[1];
        if (spanValues.length >= 3) moq = spanValues[2];
      } else if (hasSohInHeader && !hasMoqInHeader) {
        if (spanValues.length >= 1) avl = spanValues[0];
        if (spanValues.length >= 2) soh = spanValues[1];
      } else if (!hasSohInHeader && hasMoqInHeader) {
        if (spanValues.length >= 1) avl = spanValues[0];
        if (spanValues.length >= 2) moq = spanValues[1];
      } else {
        if (spanValues.length >= 1) avl = spanValues[0];
      }
      return { qty, avl, moq, soh };
    };

    const checkHeaderForColumns = (headerText: string): { hasSoh: boolean; hasMoq: boolean } => {
      const normalized = headerText.toLowerCase().replace(/\s+/g, "");
      return {
        hasSoh: normalized.includes("soh"),
        hasMoq: normalized.includes("moq"),
      };
    };

    const checkAvailabilityVisibleColumns = (
      tableElement: HTMLTableElement
    ): { hasNow: boolean; has24hrs: boolean; hasBo: boolean } => {
      const availHeader = Array.from(
        tableElement.querySelectorAll<HTMLTableCellElement>("thead tr th")
      ).find((th) => th.textContent?.toLowerCase().includes("availability"));
      if (!availHeader) return { hasNow: false, has24hrs: false, hasBo: false };
      let hasNow = false;
      let has24hrs = false;
      let hasBo = false;
      const checkboxes = availHeader.querySelectorAll("input[type=\"checkbox\"]");
      if (checkboxes.length > 0) {
        checkboxes.forEach((checkbox) => {
          const checkboxInput = checkbox as HTMLInputElement;
          if (checkboxInput.checked) {
            let surroundingText = "";
            if (checkbox.parentElement) surroundingText += checkbox.parentElement.textContent || "";
            if (checkbox.nextSibling) surroundingText += checkbox.nextSibling.textContent || "";
            if (checkbox.previousSibling) surroundingText += checkbox.previousSibling.textContent || "";
            const lowerText = surroundingText.toLowerCase();
            if (lowerText.includes("now")) hasNow = true;
            if (lowerText.includes("24") || lowerText.includes("hrs")) has24hrs = true;
            if (lowerText.includes("bo")) hasBo = true;
          }
        });
      }
      if (!hasNow && !has24hrs && !hasBo) {
        const headerText = availHeader.textContent?.toLowerCase() || "";
        hasNow = headerText.includes("now");
        has24hrs = headerText.includes("24") || headerText.includes("hrs");
        hasBo = headerText.includes("bo");
      }
      if (!hasNow && !has24hrs && !hasBo) {
        const availIndex = Array.from(
          tableElement.querySelectorAll<HTMLTableCellElement>("thead tr th")
        ).findIndex((th) => th.textContent?.toLowerCase().includes("availability"));
        if (availIndex >= 0) {
          const firstRow = tableElement.querySelector<HTMLTableRowElement>("tbody tr");
          if (firstRow) {
            const availCell = firstRow.querySelectorAll<HTMLTableCellElement>("td")[availIndex];
            if (availCell) {
              const cellParts = splitCellContent(availCell);
              if (cellParts.length === 1) { hasNow = true; }
              else if (cellParts.length === 2) { hasNow = true; hasBo = true; }
              else if (cellParts.length >= 3) { hasNow = true; has24hrs = true; hasBo = true; }
            }
          }
        }
      }
      return { hasNow, has24hrs, hasBo };
    };

    const getAvailabilityValueByType = (
      availParts: string[],
      columnType: "now" | "24hrs" | "bo",
      visibleColumns: { hasNow: boolean; has24hrs: boolean; hasBo: boolean }
    ): string => {
      const orderedColumns: ("now" | "24hrs" | "bo")[] = [];
      if (visibleColumns.hasNow) orderedColumns.push("now");
      if (visibleColumns.has24hrs) orderedColumns.push("24hrs");
      if (visibleColumns.hasBo) orderedColumns.push("bo");
      const columnIndex = orderedColumns.indexOf(columnType);
      return columnIndex >= 0 ? availParts[columnIndex] || "" : "";
    };

    // ─── NUMERIC COLUMNS (used for type coercion + alignment) ──────────────────
    const NUMERIC_COLUMN_HEADERS = new Set([
      "QTY", "AVL", "SOH", "MOQ",
      "Now", "24hrs", "BO",
      "NSP (Incl. VAT)", "Amt", "NSP (Excl. VAT)", "BOP", "RSP",
      "Weight", "Volume",
      "Volume(Per Unit)", // right-align
      "Dimension",        // right-align (string values like "85x25x25")
      "Parts",            // FIX 2: Brands Info Parts count as number
    ]);

    const toNumber = (raw: string): number | null => {
      if (raw === undefined || raw === null) return null;
      const cleaned = String(raw).replace(/\s/g, "").replace(/,/g, "");
      if (cleaned === "" || cleaned === "-") return null;
      const n = Number(cleaned);
      return isNaN(n) ? null : n;
    };

    // ─── process each table ────────────────────────────────────────────────────
    tables.forEach((tableElement) => {
      const sheetName = tableElement.getAttribute("aria-label")?.trim() || "Sheet1";

      const originalHeaders: string[] = Array.from(
        tableElement.querySelectorAll<HTMLTableCellElement>("thead tr th")
      ).map((th) => th.textContent?.trim() || "");

      const hasSrNo = originalHeaders.some((h) => isSrHeader(h));
      const srNoIndex = originalHeaders.findIndex(isSrHeader);
      const firstColIsBlankSr =
        !hasSrNo &&
        normalize(originalHeaders[0]) === "" &&
        allRowsFirstCellAreNumbers(tableElement);

      const availabilityColumns = checkAvailabilityVisibleColumns(tableElement);

      type OutputCol = {
        header: string;
        kind: "sr" | "part" | "description" | "qtygroup" | "qty" | "availability" | "other";
        sourceIndex: number;
        sub?: "qty" | "avl" | "moq" | "soh" | "now" | "bo" | "24hrs";
        originalHeader?: string;
      };

      const outputCols: OutputCol[] = [];
      const skipIndices = new Set<number>();

      if (hasSrNo) {
        outputCols.push({ header: "Sr No.", kind: "sr", sourceIndex: srNoIndex });
        skipIndices.add(srNoIndex);
      } else if (firstColIsBlankSr) {
        outputCols.push({ header: "Sr No.", kind: "sr", sourceIndex: 0 });
        skipIndices.add(0);
      } else {
        outputCols.push({ header: "Sr No.", kind: "sr", sourceIndex: -1 });
      }

      for (let i = 0; i < originalHeaders.length; i++) {
        if (skipIndices.has(i)) continue;
        const h = originalHeaders[i];
        const n = normalize(h);

        if (n.includes("part no")) {
          outputCols.push({ header: "Part No.", kind: "part", sourceIndex: i });
          outputCols.push({ header: "Alternate Part", kind: "other", sourceIndex: i }); // FIX 3: before Description
          outputCols.push({ header: "Description", kind: "description", sourceIndex: i });
          continue;
        }

        if (n === "quantity" || n.includes("qty")) {
          const { hasSoh, hasMoq } = checkHeaderForColumns(h);
          outputCols.push({ header: "QTY", kind: "qtygroup", sourceIndex: i, sub: "qty", originalHeader: h });
          outputCols.push({ header: "AVL", kind: "qtygroup", sourceIndex: i, sub: "avl", originalHeader: h });
          if (hasSoh) outputCols.push({ header: "SOH", kind: "qtygroup", sourceIndex: i, sub: "soh", originalHeader: h });
          if (hasMoq) outputCols.push({ header: "MOQ", kind: "qtygroup", sourceIndex: i, sub: "moq", originalHeader: h });
          continue;
        }

        if (n.replace(/\s/g, "").includes("quantityqtyavl")) {
          const { hasSoh, hasMoq } = checkHeaderForColumns(h);
          outputCols.push({ header: "QTY", kind: "qtygroup", sourceIndex: i, sub: "qty", originalHeader: h });
          outputCols.push({ header: "AVL", kind: "qtygroup", sourceIndex: i, sub: "avl", originalHeader: h });
          if (hasSoh) outputCols.push({ header: "SOH", kind: "qtygroup", sourceIndex: i, sub: "soh", originalHeader: h });
          if (hasMoq) outputCols.push({ header: "MOQ", kind: "qtygroup", sourceIndex: i, sub: "moq", originalHeader: h });
          continue;
        }

        if (n.replace(/\s/g, "") === "soh") {
          outputCols.push({ header: "SOH", kind: "other", sourceIndex: i });
          continue;
        }

        if (n.replace(/\s/g, "") === "moq") {
          outputCols.push({ header: "MOQ", kind: "other", sourceIndex: i });
          continue;
        }

        if (n.includes("availability")) {
          if (availabilityColumns.hasNow)
            outputCols.push({ header: "Now", kind: "availability", sourceIndex: i, sub: "now" });
          if (availabilityColumns.has24hrs)
            outputCols.push({ header: "24hrs", kind: "availability", sourceIndex: i, sub: "24hrs" });
          if (availabilityColumns.hasBo)
            outputCols.push({ header: "BO", kind: "availability", sourceIndex: i, sub: "bo" });
          continue;
        }

        if (n.includes("dimension")) {
          outputCols.push({ header: "Dimension", kind: "other", sourceIndex: i });
          outputCols.push({ header: "Weight", kind: "other", sourceIndex: i });
          continue;
        }

        if (!h || h.trim() === "") continue;

        outputCols.push({ header: h || "", kind: "other", sourceIndex: i });
      }

      outputCols.push({ header: "Original Part", kind: "other", sourceIndex: -999 });
      outputCols.push({ header: "Error Message", kind: "other", sourceIndex: -999 });

      // ─── FIX 1: Brands Info — always remove Original Part + Error Message ───
      let filteredOutputCols = outputCols;
      if (/brands info/i.test(sheetName)) {
        filteredOutputCols = outputCols.filter(
          (c) =>
            normalize(c.header) !== "delivery block reason" &&
            normalize(c.header) !== "sales office" &&
            normalize(c.header) !== "original part" &&
            normalize(c.header) !== "error message"
        );
      }

      const headers: string[] = filteredOutputCols.map((c) => c.header);
      const tbodyRows = Array.from(
        tableElement.querySelectorAll<HTMLTableRowElement>("tbody tr")
      );

      // ─── FIX 2: Pre-build a map of superseeded row → original part number
      // The DOM pattern is: the superseeded row sits AFTER its parent original row.
      // React renders it with class "superseededRow". The original part no. is the
      // part no. of the PRECEDING non-superseeded row that owns this alternate.
      // We also check every <tr> for any data attribute that carries the original part.
      const originalPartMap = new Map<number, string>(); // tbodyRow index → original part no.
      tbodyRows.forEach((rowElement, rowIndex) => {
        const isSuperseededRow = rowElement.classList.contains("superseededRow");

        // Strategy A: data attribute set by React on the <tr>
        const dataAttr =
          rowElement.getAttribute("data-original-part") ||
          rowElement.getAttribute("data-supercession") ||
          rowElement.getAttribute("data-superseded-by") ||
          rowElement.getAttribute("data-parent-part") ||
          "";
        if (dataAttr.trim()) {
          originalPartMap.set(rowIndex, dataAttr.trim());
          return;
        }

        // Strategy B: dedicated span/element carrying the original part text
        const origSpan =
          rowElement.querySelector<HTMLElement>("[class*='original']") ||
          rowElement.querySelector<HTMLElement>("[class*='superseed']") ||
          rowElement.querySelector<HTMLElement>("[class*='supercession']") ||
          rowElement.querySelector<HTMLElement>("[class*='parentPart']") ||
          rowElement.querySelector<HTMLElement>("[class*='parent-part']");
        if (origSpan) {
          const val = origSpan.textContent?.trim() || "";
          if (val) {
            originalPartMap.set(rowIndex, val);
            return;
          }
        }

        // Strategy C: if this IS a superseeded row, walk BACKWARDS to find the
        // nearest preceding non-superseeded row — its Part No. is the "Original Part"
        if (isSuperseededRow) {
          for (let prev = rowIndex - 1; prev >= 0; prev--) {
            const prevRow = tbodyRows[prev];
            if (!prevRow.classList.contains("superseededRow")) {
              // Get the part no. from the Part No. column of that row
              const partNoColDef = filteredOutputCols.find((c) => c.kind === "part");
              const partNoSrcIdx = partNoColDef ? partNoColDef.sourceIndex : -1;
              if (partNoSrcIdx >= 0) {
                const prevTds = Array.from(prevRow.querySelectorAll<HTMLTableCellElement>("td"));
                const prevPartCell = prevTds[partNoSrcIdx];
                if (prevPartCell) {
                  const prevCellLines = splitCellContent(prevPartCell);
                  const prevPartNo = prevCellLines[0]?.trim() || "";
                  if (prevPartNo) {
                    originalPartMap.set(rowIndex, prevPartNo);
                  }
                }
              }
              break;
            }
          }
        }
      });

      // ─── Process rows ─────────────────────────────────────────────────────────
      const rows: (string | number | null)[][] = [];
      let validRowCounter = 0;

      tbodyRows.forEach((rowElement, rowIndex) => {
        const tds = Array.from(rowElement.querySelectorAll<HTMLTableCellElement>("td"));
        const cellPartsCache = new Map<number, string[]>();
        const qtyGroupCache = new Map<number, { qty: string; avl: string; moq: string; soh: string }>();
        const rowOut: (string | number | null)[] = [];

        const isSuperseeded =
          rowElement.classList.contains("superseededRow") ||
          rowElement.querySelector(".material-icons-outlined") !== null ||
          tds[0]?.querySelector("svg") !== null;

        const isAlternatePart = rowElement.classList.contains("superseededRow") ? "YES" : "NO";

        const getErrorMessage = (): string => {
          if (tds.length < 2) return "";
          const cell = tds[1];

          // FIX 4: Check invalid part text first (invalid / material-not-extended rows)
          const errorSpan =
            cell.querySelector(".invalidPartText") ||
            cell.querySelector(".quantity-error") ||
            cell.querySelector(".text-danger");
          const existingError = errorSpan?.textContent?.trim() || "";
          if (existingError) return existingError;

          // FIX 4: For valid rows shown in main grid, detect procurement blocked via dot indicator
          const hasProcurementDot = cell.querySelector(".dotlegendItemProcCreateEnquiry") !== null;
          if (hasProcurementDot) return "Material Blocked for Procurement";

          return "";
        };

        const getParts = (idx: number): string[] => {
          if (cellPartsCache.has(idx)) return cellPartsCache.get(idx)!;
          const cell = tds[idx];
          const parts = splitCellContent(cell);
          cellPartsCache.set(idx, parts);
          return parts;
        };

        const getQtyGroupValues = (
          idx: number,
          originalHeader: string
        ): { qty: string; avl: string; moq: string; soh: string } => {
          if (qtyGroupCache.has(idx)) return qtyGroupCache.get(idx)!;
          const values = parseQtyAvlMoqSohFromCell(tds[idx], rowIndex, originalHeader);
          qtyGroupCache.set(idx, values);
          return values;
        };

        const dimensionColIdx = originalHeaders.findIndex((h) =>
          normalize(h).includes("dimension")
        );
        const volumeColIdx = originalHeaders.findIndex((h) =>
          normalize(h).includes("volume")
        );

        for (const col of filteredOutputCols) {
          const si = col.sourceIndex;

          // ── Volume virtual column (si === -999, old path — kept for safety) ──
          if (col.header === "Volume" && si === -999) {
            if (volumeColIdx >= 0 && tds[volumeColIdx]) {
              const raw = tds[volumeColIdx]?.textContent?.trim()
                .replace(/cm[³3]?/g, "").trim() || "";
              const num = toNumber(raw);
              rowOut.push(num !== null ? num : raw);
            } else {
              rowOut.push("");
            }
            continue;
          }

          // ── FIX 2: Original Part — use pre-built map ──────────────────────────
          if (col.header === "Original Part" && si === -999) {
            const origVal = originalPartMap.get(rowIndex) || "";
            rowOut.push(origVal);
            continue;
          }

          // ── Error Message virtual column ──────────────────────────────────────
          if (col.header === "Error Message" && si === -999) {
            rowOut.push(getErrorMessage());
            continue;
          }

          // ── Alternate Part virtual column ─────────────────────────────────────
          if (col.header === "Alternate Part") {
            rowOut.push(isAlternatePart);
            continue;
          }

          // ── Weight from Dimension cell ────────────────────────────────────────
          if (col.header === "Weight" && normalize(originalHeaders[si] || "").includes("dimension")) {
            const dimText = tds[si]?.textContent?.trim() || "-";
            const weightMatch = dimText.match(/\|\s*([\d.]+)/);
            const rawWeight = weightMatch ? weightMatch[1].trim() : "";
            const num = toNumber(rawWeight);
            rowOut.push(num !== null ? num : rawWeight === "" ? "-" : rawWeight);
            continue;
          }

          // ── FIX 3a: Dimension — strip weight, push as string, right-align handled by NUMERIC_COLUMN_HEADERS ──
          if (col.header === "Dimension" && normalize(originalHeaders[si] || "").includes("dimension")) {
            const dimText = tds[si]?.textContent?.trim() || "-";
            const dimOnly = dimText.split("|")[0].trim();
            // Push as plain string — NUMERIC_COLUMN_HEADERS includes "Dimension"
            // so the alignment loop will right-align it (string path → cell.t="s", horizontal="right")
            rowOut.push(dimOnly === "" ? "-" : dimOnly);
            continue;
          }

          switch (col.kind) {
            case "sr":
              if (col.sourceIndex === -1) rowOut.push(validRowCounter + 1);
              else {
                const srRaw = tds[si]?.textContent?.trim() ?? String(validRowCounter + 1);
                const srNum = toNumber(srRaw);
                rowOut.push(srNum !== null ? srNum : (validRowCounter + 1));
              }
              break;

            case "part": {
              const pno = getParts(si)[0] ?? "";
              rowOut.push("" + pno);
              break;
            }

            case "description": {
              const parts = getParts(si);
              rowOut.push(parts.length > 1 ? parts.slice(1).join(" ") : "");
              break;
            }

            case "qtygroup": {
              const values = getQtyGroupValues(si, col.originalHeader || "");
              let raw = "";
              if (col.sub === "qty") raw = values.qty;
              else if (col.sub === "avl") raw = values.avl;
              else if (col.sub === "moq") raw = values.moq;
              else if (col.sub === "soh") raw = values.soh;
              const num = toNumber(raw);
              rowOut.push(num !== null ? num : raw);
              break;
            }

            case "qty": {
              const cell = tds[si];
              let val: string | number = "";
              if (col.sub === "qty") {
                const input = cell?.querySelector("input");
                if (input && "value" in input) val = (input as HTMLInputElement).value;
                else val = cell?.textContent?.trim() ?? "";
              } else {
                val = cell?.textContent?.trim() ?? "";
              }
              const num = toNumber(String(val));
              rowOut.push(num !== null ? num : val);
              break;
            }

            case "availability": {
              const availParts = getParts(si);
              const visibleColumns = checkAvailabilityVisibleColumns(tableElement);
              const rawVal = getAvailabilityValueByType(
                availParts,
                col.sub as "now" | "24hrs" | "bo",
                visibleColumns
              );
              const num = toNumber(rawVal);
              rowOut.push(num !== null ? num : rawVal);
              break;
            }

            case "other": {
              // ── FIX 3b: Strip cm³ suffix from Volume(Per Unit) so toNumber works ──
              let raw = tds[si]?.textContent?.trim() ?? "";
              if (col.header === "Volume(Per Unit)") {
                raw = raw.replace(/cm[³3]?/gi, "").trim();
              }
              if (NUMERIC_COLUMN_HEADERS.has(col.header)) {
                const num = toNumber(raw);
                rowOut.push(num !== null ? num : raw);
              } else {
                rowOut.push(raw);
              }
              break;
            }
          }
        }

        // ── Row filter ────────────────────────────────────────────────────────
        let shouldIncludeRow: boolean = true;
        if (!/brands info/i.test(sheetName)) {
          const partNoColumnIndex = filteredOutputCols.findIndex((c) => c.kind === "part");
          const hasValidPartNo =
            partNoColumnIndex >= 0 &&
            rowOut[partNoColumnIndex] !== undefined &&
            String(rowOut[partNoColumnIndex]).trim() !== "";
          shouldIncludeRow = hasValidPartNo;
        } else {
          shouldIncludeRow = rowOut.some((cell) => cell !== null && String(cell).trim() !== "");
        }

        if (shouldIncludeRow) {
          validRowCounter++;
          rows.push(rowOut);
        }
      });

      // ─── Build worksheet ──────────────────────────────────────────────────────
      const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);

      const numericHeaderIndices = new Set(
        headers.map((h, i) => (NUMERIC_COLUMN_HEADERS.has(h) ? i : -1)).filter((i) => i >= 0)
      );


      const range = XLSX.utils.decode_range(ws["!ref"] || "A1");
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellAddr = XLSX.utils.encode_cell({ r: R, c: C });
          const cell: XLSX.CellObject = ws[cellAddr];
          if (!cell) continue;

          if (R === 0) {
            // header row — bold, left-aligned
            cell.s = {
              alignment: { horizontal: "left", vertical: "center", wrapText: false },
              font: { bold: true },
            };
          } else if (numericHeaderIndices.has(C)) {
            if (typeof cell.v === "number") {
              cell.t = "n";
              cell.s = {
                alignment: { horizontal: "right", vertical: "center" },
                numFmt: "0.00",
              };
            } else {
              // string value in a numeric/dimension column — still right-align
              cell.t = "s";
              cell.s = { alignment: { horizontal: "right", vertical: "center" } };
            }
          } else {
            cell.t = "s";
            cell.s = { alignment: { horizontal: "left", vertical: "center", wrapText: false } };
          }
        }
      }

      // ── Auto column widths ────────────────────────────────────────────────────
      const colWidths = headers.map((h, ci) => {
        let max = h.length;
        rows.forEach((row) => {
          const val = row[ci];
          const len = val !== null && val !== undefined ? String(val).length : 0;
          if (len > max) max = len;
        });
        return { wch: Math.min(max + 2, 40) };
      });
      ws["!cols"] = colWidths;

      XLSX.utils.book_append_sheet(workbook, ws, sheetName);
    });

    XLSX.writeFile(workbook, "enquiryexport.xlsx");
  }

  // const exportData = () => {

  //   let combinedArray = [...products, ...invalidParts];

  //   // Create a map to store unique objects based on their 'seq' property or the whole object if 'seq' is undefined
  //   let uniqueMap = new Map();
  //   combinedArray.forEach((item: any) => {
  //     // Generate a key based on the 'seq' value or the whole object if 'seq' is undefined
  //     let key = item.seq !== undefined ? item.seq.toString() : JSON.stringify(item);

  //     // If the key is not already in the map, add the item
  //     if (!uniqueMap.has(key)) {
  //       uniqueMap.set(key, item);
  //     }
  //   });

  //   // Create an array of unique objects
  //   combinedArray = Array.from(uniqueMap.values());
  //   // Sort the array based on the 'seq' property
  //   combinedArray.sort((a, b) => {
  //     if (a.seq !== undefined && b.seq !== undefined) {
  //       return a.seq - b.seq; // Sort based on 'seq' if both are defined
  //     } else if (a.seq !== undefined) {
  //       return -1; // 'a' has 'seq', so it should come before 'b'
  //     } else if (b.seq !== undefined) {
  //       return 1; // 'b' has 'seq', so it should come before 'a'
  //     } else {
  //       return 0; // Both 'a' and 'b' have no 'seq', maintain their relative order
  //     }
  //   });

  //   if (combinedArray && Array.isArray(combinedArray) && combinedArray.length > 0) {
  //     let filename = "enquiryexport.xlsx";
  //     let data: any = [];
  //     if (sessionStorage.getItem('userType') === 'FSE' && getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.customerTierType === "Government" || getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.customerTierType === "Fleet") {
  //       combinedArray.map((item: any) => {
  //         data.push({
  //           'Part No': item.productId,
  //           'Alternate Part': item.isSuperseeded ? 'YES' : 'NO',
  //           Brand: enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] ? enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`].toUpperCase() === "OES" && customerTierType !== 'Workshop' && customerTierType.toLowerCase() !== "tpcdealer" ? "ALAC" :
  //             enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`].toUpperCase() === "TOYOTA" ? "Al Futtaim Motors" :
  //               enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`].toUpperCase() === "TE" ? "Trading Enterprises" :
  //                 enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] === "OESTyres" ? "ALAC Tyres & Batteries" :
  //                   enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] === "OESParts" ? "ALAC AfterMarket Parts" :
  //                     enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] :
  //             '',
  //           "Sub-Brand": enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] === 'OES' && item && item.oesSubBrandName !== '' ? item.oesSubBrandName : enquirySubBrand[`${formatMaterialGroup(item.materialGroup)}`] ? enquirySubBrand[`${formatMaterialGroup(item.materialGroup)}`] : enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] ? enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`].toUpperCase() === "OES" && customerTierType !== 'Workshop' && customerTierType.toLowerCase() !== "tpcdealer" ? "ALAC" :
  //             enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`].toUpperCase() === "TOYOTA" ? "Al Futtaim Motors" :
  //               enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`].toUpperCase() === "TE" ? "Trading Enterprises" : enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] :
  //             '',
  //           'Part Description': item.productIdDescription,
  //           Quantity: !item.isSuperseeded ? item.quantity : '',
  //           'NSP (Incl. VAT)': item.nsp ? getExportNSPValue(item) ? getExportNSPValue(item) : Number(parseFloat(getSellingPrice(item.nsp, isSellingPriceData, markupPercentage)).toFixed(2)) : '0.00',
  //           'RSP': sessionStorage.getItem('userType') === 'FSE' && getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.customerTierType === "Government" || getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.customerTierType === "Fleet" && item.rsp ? Number(parseFloat(item.rsp).toFixed(2)) : '0.00',
  //           'SOH': sessionStorage.getItem('userType') === 'FSE' && item.soh
  //             ? Number(parseInt(item.soh))
  //             : '0.00',
  //           // 'SOH': sessionStorage.getItem('userType') === 'FSE' && item.soh ? Number(parseInt(item.soh)) : '0.00',
  //           Amt: Number(parseFloat(getSellingPrice(getAmtValue(item), isSellingPriceData, markupPercentage)).toFixed(2)),
  //           // 'NSP (Excl. VAT)': item.nspev ? Number(parseFloat(getSellingPrice(item.nspev, isSellingPriceData, markupPercentage)).toFixed(2)) : '0.00',
  //           'NSP (Excl. VAT)': item.nspev ? getExportNSPEVValue(item) ? getExportNSPEVValue(item) : Number(parseFloat(getSellingPrice(item.nspev, isSellingPriceData, markupPercentage)).toFixed(2)) : '0.00',
  //           // BOP: item.aop ? Number(parseFloat(getSellingPrice(item.aop, isSellingPriceData, markupPercentage)).toFixed(2)) : '0.00',
  //           BOP: item.aop ? getExportBOPValue(item) ? getExportBOPValue(item) : Number(parseFloat(getSellingPrice(item.aop, isSellingPriceData, markupPercentage)).toFixed(2)) : '0.00',
  //           Year: item.attributes?.find((attr: any) => attr.name === 'batchYear')?.value || '-',
  //           'Now Availability': item.nowAvailability,
  //           '24 Availability': item.hrs24Availability,
  //           'BO Availability': item.airAvailability,
  //           Dimension: item.isValid
  //             ? `${parseInt(item.dimensions.length)} x ${parseInt(
  //               item.dimensions.width
  //             )} x ${parseInt(item.dimensions.height)}`
  //             : "-",
  //           Weight: item.isValid ? (item.dimensions.grossWeight ? Number(parseFloat(item.dimensions.grossWeight).toFixed(2)) : '-') : "-",
  //           Volume: item.isValid ? Number(parseFloat(item.dimensions.volume).toFixed(2)) : "-",
  //           'Orignal Part': item.supercessionMaterial,
  //           'Error Message': item.isSuperseeded ? '' : item.isProcurementPart ? 'Material Blocked for Procurement' : item.isMaterialNotExtended ? 'Material Not extended to Plant' :
  //             !item.invalidMaterialGroup ? 'Invalid Part' : item.isValid ? '' : `${enquiryMapping[`${formatMaterialGroup(item.invalidMaterialGroup)}`]}` != "undefined" ? isTBLAccess() && enquiryMapping[`${formatMaterialGroup(item.invalidMaterialGroup)}`] === 'OESTyres' ? 'Tyres and Batteries Article' : `No access to ${enquiryMapping[`${formatMaterialGroup(item.invalidMaterialGroup)}`] === 'OESTyres' ? 'ALAC Tyres & Batteries' : enquiryMapping[`${formatMaterialGroup(item.invalidMaterialGroup)}`] === 'OESParts' ? 'ALAC AfterMarket Parts' : enquiryMapping[`${formatMaterialGroup(item.invalidMaterialGroup)}`]} Brand` : item.status ? item.status : 'No access to Brand',
  //         });
  //       });
  //     } else if (sessionStorage.getItem('userType') === 'FSE' && getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.customerTierType !== "Government" || getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.customerTierType !== "Fleet") {
  //       combinedArray.map((item: any) => {
  //         data.push({
  //           'Part No': item.productId,
  //           'Alternate Part': item.isSuperseeded ? 'YES' : 'NO',
  //           Brand: enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] ? enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`].toUpperCase() === "OES" && customerTierType !== 'Workshop' && customerTierType.toLowerCase() !== "tpcdealer" ? "ALAC" :
  //             enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`].toUpperCase() === "TOYOTA" ? "Al Futtaim Motors" :
  //               enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`].toUpperCase() === "TE" ? "Trading Enterprises" :
  //                 enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] === "OESTyres" ? "ALAC Tyres & Batteries" :
  //                   enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] === "OESParts" ? "ALAC AfterMarket Parts" :
  //                     enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`]
  //             : '',
  //           "Sub-Brand": enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] === 'OES' && item && item.oesSubBrandName !== '' ? item.oesSubBrandName : enquirySubBrand[`${formatMaterialGroup(item.materialGroup)}`] ? enquirySubBrand[`${formatMaterialGroup(item.materialGroup)}`] : enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] ? enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`].toUpperCase() === "OES" && customerTierType !== 'Workshop' && customerTierType.toLowerCase() !== "tpcdealer" ? "ALAC" :
  //             enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`].toUpperCase() === "TOYOTA" ? "Al Futtaim Motors" :
  //               enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`].toUpperCase() === "TE" ? "Trading Enterprises" : enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`]
  //             : '',
  //           'Part Description': item.productIdDescription,
  //           Quantity: !item.isSuperseeded ? item.quantity : '',
  //           // 'NSP (Incl. VAT)': item.nsp ? Number(parseFloat(getSellingPrice(item.nsp, isSellingPriceData, markupPercentage)).toFixed(2)) : '0.00',
  //           'NSP (Incl. VAT)': item.nsp ? getExportNSPValue(item) ? getExportNSPValue(item) : Number(parseFloat(getSellingPrice(item.nsp, isSellingPriceData, markupPercentage)).toFixed(2)) : '0.00',
  //           'SOH': sessionStorage.getItem('userType') === 'FSE' && item.soh
  //             ? Number(parseInt(item.soh))
  //             : '0.00',
  //           // 'SOH': sessionStorage.getItem('userType') === 'FSE' && item.soh ? Number(parseInt(item.soh)) : '0.00',
  //           Amt: Number(parseFloat(getSellingPrice(getAmtValue(item), isSellingPriceData, markupPercentage)).toFixed(2)),
  //           // 'NSP (Excl. VAT)': item.nspev ? Number(parseFloat(getSellingPrice(item.nspev, isSellingPriceData, markupPercentage)).toFixed(2)) : '0.00',
  //           'NSP (Excl. VAT)': item.nspev ? getExportNSPEVValue(item) ? getExportNSPEVValue(item) : Number(parseFloat(getSellingPrice(item.nspev, isSellingPriceData, markupPercentage)).toFixed(2)) : '0.00',
  //           // BOP: item.aop ? Number(parseFloat(getSellingPrice(item.aop, isSellingPriceData, markupPercentage)).toFixed(2)) : '0.00',
  //           BOP: item.aop ? getExportBOPValue(item) ? getExportBOPValue(item) : Number(parseFloat(getSellingPrice(item.aop, isSellingPriceData, markupPercentage)).toFixed(2)) : '0.00',
  //           Year: item.attributes?.find((attr: any) => attr.name === 'batchYear')?.value || '-',
  //           'Now Availability': item.nowAvailability,
  //           '24 Availability': item.hrs24Availability,
  //           'BO Availability': item.airAvailability,
  //           Dimension: item.isValid
  //             ? `${parseInt(item.dimensions.length)} x ${parseInt(
  //               item.dimensions.width
  //             )} x ${parseInt(item.dimensions.height)}`
  //             : "-",
  //           Weight: item.isValid ? (item.dimensions.grossWeight ? Number(parseFloat(item.dimensions.grossWeight).toFixed(2)) : '-') : "-",
  //           Volume: item.isValid ? Number(parseFloat(item.dimensions.volume).toFixed(2)) : "-",
  //           'Orignal Part': item.supercessionMaterial,
  //           'Error Message': item.isSuperseeded ? '' : item.isProcurementPart ? 'Material Blocked for Procurement' : item.isMaterialNotExtended ? 'Material Not extended to Plant' :
  //             !item.invalidMaterialGroup ? 'Invalid Part' : item.isValid ? '' : `${enquiryMapping[`${formatMaterialGroup(item.invalidMaterialGroup)}`]}` != "undefined" ? isTBLAccess() && enquiryMapping[`${formatMaterialGroup(item.invalidMaterialGroup)}`] === 'OESTyres' ? 'Tyres and Batteries Article' : `No access to ${enquiryMapping[`${formatMaterialGroup(item.invalidMaterialGroup)}`] === 'OESTyres' ? 'ALAC Tyres & Batteries' : enquiryMapping[`${formatMaterialGroup(item.invalidMaterialGroup)}`] === 'OESParts' ? 'ALAC AfterMarket Parts' : enquiryMapping[`${formatMaterialGroup(item.invalidMaterialGroup)}`]} Brand` : item.status ? item.status : 'No access to Brand',
  //         });
  //         // if (sessionStorage.getItem('userType') === 'FSE') {
  //         //   data.push({
  //         //     'SOH': item.soh ? Number(parseInt(item.soh)) : '0.00',
  //         //     // 'RSP': item.rsp ? Number(parseFloat(item.rsp).toFixed(2)) : '0.00'
  //         //   });
  //         // }
  //       });
  //     } else {
  //       combinedArray.map((item: any) => {
  //         data.push({
  //           'Part No': item.productId,
  //           'Alternate Part': item.isSuperseeded ? 'YES' : 'NO',
  //           Brand: customerTierType === 'tpcdealer' ? 'Tradepoint' : enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] ? enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`].toUpperCase() === "OES" && customerTierType !== 'Workshop' ? "ALAC" :
  //             enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`].toUpperCase() === "TOYOTA" ? "Al Futtaim Motors" :
  //               enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`].toUpperCase() === "TE" ? "Trading Enterprises" :
  //                 enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] === "OESTyres" ?
  //                   "ALAC Tyres & Batteries" :
  //                   enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] === "OESParts" ?
  //                     "ALAC AfterMarket Parts" :
  //                     enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`]
  //             : '',
  //           "Sub-Brand": enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] === 'OES' && item && item.oesSubBrandName !== '' ? item.oesSubBrandName : enquirySubBrand[`${formatMaterialGroup(item.materialGroup)}`] ? enquirySubBrand[`${formatMaterialGroup(item.materialGroup)}`] : customerTierType === 'tpcdealer' ? 'Tradepoint' : enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] ? enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`].toUpperCase() === "OES" && customerTierType !== 'Workshop' ? "ALAC" :
  //             enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`].toUpperCase() === "TOYOTA" ? "Al Futtaim Motors" :
  //               enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`].toUpperCase() === "TE" ? "Trading Enterprises" : enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`]
  //             : '',
  //           'Part Description': item.productIdDescription,
  //           Quantity: !item.isSuperseeded ? item.quantity : '',
  //           // 'NSP (Incl. VAT)': item.nsp ? Number(parseFloat(getSellingPrice(item.nsp, isSellingPriceData, markupPercentage)).toFixed(2)) : '0.00',
  //           'NSP (Incl. VAT)': item.nsp ? getExportNSPValue(item) ? getExportNSPValue(item) : Number(parseFloat(getSellingPrice(item.nsp, isSellingPriceData, markupPercentage)).toFixed(2)) : '0.00',
  //           Amt: Number(parseFloat(getSellingPrice(getAmtValue(item), isSellingPriceData, markupPercentage)).toFixed(2)),
  //           // 'NSP (Excl. VAT)': item.nspev ? Number(parseFloat(getSellingPrice(item.nspev, isSellingPriceData, markupPercentage)).toFixed(2)) : '0.00',
  //           'NSP (Excl. VAT)': item.nspev ? getExportNSPEVValue(item) ? getExportNSPEVValue(item) : Number(parseFloat(getSellingPrice(item.nspev, isSellingPriceData, markupPercentage)).toFixed(2)) : '0.00',
  //           // BOP: item.aop ? Number(parseFloat(getSellingPrice(item.aop, isSellingPriceData, markupPercentage)).toFixed(2)) : '0.00',
  //           BOP: item.aop ? getExportBOPValue(item) ? getExportBOPValue(item) : Number(parseFloat(getSellingPrice(item.aop, isSellingPriceData, markupPercentage)).toFixed(2)) : '0.00',
  //           'Now Availability': item.nowAvailability,
  //           '24 Availability': item.hrs24Availability,
  //           'BO Availability': item.airAvailability,
  //           Dimension: item.isValid
  //             ? `${parseInt(item.dimensions.length)} x ${parseInt(
  //               item.dimensions.width
  //             )} x ${parseInt(item.dimensions.height)}`
  //             : "-",
  //           Weight: item.isValid ? (item.dimensions.grossWeight ? Number(parseFloat(item.dimensions.grossWeight).toFixed(2)) : '-') : "-",
  //           Volume: item.isValid ? Number(parseFloat(item.dimensions.volume).toFixed(2)) : "-",
  //           'Orignal Part': item.supercessionMaterial,
  //           'Error Message': item.isSuperseeded ? '' : item.isProcurementPart ? 'Material Blocked for Procurement' : item.isMaterialNotExtended ? 'Material Not extended to Plant' :
  //             !item.invalidMaterialGroup ? 'Invalid Part' : item.isValid ? '' : `${enquiryMapping[`${formatMaterialGroup(item.invalidMaterialGroup)}`]}` != "undefined" ? isTBLAccess() && enquiryMapping[`${formatMaterialGroup(item.invalidMaterialGroup)}`] === 'OESTyres' ? 'Tyres and Batteries Article' : `No access to ${enquiryMapping[`${formatMaterialGroup(item.invalidMaterialGroup)}`] === 'OESTyres' ? 'ALAC Tyres & Batteries' : enquiryMapping[`${formatMaterialGroup(item.invalidMaterialGroup)}`] === 'OESParts' ? 'ALAC AfterMarket Parts' : enquiryMapping[`${formatMaterialGroup(item.invalidMaterialGroup)}`]} Brand` : item.status ? item.status : 'No access to Brand',
  //         });
  //         // if (sessionStorage.getItem('userType') === 'FSE') {
  //         //   data.push({
  //         //     'SOH': item.soh ? Number(parseInt(item.soh)) : '0.00',
  //         //     // 'RSP': item.rsp ? Number(parseFloat(item.rsp).toFixed(2)) : '0.00'
  //         //   });
  //         // }
  //       });
  //     }
  //     var ws = XLSX.utils.json_to_sheet(data);
  //     var wb = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(wb, ws, "sheet1");
  //     XLSX.writeFile(wb, filename);
  //   }
  // };

  const exportToExcelData = () => {
    if (procuredPart && procuredPart.length > 0) {
      let filename = "ProcurementPartsExport.xlsx";
      let data: any = [];
      procuredPart && Array.isArray(procuredPart) && procuredPart.length > 0 && procuredPart.map((p: any, i: any) => (
        data.push({
          'Part No.': p,
          'Error Message': 'Material Blocked for Procurement'
        })
      ))
      var ws = XLSX.utils.json_to_sheet(data);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "sheet1");
      XLSX.writeFile(wb, filename);
    }
  };

  const exportToExcelMaterialData = () => {
    if (materialNotExtendedPart && materialNotExtendedPart.length > 0) {
      let filename = "materialNotExtendedParts.xlsx";
      let data: any = [];
      materialNotExtendedPart && Array.isArray(materialNotExtendedPart) && materialNotExtendedPart.length > 0 && materialNotExtendedPart.map((p: any, i: any) => (
        data.push({
          'Part No.': p,
          'Error Message': 'Material Not Extended to Plant'
        })
      ))
      var ws = XLSX.utils.json_to_sheet(data);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "sheet1");
      XLSX.writeFile(wb, filename);
    }
  };

  const isNumeric = (n: any) => {
    return !isNaN(parseFloat(n)) && isFinite(n);
  };

  const formatMaterialGroup = (data: any) => {
    if (data) {
      return data.substring(0, 5).toUpperCase()
    } else {
      return "XXXXX"
    }
  }

  const getBrandName = (key: string) => {
    const brandInfo = brandAccess?.find(
      (item: any) => item.code === key
    );

    let brandName = brandInfo?.displayName || key;

    // Hard-coded due to brand name change
    if (key === "AMP") {
      brandName = "Aftermarket Parts";
    }

    if (key === "TBL") {
      brandName = "Tyres, Batteries & Lubes";
    }
    // Special condition for AMP
    // if (
    //   key === "AMP" &&
    //   (customerTierType === "Workshop" ||
    //     customerTierType === "tpcdealer")
    // ) {
    //   brandName = "Tradepoint";
    // }

    return brandName;
  };

  const isColumnVisible = (colName: string) => {

    if (enquiryAction === 'view') {
      return true
    }
    const priceColumns = [
      'NSP (Incl. VAT)',
      'RSP',
      'Amt',
      'NSP (Excl. VAT)',
      'BOP'
    ];

    const availabilityColumns = [
      'NOW',
      'BO',
      '24Hrs'
    ];


    const checkVisibility = (colList?: string[], targetName?: string) => {
      if (Array.isArray(colList)) {
        if (!colList || colList.length === 0) return true;
        return colList.includes(targetName || '');
      }
      return true;
    };

    // Price columns
    if (priceColumns.includes(colName)) {
      return checkVisibility(columnPreferences?.priceColumnVisibility, colName);
    }

    // Availability columns
    if (availabilityColumns.includes(colName)) {
      return checkVisibility(columnPreferences?.availabilityColumnVisibility, colName);
    }

    // Default columns
    return checkVisibility(columnPreferences?.visibleColumns, colName);
  }

  const getEnquiryNumber = (
    data: any[],
    brandName: string,
    isMultiEnquiryCustomer: boolean
  ) => {

    if (!data?.length) return '';
    const isCD01Brand =
      brandName === 'Tyres, Batteries & Lubes' ||
      brandName === 'Aftermarket Parts';

    if (isMultiEnquiryCustomer) {
      const enquiry = isCD01Brand
        ? data.find((item: any) => item.salesOffice === 'CD01')
        : data.find((item: any) => item.salesOffice !== 'CD01');

      return enquiry?.enquiryNumber || '';
    }

    const enquiryNumber =
      data[0]?.enquiryNumber ||
      data[0]?.products?.[0]?.enquiryNumber ||
      '';

    return enquiryNumber;
  };
  const renderRows = () => {
    globalSearchedPartsData.filteredList = [];
    globalSearchedPartsData.validParts = [];
    globalSearchedPartsData.invalidParts = [];
    let mappedData: any = [];
    let invalidProducts: any = [];
    if (products && Array.isArray(products) && products.length > 0) {
      let productunref: any = JSON.parse(JSON.stringify(products));

      if (searchByPartNo && searchByPartNo.length >= 3) {

        productunref = productunref.filter((item: any) =>
          item.productId?.toLowerCase().includes(searchByPartNo.toLowerCase()) ||
          item.productIdDescription?.toLowerCase().includes(searchByPartNo.toLowerCase())
        );
      }

      if (searchByPartNo && searchByPartNo.length >= 3 && productunref.length === 0) {
        return [
          <TableRow key="no-part-found">
            <TableCell colSpan={15} className="text-center font-weight-600">
              No Part found
            </TableCell>
          </TableRow>,
        ];
      }
      globalSearchedPartsData.filteredList = productunref;

      // 🚫 Remove deleted items first
      productunref = productunref.filter((item: any) => item.action !== "D");

      productunref.forEach((item: any, index: any) => {
        if (item.isAddToEnquiry !== false) {
          let storeItem: any = JSON.parse(JSON.stringify(item));
          let isParentPartExist: any = ((item?.isChildPart || item?.isParentPart) && !item.isMaterialNotExtended) ? true : false
          storeItem["actualIndex"] = index;
          let categoryKey = enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`];
          let brandName = getBrandName(categoryKey);
          // // ✅ Brand filter check
          if (columnPreferences && columnPreferences?.brandFilter &&
            columnPreferences?.brandFilter?.length > 0 &&
            !columnPreferences?.brandFilter?.includes(brandName) && enquiryAction !== 'view'
          ) {
          } else {
            const isParentChild = item.isParentPart || item.isChildPart;
            if (annexureEnquiry === 'true') {
              if (
                item.materialGroup &&
                enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] &&
                !item.isMaterialNotExtended &&
                item.isValid
              ) {
                const category = enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`];
                mappedData.push(storeItem);
              } else {
                invalidProducts.push(storeItem);
              }
            } else if ((isOESOEM || iamMap.current) && annexureEnquiry !== 'true') {
              if (!columnPreferences?.alternatePartsToggle && enquiryAction !== "view") {
                //  Toggle OFF → Only allow parent parts
                if ((item.isParentPart || item.isChildPart !== true) && ((!item.isMaterialNotExtended && item.materialGroup) || (item.materialGroup &&
                  enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] &&
                  !item.isMaterialNotExtended))) {
                  mappedData.push(storeItem);
                } else if (item.isValid === false) {
                  invalidProducts.push(storeItem);
                }
                if (invalidParts && invalidParts.length > 0) {

                  invalidParts.forEach((invalidItem: any) => {

                    const isParent = invalidItem.isParentPart === true;
                    const isChild = invalidItem.isChildPart === true;

                    const alreadyExists = mappedData.some(
                      (existingItem: any) =>
                        existingItem.seq === invalidItem.seq &&
                        existingItem.isParentPart === invalidItem.isParentPart
                    );

                    // ✅ Always add parent (even if invalid)
                    if (isParent && !alreadyExists) {
                      mappedData.push(invalidItem);
                      return;
                    }

                    // ✅ Add child parts
                    if (isChild && !alreadyExists) {

                      if (!invalidItem.isMaterialNotExtended) {
                        mappedData.push(invalidItem);
                      } else {
                        let adjustedSeq = invalidItem.seq - isCountOfMaterialNotExtendedParts;
                        adjustedSeq = adjustedSeq >= 0 ? adjustedSeq : 0;

                        mappedData.splice(adjustedSeq, 0, invalidItem);
                      }
                    }
                  });

                  // ✅ VERY IMPORTANT → maintain order
                  mappedData.sort((a: any, b: any) => a.seq - b.seq);
                }
              } else {
                //  Toggle ON → Keep original OES/OEM logic
                if (
                  (isParentPartExist && !item.isMaterialNotExtended && item.materialGroup) ||
                  (item.materialGroup &&
                    enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] &&
                    !item.isMaterialNotExtended)
                ) {
                  mappedData.push(storeItem);
                } else {
                  invalidProducts.push(storeItem);
                }

                if (invalidParts && invalidParts.length > 0) {

                  invalidParts.forEach((invalidItem: any) => {

                    const isParent = invalidItem.isParentPart === true;
                    const isChild = invalidItem.isChildPart === true;

                    const alreadyExists = mappedData.some(
                      (existingItem: any) =>
                        existingItem.seq === invalidItem.seq &&
                        existingItem.isParentPart === invalidItem.isParentPart
                    );

                    // ✅ Always add parent (even if invalid)
                    if (isParent && !alreadyExists) {
                      mappedData.push(invalidItem);
                      return;
                    }

                    // ✅ Add child parts
                    if (isChild && !alreadyExists) {

                      if (!invalidItem.isMaterialNotExtended) {
                        mappedData.push(invalidItem);
                      } else {
                        let adjustedSeq = invalidItem.seq - isCountOfMaterialNotExtendedParts;
                        adjustedSeq = adjustedSeq >= 0 ? adjustedSeq : 0;

                        mappedData.splice(adjustedSeq, 0, invalidItem);
                      }
                    }
                  });

                  // ✅ VERY IMPORTANT → maintain order
                  mappedData.sort((a: any, b: any) => a.seq - b.seq);
                }
              }
            } else {
              if (
                item.materialGroup &&
                enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] &&
                !item.isMaterialNotExtended
              ) {
                const category = enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`];
                mappedData.push(storeItem);
              } else {
                invalidProducts.push(storeItem);
              }
            }
          }
        }
      });

      if (invalidParts && invalidParts.length > 0) {
        const combinedArray = [...invalidProducts];

        for (const item of invalidParts) {
          const isAlreadyExists = combinedArray.some(
            (element) =>
              `${element.seq}-${element.productId}` ===
              `${item.seq}-${item.productId}`
          );

          if (!isAlreadyExists) {
            combinedArray.push(item);
          }
        }

        invalidProducts = combinedArray;
      }
    }

    function reorderParts(mappedData: any[]) {
      let reordered: any[] = [];

      // Step 1: take only parts that have seq (non-superseeded) and sort by seq
      const normalParts = mappedData
        .filter((item) => item.seq !== undefined && item.seq !== null)
        .sort((a, b) => a.seq - b.seq);

      // helper to insert children recursively
      const insertChildren = (parent: any) => {
        const children = mappedData.filter(
          (s) =>
            (s.seq === undefined || s.seq === null) &&
            s.isSuperseeded &&
            s.supercessionMaterial === parent.productId &&
            !reordered.includes(s)
        );

        children.forEach((child) => {
          reordered.push(child);
          insertChildren(child); // recursive: in case child has its own superseeded children
        });
      };

      // Step 2: add parents and their children
      normalParts.forEach((part) => {
        reordered.push(part);
        insertChildren(part);
      });

      // Step 3: append any leftover superseeded parts (orphans)
      const leftovers = mappedData.filter(
        (s) =>
          (s.seq === undefined || s.seq === null) &&
          s.isSuperseeded &&
          !reordered.includes(s)
      );
      reordered.push(...leftovers);

      return reordered;
    }

    // Usage
    mappedData = reorderParts(mappedData);

    /* ---------- build finalRows ---------- */
    let finalRows: any[] = [];

    // ✅ Directly render rows from mappedData (no categories)
    mappedData.forEach((row: any, idx: number) => {
      finalRows.push(
        <Row
          key={`row-${idx}`}
          index={idx}
          availability={availability}
          setcheckedAllBO={setcheckedAllBO}
          setcheckedAllNow={setcheckedAllNow}
          setChecked24hrs={setChecked24hrs}
          isChangeCheckBox={isChangeCheckBox}
          enquiryAction={enquiryAction}
          setisSelectedAll={setisSelectedAll}
          setreferenceNumber={setreferenceNumber}
          setbrandRefNumbers={setbrandRefNumbers}
          brandRefNumbers={brandRefNumbers}
          setDeliveryBlockReason={setDeliveryBlockReason}
          deliveryBlockReason={deliveryBlockReason}
          salesOffice={salesOffice}
          setSalesOffice={setSalesOffice}
          products={products}
          brandName={row.brand || "-"} // 👈 You may decide how to handle brand here
          brandData={[row]}            // 👈 Single-item array since Row expects brandData
          verificationData={verificationData}
          isAvailabiityChecked={isAvailabiityChecked}
          setproducts={setproducts}
          setIsQuantityUpdated={setIsQuantityUpdated}
          isSellingPriceData={isSellingPriceData}
          markupPercentage={markupPercentage}
          enquiryMapping={enquiryMapping}
          // enquiryMappingTPC={enquiryMappingTPC}
          enquirySubBrand={enquirySubBrand}
          isSpecialPrice={isSpecialPrice}
          spParts={spParts}
          isAvailabiityCheckedAtTime={isAvailabiityCheckedAtTime}
          isSPRModifyData={isSPRModifyData}
          accessData={accessData}
          requestStatus={requestStatus}
          setDisableQuotation={setDisableQuotation}
          selectedAccessType={selectedAccessType}
          handleOpenModal={handleOpenModal}
          annexureEnquiry={annexureEnquiry}
          isTBLAccess={isTBLAccess}
          handleOpenEnquiryGridImage={handleOpenEnquiryGridImage}
          columnPreferences={columnPreferences}
        />
      );
    });

    if (mappedData && mappedData.length === 0 && products && products.length > 0 && invalidParts && invalidParts.length === 0) {
      finalRows.push(
        <TableRow className="MuiPaper-elevation1">
          <TableCell
            colSpan={100}
            align="center"
            style={{ textAlign: "center" }}
            className="py-5 MuiPaper-elevation1"
          >
            No parts found
          </TableCell>
        </TableRow>
      )
    }
    // Step 5: Invalid products rendering
    if (invalidParts && invalidParts.length > 0) {
      const combinedArray = [...invalidProducts];
      for (const item of invalidParts) {
        if (!combinedArray.some(element => element.seq === item.seq)) {
          if ((item?.isChildPart || (item?.isParentPart)) && !item.isMaterialNotExtended) {
          } else {
            combinedArray.push(item);
          }
        }
      }
      invalidProducts = combinedArray;
    }

    if (searchByPartNo && searchByPartNo.length >= 3) {
      invalidProducts = invalidProducts.filter((item: any) =>
        item.productId?.toLowerCase().includes(searchByPartNo.toLowerCase())
      );
    }

    invalidProducts.forEach((item: any) => {
      const rowClassCondition =
        !item.isValid ||
        item.isMaterialNotExtended ||
        item.isProcurementPart ||
        item.isZeroPrice ||
        item.isInvalid ||
        item.isRowGreyed;

      if (!item.isProcurementPart) {
        finalRows.push(
          <TableRow
            key={`invalid-${item.productId}-${item.seq}`}
            className={
              rowClassCondition ? "invalidRowClass invalidRowClassInvalid" : ""
            }
          >
            <TableCell className="">
              <input
                type="checkbox"
                disabled={true}
                checked={item.selected ? true : false}
                onChange={() => {
                  if (enquiryAction !== "view") {
                    let productsTemp: any = JSON.parse(JSON.stringify(products));

                    let dataCheck = productsTemp.filter((ele: any) => {
                      return ele.productId === item.productId
                    })
                    if (dataCheck.length > 0) {
                      productsTemp[item.actualIndex]["selected"] = !item.selected;
                      setproducts([...productsTemp]);
                      setisSelectedAll(false);
                    } else {
                      let seqArr = [...products, ...invalidParts];
                      let selectEle = seqArr.filter((ele) => ele.productId == item.productId);
                      selectEle[0].selected = !item.selected;
                      setproducts([...seqArr])
                    }

                  }
                }}
              />
            </TableCell>
            <TableCell className="invalidRowClassInvalidPart">
              <div className="greyLabelTable fontsizetenew px-2">{item.productId}</div>
              <div className="greyLabelTable invalidPartText fontsizetenew px-2">
                {/* {item.productId == procuredPart ? "Material blocked for Procurement" : !item.invalidMaterialGroup ? 'Invalid part' : `${enquiryMapping[`${formatMaterialGroup(item.invalidMaterialGroup)}`]}` != "undefined" ? `${enquiryMapping[`${formatMaterialGroup(item.invalidMaterialGroup)}`]} Brand not allowed` : "Brand not allowed"} */}
                {
                  sessionStorage.getItem("userType") === "FSE" &&
                    customerTypeAccess.includes("dealer") &&
                    sessionStorage.getItem('annexureEnquiry') === "true"
                    ? item.error
                      ? item.error
                      : "Does not belong to Annexure/Core Products list."
                    : customerTierType === "Dealer" &&
                      annexureEnquiry === "true"
                      ? item.error
                        ? item.error
                        : "Does not belong to Annexure/Core Products list."
                      : item.isMaterialNotExtended
                        ? 'Material Not Extended to plant'
                        : item.isProcurementPart
                          ? "Material blocked for Procurement"
                          : item.isZeroPrice
                            ? 'Zero Price Part'
                            : !item.invalidMaterialGroup
                              ? 'Invalid part'
                              : enquiryMapping[
                                formatMaterialGroup(item.invalidMaterialGroup)
                              ] !== undefined
                                ? (
                                  isTBLAccess() &&
                                  enquiryMapping[
                                  formatMaterialGroup(item.invalidMaterialGroup)
                                  ] === 'TBL'
                                )
                                  ? 'Tyres and Batteries Article'
                                  : `No access to ${getBrandDisplayName(
                                    enquiryMapping[
                                    formatMaterialGroup(item.invalidMaterialGroup)
                                    ]
                                  )} Brand`
                                : "No access to Brand"
                }
              </div>
            </TableCell>
            <TableCell className="font-10 font-weight-700">
              {item && (!item.materialGroup || item.materialGroup === '') ? '' : enquirySubBrand?.[`${formatMaterialGroup(item.materialGroup)}`] ? enquirySubBrand[`${formatMaterialGroup(item.materialGroup)}`] : item?.subBrandName?.trim() ? item.subBrandName :
                customerTierType && customerTierType.toLowerCase() !== "tpcdealer" ? (
                  <>
                    {item && item.materialGroup ? getNewBrand(enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`]) : ''}
                  </>
                ) : (
                  <>
                    {item && item.materialGroup ? getNewBrand(enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`]) : ''}
                  </>
                )}

              {/* {customerTierType && customerTierType.toLowerCase() !== "tpcdealer" ? (
                <>
                  {item && item.materialGroup ? getNewBrand(enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`]) : ''}
                </>
              ) : (
                <>
                  {item && item.materialGroup ? getNewBrand(enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`]) : ''}
                </>
              )} */}

              {/* {item && item.materialGroup ? getNewBrand(enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`]) : ''} */}
            </TableCell>
            <TableCell className="pl-0 pr-0 invalidRowClassInvalidPart">
              <div className="row" style={{ margin: 0, alignItems: "center" }}>
                {/* Qty Input */}
                <div
                  className={
                    sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ||
                      (customerTierType && customerTierType.toLowerCase() === 'tbl dealer')
                      ? 'col-3 d-flex justify-content-center align-items-center'
                      : 'col-4 d-flex justify-content-center align-items-center'
                  }
                >
                  <input
                    onChange={(e) => {
                      if (enquiryAction !== "view") {
                        let productsTemp: any = JSON.parse(
                          JSON.stringify(products)
                        );
                        let value = e.target.value && parseInt(e.target.value) && /^[+]?\d+([.]\d+)?$/.test(e.target.value) &&
                          parseInt(e.target.value) >= 1
                          ? parseInt(e.target.value)
                          : ""
                        setquantity(value);
                        productsTemp[item.actualIndex]["quantity"] = value;
                        setproducts([...productsTemp]);
                      }
                    }}
                    value={item.quantity}
                    maxLength={5}
                    type="text"
                    className="cardCommon mr-2 smallcircularinputFiled"
                    placeholder=""
                  />
                </div>
                {/* Avl */}
                <div
                  className={
                    sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ||
                      (customerTierType && customerTierType.toLowerCase() === 'tbl dealer')
                      ? 'col-3 d-flex justify-content-center align-items-center'
                      : 'col-4 d-flex justify-content-center align-items-center'
                  }
                >
                  <span className="font-11 font-weight-700">
                    {item.avl !== undefined ? item.avl : "0"}
                  </span>
                </div>
                {/* SOH (FSE only) */}
                {
                  sessionStorage.getItem('userType') === 'FSE' && (
                    <div className="col-3 d-flex justify-content-center align-items-center">
                      <span className="font-11 font-weight-700">
                        {item.soh !== undefined ? item.soh : ""}

                      </span>
                    </div>
                  )
                }
                {/* MOQ for Dealer/TBL Dealer */}
                {
                  ((customerTierType && customerTierType.toLowerCase() === 'tbl dealer') || customerTierType === "Dealer") &&
                  isTBLAccess() &&
                  annexureEnquiry !== 'true' && (
                    <div
                      className={
                        sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ||
                          (customerTierType && customerTierType.toLowerCase() === 'tbl dealer')
                          ? 'col-3 d-flex justify-content-center align-items-center'
                          : 'col-4 d-flex justify-content-center align-items-center'
                      }
                    >
                      <span className="font-11 font-weight-700">
                        {item.moq !== undefined ? item.moq : ""}
                      </span>
                    </div>
                  )
                }
              </div >
            </TableCell >
            {isColumnVisible('RSP') && isColumnVisible('Price') && (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') && getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.customerTierType === "Government" || getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.customerTierType === "Fleet" ?
              <TableCell className="font-10 font-weight-700 text-444">{isAvailabiityChecked && item["rsp"] ? item["rsp"] : "XX.XX"}</TableCell>
              : ""}
            {/* <TableCell className=" font-10 font-weight-700 text-444">{isAvailabiityChecked && item["rsp"] ? item["rsp"] : "XX.XX"}</TableCell> */}
            {isColumnVisible('NSP (Incl. VAT)') && isColumnVisible('Price') && (
              <TableCell className=" font-10 font-weight-700 text-444">{isAvailabiityChecked && item["nsp"] ? item["nsp"] : 0.00}</TableCell>
            )}
            {isColumnVisible('Amt') && isColumnVisible('Price') && (
              <TableCell className=" font-10 font-weight-700 text-444">{isAvailabiityChecked ? parseFloat(getSellingPrice(getAmtValue(item), isSellingPriceData, markupPercentage)).toFixed(2) : 0.00}</TableCell>
            )}
            {isColumnVisible('NSP (Excl. VAT)') && isColumnVisible('Price') && (
              <TableCell className=" font-10 font-weight-700 text-444">{isAvailabiityChecked && item["nspev"] ? item["nspev"] : 0.00}</TableCell>
            )}
            {isColumnVisible('BOP') && isColumnVisible('Price') && (
              <>
                {annexureEnquiry === "true" ? null : (
                  <TableCell className=" font-10 font-weight-700 text-444">{isAvailabiityChecked && item["bop"] ? item["bop"] : 0.00}</TableCell>
                )}
              </>
            )}
            {annexureEnquiry === 'true' || window.location.pathname.includes('annexure') ? null : (customerTierType && customerTierType.toLowerCase() === 'tbl dealer' || customerTierType === "Dealer") &&
              isTBLAccess() && (
                <TableCell className="font-10 font-weight-700 text-444">
                  {item.attributes?.find((attr: any) => attr.name === 'batchYear')?.value || '-'}
                </TableCell>
              )}
            {isColumnVisible('Availability') && (
              <TableCell className="invalidRowClassInvalidPart">
                <div className="row no-gutters">
                  {isColumnVisible('NOW') && (
                    <div className="col-4 greyLabelTable">
                      <input type="checkbox" disabled />{" "}
                      {isAvailabiityChecked && item["nowAvailability"]
                        ? item["nowAvailability"]
                        : "0"}
                    </div>
                  )}
                  {isColumnVisible('BO') && (
                    <>
                      {annexureEnquiry === "true" ? null : (
                        <div className="col-4 greyLabelTable">
                          <input type="checkbox" disabled /> {isAvailabiityChecked && item["airAvailability"]
                            ? item["airAvailability"]
                            : "0"}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </TableCell>
            )}
            {isColumnVisible('Dimension') && (
              <TableCell className="invalidRowClassInvalidPart">
                <div className="greyLabelTable fontsizetenew">
                  {item.isValid
                    ? `${parseInt(item.dimensions.length)} x ${parseInt(
                      item.dimensions.width
                    )} x ${parseInt(item.dimensions.height)} | ${item.dimensions.grossWeight ? parseFloat(item.dimensions.grossWeight).toFixed(2) : '-'}`
                    : "-"}
                </div>
              </TableCell>
            )}
            {isColumnVisible('Volume') && (
              <TableCell className="invalidRowClassInvalidPart">
                <div className="greyLabelTable fontsizetenew">
                  {item.isValid ? `${parseInt(item.dimensions.volume)}m` : "-"}
                </div>
              </TableCell>
            )}
          </TableRow>
        );
      }
    });

    globalSearchedPartsData.validParts = mappedData;
    globalSearchedPartsData.invalidParts = invalidProducts;

    return finalRows;
  };

  const getMappedDataByBrandAccess = () => {
    const mappedData: any = {};

    if (brandAccess && Array.isArray(brandAccess)) {
      brandAccess.forEach((item: any) => {
        mappedData[item.code] = [];
      });
    }

    // Optional fallback
    if (Object.keys(mappedData).length === 0) {
      mappedData["Others"] = [];
    }

    return mappedData;
  };

  const getRenderRowsBrandInfo = () => {
    let mappedData: any;
    rowSummaryGlobalData = []; // Clear previous values
    mappedData = getMappedDataByBrandAccess() || {};
    // if (
    //   customerTierType &&
    //   (customerTierType.toLowerCase() === "tbl dealer" ||
    //     customerTierType.toLowerCase() === "dealer")
    // ) {
    //   mappedData = {
    //     Toyota: [],
    //     Honda: [],
    //     Famco: [],
    //     TE: [],
    //     BYD: [],
    //     Others: [],
    //     OESParts: [],
    //     OESTyres: [],
    //   };
    // } else {
    //   mappedData = {
    //     Toyota: [],
    //     Honda: [],
    //     Famco: [],
    //     BYD: [],
    //     TE: [],
    //     Others: [],
    //     OES: [],
    //   };
    // }
    let invalidProducts: any = [];
    if (products && Array.isArray(products) && products.length > 0) {
      let productunref: any = JSON.parse(JSON.stringify(products));

      if (searchByPartNo && searchByPartNo.length >= 3) {
        productunref = productunref.filter((item: any) =>
          item.productId?.toLowerCase().includes(searchByPartNo.toLowerCase()) ||
          item.productIdDescription?.toLowerCase().includes(searchByPartNo.toLowerCase())
        );
      }

      // if (searchByPartNo && searchByPartNo.length >= 3 && productunref.length === 0) {
      //   return [
      //     <TableRow key="no-part-found">
      //       <TableCell colSpan={15} className="text-center font-weight-600">
      //         No Part found
      //       </TableCell>
      //     </TableRow>,
      //   ];
      // }

      productunref.map((item: any, index: any) => {
        if (item.isAddToEnquiry !== false) {
          let storeItem: any = JSON.parse(JSON.stringify(item));
          let isParentPartExist: any = ((item?.isChildPart || item?.isParentPart) && !item.isMaterialNotExtended) ? true : false
          storeItem["actualIndex"] = index;
          if (annexureEnquiry === 'true') {
            if (
              item.materialGroup &&
              enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] &&
              !item.isMaterialNotExtended &&
              item.isValid
            ) {
              const category = enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`];
              if (!mappedData[category]) {
                mappedData[category] = [];
              }
              mappedData[category].push(storeItem);
            } else {
              invalidProducts.push(storeItem);
            }
          } else if ((isOESOEM || iamMap.current) && annexureEnquiry !== 'true') {
            if ((isParentPartExist && !item.isMaterialNotExtended && item.materialGroup) || (item.materialGroup && enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] &&
              !item.isMaterialNotExtended)) {
              const category = enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`];
              if (!mappedData[category]) {
                mappedData[category] = [];
              }
              mappedData[category].push(storeItem);
            } else {
              invalidProducts.push(storeItem);
            }
          } else {
            if (
              item.materialGroup &&
              enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`] &&
              !item.isMaterialNotExtended
            ) {
              const category = enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`];
              if (!mappedData[category]) {
                mappedData[category] = [];
              }
              mappedData[category].push(storeItem);
            } else {
              invalidProducts.push(storeItem);
            }
          }
        }
      });

      if (invalidParts && invalidParts.length > 0) {
        const combinedArray = [...invalidProducts];
        for (const item of invalidParts) {
          if (!combinedArray.some((element) => element.seq === item.seq)) {
            combinedArray.push(item);
          }
        }
        invalidProducts = combinedArray;
      }
    }

    if (searchByPartNo && searchByPartNo.length >= 3) {
      invalidProducts = invalidProducts.filter((item: any) =>
        item.productId?.toLowerCase().includes(searchByPartNo.toLowerCase())
      );
    }

    Object.keys(mappedData).map((key) => {
      mappedData[key] = mappedData[key].sort((a: any, b: any) => {
        let deciderCondition = b.isSuperseeded ? -1 : 1;
        let part1ItemNumber =
          a.nowEnquiryItemNumber || a.hrs24EnquiryItemNumber || a.airEnquiryItemNumber;
        let part2ItemNumber =
          b.nowEnquiryItemNumber || b.hrs24EnquiryItemNumber || b.airEnquiryItemNumber;
        return parseInt(part1ItemNumber) > parseInt(part2ItemNumber)
          ? 1
          : parseInt(part2ItemNumber) > parseInt(part1ItemNumber)
            ? -1
            : deciderCondition;
      });
    });

    let tyrePartsDataLength: any = 0;
    Object.keys(mappedData).map((key) => {
      if (mappedData[key].length > 0) {

        // Get displayName from brandAccess using code
        const brandInfo = brandAccess?.find(
          (item: any) => item.code === key
        );

        let brandName = brandInfo?.displayName || key;

        // Hard-coded due to brand name change
        if (key === "AMP") {
          brandName = "Aftermarket Parts";
        }

        if (key === "TBL") {
          brandName = "Tyres, Batteries & Lubes";
        }

        // Special condition for AMP
        // if (
        //   key === "AMP" &&
        //   (customerTierType === "Workshop" ||
        //     customerTierType === "tpcdealer")
        // ) {
        //   brandName = "Tradepoint";
        // }

        rowSummaryGlobalData.push({
          brandCodeInfo: key,
          brandNameInfo: brandName,
          itemCountInfo: mappedData[key].length,
          verificationDataInfo: verificationData,
          brandCodeAsPerTheBrand: key
        });

        if (key === "TBL") {
          tyrePartsDataLength = mappedData[key].length;
        }
      }
    });
  };

  const enquiryDataToEditMode = async (enquiryDataFetched: any, reset?: any, withDeletion?: any, availabilityMode?: any) => {
    let productsTemp: any = [];
    let sp: any = false;
    let orgsAssignedToUser = "";
    productsTemp = productsTemp.filter((product: any) => product.isValid);
    // let pushedProducts: any = [];
    let brandRefNumbersTemp = JSON.parse(JSON.stringify(brandRefNumbers));
    // if (sessionStorage.getItem('userType') === 'FSE') {
    let deliveryBlockReasonTemp = JSON.parse(JSON.stringify(deliveryBlockReason));
    // }
    if (assignedBrandsData && Array.isArray(assignedBrandsData)) {
      assignedBrandsData.map((item: any) => {
        if (item.code) {
          orgsAssignedToUser += enquiryMappingReverse[
            `${item.code}`
          ] + ",";
        }
      });
    }
    if (customerTierType && customerTierType.toLowerCase() === "tbl dealer" || customerTierType === 'Dealer' || customerTypeAccess.includes('dealer')) {
      let orgArray = orgsAssignedToUser.split(',').filter(Boolean); // removes empty strings

      if (!isTBLAccess() && isPartsAccess()) {
        orgArray = orgArray.filter((org) => org !== "AMPTB"); // ✅ remove AMPTB if Tyres not included
      } else if (!isPartsAccess() && isOnlyTBLAccess()) {
        orgArray = orgArray.filter(org => org === 'AMPTB'); // ✅ remove ALPOE if Parts not included
      }
      // Remove duplicates and convert back to comma-separated string
      orgsAssignedToUser = [...new Set(orgArray)].join(',') + ',';
    }

    // if (!productsTemp || productsTemp.length === 0) {
    enquiryDataFetched && enquiryDataFetched.length > 0 && enquiryDataFetched.map((subenquiry: any, index: any) => {
      const isAFGPattern = /^AFG\d{4}$/.test(subenquiry.masterReferenceNumber);
      if (!isAFGPattern) {
        setreferenceNumber(subenquiry.masterReferenceNumber);
      }
      if (enquiryDataFetched && enquiryDataFetched.length === 1) {
        if (enquiryDataFetched[0].status) {
          // setEnquiryStatus(enquiryDataFetched[0].status);
          if (enquiryDataFetched[0].status && enquiryDataFetched[0].status.toLowerCase() === 'verification queued') {
            setIsQueue(true);
            setCheckAvailabilityButtonText(CHECK_AVAILABILITY_BUTTON_TEXT.QUEUED)
          } else if (enquiryDataFetched[0].status && enquiryDataFetched[0].status.toLowerCase() === 'verification in progress' && enquiryDataFetched[0].isQueued) {
            setIsQueue(true);
            setCheckAvailabilityButtonText(CHECK_AVAILABILITY_BUTTON_TEXT.PROGRESS)
          } else {
            setIsQueue(false);
            setCheckAvailabilityButtonText(CHECK_AVAILABILITY_BUTTON_TEXT.NORMAL)
          }
          if (enquiryDataFetched[0].status && enquiryDataFetched[0].status.toLowerCase() === 'order placement queued') {
            setorderQueued(true)
          }
        }
      } else {
        if (enquiryDataFetched[0].status) {
          // setEnquiryStatus(enquiryDataFetched[0].status);
          if (enquiryDataFetched.some((obj: any) => obj.status.toLowerCase() === 'verification queued')) {
            setIsQueue(true);
            setCheckAvailabilityButtonText(CHECK_AVAILABILITY_BUTTON_TEXT.QUEUED)
          } else if (enquiryDataFetched.some((obj: any) => obj.status.toLowerCase() === 'verification in progress') && enquiryDataFetched.some((obj: any) => obj.isQueued)) {
            setIsQueue(true);
            setCheckAvailabilityButtonText(CHECK_AVAILABILITY_BUTTON_TEXT.PROGRESS)
          } else {
            setIsQueue(false);
            setCheckAvailabilityButtonText(CHECK_AVAILABILITY_BUTTON_TEXT.NORMAL)
          }
          if (enquiryDataFetched.some((obj: any) => obj.status.toLowerCase() === 'order placement queued')) {
            setorderQueued(true)
          }
        }
      }
      if (enquiryDataFetched[0].specailPriceRequestDetails && enquiryDataFetched[0].specailPriceRequestDetails) {
        setRequestSPData(enquiryDataFetched[0].specailPriceRequestDetails && enquiryDataFetched[0].specailPriceRequestDetails)
        setSpParts(enquiryDataFetched[0].specailPriceRequestDetails && enquiryDataFetched[0].specailPriceRequestDetails.products)
        setIsSpEnquiry(true);
        sp = true;
      }
      // if (subenquiry && subenquiry.removedProducts && Array.isArray(subenquiry.removedProducts)) {
      //   setRemovedProductsLength(subenquiry.removedProducts.length)
      //   let combinedArray = [...subenquiry.removedProducts];
      //   let seqMap = new Map();
      //   combinedArray.forEach(item => {
      //     if (!seqMap.has(item.seq)) {
      //       seqMap.set(item.seq, item);
      //     }
      //   });

      //   // Get values from the map to retrieve unique items based on 'seq'
      //   combinedArray = Array.from(seqMap.values());
      //   combinedArray.sort((a: any, b: any) => a.seq - b.seq);

      //   setInvalidParts(combinedArray)

      // }


      // if (invalidParts && invalidParts.length > 0 && !isAvailabiityChecked) {
      //   setInvalidParts(invalidParts)
      // }
      if (subenquiry && subenquiry.products && Array.isArray(subenquiry.products)) {
        subenquiry.products.map((productSub: any) => {
          // if (!pushedProducts.includes(productSub.productId)) {
          //   pushedProducts.push(productSub.productId);
          // productsTemp.push(JSON.parse(JSON.stringify(productSub)));
          // }
          // setreferenceNumber(subenquiry.masterReferenceNumber);
          if (subenquiry.verifiedOn && index == 0) {
            var now = moment(new Date());
            var start = moment(new Date(subenquiry.verifiedOn));
            var duration: any = moment.duration(start.diff(now));
            var minutes: any = Math.abs(duration.asMinutes());
            if (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') {
              if (!(minutes && minutes > 60) || availabilityMode) {
                if (!sp && !isQueue) {
                  setisAvailabiityCheckedAtTime(new Date(subenquiry.verifiedOn)) // need to change as per new key
                  setIsTimmerExpired(false); // Reset the expired flag to allow timer restart
                }
                if (selectedAccessType === "Parts" || (isTyrePartsSearchSuccessFully === true && isTyrePartsAddedtoGrid === true) || products.some((p: any) => p.isAddToEnquiry === false)) {
                  setisAvailabiityChecked(true);
                }
                setDisableQuotation(false);
              }
            }
            else {
              if (!(minutes && minutes > 5) || availabilityMode) {
                if (!sp && !isQueue) {
                  setisAvailabiityCheckedAtTime(new Date(subenquiry.verifiedOn))
                  setIsTimmerExpired(false); // Reset the expired flag to allow timer restart
                }
                if (selectedAccessType === "Parts" || (isTyrePartsSearchSuccessFully === true && isTyrePartsAddedtoGrid === true) || products.some((p: any) => p.isAddToEnquiry === false)) {
                  setisAvailabiityChecked(true);
                }
                setDisableQuotation(false);
              }
            }
          }
          brandRefNumbersTemp[
            `${enquiryMapping[`${formatMaterialGroup(productSub.materialGroup)}`]}`
          ] = productSub.enquiryReferenceNumber;

          if (productSub && productSub.deliveryBlockReason && productSub.deliveryBlockReason !== '') {
            if (deliveryBlockReasonTemp[`${enquiryMapping[`${formatMaterialGroup(productSub.materialGroup)}`]}`]
            ) {
              deliveryBlockReasonTemp[
                `${enquiryMapping[`${formatMaterialGroup(productSub.materialGroup)}`]}`
              ].deliveryBlockReason = productSub.deliveryBlockReason;

              deliveryBlockReasonTemp[
                `${enquiryMapping[`${formatMaterialGroup(productSub.materialGroup)}`]}`
              ].deliveryBlockReasonCode = productSub.deliveryBlockReasonCode;
            }
          }
          if (enquiryDataFetched[0].specailPriceRequestDetails && enquiryDataFetched[0].specailPriceRequestDetails.expiredAfterApproval == false && enquiryDataFetched[0].specailPriceRequestDetails.status == 'Approved') {
            enquiryDataFetched[0].specailPriceRequestDetails.products && Array.isArray(enquiryDataFetched[0].specailPriceRequestDetails.products) &&
              enquiryDataFetched[0].specailPriceRequestDetails.products.map((spProducts: any) => {
                let approvedPrice: any = 0.00;
                let boapprovedPrice: any = 0.00;

                if (enquiryDataFetched[0].specailPriceRequestDetails.offeredTotalPriceType === "part" && spProducts.isSpecialPriced == false && spProducts["nowAvailability"]) {
                  if (spProducts.nowOfferedPriceType == 'byPercentage' && spProducts["nowOfferedCalculatedPrice"] && spProducts["nowOfferedCalculatedPrice"] !== '' && spProducts["nowOfferedCalculatedPrice"] !== 'NaN') {
                    approvedPrice = parseFloat(spProducts["nowOfferedCalculatedPrice"]).toFixed(2)
                  } else if (spProducts.nowOfferedPriceType == 'byCurrency' && spProducts["nowOfferedPrice"] && spProducts["nowOfferedPrice"] !== '' && spProducts["nowOfferedPrice"] !== 'NaN') {
                    approvedPrice = parseFloat(spProducts["nowOfferedPrice"]).toFixed(2);
                  } else {
                    approvedPrice = parseFloat(spProducts["nspev"]).toFixed(2);
                  }
                  if (spProducts.productId === productSub.productId && spProducts.nowEnquiryItemNumber === productSub.nowEnquiryItemNumber) {
                    productSub['spNowAvailability'] = spProducts.nowAvailability;
                    productSub["nowApprovedPrice"] = approvedPrice;
                  }
                }
                else if (enquiryDataFetched[0].specailPriceRequestDetails.offeredTotalPriceType === "total" && spProducts["nspev"] && spProducts["nowAvailability"] && spProducts.isSpecialPriced === false &&
                  enquiryDataFetched[0].specailPriceRequestDetails.status === 'Approved') {
                  if (enquiryDataFetched[0].specailPriceRequestDetails.offeredTotalPriceCurrency === "By AED") {
                    let value: any = enquiryDataFetched[0].specailPriceRequestDetails.offeredTotalPriceCalculated.replace("%", "").replace("-", "");
                    let newNsp: any = (parseFloat(value) * spProducts["nspev"]) / 100;
                    let ns: any = spProducts["nspev"] - parseFloat(newNsp);
                    approvedPrice = parseFloat(ns).toFixed(2);
                  }
                  if (enquiryDataFetched[0].specailPriceRequestDetails.offeredTotalPriceCurrency === "By %") {
                    let newNsp: any = (parseFloat(enquiryDataFetched[0].specailPriceRequestDetails.offeredTotalPrice) * spProducts["nspev"]) / 100;
                    let ns: any = spProducts["nspev"] - parseFloat(newNsp);
                    approvedPrice = parseFloat(ns).toFixed(2);
                  }
                  if (spProducts.productId == productSub.productId && spProducts.nowEnquiryItemNumber === productSub.nowEnquiryItemNumber) {
                    productSub['spNowAvailability'] = spProducts.nowAvailability;
                    productSub["nowApprovedPrice"] = approvedPrice;
                  }
                }

                if (enquiryDataFetched[0].specailPriceRequestDetails.offeredTotalPriceType === "part" && spProducts.isSpecialPriced == false && spProducts["airAvailability"]) {
                  if (spProducts.airOfferedPriceType == 'byPercentage' && spProducts["airOfferedCalculatedPrice"] && spProducts["airOfferedCalculatedPrice"] !== '' && spProducts["airOfferedCalculatedPrice"] !== 'NaN') {
                    boapprovedPrice = parseFloat(spProducts["airOfferedCalculatedPrice"]).toFixed(2)
                  } else if (spProducts.airOfferedPriceType == 'byCurrency' && spProducts["airOfferedPrice"] && spProducts["airOfferedPrice"] !== '' && spProducts["airOfferedPrice"] !== 'NaN') {
                    boapprovedPrice = parseFloat(spProducts["airOfferedPrice"]).toFixed(2);
                  } else {
                    boapprovedPrice = parseFloat(spProducts["aop"]).toFixed(2);
                  }
                  if (spProducts.productId == productSub.productId && spProducts.airEnquiryItemNumber === productSub.airEnquiryItemNumber) {
                    productSub['spAirAvailability'] = spProducts.airAvailability;
                    productSub["airApprovedPrice"] = boapprovedPrice;
                  }
                  // if(spProducts.airAvailability > productSub.airAvailability) {

                  // }
                }
                else if (enquiryDataFetched[0].specailPriceRequestDetails.offeredTotalPriceType === "total" && spProducts["aop"] && spProducts["airAvailability"] && spProducts.isSpecialPriced === false &&
                  enquiryDataFetched[0].specailPriceRequestDetails.status === 'Approved') {
                  if (enquiryDataFetched[0].specailPriceRequestDetails.offeredTotalPriceCurrency === "By AED") {


                    let value: any = enquiryDataFetched[0].specailPriceRequestDetails.offeredTotalPriceCalculated.replace("%", "").replace("-", "");
                    let newBop: any = (parseFloat(value) * spProducts["bop"]) / 100;
                    let bo: any = spProducts["aop"] - parseFloat(newBop);
                    approvedPrice = parseFloat(bo).toFixed(2);

                    // let value: any = (parseFloat(enquiryDataFetched[0].specailPriceRequestDetails.offeredTotalPriceCalculated.replace("%", "").replace("-", "")) * spProducts["bop"]) / 100
                    // boapprovedPrice = parseFloat(value).toFixed(2);
                  }
                  if (enquiryDataFetched[0].specailPriceRequestDetails.offeredTotalPriceCurrency === "By %") {
                    let newBop: any = (parseFloat(enquiryDataFetched[0].specailPriceRequestDetails.offeredTotalPrice) * spProducts["aop"]) / 100;
                    let bo: any = spProducts["aop"] - parseFloat(newBop);
                    boapprovedPrice = parseFloat(bo).toFixed(2);
                  }
                  if (spProducts.productId == productSub.productId && spProducts.airEnquiryItemNumber === productSub.airEnquiryItemNumber) {
                    productSub['spAirAvailability'] = spProducts.airAvailability;
                    productSub["airApprovedPrice"] = boapprovedPrice;
                  }
                }
              });

          }
          // responsePart?.productId?.trim()?.toUpperCase() === item.productId.trim().toUpperCase() &&
          // formatMaterialGroup(responsePart?.attributes?.materialGroup?.value) &&
          // orgsAssignedToUser.includes(formatMaterialGroup(responsePart?.attributes?.materialGroup?.value))
          productSub["materialGroup"] = formatMaterialGroup(productSub.materialGroup) &&
            orgsAssignedToUser.includes(formatMaterialGroup(productSub.materialGroup)) ? productSub.materialGroup : '';
          productSub["isValid"] = formatMaterialGroup(productSub.materialGroup) &&
            orgsAssignedToUser.includes(formatMaterialGroup(productSub.materialGroup)) ? true : false;
          productSub["enquiryNumber"] = subenquiry.enquiryNumber;
          productSub["id"] = subenquiry.id;
          if ((isOESOEM || iamMap.current) && annexureEnquiry !== 'true') {
            productSub["isParentPart"] = productSub.isParentPart;
            productSub["isChildPart"] = productSub.isChildPart;
            productSub["brandName"] = productSub.brandName;
          }
          productSub["error"] = productSub.error;
          productSub["successMessage"] = productSub.successMessage;
          productSub["isRowGreyed"] = productSub.isRowGreyed;
          productSub["popupError"] = productSub.popupError;
          productsTemp.push(JSON.parse(JSON.stringify(productSub)));
        });
      }
    });
    productsTemp = productsTemp.map((item: any) => {
      if (item.isMaterialNotExtended) {
        item.action = "D";
        // item["isValid"] = false;
      } else {
        item.action = "C";
      }
      return item;
    });
    // setbrandRefNumbers({ ...brandRefNumbersTemp });
    setDeliveryBlockReason({ ...deliveryBlockReasonTemp })
    let rmparts: any = await getRemovedProducts(enquiryDataFetched) || invalidParts;

    if ((invalidParts && invalidParts.length > 0) || (rmparts && rmparts.length > 0) || (enquiryDataFetched && enquiryDataFetched.length > 0 && enquiryDataFetched[0].removedProducts && enquiryDataFetched[0].removedProducts.length > 0)) {
      // Iterate over invalidParts to filter out objects with isProcurementPart = true
      // let rmparts: any = enquiryDataFetched && enquiryDataFetched.length > 0 && enquiryDataFetched[0].removedProducts || invalidParts;

      rmparts
        .filter((part: any) => part.isValid === false)
        .forEach((part: any) => {
          if (part.isProcurementPart === true || part.isZeroPrice) {
            const existingIndex = productsTemp.findIndex((item1: any) => item1.seq === part.seq);
            if (existingIndex === -1) {
              productsTemp.splice(part.seq - 1, 0, part);
            } else {
              console.log(`An object with sequence ${part.seq} already exists in the products array.`);
            }
          }
        });
    }

    setproducts([...productsTemp]);
    setActualProductLength(productsTemp.length);
    setisUpdateMode(true);
    setisEnquirySaved(true);
    // requestPriceAccess();
    if (sessionStorage.getItem('partsData')) {
      let partsDataExisting: any = sessionStorage.getItem("partsData");
      let newData: any = JSON.parse(partsDataExisting);
      sessionStorage.setItem("partsData", '');
      commonInsertionLogicforOES(newData, productsTemp);
    }
    return
  };

  const getNowwAnxPrice = (item: any, annexureEnquiry: any, downgradedTier?: any, annexureDetail?: any, orgId?: any) => {
    if (annexureEnquiry !== 'true') return;

    const annexureDetails = annexureDetail ? annexureDetail : item.annexureDetails;
    if (!annexureDetails || !annexureDetails.quantityTierRange || !annexureDetails.priceTierRange) return;

    const quantity = parseInt(item.quantity);
    if (isNaN(quantity)) return;

    let matchedTier = '';

    for (const [tierKey, range] of Object.entries(annexureDetails.quantityTierRange)) {
      const typedRange = range as { minQty: any; maxQty: any };
      const minQty = parseInt(typedRange.minQty);
      const maxQty = parseInt(typedRange.maxQty);

      if (quantity >= minQty && quantity <= maxQty) {
        matchedTier = tierKey;
        break;
      }
    }
    if (downgradedTier) {
      matchedTier = downgradedTier;
    }

    // ✅ Allowed tiers
    const allowedTiers = ["gold", "platinum", "elite"];

    let tierType: any = ""; // default
    const brandTierObj = brandPricingTier.current?.[0];
    if (brandTierObj?.tier) {
      let extractedTier = brandTierObj.tier.split('-').pop()?.trim()?.toLowerCase();

      if (allowedTiers.includes(extractedTier)) {
        tierType = extractedTier;
      } else {
        tierType = null; // fallback
      }
    }
    // }

    // // Convert pricingTier to lowercase (e.g. 'Elite' → 'elite')
    // if (pricingTier !== '') {
    //   tierType = pricingTier.toLowerCase();
    // } else {
    //   if (sessionStorage.getItem('userType') === 'FSE') {
    //     tierType = getCustomerDetailsBySapId?.data?.pricingTier;
    //   } else {
    //     tierType = get(profileDetails, 'data.data.customerInfo.pricingTier', '');
    //   }
    // }

    tierType = tierType?.toLowerCase();

    if (matchedTier && annexureDetails.priceTierRange[matchedTier]?.[tierType]) {
      const price = parseFloat(annexureDetails.priceTierRange[matchedTier][tierType]);
      if (!isNaN(price)) {
        return price.toFixed(2);
      }
    }
  };

  const applyAnnexurePricing = (item: any, annexureEnquiry: string, downgradedTier?: any) => {
    if (annexureEnquiry !== 'true') return;

    const annexureDetails = item.annexureDetails;
    if (!annexureDetails || !annexureDetails.quantityTierRange || !annexureDetails.priceTierRange) return;

    const quantity = parseInt(item.quantity);
    if (isNaN(quantity)) return;

    let matchedTier = '';

    for (const [tierKey, range] of Object.entries(annexureDetails.quantityTierRange)) {
      const typedRange = range as { minQty: any; maxQty: any };
      const minQty = parseInt(typedRange.minQty);
      const maxQty = parseInt(typedRange.maxQty);

      if (quantity >= minQty && quantity <= maxQty) {
        matchedTier = tierKey;
        break;
      }
    }
    if (downgradedTier) {
      matchedTier = downgradedTier;
    }
    const allowedTiers = ["gold", "platinum", "elite"];

    // --- Determine pricing tier dynamically ---
    let tierType: any = '';
    const brandTierObj = brandPricingTier.current?.[0];
    if (brandTierObj?.tier) {
      let extractedTier = brandTierObj.tier.split('-').pop()?.trim()?.toLowerCase();

      if (allowedTiers.includes(extractedTier)) {
        tierType = extractedTier;
      } else {
        tierType = null; // fallback
      }
    }

    // if (pricingTier && pricingTier !== '') {
    //   tierType = pricingTier.toLowerCase();
    // } else {
    //   if (sessionStorage.getItem('userType') === 'FSE') {
    //     tierType = getCustomerDetailsBySapId?.data?.pricingTier;
    //   } else {
    //     tierType = get(profileDetails, 'data.data.customerInfo.pricingTier', '');
    //   }
    // }

    // Convert to lowercase safely
    tierType = tierType?.toLowerCase() || 'gold';

    // --- Fetch tier-based price dynamically ---
    const tierPrice = annexureDetails.priceTierRange[matchedTier]?.[tierType];

    if (matchedTier && tierPrice) {
      const parsedPrice = parseFloat(tierPrice);
      if (!isNaN(parsedPrice)) {
        // Removed toFixed(2) — maintain numeric value for further calc
        item.nspev = parsedPrice;
        item.nowAnxPrice = parsedPrice;
        item.nsp = parsedPrice * 1.05; // Add 5% uplift
      }
    }
  };

  const verifyEnquiryDataToEditMode = async (enquiryDataFetched: any, enquiryDataFetchedGetCall?: any, deletion?: any, queue?: any, isCopyfromItems?: any, isAddToEnquiry: any = true, callerProductsSnapshot?: any) => {
    let productsTemp: any = [];
    let procurement: any = [];
    let materialNotExtended: any = [];
    let isPro: any = false;
    let isMat: any = false;
    if (enquiryDataFetchedGetCall && Array.isArray(enquiryDataFetchedGetCall)) {
      enquiryDataFetchedGetCall.map((subenquiry: any, index: any) => {
        if (subenquiry && subenquiry.products && Array.isArray(subenquiry.products)) {
          subenquiry.products.map((productSub: any) => {
            productSub["enquiryNumber"] = subenquiry.enquiryNumber;
            if ((isOESOEM || iamMap.current) && annexureEnquiry !== 'true') {
              productSub["isParentPart"] = productSub.isParentPart;
              productSub["isChildPart"] = productSub.isChildPart;
              productSub["brandName"] = productSub.brandName;
            }
            productSub["id"] = subenquiry.id;
            productsTemp.push(JSON.parse(JSON.stringify(productSub)));
          });
        }
      });
      productsTemp.map((item: any) => {
        if (item.isMaterialNotExtended) {
          item.action = "D";
        } else {
          item.action = "C";
        }
        return item;
      });
    } else {
      productsTemp = JSON.parse(JSON.stringify(products));
    }
    productsTemp = productsTemp.filter((product: any) => product.isValid && !product.isSuperseeded);
    productsTemp = productsTemp.map((item: any) => {
      item["nowAvailability"] = 0;
      // item["nowAvailabilityChecked"] = false;
      // >>>>>>>>>>>>>>>>>>>>>>>>> NEW 24 HRS CODE <<<<<<<<<<<<<<<<<<<<<
      if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer")) {
        item["hrs24Availability"] = 0;
        // item["hrs24AvailabilityChecked"] = false;
      }
      // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
      item["airAvailability"] = 0;
      // item["airAvailabilityChecked"] = false;
      item["action"] = item.isMaterialNotExtended ? "D" : "C";
      return item;
    });


    let enquiryDataFetchedLatest = enquiryDataFetched && enquiryDataFetched.error && Array.isArray(enquiryDataFetched.error) && enquiryDataFetched.error.length > 0 ? enquiryDataFetched.error : enquiryDataFetched;
    if (enquiryDataFetchedLatest && Array.isArray(enquiryDataFetchedLatest)) {
      const filteredData = enquiryDataFetchedLatest.filter(
        (item, index, self) => {
          const code = item.materialGroupCode;

          // ✅ If no materialGroupCode → keep all
          if (!code) return true;

          // ✅ If exists → apply deduplication
          return (
            index ===
            self.findIndex(
              (t) => t.materialGroupCode === code
            )
          );
        }
      );

      setIsSpecialPrice(filteredData[0].specialPriceRequestType);
      filteredData.map((subEnquiries: any) => {
        if (subEnquiries && subEnquiries["verifiedData"] &&
          subEnquiries["verifiedData"]["items"] &&
          Array.isArray(subEnquiries["verifiedData"]["items"])
        ) {
          if (queue && isCopyfromItems) {
            subEnquiries["verifiedData"]["confirmations"] = subEnquiries["verifiedData"]["items"];
          }
          if (isAddToEnquiry === false && annexureEnquiry === 'true') {
          } else {
            subEnquiries["verifiedData"]["items"].map((item: any) => {
              if (item && item.procurementBlockIndicator && item.procurementBlockIndicator === 'X') {
                procurement.push(item.materialNumber)
              }
            });
            subEnquiries["verifiedData"]["items"].map((item: any) => {
              if (item && item.isMaterialNotExtended) {
                // Prefer callerProductsSnapshot — the caller's OWN local productsTemp, built
                // directly from what was actually just searched/sent, so isAddToEnquiry is
                // guaranteed accurate. Neither productsTemp built here (from the backend's
                // enquiry response, which may not echo back this frontend-only flag at all)
                // nor the outer `products` state (a stale closure — this function runs inside
                // the same call chain that just inserted a brand-new Tyre-search result,
                // before that insert is committed to React state) can be trusted for this.
                const exclusionCheckSource = Array.isArray(callerProductsSnapshot) ? callerProductsSnapshot : productsTemp;
                const isNotYetAddedToEnquiry = exclusionCheckSource.some(
                  (p: any) => p.productId === item.materialNumber && p.isAddToEnquiry === false
                );
                // Still a live, uncommitted Tyre-search result — don't flag it Material Not
                // Extended (nothing for the user to act on via that popup yet). Deletion of
                // isAddToEnquiry === false parts is handled uniformly elsewhere (Check
                // Availability, Save/Update Order Enquiry, switching to Parts) for ALL such
                // parts, not just the ones that happen to be Material Not Extended.
                if (!isNotYetAddedToEnquiry) {
                  materialNotExtended.push(item.materialNumber)
                }
              }
            });
          }
        }
        if (procurement && procurement.length > 0 && annexureEnquiry !== 'true') {
          setprocuredPart(procurement);
          isPro = true;
          setIsProcuredPartExist(true);
        } else {
          isPro = false;
          setIsProcuredPartExist(false);
        }
        if (materialNotExtended && materialNotExtended.length > 0 && annexureEnquiry !== 'true') {
          setCountOfMaterialNotExtendedParts(materialNotExtended.length)
          setMaterialNotExtendedPart(materialNotExtended);
          setIsMaterialNotExtendedExist(true);
          isMat = true;
        } else {
          isMat = false;
          setIsMaterialNotExtendedExist(false);
        }
        if (
          subEnquiries &&
          subEnquiries["verifiedData"] &&
          subEnquiries["verifiedData"]["confirmations"] &&
          Array.isArray(subEnquiries["verifiedData"]["confirmations"])
        ) {
          subEnquiries["verifiedData"]["confirmations"] = subEnquiries["verifiedData"]["confirmations"].filter(
            (item: any, index: any, self: any) => {
              if (item.superceededPartIndicator?.toUpperCase() === "X") {
                return (
                  index ===
                  self.findLastIndex(
                    (t: any) =>
                      t.supercessionMaterial === item.supercessionMaterial &&
                      t.superceededPartIndicator?.toUpperCase() === "X"
                  )
                );
              }
              return true; // keep non-"X" records as is
            }
          );
          subEnquiries["verifiedData"]["confirmations"].map((confirmationsingle: any) => {
            let availableQty: any = 0;
            let isItemFound = false;
            productsTemp && productsTemp.length > 0 && productsTemp.map((item: any) => {
              if (procurement && procurement.length > 0 && procurement.includes(item.productId)) {
                item["isProcurementPart"] = true;
                item['selected'] = false; // selected made false for procurement items -Bhargavi 25/03 for sending action C
              }
              if (materialNotExtended && materialNotExtended.length > 0 && materialNotExtended.includes(item.productId)) {
                item["isMaterialNotExtended"] = true;
                item['selected'] = false;
              }
              if (item.productId == confirmationsingle.proposedArticle && item.nowEnquiryItemNumber == confirmationsingle.enquiryItemNumber) {
                isItemFound = true;
                if (annexureEnquiry === 'true') {
                  if (
                    confirmationsingle &&
                    (confirmationsingle["deliveryBucketId"] &&
                      confirmationsingle["deliveryBucketId"].toUpperCase() === "NOW") || !confirmationsingle["deliveryBucketId"]
                  ) {
                    availableQty = parseInt(confirmationsingle.availableQuantityforProposedArticle);
                    const requestedQty = parseInt(item.quantity);
                    const tierRanges = item.annexureDetails?.quantityTierRange;
                    const priceTiers = item.annexureDetails?.priceTierRange;
                    let currentTier = '';
                    if (tierRanges) {
                      for (const [tier, range] of Object.entries(tierRanges as Record<string, { minQty: string; maxQty: string }>)) {
                        const min = parseInt(range.minQty);
                        const max = range.maxQty !== "" ? parseInt(range.maxQty) : 99999; // Treat empty maxQty as 99999
                        if (requestedQty >= min && requestedQty <= max) {
                          currentTier = tier;
                          break;
                        }
                      }
                    }

                    const tier1Min = parseInt(tierRanges?.tier_1?.minQty);
                    if (requestedQty >= tier1Min && availableQty < tier1Min) {
                      item.error = "Low stock. Min. Tier 1 Qty not fulfilled";
                      item.isRowGreyed = true;
                      item.popupError = true;
                      item.nowAvailabilityChecked = false;
                      applyAnnexurePricing(item, annexureEnquiry, false); // Apply downgraded tier pricing
                      return;
                    }
                    //  else {
                    //   item.error = '';
                    //   item.isRowGreyed = false;
                    //   item.popupError = false;
                    //   item.nowAvailabilityChecked = true;
                    // }

                    // Case 3: Available quantity fits a lower tier than requested
                    if (availableQty < requestedQty && availableQty >= tier1Min) {
                      let downgradedTier = '';
                      if (tierRanges) {
                        for (const [tier, range] of Object.entries(tierRanges as Record<string, { minQty: string; maxQty: string }>)) {
                          const min = parseInt(range.minQty);
                          const max = range.maxQty !== "" ? parseInt(range.maxQty) : 99999;
                          if (availableQty >= min && availableQty <= max) {
                            downgradedTier = tier;
                            break;
                          }
                        }
                      }

                      if (downgradedTier && downgradedTier !== currentTier) {
                        item.error = `Low Stock. ${downgradedTier.replace('_', ' ').toUpperCase()} price applied`;
                        item.popupError = true;
                        applyAnnexurePricing(item, annexureEnquiry, downgradedTier); // Apply downgraded tier pricing
                      }
                    }
                    if (tierRanges) {
                      for (const [tier, range] of Object.entries(tierRanges as Record<string, { minQty: string; maxQty: string }>)) {
                        const min = parseInt(range.minQty);
                        const max = range.maxQty !== "" ? parseInt(range.maxQty) : 99999;

                        if (requestedQty >= min && requestedQty <= max) {
                          item.successMessage = `Tier ${tier.split('_')[1]} Price applied`;
                          // if (availableQty < requestedQty) {
                          //   item.error = 'Requested quantity exceeds available stock';
                          //   item.isRowGreyed = true;
                          //   item.popupError = true;
                          // } else {
                          item.error = '';
                          item.isRowGreyed = false;
                          item.popupError = false;
                          // }
                          break;
                        }
                      }
                    }

                  }
                }

                if (
                  confirmationsingle &&
                  confirmationsingle["deliveryBucketId"] &&
                  confirmationsingle["deliveryBucketId"].toUpperCase() === "NOW"
                ) {
                  item["nowAvailability"] = parseInt(
                    confirmationsingle.availableQuantityforProposedArticle
                  );
                  item["nowAvailabilityChecked"] = item.error !== '' && item.isRowGreyed ? false : item["nowAvailability"] ? true : false;

                  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< 24 hrs Code >>>>>>>>>>>>>>>>>>>>>>
                } else if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && confirmationsingle && confirmationsingle["deliveryBucketId"] && confirmationsingle["deliveryBucketId"] === "24") {
                  item["hrs24Availability"] = parseInt(
                    confirmationsingle.availableQuantityforProposedArticle
                  );
                  item["hrs24AvailabilityChecked"] = annexureEnquiry === 'true' ? false : item["hrs24Availability"] ? true : false;
                  // .....................................................................
                } else {
                  item["airAvailability"] = parseInt(
                    confirmationsingle.availableQuantityforProposedArticle
                  );
                  item["airAvailabilityChecked"] =
                    annexureEnquiry === 'true'
                      ? false
                      : item["isProcurementPart"] && item["airAvailability"] !== 0
                        ? false
                        // : customerTierType &&
                        //   customerTierType.toLowerCase() === 'tbl dealer'
                        //   ? false
                        : item["airAvailability"]
                          ? true
                          : false;
                  // item["airAvailabilityChecked"] = annexureEnquiry === 'true' || item.accessTyres === true ? false : item["isProcurementPart"] && item["airAvailability"] !== 0 ? false : sessionStorage.getItem('userType') === 'FSE' || customerTierType && customerTierType.toLowerCase() === 'tbl dealer' ? false : item["airAvailability"] ? true : false;
                }
                item["isSpecialPriced"] =
                  confirmationsingle.priceActivIndicator &&
                    confirmationsingle.priceActivIndicator === "X"
                    ? true
                    : false;
                item["isSpecialPriceRequestPart"] = confirmationsingle.isSpecialPriceRequestPart ? true : false;
                item["isRejected"] = confirmationsingle.isRejected ? true : false;
                item["rsp"] = parseFloat(
                  confirmationsingle.maximumRetailSalesPrice
                ).toFixed(2);
                item["soh"] = parseInt(
                  confirmationsingle.totalAtpQuantityAtSiteLevel
                );
                item["amt"] = parseFloat(
                  confirmationsingle.forwardOrderPrice
                ).toFixed(2);
                if (annexureEnquiry === 'true') {
                  applyAnnexurePricing(item, annexureEnquiry);
                } else {
                  item["nsp"] = parseFloat(
                    confirmationsingle.netSalesPrice
                  ).toFixed(2);
                  item["nspev"] = parseFloat(
                    confirmationsingle.netSellingPriceexcludingVAT ? confirmationsingle.netSellingPriceexcludingVAT : confirmationsingle.netSellingPriceExcludingVat
                  ).toFixed(2);
                }
                if (item["nowAvailabilityChecked"]) {
                  item["nowOfferedPrice"] = parseFloat(
                    confirmationsingle.nowOfferedPrice ? confirmationsingle.nowOfferedPrice : confirmationsingle.nowOfferedPrice
                  ).toFixed(2);
                  item["nowRequestPrice"] = parseFloat(
                    confirmationsingle.nowRequestPrice ? confirmationsingle.nowRequestPrice : confirmationsingle.nowRequestPrice
                  ).toFixed(2);
                  item["nowOfferedCalculatedPrice"] = parseFloat(
                    confirmationsingle.nowOfferedCalculatedPrice ? confirmationsingle.nowOfferedCalculatedPrice : confirmationsingle.nowOfferedCalculatedPrice
                  ).toFixed(2);
                  item["nowRequestPriceType"] =
                    confirmationsingle.nowRequestPriceType ? confirmationsingle.nowRequestPriceType : confirmationsingle.nowRequestPriceType
                  item["nowOfferedPriceType"] =
                    confirmationsingle.nowOfferedPriceType ? confirmationsingle.nowOfferedPriceType : confirmationsingle.nowOfferedPriceType
                }
                if (item["airAvailabilityChecked"]) {
                  item["airRequestPrice"] = parseFloat(
                    confirmationsingle.airRequestPrice ? confirmationsingle.airRequestPrice : confirmationsingle.airRequestPrice
                  ).toFixed(2);
                  item["airOfferedCalculatedPrice"] = parseFloat(
                    confirmationsingle.airOfferedCalculatedPrice ? confirmationsingle.airOfferedCalculatedPrice : confirmationsingle.airOfferedCalculatedPrice
                  ).toFixed(2);
                  item["airOfferedPrice"] = parseFloat(
                    confirmationsingle.airOfferedPrice ? confirmationsingle.airOfferedPrice : confirmationsingle.airOfferedPrice
                  ).toFixed(2);
                  item["airRequestPriceType"] =
                    confirmationsingle.airRequestPriceType ? confirmationsingle.airRequestPriceType : confirmationsingle.airRequestPriceType
                  item["airOfferedPriceType"] =
                    confirmationsingle.airOfferedPriceType ? confirmationsingle.airOfferedPriceType : confirmationsingle.airOfferedPriceType
                }
                item["aop"] = parseFloat(
                  confirmationsingle.forwardOrderPrice
                ).toFixed(2);
                if (
                  confirmationsingle &&
                  confirmationsingle["deliveryBucketId"] &&
                  confirmationsingle["deliveryBucketId"].toUpperCase() === "NOW"
                ) {
                  item["nowEnquiryItemNumber"] = confirmationsingle.enquiryItemNumber ? confirmationsingle.enquiryItemNumber : "";
                  item["nowProposedItemNumber"] = confirmationsingle.proposedItemNumber ? confirmationsingle.proposedItemNumber : "";
                  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 24 HRS CODE <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
                } else if (confirmationsingle && confirmationsingle["deliveryBucketId"] && confirmationsingle["deliveryBucketId"] === "24") {
                  item["hrs24EnquiryItemNumber"] = confirmationsingle.enquiryItemNumber ? confirmationsingle.enquiryItemNumber : "";
                  item["hrs24ProposedItemNumber"] = confirmationsingle.proposedItemNumber ? confirmationsingle.proposedItemNumber : "";
                  //  >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
                } else {
                  item["airEnquiryItemNumber"] = confirmationsingle.enquiryItemNumber ? confirmationsingle.enquiryItemNumber : "";
                  item["airProposedItemNumber"] = confirmationsingle.proposedItemNumber ? confirmationsingle.proposedItemNumber : "";
                }
              }
            });
            if (annexureEnquiry === 'true' || (isAddToEnquiry === false)) {
            } else {
              if (!isItemFound && isAddToEnquiry !== false && materialNotExtended && materialNotExtended.length === 0 && confirmationsingle && confirmationsingle['supercessionMaterial'] && confirmationsingle['availableQuantityforProposedArticle'] && parseInt(confirmationsingle['availableQuantityforProposedArticle']) &&
                confirmationsingle["superceededPartIndicator"] &&
                confirmationsingle["superceededPartIndicator"].toUpperCase() === "X") {
                let materialGroup = ""
                let enquiryIdDatabase = ""
                let enquiryNumberDataBase = ""
                let orgId = ""
                let accessParts: any;
                let accessTyres: any;
                let isAddToEnquiry: any;
                productsTemp.map((itemProd: any) => {
                  if (itemProd.productId == confirmationsingle.supercessionMaterial) {
                    materialGroup = itemProd.materialGroup;
                    orgId = "";
                    enquiryIdDatabase = itemProd.id;
                    enquiryNumberDataBase = itemProd.enquiryNumber;
                    isAddToEnquiry = true;
                    // if (customerTierType && customerTierType.toLowerCase() === 'tbl dealer' || customerTierType === "Dealer") {
                    accessParts = itemProd.accessParts
                    accessTyres = itemProd.accessTyres
                    // }
                  }
                })

                let newSupperSeededItem: any = {
                  materialGroup: materialGroup,
                  id: enquiryIdDatabase,
                  enquiryNumber: enquiryNumberDataBase,
                  accessParts: accessParts,
                  accessTyres: accessTyres,
                  isAddToEnquiry: true,
                  isSuperseeded: true,
                  quantity: 0,
                  productId: confirmationsingle.proposedArticle,
                  productIdDescription: confirmationsingle.materialDescription,
                  productCost: 0,
                  currency: sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ? `${companyCurrencyTypeByFSE}` : customerTierType === "Int. Business" ? `${companyCurrencyType}` : 'AED',
                  unitOfMeasure: confirmationsingle.baseUnitofMeasure,
                  VAT: "",
                  orgId: "",
                  enquiryReferenceNumber: "",
                  isSpecialPriced: false,
                  isSpecialPriceRequestPart: false,
                  isRejected: false,
                  nowAvailability: 0,
                  nowAvailabilityChecked: false,
                  hrs24Availability: 0,
                  hrs24AvailabilityChecked: false,
                  airAvailability: 0,
                  airAvailabilityChecked: false,
                  action: "I",
                  dimensions: {
                    height: confirmationsingle.dimensionHeight,
                    width: confirmationsingle.dimensionWidth,
                    length: confirmationsingle.dimensionLength,
                    volume: confirmationsingle.dimensionVolume ? confirmationsingle.dimensionVolume : '',
                    grossWeight: confirmationsingle.unitWeightInKgs
                  },
                  attributes: [
                    {
                      name: "height",
                      value: confirmationsingle.dimensionHeight,
                    },
                    {
                      name: "width",
                      value: confirmationsingle.dimensionWidth,
                    },
                    {
                      name: "length",
                      value: confirmationsingle.dimensionLength,
                    },
                    {
                      name: "grossWeight",
                      value: confirmationsingle.unitWeightInKgs,
                    },
                    {
                      name: "volume",
                      value: 0,
                    },
                  ],
                  plant: "",
                  nowEnquiryItemNumber: "",
                  nowProposedItemNumber: "",
                  hrs24EnquiryItemNumber: "",
                  hrs24ProposedItemNumber: "",
                  airEnquiryItemNumber: "",
                  airProposedItemNumber: "",
                  isValid: true,
                  supercessionMaterial: confirmationsingle.supercessionMaterial
                }
                if (
                  confirmationsingle &&
                  confirmationsingle["deliveryBucketId"] &&
                  confirmationsingle["deliveryBucketId"].toUpperCase() === "NOW"
                ) {
                  newSupperSeededItem["nowAvailability"] = parseInt(
                    confirmationsingle.availableQuantityforProposedArticle
                  );
                  newSupperSeededItem["quantity"] += parseInt(
                    confirmationsingle.availableQuantityforProposedArticle
                  );
                  newSupperSeededItem["nowAvailabilityChecked"] = newSupperSeededItem["nowAvailability"] ? true : false;
                  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 24 HOURS CODE <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
                } else if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && newSupperSeededItem) {
                  newSupperSeededItem["hrs24Availability"] = parseInt(
                    confirmationsingle.availableQuantityforProposedArticle
                  );
                  newSupperSeededItem["quantity"] += parseInt(
                    confirmationsingle.availableQuantityforProposedArticle
                  );
                  newSupperSeededItem["hrs24AvailabilityChecked"] = newSupperSeededItem["hrs24Availability"] ? true : false;
                  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
                } else {
                  newSupperSeededItem["airAvailability"] = parseInt(
                    confirmationsingle.availableQuantityforProposedArticle
                  );
                  newSupperSeededItem["quantity"] = parseInt(
                    confirmationsingle.availableQuantityforProposedArticle
                  );
                  // newSupperSeededItem["airAvailabilityChecked"] = customerTierType && customerTierType.toLowerCase() === 'tbl dealer' ? false : newSupperSeededItem["airAvailability"] ? true : false;
                  newSupperSeededItem["airAvailabilityChecked"] = newSupperSeededItem["airAvailability"] ? true : false;
                }
                newSupperSeededItem["isSpecialPriced"] =
                  confirmationsingle.priceActivIndicator &&
                    confirmationsingle.priceActivIndicator === "X"
                    ? true
                    : false;
                newSupperSeededItem["isSpecialPriceRequestPart"] =
                  confirmationsingle.isSpecialPriceRequestPart
                    ? true
                    : false;
                newSupperSeededItem["isRejected"] = confirmationsingle.isRejected ? true : false;
                newSupperSeededItem["rsp"] = parseFloat(
                  confirmationsingle.maximumRetailSalesPrice
                ).toFixed(2);
                newSupperSeededItem["soh"] = parseInt(
                  confirmationsingle.totalAtpQuantityAtSiteLevel
                );
                newSupperSeededItem["nsp"] = parseFloat(
                  confirmationsingle.netSalesPrice
                ).toFixed(2);
                newSupperSeededItem["amt"] = parseFloat(
                  confirmationsingle.forwardOrderPrice
                ).toFixed(2);
                newSupperSeededItem["nspev"] = parseFloat(
                  confirmationsingle.netSellingPriceexcludingVAT ? confirmationsingle.netSellingPriceexcludingVAT : confirmationsingle.netSellingPriceExcludingVat
                ).toFixed(2);
                if (newSupperSeededItem["nowAvailabilityChecked"]) {
                  newSupperSeededItem["nowRequestPrice"] = parseFloat(
                    confirmationsingle.nowRequestPrice ? confirmationsingle.nowRequestPrice : confirmationsingle.nowRequestPrice
                  ).toFixed(2);
                  newSupperSeededItem["nowOfferedPrice"] = parseFloat(
                    confirmationsingle.nowOfferedPrice ? confirmationsingle.nowOfferedPrice : confirmationsingle.nowOfferedPrice
                  ).toFixed(2);
                  newSupperSeededItem["nowOfferedCalculatedPrice"] = parseFloat(
                    confirmationsingle.nowOfferedCalculatedPrice ? confirmationsingle.nowOfferedCalculatedPrice : confirmationsingle.nowOfferedCalculatedPrice
                  ).toFixed(2);
                  newSupperSeededItem["nowRequestPriceType"] =
                    confirmationsingle.nowRequestPriceType ? confirmationsingle.nowRequestPriceType : confirmationsingle.nowRequestPriceType
                  newSupperSeededItem["nowOfferedPriceType"] =
                    confirmationsingle.nowOfferedPriceType ? confirmationsingle.nowOfferedPriceType : confirmationsingle.nowOfferedPriceType
                }
                if (newSupperSeededItem["airAvailabilityChecked"]) {
                  newSupperSeededItem["airRequestPrice"] = parseFloat(
                    confirmationsingle.airRequestPrice ? confirmationsingle.airRequestPrice : confirmationsingle.airRequestPrice
                  ).toFixed(2);
                  newSupperSeededItem["airOfferedCalculatedPrice"] = parseFloat(
                    confirmationsingle.airOfferedCalculatedPrice ? confirmationsingle.airOfferedCalculatedPrice : confirmationsingle.airOfferedCalculatedPrice
                  ).toFixed(2);
                  newSupperSeededItem["airOfferedPrice"] = parseFloat(
                    confirmationsingle.airOfferedPrice ? confirmationsingle.airOfferedPrice : confirmationsingle.airOfferedPrice
                  ).toFixed(2);
                  newSupperSeededItem["airRequestPriceType"] =
                    confirmationsingle.airRequestPriceType ? confirmationsingle.airRequestPriceType : confirmationsingle.airRequestPriceType
                  newSupperSeededItem["airOfferedPriceType"] =
                    confirmationsingle.airOfferedPriceType ? confirmationsingle.airOfferedPriceType : confirmationsingle.airOfferedPriceType

                }
                newSupperSeededItem["aop"] = parseFloat(
                  confirmationsingle.forwardOrderPrice
                ).toFixed(2);
                if (
                  confirmationsingle &&
                  confirmationsingle["deliveryBucketId"] &&
                  confirmationsingle["deliveryBucketId"].toUpperCase() === "NOW"
                ) {
                  newSupperSeededItem["nowEnquiryItemNumber"] = confirmationsingle.enquiryItemNumber ? confirmationsingle.enquiryItemNumber : "";
                  newSupperSeededItem["nowProposedItemNumber"] = confirmationsingle.proposedItemNumber ? confirmationsingle.proposedItemNumber : "";
                  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 24 HRS CODE <<<<<<<<<<<<<<<<<<<<<<<<<<<<<
                } else if (confirmationsingle && confirmationsingle["deliveryBucketId"] && confirmationsingle["deliveryBucketId"] === "24") {
                  newSupperSeededItem["hrs24EnquiryItemNumber"] = confirmationsingle.enquiryItemNumber ? confirmationsingle.enquiryItemNumber : "";
                  newSupperSeededItem["hrs24ProposedItemNumber"] = confirmationsingle.proposedItemNumber ? confirmationsingle.proposedItemNumber : "";
                  //  >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
                } else {
                  newSupperSeededItem["airEnquiryItemNumber"] = confirmationsingle.enquiryItemNumber ? confirmationsingle.enquiryItemNumber : "";
                  newSupperSeededItem["airProposedItemNumber"] = confirmationsingle.proposedItemNumber ? confirmationsingle.proposedItemNumber : "";
                }
                if (materialGroup) {
                  productsTemp.push(newSupperSeededItem)
                }
              }
            }
          });
        }
      });
    }
    if (materialNotExtended && materialNotExtended.length === 0 && enquiryDataFetched && enquiryDataFetched.error && Array.isArray(enquiryDataFetched.error) && enquiryDataFetched.error.length > 0) {
      setOpenSnackbarType("error");
      setOpenErrorSnackbar(true);
      setSuccessMessage(enquiryDataFetched?.statusText?.data?.message?.message?.messageText || enquiryDataFetched?.message?.message || 'Verify enquiry failed');
      handleopenCloseSnackbar(true);
      return
    }

    if (queue) {
      setIsQueue(true);
    }
    let rmp: any = await getRemovedProducts(enquiryDataFetchedGetCall) || invalidParts;

    if ((invalidParts && invalidParts.length > 0) || (rmp && rmp.length > 0) || (enquiryDataFetchedGetCall && Array.isArray(enquiryDataFetchedGetCall) && enquiryDataFetchedGetCall[0].removedProducts && enquiryDataFetchedGetCall[0].removedProducts.length > 0)) {
      // Iterate over invalidParts to filter out objects with isProcurementPart = true

      rmp.forEach((part: any) => {
        if (part.isProcurementPart === true || part.isZeroPrice) {
          // Check if an object with the same sequence number already exists in the products array
          const existingIndex = productsTemp.findIndex((item1: any) => item1.seq === part.seq);
          if (existingIndex === -1) {
            // Add the filtered object into the products array
            productsTemp.splice(part.seq - 1, 0, part);
          } else {
            console.log(`An object with sequence ${part.seq} already exists in the products array.`);
          }
        }
      });

      // Logging the modified products array for verification
    }
    // let finalArray = _.values(tempProductsObject);

    if (annexureEnquiry === 'true') {
      productsTemp?.forEach((item: any) => {
        const noNowAvailability = item.nowAvailability === 0;
        const noExistingError = !item.error || item.error?.trim() === '';

        if (noNowAvailability && noExistingError) {
          item.error = "Low stock. Min. Tier 1 Qty not fulfilled";
          item.isRowGreyed = true;
          item.popupError = true;
          item.nowAvailabilityChecked = false;
          applyAnnexurePricing(item, annexureEnquiry, false); // Apply downgraded tier pricing
        }
      });
    }
    setproducts([...productsTemp]);
    setActualProductLength(productsTemp.length);
    const hasPopupError = productsTemp.some((item: any) => item.popupError === true);
    if (hasPopupError) {
      setOpenAnnexureErrorPopup(true)
    }
    if (isAddToEnquiry === false && annexureEnquiry !== 'true') {
      setHideZeroMessage(true)
    } else {
      setHideZeroMessage(false)
      setchangeData([...productsTemp]);
    }
    if ((isPro || (procurement && procurement.length > 0)) && annexureEnquiry !== 'true') {
      setIsProcuredPartExist(true);
      setplaceorderEnabled(true); // updated to true pproblem parts
    } else {
      setIsProcuredPartExist(false);
      setplaceorderEnabled(true);
    }
    if ((isMat || (materialNotExtended && materialNotExtended.length > 0)) && annexureEnquiry !== 'true') {
      // let invalidP: any = invalidParts;
      // let materialE: any = productsTemp.filter((product: any) => product.action !== 'D' && product.isMaterialNotExtended && product.seq);
      // invalidP = [...invalidParts, ...materialE]
      // setInvalidParts(invalidP)
      setIsMaterialNotExtendedExist(true);
      setplaceorderEnabled(false);
    } else {
      setIsMaterialNotExtendedExist(false);
      setplaceorderEnabled(true);
    }

    if (isAddToEnquiry === false && annexureEnquiry !== 'true') {
      setHideZeroMessage(true)
    } else {
      setHideZeroMessage(false);
    }
    if (selectedAccessType === "Parts" || (isTyrePartsSearchSuccessFully === true && isTyrePartsAddedtoGrid === true) || products.some((p: any) => p.isAddToEnquiry === false)) {
      setisAvailabiityChecked(true);
    }
    // setisAvailabiityChecked(true);
    setorderQueued(false);
    setisAvailabiityCheckedAtTime(new Date());
    setIsTimmerExpired(false); // Reset the expired flag to allow timer restart
    // if (deletion) {
    //   setplaceorderEnabled(false);
    // } else {
    //   setplaceorderEnabled(true);
    // }
  }
  const getZeroParts = (parts: any) => {
    let zeroParts: any = []
    if (parts && parts.length > 0) {
      parts.map((item: any) => {
        if (item) {
          //  const isZeroValue = (value: any) =>
          //   value !== undefined &&
          //   value !== null &&
          //   !isNaN(Number(value)) &&
          //   Number(value) === 0;

          // if (isZeroValue(item.nsp) || isZeroValue(item.nowAvailability)) {
          //   zeroParts.push(item);
          // }
          if (((item.nsp && item.nsp === "0.00") || (item.nsp && parseFloat(item.nsp) === 0)) && item.nowAvailability === 0) {
            zeroParts.push(item);
          }
        }
      })
      setZeroProducts([...zeroParts])
      return zeroParts;
      // let invalid: any = [...invalidParts, ...zeroParts];
      // setInvalidParts(invalid);
    }
  }

  // useEffect(() => {
  //   console.log(zeroProducts, isAvailabiityChecked, hideZeroMessage);
  //   if (zeroProducts && zeroProducts.length > 0 && isAvailabiityChecked && !hideZeroMessage) {
  //     openZeroPricePopup(true);
  //   }
  // }, [zeroProducts, isAvailabiityChecked]);

  // commented in problem parts

  useEffect(() => {
    const allAddedToEnquiry =
      products?.length > 0 &&
      products.every((p: any) => p.isAddToEnquiry === true);
    if (
      procuredPart?.length > 0 &&
      isAvailabiityChecked &&
      !hideZeroMessage &&
      allAddedToEnquiry
    ) {
      openZeroPricePopup(true);
    } else {
      setIsProcuredPartExist(false);
    }
  }, [
    procuredPart,
    isAvailabiityChecked,
    hideZeroMessage
  ]);

  // useEffect(() => {
  //     const allAddedToEnquiry =
  //       products?.length > 0 &&
  //       products.every((p: any) => p.isAddToEnquiry === true);
  //     if (
  //       materialNotExtendedPart &&
  //       materialNotExtendedPart.length > 0 &&
  //       isAvailabiityChecked &&
  //       !hideZeroMessage &&
  //       allAddedToEnquiry
  //     ) {
  //       openZeroPricePopup(true);
  //     }
  //   }, [
  //     materialNotExtendedPart,
  //     isAvailabiityChecked,
  //     hideZeroMessage
  //   ]);

  useEffect(() => {
    // SAP only sends Material Not Extended info once, so we capture it into
    // materialNotExtendedPart as soon as it arrives (even from a live Tyre-search's automatic
    // verify, before anything is added to the enquiry) — but we must NOT show the popup for
    // parts that are only sitting in a not-yet-added Tyre search (isAddToEnquiry === false).
    // Only show it once the flagged part(s) are actually part of the enquiry (isAddToEnquiry
    // true), which naturally lines up with "Add to Order Enquiry" + "Check Availability and
    // Price". Deliberately not gated on isAvailabiityChecked: a genuine Material Not Extended
    // failure means verification did NOT succeed, but the popup still needs to show.
    const hasAddedMaterialNotExtendedPart =
      materialNotExtendedPart &&
      materialNotExtendedPart.length > 0 &&
      products.some((p: any) => materialNotExtendedPart.includes(p.productId) && p.isAddToEnquiry !== false);
    if (hasAddedMaterialNotExtendedPart && !hideZeroMessage) {
      openZeroPricePopup(true);
    }
  }, [
    materialNotExtendedPart,
    products,
    hideZeroMessage
  ]);

  // Self-healing safeguard: whatever caused a part to stop being a live concern (search
  // replaced, switched to Parts, deleted, action "D", or the product simply no longer exists)
  // must never leave a stale entry behind in materialNotExtendedPart or
  // capturedMaterialNotExtendedIds — relying on every abandonment code path to remember to
  // clean up individually is fragile. This runs on every products change and prunes both down
  // to only what's still actually true right now.
  useEffect(() => {
    if (Array.isArray(materialNotExtendedPart) && materialNotExtendedPart.length > 0) {
      const stillValid = materialNotExtendedPart.filter((id: any) => {
        const match = products.find((p: any) => p.productId === id);
        return !!match && match.isAddToEnquiry === true && match.action !== "D";
      });
      if (stillValid.length !== materialNotExtendedPart.length) {
        setMaterialNotExtendedPart(stillValid);
        setCountOfMaterialNotExtendedParts(stillValid.length);
        if (stillValid.length === 0) {
          setIsMaterialNotExtendedExist(false);
        }
      }
    }
    if (capturedMaterialNotExtendedIds.current.length > 0) {
      const stillRelevant = capturedMaterialNotExtendedIds.current.filter((id: string) => {
        const match = products.find((p: any) => p.productId === id);
        // Keep it if the product still exists and hasn't been deleted — whether or not it's
        // currently added, since a not-yet-added one is exactly what this ref is meant to
        // remember for later.
        return !!match && match.action !== "D";
      });
      if (stillRelevant.length !== capturedMaterialNotExtendedIds.current.length) {
        capturedMaterialNotExtendedIds.current = stillRelevant;
      }
    }
  }, [products]);

  const callChangeData = async () => {
    let zeroParts: any = [];

    if (materialNotExtendedPart?.length === 0) {
      zeroParts = getZeroParts(changeData);
    }

    if (zeroParts?.length > 0) {
      updateOnly(changeData, undefined, undefined, undefined, zeroParts);
    } else {
      updateOnly(changeData);
    }

    const allAddedToEnquiry =
      products?.length > 0 &&
      products.every((p: any) => p.isAddToEnquiry === true);

    if (
      zeroParts?.length > 0 &&
      allAddedToEnquiry &&
      isAvailabiityChecked &&
      !hideZeroMessage &&
      annexureEnquiry !== "true"
    ) {
      openZeroPricePopup(true);
    }

    setchangeData(null);
  };

  useEffect(() => {
    if (changeData) {
      callChangeData();
    }
  }, [changeData, hideZeroMessage]);

  useEffect(() => {
    if (enquiryData != null && !accessData && sessionStorage.getItem('userType') !== 'FSE' && sessionStorage.getItem('userType') !== 'sre') {
      requestPriceAccess()
    }
  }, [enquiryData, accessData])

  useEffect(() => {
    let checkedTotal: any
    let reqType: any
    let checkedCalculatedTotal: any
    let checkedReqType: any

    if (verificationData && verificationData.data && verificationData.data.length > 0) {
      verificationData.data.map((data: any) => {
        reqType = data && data.specialPriceRequestType
        checkedTotal = data && data.specialRequestOfferedTotalPricePercentage
        checkedCalculatedTotal = data && data.specialRequestOfferedTotalPriceCalculated
        checkedReqType = data && data.specialRequestOfferedTotalPriceCurrency
      })
    }
    setRequestedTotalType(reqType);
    setEstmateTotal(checkedTotal);
    setRequestedCaluclatedTotalPrice(checkedCalculatedTotal);
    setRequestedCalculatedTotalType(checkedReqType);
  }, [verificationData])

  useEffect(() => {
  }, [requestStatus, enquiryAction, accessData, isSPRModifyData])

  useEffect(() => {
    let requestStatusHideEnquiry: any;
    let reorderEnquiry: any;
    viewSpecialPriceDetails && viewSpecialPriceDetails.data && viewSpecialPriceDetails.data.data && viewSpecialPriceDetails.data.data.data && viewSpecialPriceDetails.data.data.data.length > 0 && viewSpecialPriceDetails.data.data.data.map((ele: any) => {
      requestStatusHideEnquiry = ele && ele.status
      reorderEnquiry = ele && ele.expiredAfterApproval
    })

    setRequestStatus(requestStatusHideEnquiry);
    setShowReorderEnquiry(reorderEnquiry)
  }, [viewSpecialPriceDetails])

  const getEstimatedTotal = (isAvailabiityChecked?: any, withFilter?: any, withDeletion?: any) => {
    const safeFloat = (val: any) => {
      const parsed = parseFloat(val);
      return val !== undefined && val !== null && val !== '' && val !== 'NaN' && !isNaN(parsed) ? parsed : 0;
    };

    // let productsTemp = JSON.parse(JSON.stringify(products));

    let productsTemp: any[] = [];

    if (products && products.length > 0) {
      products.forEach((item: any) => {
        if (item.accessTyres === true) {
          if (item.isAddToEnquiry === true) {
            productsTemp.push(JSON.parse(JSON.stringify(item)));
          }
        } else {
          productsTemp.push(JSON.parse(JSON.stringify(item)));
        }
      });
    }
    if (withFilter) {
      productsTemp = productsTemp.filter((item: any) =>
        !isAvailabiityChecked ||
        (isAvailabiityChecked && (
          availability === "All" ||
          (availability === "Now" && item.nowAvailability && !item.airAvailability) ||
          (
            customerTierType &&
            (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") &&
            availability === "24" &&
            item.hrs24Availability &&
            !item.nowAvailability &&
            !item.airAvailability
          ) ||
          (availability === "BO" && item.airAvailability)
        ))
      );
    }

    if (isAvailabiityChecked && productsTemp && productsTemp.length > 0) {
      let total: number = 0;
      let individualPrice: any[] = [];

      productsTemp.forEach((item: any) => {
        const currentEnquiry = enquiryData?.find((enquiry: any) =>
          enquiry?.products?.some(
            (product: any) => product?.id === item?.id
          )
        );

        const enquirySalesOffice =
          currentEnquiry?.salesOffice ||
          currentEnquiry?.headerDetails?.salesOffice ||
          item?.salesOffice ||
          '';

        let brand = enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`];

        if (!withDeletion || (withDeletion && !item['selected'])) {
          if (item.nsp || item.aop) {

            // NOW AVAILABILITY
            if (item.nowAvailabilityChecked && !item.isRowGreyed) {
              if (enquiryAction === 'view' && item.nowApprovedPrice) {
                total += safeFloat(item.nowAvailability) * safeFloat(item.nowApprovedPrice);
              } else {
                if (item.isSpecialPriceRequestPart && item.isRejected === false && requestStatus === 'Approved') {
                  if (item.nowOfferedPriceType === 'byPercentage') {
                    const val = safeFloat(item.nowAvailability) * safeFloat(item.nowOfferedCalculatedPrice);
                    total += val;
                    individualPrice.push({
                      salesOffice: enquirySalesOffice,
                      total: val
                    });
                  } else if (item.nowOfferedPriceType === 'byCurrency') {
                    const val = safeFloat(item.nowAvailability) * safeFloat(item.nowOfferedPrice);
                    total += val;
                    individualPrice.push({
                      salesOffice: enquirySalesOffice,
                      total: val
                    });
                  } else {
                    const val = safeFloat(item.nowAvailability) * safeFloat(item.nsp);
                    total += val;
                    individualPrice.push({
                      salesOffice: enquirySalesOffice,
                      total: val
                    });
                  }
                } else {
                  if (requestedTotalType === "total" && requestStatus === 'Approved') {
                    if (requestedCalculatedTotalType === "By %" && !item.isSpecialPriced) {
                      const nsp1 = (safeFloat(estmateTotal) * safeFloat(item.nsp)) / 100;
                      const newNsp = safeFloat(item.nsp) - nsp1;
                      const val = safeFloat(item.nowAvailability) * newNsp;
                      total += val;
                      individualPrice.push({
                        salesOffice: enquirySalesOffice,
                        total: val
                      });
                    } else if (requestedCalculatedTotalType === "By AED" && !item.isSpecialPriced) {
                      const value = safeFloat(requestedCaluclatedTotalPrice.replace("%", "").replace("-", ""));
                      const newNsp = (value * safeFloat(item.nsp)) / 100;
                      const nsp = safeFloat(item.nsp) - newNsp;
                      const val = safeFloat(item.nowAvailability) * nsp;
                      total += val;
                      individualPrice.push({
                        salesOffice: enquirySalesOffice,
                        total: val
                      });
                    } else {
                      const val = safeFloat(item.nowAvailability) * safeFloat(item.nsp);
                      total += val;
                      individualPrice.push({
                        salesOffice: enquirySalesOffice,
                        total: val
                      });
                    }
                  } else {
                    const val = safeFloat(item.nowAvailability) * safeFloat(item.nsp);
                    total += val;
                    individualPrice.push({
                      salesOffice: enquirySalesOffice,
                      total: val
                    });
                  }
                }
              }
            }

            // 24 HRS AVAILABILITY
            if (
              customerTierType &&
              ["workshop", "tpcdealer"].includes(customerTierType.toLowerCase()) &&
              item.hrs24AvailabilityChecked
            ) {
              const val = safeFloat(item.hrs24Availability) * safeFloat(item.nsp);
              total += val;
              individualPrice.push({
                salesOffice: enquirySalesOffice,
                total: val
              });
            }

            // AIR AVAILABILITY
            if (
              item.airAvailabilityChecked &&
              // customerTierType &&
              // !["workshop", "tpcdealer"].includes(customerTierType.toLowerCase()) &&
              !item.isProcurementPart &&
              // item.accessTyres !== true &&
              annexureEnquiry !== 'true'
            ) {
              if (enquiryAction === 'view' && item.airApprovedPrice) {
                total += safeFloat(item.airAvailability) * safeFloat(item.airApprovedPrice);
              } else {
                if (item.isSpecialPriceRequestPart && item.isRejected === false && requestStatus === 'Approved') {
                  if (item.airOfferedPriceType === 'byPercentage') {
                    const val = safeFloat(item.airAvailability) * safeFloat(item.airOfferedCalculatedPrice);
                    total += val;
                    individualPrice.push({
                      salesOffice: enquirySalesOffice,
                      total: val
                    });
                  } else if (item.airOfferedPriceType === 'byCurrency') {
                    const val = safeFloat(item.airAvailability) * safeFloat(item.airOfferedPrice);
                    total += val;
                    individualPrice.push({
                      salesOffice: enquirySalesOffice,
                      total: val
                    });
                  } else {
                    const val = safeFloat(item.airAvailability) * safeFloat(item.aop);
                    total += val;
                    individualPrice.push({
                      salesOffice: enquirySalesOffice,
                      total: val
                    });
                  }
                } else {
                  if (requestedTotalType === "total" && requestStatus === 'Approved') {
                    if (requestedCalculatedTotalType === "By %" && !item.isSpecialPriced) {
                      const nsp1 = (safeFloat(estmateTotal) * safeFloat(item.aop)) / 100;
                      const newAop = safeFloat(item.aop) - nsp1;
                      const val = safeFloat(item.airAvailability) * newAop;
                      total += val;
                      individualPrice.push({
                        salesOffice: enquirySalesOffice,
                        total: val
                      });
                    } else if (requestedCalculatedTotalType === "By AED" && !item.isSpecialPriced) {
                      const value = safeFloat(requestedCaluclatedTotalPrice.replace("%", "").replace("-", ""));
                      const newAop = (value * safeFloat(item.aop)) / 100;
                      const aop = safeFloat(item.aop) - newAop;
                      const val = safeFloat(item.airAvailability) * aop;
                      total += val;
                      individualPrice.push({
                        salesOffice: enquirySalesOffice,
                        total: val
                      });
                    } else {
                      const val = safeFloat(item.airAvailability) * safeFloat(item.aop);
                      total += val;
                      individualPrice.push({
                        salesOffice: enquirySalesOffice,
                        total: val
                      });
                    }
                  } else {
                    const val = safeFloat(item.airAvailability) * safeFloat(item.aop);
                    total += val;
                    individualPrice.push({
                      salesOffice: enquirySalesOffice,
                      total: val
                    });
                  }
                }
              }
            }
          }
        }
      });

      if (individualPrice.length > 0) {
        const holder: any = {};

        individualPrice.forEach((d) => {
          holder[d.salesOffice] = holder[d.salesOffice]
            ? holder[d.salesOffice] + d.total
            : d.total;
        });

        const obj2 = Object.entries(holder).map(([salesOffice, total]) => ({
          salesOffice,
          total: safeFloat(total).toFixed(2),
        }));

        sessionStorage.setItem('iprice', JSON.stringify(obj2));
      }

      return safeFloat(total).toFixed(2);
    }

    return '0.00';
  };


  const getViewEstimatedTotal = () => {
    let total: any = 0;
    if (enquiryData && enquiryData.length > 0) {
      enquiryData.map((data: any) => {
        if (enquiryAction === 'view' && data.specailPriceRequestDetails) {
          total = getEstimatedTotal(true, true)
        } else {
          /* commented because estimated total should be consistent before and after order placement -- Bhargavi 09/03/2023 */
          // if (data && data.netOrderValue) {
          //   total = parseFloat(total) + parseFloat(data.netOrderValue);
          // } else {
          total = getEstimatedTotal(isAvailabiityChecked, true)
          // }
        }
      })
    }
    if (requestedTotalType === "total" && requestedCalculatedTotalType === "By %" && requestStatus === 'Approved') {
      return parseFloat(requestedCaluclatedTotalPrice).toFixed(2);
    } else if (requestedTotalType === "total" && requestedCalculatedTotalType === "By AED" && requestStatus === 'Approved') {
      return parseFloat(estmateTotal).toFixed(2);
    } else {
      return parseFloat(total).toFixed(2);
    }
    // return parseFloat(total).toFixed(2)
  }

  const getEstimatedTotalSap = (withFilter?: any, newData?: any) => {
    let productsTemp = JSON.parse(JSON.stringify(products))
    if (withFilter) {
      productsTemp = productsTemp.filter((item: any) => !isAvailabiityChecked ||
        (isAvailabiityChecked && (availability === "All" || (availability === "Now" && item.nowAvailability && !item.airAvailability) ||
          (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && availability === "24" && item.hrs24Availability && !item.nowAvailability && !item.airAvailability) ||
          (availability === "BO" && item.airAvailability))))
    }
    let sum: any = 0;
    let individualPrice: any = [];
    if (newData.data && newData.data.length > 0) {
      newData.data.map((data: any) => {
        if (data && data.verifiedData && data.verifiedData.header && data.verifiedData.header.netOrderValue) {
          individualPrice.push({ salesoffice: data.salesoffice, total: data.verifiedData.header.netOrderValue })
          sum = parseFloat(sum) + parseFloat(data.verifiedData.header.netOrderValue)
        }
      });
      setEstimatedTotal(sum);
      setIndividialPrice(individualPrice)
    }
    return sum;
  };

  const getIsAirAvalibityExistCount = () => {
    let airAvailabilityProducts = products.filter((product: any) => product.airAvailability > 0);
    return airAvailabilityProducts.length;
  }

  const getnetOrderValue = (enquiry: any, changeCheckBox: any, withDeletion?: any) => {

    if (!enquiry) {
      return 0;
    }

    const salesOffice = enquiry?.salesOffice;

    if (!salesOffice) {
      return 0;
    }

    if (changeCheckBox) {
      const data: any = sessionStorage.getItem('iprice');
      const individualCost = JSON.parse(data || "[]");

      if (individualCost && individualCost.length > 0) {
        const value = individualCost.filter(
          (a: any) => a.salesOffice === salesOffice
        );

        if (value && value.length > 0) {
          return value[0].total;
        }
      }
    } else {
      if (individualPrice && individualPrice.length > 0) {
        const value: any[] = (individualPrice as any[]).filter(
          (a: any) => a.salesOffice === salesOffice
        );

        if (value.length > 0) {
          return value[0].total;
        }
      }
    }

    return 0;
  };

  const requestPriceAccess = async () => {
    let enquiryId = enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].B2bEnquiryId ? enquiryData[0].B2bEnquiryId : ""
    if (!_.isEmpty(enquiryId) && customerTierType && customerTierType.toLowerCase() === "dealer") {
      let data: any = await requestSpecialPriceService.requestSpecialPriceAccessAPI(
        {
          "sapCustomerId": sapCustomerId,
          "enquiryId": enquiryId
        }
      )
      setAccessData(data);
    }
  }

  // Stop tracking a part as Material Not Extended once it's been abandoned/deleted (action
  // "D" for an isAddToEnquiry === false cleanup) — otherwise a stale productId lingers in
  // materialNotExtendedPart/capturedMaterialNotExtendedIds and the popup keeps listing a part
  // that no longer exists in the enquiry, from a completely different earlier search.
  const clearMaterialNotExtendedTracking = (productIds: any[]) => {
    if (!productIds || productIds.length === 0) return;
    capturedMaterialNotExtendedIds.current = capturedMaterialNotExtendedIds.current.filter(
      (id: string) => !productIds.includes(id)
    );
    setMaterialNotExtendedPart((prev: any) =>
      Array.isArray(prev) ? prev.filter((id: any) => !productIds.includes(id)) : prev
    );
  };

  // Lightweight, side-effect-free extraction of Material Not Extended part numbers from a
  // verify response/error payload — no procurement/timer/availability processing, just
  // remembers which parts SAP flagged, since it may never tell us again.
  const captureMaterialNotExtendedIds = (availDataOrError: any) => {
    const source =
      availDataOrError && availDataOrError.error && Array.isArray(availDataOrError.error) && availDataOrError.error.length > 0
        ? availDataOrError.error
        : availDataOrError;
    if (!Array.isArray(source)) return;
    source.forEach((subEnquiries: any) => {
      const items = subEnquiries?.verifiedData?.items;
      if (Array.isArray(items)) {
        items.forEach((item: any) => {
          if (item && item.isMaterialNotExtended && item.materialNumber && !capturedMaterialNotExtendedIds.current.includes(item.materialNumber)) {
            capturedMaterialNotExtendedIds.current.push(item.materialNumber);
          }
        });
      }
    });
  };

  // Surface any previously-captured Material Not Extended parts that are NOW actually part of
  // the enquiry (isAddToEnquiry === true) — called only from an explicit Check Availability and
  // Price click, since SAP won't necessarily re-flag them on a later call.
  const revealCapturedMaterialNotExtendedParts = () => {
    if (capturedMaterialNotExtendedIds.current.length === 0) return;
    const addedMatches = products
      .filter((p: any) => p.isAddToEnquiry === true && capturedMaterialNotExtendedIds.current.includes(p.productId))
      .map((p: any) => p.productId);
    if (addedMatches.length > 0) {
      setMaterialNotExtendedPart((prev: any) => Array.from(new Set([...(Array.isArray(prev) ? prev : []), ...addedMatches])));
      setCountOfMaterialNotExtendedParts((prev: any) => Array.from(new Set([...(Array.isArray(prev) ? prev : []), ...addedMatches])).length);
      setIsMaterialNotExtendedExist(true);
    }
  };

  const saveUpdateEnquiryOnDeleteUnavailbility = async (shouldCheckAvailability: any, withDeletion?: any, p?: any) => {
    let data: any = null;
    setIsQuantityUpdated(false);
    setActualProductLength(p && p.length > 0 ? p.length : products.length);
    let productsTemp = JSON.parse(JSON.stringify(p && p.length > 0 ? p : products));
    let productsExtract = [...productsTemp]
    let inValidParts = productsExtract.filter((product: any) => !product.isValid).map(item => item['productId']);
    productsTemp = productsTemp.filter((product: any) => product.isValid);
    // productsTemp = productsTemp.filter((product: any) => !product.isMaterialNotExtended);
    if (
      productsTemp &&
      Array.isArray(productsTemp) &&
      productsTemp.length > 0
    ) {
      let emptyRefNo = false;
      let emptyQuantity = false;
      productsTemp = productsTemp.map((item: any) => {
        if (item && item.materialGroup) {
          if (
            item && item.materialGroup && !brandRefNumbers[`${enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`]}`] ||
            !brandRefNumbers[`${enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`]}`].trim()
          ) {
            emptyRefNo = true;
          }
        }
        if (referenceNumber === "") {
          emptyRefNo = true;
        }
        if (!parseInt(item.quantity)) {
          emptyQuantity = item.productId;
        }
        if (item && item.materialGroup) {
          item["enquiryReferenceNumber"] =
            brandRefNumbers[
            `${enquiryMapping[`${formatMaterialGroup(item?.materialGroup)}`]}`
            ];
          item["deliveryBlockReason"] =
            deliveryBlockReason[
              `${enquiryMapping[
              `${formatMaterialGroup(item?.materialGroup)}`
              ]}`
            ]?.deliveryBlockReason || '';
          item["deliveryBlockReasonCode"] = item?.materialGroup
            ? deliveryBlockReason[
              `${enquiryMapping[
              `${formatMaterialGroup(item.materialGroup)}`
              ]}`
            ]?.deliveryBlockReasonCode
            : '';
          item.error = item.error;
          item.isRowGreyed = item.isRowGreyed;
        } else {
          item["enquiryReferenceNumber"] = '';
          item["deliveryBlockReason"] = '';
          item["deliveryBlockReasonCode"] = '';
        }
        item["masterReferenceNumber"] = referenceNumber;
        return item;
      });
      if (emptyRefNo) {
        setOpenSnackbarType("error");
        setOpenErrorSnackbar(true);
        setSuccessMessage(`All reference numbers are mandatory`);
        handleopenCloseSnackbar(true);
        return;
      }
      if (emptyQuantity) {
        setOpenSnackbarType("error");
        setOpenErrorSnackbar(true);
        setSuccessMessage(
          `Quantity of product ${emptyQuantity} should be greater than zero`
        );
        handleopenCloseSnackbar(true);
        return;
      }
      if (
        customerTierType &&
        customerTierType.toLowerCase() === "int. business" &&
        has2431 &&
        has2428 &&
        !sessionStorage.getItem('orderCreatedBy')
      ) {
        setOpenSnackbar(true);
        setOpenErrorSnackbar(true);
        setSuccessMessage("Please select Order Created By");
        setLoading(false);
        return;
      }
      setproducts(JSON.parse(JSON.stringify(productsTemp)));
      let preventGetCall = false;
      if (!isEnquirySaved) {
        data = await dispatch(createEnquiry(customerTierType, customerAccountType, referenceNumber !== '' ? referenceNumber : tempRef, productsTemp, annexureEnquiry === 'true' ? true : false, sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ? firstName + ' ' + lastName : firstName, sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ? webApplicationLoginId : b2cUserId, enquirySessionId));
        sessionStorage.setItem('subEnquiryId', JSON.stringify(data && data.data && data.data.subEnquiries && data.data.subEnquiries));
        setSubEnquiriesData(data && data.data && data.data.subEnquiries && data.data.subEnquiries);
      } else {
        let filteredItemNos: any = []
        let superseeded: any = productsTemp.filter((p: any) => p.isSuperseeded)

        const isSuperseededExist = (item: any) => {
          let issuperseededexist: any = superseeded.find((s: any) => s.supercessionMaterial === item.productId && parseInt(s.nsp) > 0);
          if (issuperseededexist && parseInt(issuperseededexist?.nsp) > 0) {
            return true
          } else {
            return false
          }
        }
        productsTemp.map((item: any) => {
          if (withDeletion) {
            let issuperseededexist: any = superseeded.find((s: any) => s.supercessionMaterial === item.productId && parseInt(s.nsp) > 0);
            // setIsQuantityUpdated(true) // Aded this condition to make place order disabled again if product got deleted
            if (item['nowAvailability'] == 0) {
              let issuperseededexist: any = superseeded.find((s: any) => s.supercessionMaterial === item.productId && parseInt(s.nsp) > 0);
              if (issuperseededexist && parseInt(issuperseededexist?.nsp) > 0) {
              } else {
                filteredItemNos.push({
                  productId: item.productId,
                  itemNumber: item.nowEnquiryItemNumber || item.hrs24EnquiryItemNumber || item.airEnquiryItemNumber
                })
                item["action"] = "D";
                item["isManualDelete"] = true;
              }
            }
          }

          // newly added problem parts code start

          if (zeroProducts && zeroProducts.length > 0 && isAvailabiityChecked) {
            if ((parseFloat(item.nsp) === 0 || parseFloat(item.nsp) === 0.00) && !item.isSuperseeded && !item.isMaterialNotExtended && !isSuperseededExist(item)) {
              item.action = "D";
              item.isZeroPrice = true;
            }
          }
          if (item.isMaterialNotExtended) {
            item["action"] = "D";
          }
          if (item.isProcurementPart && item.nowAvailability && parseInt(item.nowAvailability) !== 0 && !withDeletion) {
            item["action"] = "C";
          }
          if (
            item.isProcurementPart &&
            parseInt(item.airAvailability || 0) === 0
          ) {
            if (isSuperseededExist(item)) {
              item["action"] = "C";
            } else {
              item["action"] = "D";
            }

            item["airAvailabilityChecked"] = false;
          }
          // newly added problem parts code end

          // item["nowAvailabilityChecked"] = false;
          // item["hrs24AvailabilityChecked"] = false;
          // item["airAvailabilityChecked"] = false;
          if (item.nowAvailabilityChecked) {
            item["productCost"] = 0;
          }
          // >>>>>>>>>>>>>>>>>>>> 24 HRS CODE <<<<<<<<<<<<<<<
          if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && item.hrs24AvailabilityChecked) {
            item["productCost"] = 0;
          }
          //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
          if (item.airAvailabilityChecked) {
            item["productCost"] = 0;
          }
          return item
        })
        productsTemp = productsTemp.filter((item: any) => {
          let isNotDeleted = true
          filteredItemNos.map((part: any) => {
            if (item.isSuperseeded && item.supercessionMaterial == part.productId &&
              (part.itemNumber == item.nowEnquiryItemNumber ||
                part.itemNumber == item.nowEnquiryItemNumber)) {
              isNotDeleted = false
            }
          })
          return isNotDeleted
        })
        let updationData: any = {};
        let insertData: any = [];

        let productsTempNew: any = productsTemp;
        let rmpro: any = await getRemovedProducts(enquiryData);

        // Filter the productsTempNew array
        productsTempNew = productsTempNew.filter((product: any) => {
          // product.orgId = "";
          if ((invalidParts && invalidParts.length > 0) || (rmpro && rmpro.length > 0) || (enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].removedProducts && enquiryData[0].removedProducts.length > 0)) {
            // Check if the product's sequence number exists in invalidParts

            let inp: any = rmpro || enquiryData[0].removedProducts || invalidParts;
            const seqExistsInInvalidParts = inp.some((part: any) => part.seq === product.seq);
            // If the sequence number exists in invalidParts, apply filter
            if (seqExistsInInvalidParts) {
              return (product.action !== 'D' && !product.isProcurementPart) || (product.action !== 'D' && !product.isZeroPrice);
            } else {
              // If the sequence number doesn't exist in invalidParts, retain the item
              return true;
            }
          } else {
            return product;
          }
        });

        productsTempNew.map((singleProduct: any) => {
          if (singleProduct["id"]) {
            if (updationData[singleProduct["id"]]) {
              updationData[singleProduct["id"]].push(singleProduct);
            } else {
              updationData[singleProduct["id"]] = [singleProduct];
            }
          } else {
            insertData.push(singleProduct)
          }
        });
        let finalData: any = [];
        Object.keys(updationData).map((singlekey: any) => {
          const currentEnquiry = (enquiryData ?? []).find((enquiry: any) =>
            enquiry?.products?.some(
              (product: any) => product?.id === updationData[singlekey]?.[0]?.id
            )
          );
          let tc: any = getEstimatedTotal(isAvailabiityChecked, true, withDeletion);
          finalData.push({
            id: singlekey,
            masterReferenceNumber: referenceNumber !== '' ? referenceNumber : tempRef,
            products: updationData[singlekey],
            // totalCost: changeCheckBox ? getEstimatedTotal(true, withDeletion) : estTotal,
            totalCost: getEstimatedTotal(isAvailabiityChecked, true, withDeletion),
            netOrderValue: parseInt(tc) == 0 ? 0 : getnetOrderValue(currentEnquiry, true, withDeletion)
          });
        });
        let enquiryDetailsQueueCheckData: any;
        if (checkAvailabilityButtonText.toLowerCase() !== CHECK_AVAILABILITY_BUTTON_TEXT.NORMAL.toLowerCase()) {
          //Trigger verification queued check before attempting update
          enquiryDetailsQueueCheckData = await dispatch(verifyEnquiryQueueCheck(customerTierType, enquiryData[0].B2bEnquiryId, enquiryData[0].customerId));
          //Error enquiryDetailsQueueCheckData.message.status == "E"
          if (enquiryDetailsQueueCheckData && enquiryDetailsQueueCheckData.message && enquiryDetailsQueueCheckData.message?.status && enquiryDetailsQueueCheckData.message?.status == "E") {
            setOpenSnackbarType("error");
            setOpenErrorSnackbar(true);
            setSuccessMessage(enquiryDetailsQueueCheckData?.message?.message);
            handleopenCloseSnackbar(true);
            setplaceorderEnabled(false);
            return;
          }
          //Queued enquiryDetailsQueueCheckData.message.message === "verification queued"
          else if (enquiryDetailsQueueCheckData && enquiryDetailsQueueCheckData.message && enquiryDetailsQueueCheckData.message.message && typeof enquiryDetailsQueueCheckData.message.message === 'string' && enquiryDetailsQueueCheckData.message.message.toLowerCase() == "verification queued") {
            setOpenSnackbarType("error");
            setOpenErrorSnackbar(true);
            setIsQueue(true);
            setSuccessMessage((sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') ?
              'Enquiry has been submitted for verification and will take few minutes to get completed. You can check its status by selecting “Queued Enquiries” in the Order-Enquiry List.'
              : 'Enquiry queued for verification, press the verification button after 1 min');
            handleopenCloseSnackbar(true);
            setplaceorderEnabled(false);
            return;
          }
          //In Progress enquiryDetailsQueueCheckData.message.message === "verification in progress"
          else if (enquiryDetailsQueueCheckData && enquiryDetailsQueueCheckData.message && enquiryDetailsQueueCheckData.message.message && typeof enquiryDetailsQueueCheckData.message.message === 'string' && enquiryDetailsQueueCheckData.message.message.toLowerCase() == "verification in progress") {
            setOpenSnackbarType("error");
            setOpenErrorSnackbar(true);
            setIsQueue(true);
            setSuccessMessage('Enquiry verification in progress, press the verification button after 1 min.');
            setCheckAvailabilityButtonText(CHECK_AVAILABILITY_BUTTON_TEXT.PROGRESS);
            handleopenCloseSnackbar(true);
            setplaceorderEnabled(false);
            return;
          }
          //In Progress enquiryDetailsQueueCheckData.message.message === "enquiry changed"
          else if (enquiryDetailsQueueCheckData && enquiryDetailsQueueCheckData.message && enquiryDetailsQueueCheckData.message.message && typeof enquiryDetailsQueueCheckData.message.message === 'string' && enquiryDetailsQueueCheckData.message.message.toLowerCase() == "enquiry changed") {
            setOpenSnackbarType("error");
            setOpenErrorSnackbar(true);
            setSuccessMessage('Enquiry changed, press the verification button after 10 seconds');
            setIsQueue(false);
            setCheckAvailabilityButtonText(CHECK_AVAILABILITY_BUTTON_TEXT.PROGRESS);
            handleopenCloseSnackbar(true);
            setplaceorderEnabled(false);
            return;
          }
          //Success enquiryDetailsQueueCheckData.message.message === "verification completed"
          else if (enquiryDetailsQueueCheckData && enquiryDetailsQueueCheckData.message && enquiryDetailsQueueCheckData.message.message && typeof enquiryDetailsQueueCheckData.message.message === 'string' && enquiryDetailsQueueCheckData.message.message.toLowerCase() == "verification completed") {
            setCheckAvailabilityButtonText(CHECK_AVAILABILITY_BUTTON_TEXT.NORMAL);
            //should be removed and format should be updated on api side
            setIsQueue(false);
            let verificationData: any = []
            let hasConfirmationData = true;
            if (enquiryDetailsQueueCheckData && Array.isArray(enquiryDetailsQueueCheckData.data)) {
              enquiryDetailsQueueCheckData.data.map((item: any) => {
                if (item && item.confirmations && Array.isArray(item.confirmations) && item.confirmations.length > 0) {
                  verificationData.push({
                    verifiedData: item
                  })
                } else {
                  hasConfirmationData = false;
                }
              })
            }
            if (hasConfirmationData) {
              //should be removed and format should be updated on api side
              preventGetCall = true;
              let logData: any = await dispatch(getEnquiryDetails(customerTierType,
                enquiryData &&
                Array.isArray(enquiryData) &&
                enquiryData.length > 0 &&
                enquiryData[0].B2bEnquiryId,
                (enquiryAction === "view" && orderType !== "Cancelled") ? true : false, false
              ));
              // let logData: any = await dispatch(getOrderLogs(enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].B2bEnquiryId ? enquiryData[0].B2bEnquiryId : data.data.masterId))
              if (logData && logData.message && logData.message.status === "E") {
                setTimeout(() => {
                  setOpenSnackbarType("error");
                  setOpenErrorSnackbar(true);
                  setSuccessMessage(logData && logData.message && logData.message.message && logData.message.message);
                  handleopenCloseSnackbar(true);
                }, 2000)
                setIsDisableOrderLogButton(true);
              } else {
                await getOrderLogsData(logData?.data);
                setIsDisableOrderLogButton(false);

                let rmpro: any = await getRemovedProducts(logData?.data?.data);
                setInvalidParts(rmpro && rmpro.length > 0 ? rmpro : logData?.data?.data[0].removedProducts ? logData?.data?.data[0].removedProducts : []);
                setRemovedProductsLength(rmpro && rmpro.length > 0 ? rmpro.length : logData?.data?.data[0].removedProducts?.length)

                // setInvalidParts(logData?.data?.data[0].removedProducts ? logData?.data?.data[0].removedProducts : []);
                // setRemovedProductsLength(logData?.data?.data[0].removedProducts?.length)
              }
              setGetLatestOrderCount(false);
              // let savedData: any = await dispatch(getEnquiryDetails(customerTierType,
              //   enquiryData &&
              //     Array.isArray(enquiryData) &&
              //     enquiryData.length > 0 &&
              //     enquiryData[0].B2bEnquiryId
              //     ? enquiryData[0].B2bEnquiryId
              //     : data.data.masterId,
              //   (enquiryAction === "view" && orderType !== "Cancelled") ? true : false, false
              // ));

              // if (selectedAccessType !== "Parts" && isTyrePartsSearchSuccessFully === true && isTyrePartsAddedtoGrid === true && customerTierType && customerTierType.toLowerCase() === 'tbl dealer') {
              //   setisAvailabiityChecked(true);
              // } else if (selectedAccessType === "Parts" && customerTierType && customerTierType.toLowerCase() === 'tbl dealer') {
              //   setisAvailabiityChecked(true);
              // } else if (customerTierType && customerTierType.toLowerCase() !== "tbl dealer") {
              //   setisAvailabiityChecked(true);
              // }

              setDisableQuotation(false);
              setorderQueued(false);
              setisAvailabiityCheckedAtTime(new Date());
              setIsTimmerExpired(false); // Reset the expired flag to allow timer restart
              verifyEnquiryDataToEditMode(verificationData, logData.data.data, withDeletion, true)
              setSuccessMessage(enquiryDetailsQueueCheckData.message.message);
              setOpenErrorSnackbar(false);
              handleopenCloseSnackbar(true);
              if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer")) {
                setSelectedDeliveryTypeError(false);
              }
              return;
            } else {
              setOpenSnackbarType("error");
              setOpenErrorSnackbar(true);
              setSuccessMessage('Enquiry verification in progress, press the verification button after 1 min.');
              handleopenCloseSnackbar(true);
              setplaceorderEnabled(false);
              return;
            }
          }
          else {
            setOpenSnackbarType("error");
            setOpenErrorSnackbar(true);
            setSuccessMessage(enquiryDetailsQueueCheckData?.message?.message);
            setCheckAvailabilityButtonText(CHECK_AVAILABILITY_BUTTON_TEXT.PROGRESS);
            handleopenCloseSnackbar(true);
            setplaceorderEnabled(false);
            return;
          }
        }
        let data1: any;
        data = await dispatch(
          updateEnquiry(customerTierType, !shipToPartyFeatureAccess ? '' : customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && deliveryType === "SELF-PIC" ? firstAddress.shiftToPartyCustomerNumber : multipleAddressData, enquiryData[0].B2bEnquiryId, finalData, true, insertData, enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].enquiryNumber, enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].b2bLostSalesReportId ? enquiryData[0].b2bLostSalesReportId : getUniqueTimestamp(), null, null, null, null, null, annexureEnquiry === 'true' ? true : false
          )
        );
        if (data && data.data) {
          data1 = await dispatch(
            updateEnquiry(customerTierType, !shipToPartyFeatureAccess ? '' : customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && deliveryType === "SELF-PIC" ? firstAddress.shiftToPartyCustomerNumber : multipleAddressData, enquiryData[0].B2bEnquiryId, finalData, false, insertData, enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].enquiryNumber, enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].b2bLostSalesReportId ? enquiryData[0].b2bLostSalesReportId : getUniqueTimestamp(), null, null, null, null, null, annexureEnquiry === 'true' ? true : false
            )
          );
        }
        if (!(data1 && data1.data && Array.isArray(data1.data))) {
          setOpenSnackbarType("error");
          setOpenErrorSnackbar(true);
          setSuccessMessage(data1 && data1.error && typeof data1.error === 'string' ? data1.error : data1?.message && data1?.message?.message && typeof data1?.message?.message === 'string' ? data1?.message?.message : `Order Enquiry Update Failed`);
          // setSuccessMessage(data1 && data1.error && typeof data1.error === 'string' ? data1.error : `Order Enquiry Update Failed`);
          handleopenCloseSnackbar(true);
          return
        }
      }
      if (
        ((data && data.data && data.data.masterId) ||
          (isEnquirySaved && enquiryData[0].B2bEnquiryId)) && !preventGetCall
      ) {
        await dispatch(setEnquiryId(enquiryData &&
          Array.isArray(enquiryData) &&
          enquiryData.length > 0 &&
          enquiryData[0].B2bEnquiryId
          ? enquiryData[0].B2bEnquiryId
          : data.data.masterId));
        let savedData: any = await dispatch(getEnquiryDetails(customerTierType,
          enquiryData &&
            Array.isArray(enquiryData) &&
            enquiryData.length > 0 &&
            enquiryData[0].B2bEnquiryId
            ? enquiryData[0].B2bEnquiryId
            : data.data.masterId,
          (enquiryAction === "view" && orderType !== "Cancelled") ? true : false, false
        ));
        if (
          savedData &&
          savedData.data &&
          savedData.data.data &&
          savedData.data.data[0]
        ) {

          let rmpro: any = await getRemovedProducts(savedData?.data?.data);
          setInvalidParts(rmpro && rmpro.length > 0 ? rmpro : savedData.data.data[0].removedProducts ? savedData.data.data[0].removedProducts : []);
          setRemovedProductsLength(rmpro && rmpro.length > 0 ? rmpro.length : savedData?.data?.data[0].removedProducts?.length)

          // setInvalidParts(savedData.data.data[0].removedProducts ? savedData.data.data[0].removedProducts : []);
          // setRemovedProductsLength(savedData?.data?.data[0].removedProducts?.length);
          await getOrderLogsData(savedData?.data);
          setenquiryData(savedData?.data?.data);
          setGetVerifyData(savedData);
          if (inValidParts.length > 0 && sessionStorage.getItem('userType') === 'FSE') {
            sendEmailToMMForInvalidParts(inValidParts, savedData.data.data)
          }
          if (!isEnquirySaved) {
            setisUpdateMode(true);
            setisEnquirySaved(true);
            // requestPriceAccess();
            setActualProductLength(savedData.data.data[0].products.length)
          }
          if (sessionStorage.getItem('userType') === 'FSE') {
            await enquiryDataToEditMode(savedData.data.data, false, withDeletion);
          }
          if (!shouldCheckAvailability) {
            enquiryDataToEditMode(savedData.data.data, false, withDeletion);
            if (withDeletion) {
              setIsDelted(true)
            }
            setSuccessMessage(
              isEnquirySaved
                ? `Order Enquiry Updated successfully ${savedData.data.data[0] &&
                savedData.data.data[0].B2bEnquiryId
                }`
                : `Order Enquiry saved successfully ${savedData.data.data[0] &&
                savedData.data.data[0].B2bEnquiryId
                }`
            );
            if (importOes) {
              await dispatch(setEnquiryId(savedData.data.data[0].B2bEnquiryId));
              return savedData.data.data[0].B2bEnquiryId;
            }
            setOpenErrorSnackbar(false);
            handleopenCloseSnackbar(true);
            if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer")) {
              setSelectedDeliveryTypeError(false);
            }
          }
        } else {
          setOpenSnackbarType("error");
          setOpenErrorSnackbar(true);
          setSuccessMessage(
            `Order Enquiry ${!isEnquirySaved ? "Creation" : "Update"} Failed`
          );
          setOpenErrorSnackbar(false);
          handleopenCloseSnackbar(true);
          if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer")) {
            setSelectedDeliveryTypeError(false);
          }
        }
        if (
          shouldCheckAvailability &&
          ((savedData &&
            savedData.data &&
            savedData.data.data[0] &&
            savedData.data.data[0].B2bEnquiryId) ||
            (enquiryData && enquiryData[0].B2bEnquiryId))
        ) {
          isChangeCheckBox(false);
          sessionStorage.setItem('iprice', '');
          setprocuredPart([]);
          let availData: any = await dispatch(
            verifyEnquiry(customerTierType,
              (enquiryData &&
                Array.isArray(enquiryData) &&
                enquiryData[0].B2bEnquiryId
                ? enquiryData[0].B2bEnquiryId
                : savedData &&
                savedData.data &&
                savedData.data.data[0] &&
                savedData.data.data[0].B2bEnquiryId), enquirySessionId
            )
          );
          setVerificationData(availData);
          sessionStorage.setItem('reset-the-orderlog-count', "false")

          let data: any = await dispatch(getEnquiryDetails(customerTierType,
            enquiryData &&
            Array.isArray(enquiryData) &&
            enquiryData.length > 0 &&
            enquiryData[0].B2bEnquiryId,
            (enquiryAction === "view" && orderType !== "Cancelled") ? true : false, false
          ));
          await getOrderLogsData(data?.data);
          // let data: any = await dispatch(getOrderLogs(enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].B2bEnquiryId ? enquiryData[0].B2bEnquiryId : savedData && savedData.data && savedData.data.data[0] && savedData.data.data[0].B2bEnquiryId))
          if (data && data.message && data.message.status === "E") {
            setTimeout(() => {
              setOpenSnackbarType("error");
              setOpenErrorSnackbar(true);
              setSuccessMessage(data && data.message && data.message.message && data.message.message);
              handleopenCloseSnackbar(true);
            }, 2000)
            setIsDisableOrderLogButton(true);
          } else {

            let rmpro: any = await getRemovedProducts(data?.data?.data);
            setInvalidParts(rmpro && rmpro.length > 0 ? rmpro : data?.data?.data[0].removedProducts ? data?.data?.data[0].removedProducts : []);
            setRemovedProductsLength(rmpro && rmpro.length > 0 ? rmpro.length : data?.data?.data[0].removedProducts?.length)

            // setInvalidParts(data?.data?.data[0].removedProducts ? data?.data?.data[0].removedProducts : []);
            // setRemovedProductsLength(data?.data?.data[0].removedProducts?.length)
            setIsDisableOrderLogButton(false);
          }
          setGetLatestOrderCount(false);

          if (
            availData &&
            availData.data &&
            Array.isArray(availData.data) &&
            availData.data.length > 0
          ) {
            setMaterialNotExtendedPart([]);
            setIsMaterialNotExtendedExist(false);
            if (availData.message.status !== 'I') {
              setCheckAvailabilityButtonText(CHECK_AVAILABILITY_BUTTON_TEXT.NORMAL)
              setisAvailabiityCheckedAtTime(new Date());
              setIsTimmerExpired(false); // Reset the expired flag to allow timer restart
              setIsQueue(false);
              verifyEnquiryDataToEditMode(availData.data, savedData.data.data, null, null, null, true, productsTemp);
              setSuccessMessage(`Availability and Price successfully fetched`);
              setOpenErrorSnackbar(false);
              handleopenCloseSnackbar(true);
              if (isUpdateEnquiry === "true") {
                sessionStorage.setItem('sendMailIsUpdateEnquiry', "true");
              } else {
                sessionStorage.setItem('sendMailIsUpdateEnquiry', "");
              }
              // if (selectedAccessType !== "Parts" && isTyrePartsSearchSuccessFully === true && isTyrePartsAddedtoGrid === true && customerTierType && customerTierType.toLowerCase() === 'tbl dealer') {
              //   setisAvailabiityChecked(true);
              // } else if (selectedAccessType === "Parts" && customerTierType && customerTierType.toLowerCase() === 'tbl dealer') {
              //   setisAvailabiityChecked(true);
              // } else if (customerTierType && customerTierType.toLowerCase() !== "tbl dealer") {
              //   setisAvailabiityChecked(true);
              // }
              setDisableQuotation(false);
              // requestPriceAccess();
              if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer")) {
                setSelectedDeliveryTypeError(false);
              }
            } else {
              //Set Check Availability Button to show verification queued if check data is not verified.
              setCheckAvailabilityButtonText(CHECK_AVAILABILITY_BUTTON_TEXT.QUEUED)
              setOpenSnackbarType("error");
              setOpenErrorSnackbar(true);
              setIsQueue(true);
              setSuccessMessage((sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') ?
                'Enquiry has been submitted for verification and will take few minutes to get completed. You can check its status by selecting “Queued Enquiries” in the Order-Enquiry List.'
                : 'Enquiry queued for verification, press the verification button after 1 min');
              handleopenCloseSnackbar(true);
              setplaceorderEnabled(false);
            }
          } else {
            enquiryDataToEditMode(savedData?.data?.data, true, false, false);
            setOpenSnackbarType("error");
            setOpenErrorSnackbar(true);
            if (availData && availData.error && Array.isArray(availData.error) && availData.error.length > 0) {
              setSuccessMessage(availData.statusText && typeof availData.statusText === 'object' && typeof availData.statusText.data === 'object' ? availData.statusText.data.message && availData.statusText.data.message.message && typeof availData.statusText.data.message.message === 'object' && availData.statusText.data.message.message.messageText : 'Verify enquiry failed');
            } else {
              setSuccessMessage(typeof availData.error === 'string' ? availData.error : typeof availData.error === 'object' ? (availData.error && availData.error?.messageId ? availData.error?.messageId : 'Verify enquiry failed') : 'Verify enquiry failed');
            }
            handleopenCloseSnackbar(true);
            // Verify genuinely failed (may be a real Material Not Extended / Procurement Block
            // failure, or a technical failure) — don't leave a prior successful check's
            // "verified" UI state (timer, Place Order, Order Log) showing as still valid.
            setisAvailabiityChecked(false);
            setplaceorderEnabled(false);
            // Only treat this as a pricing/business-rule failure (Material Not Extended,
            // Procurement Block, etc.) worth parsing into the grid when every part in the
            // enquiry is actually committed (isAddToEnquiry !== false) — while any Tyre-search
            // result is still unresolved, a verify failure is just shown as the generic
            // failure message above, nothing gets parsed/flagged for those uncommitted rows.
            if (
              productsTemp.every((p: any) => p.isAddToEnquiry !== false) &&
              availData && availData.error && Array.isArray(availData.error) && availData.error.length > 0
            ) {
              verifyEnquiryDataToEditMode(availData.error, savedData.data.data, null, null, null, true, productsTemp);
            }
          }
        }
      } else if (data && data.error) {
        setOpenSnackbarType("error");
        setOpenErrorSnackbar(true);
        setSuccessMessage(
          typeof data.message === 'string'
            ? data.message
            : typeof data.error === 'string'
              ? data.error
              : "Unable to create the enquiry."
        );
        handleopenCloseSnackbar(true);
        return;
      }
    } else {
      setOpenSnackbarType("error");
      setOpenErrorSnackbar(true);
      setSuccessMessage(`No valid parts are present`);
      handleopenCloseSnackbar(true);
      return;
    }
    if (!shouldCheckAvailability) {
      setisAvailabiityChecked(false);
      setplaceorderEnabled(false)
    }
  };

  const onClickDelete = async (pro?: any) => {
    if (invalidParts && invalidParts.length > 0) {
      setIsInvalidPartsExist(true);
    } else {
      setIsInvalidPartsExist(false);
    }
    let hasDeletions = false;
    let selected: any = [];
    let productsTemp: any = pro && pro.length > 0 ? JSON.parse(
      JSON.stringify(pro)
    ) : JSON.parse(
      JSON.stringify(products)
    );
    // isChangeCheckBox(true);
    productsTemp = productsTemp.filter(
      (item: any) => {
        if (item.selected) {
          selected.push(item.productId)
          hasDeletions = true;
        }
        return !item.selected
      }
    );
    if (isEnquirySaved) {
      if (hasDeletions) {
        setIsInvalidPartsExist(false);
        saveUpdateEnquiry(false, true);
        if (invalidParts.length > 0) {
          let b2bEnqId = enquiryData && enquiryData[0]?.B2bEnquiryId;
          let selectInvaildParts = invalidParts.filter((item: any) => {
            if (selected.includes(item.productId)) {
              item.isManualDelete = true;
              return item;
            }
          })
          if (pro && pro.length > 0) { } else {
            await deleteProblemParts(b2bEnqId, selectInvaildParts, true);
          }
        }
      }
    } else {
      setproducts([...productsTemp]);
      let deletedParts = invalidParts.filter((item: any) => {
        if (!selected.includes(item.productId)) {
          return item;
        }
      })
      setInvalidParts([...deletedParts]);
      //dispatch(deleteLostSaleReport(customerTierType, selected, enquirySessionId))
    }
  }

  const sendEmailToMMForInvalidParts = (invalidParts: Array<[]>, savedEnquiryData: any) => {

    let emailPayload = {
      "userType": "FSE",
      "emailType": "invalidParts",
      "webApplicationLoginId": webApplicationLoginId,
      "firstNaem": firstName,
      "lastName": lastName,
      "email": profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo && profileDetails.data.data.basicInfo.email,
      "enquiryId": savedEnquiryData && savedEnquiryData.length > 0 && savedEnquiryData[0].B2bEnquiryId ? savedEnquiryData[0].B2bEnquiryId : "",
      "invalidParts": invalidParts
    }
    dispatch(sendAnnouncmentToCustomer(emailPayload))
  }

  const shouldShowAvailabilityBlock = () => {
    const isTyreAccessSelected = selectedAccessType === "Tyres";

    const hasTyreAccess = products?.some((p: any) => p.accessTyres === true);

    const allAddedToEnquiry =
      products?.length > 0 &&
      products.every((p: any) => p.isAddToEnquiry === true);

    if (!isTyreAccessSelected) {
      return true;
    }

    return allAddedToEnquiry && isAvailabiityChecked;
  };

  const saveUpdateEnquiry = async (shouldCheckAvailability: any, withDeletion?: any, p?: any, isAddToEnquiry?: any, calldeleteAPI?: any) => {
    sessionStorage.setItem("isProblemParts", "");
    sessionStorage.setItem('isCopyandCreate', "");
    sessionStorage.setItem("partsData", "")
    let data: any = null;
    let refNo: any = '';
    setIsQuantityUpdated(false);
    if (!isQueue) {
      // if (!isQueue && isAddToEnquiry) {
      setIscallAPI(true);
    }
    setActualProductLength(p && p.length > 0 ? p.length : products.length);

    let productsTemp = JSON.parse(JSON.stringify(p && p.length > 0 ? p : products));
    if (isEnquirySaved && calldeleteAPI) {
      const deletedProductIds: string[] = [];
      productsTemp = products.map((product: any) => {
        if (product.isAddToEnquiry === false) {
          // isMaterialNotExtended: false — abandoned/unresolved search result being cleaned
          // up here, not a genuine MNE removal; keeping both flags together makes the backend
          // log it as a real removed part even though it was never added to the enquiry.
          deletedProductIds.push(product.productId);
          return {
            ...product,
            action: "D",
            isMaterialNotExtended: false
          };
        }
        // Clicking "Check Availability and Price" again — AFTER the Material Not Extended
        // popup has already been shown once for this part (product.isMaterialNotExtended /
        // materialNotExtendedPart only ever get set once a verify failure has actually
        // surfaced the popup) — must delete those flagged parts (action "D"). Deliberately
        // NOT checking capturedMaterialNotExtendedIds here: that ref can hold a part the user
        // has never been shown a popup for yet (e.g. flagged during an earlier live Tyre
        // search), and the very first Check Availability click for a freshly added part must
        // send everything as-is so the user sees the popup before anything is silently deleted.
        if (
          product.isMaterialNotExtended ||
          (Array.isArray(materialNotExtendedPart) && materialNotExtendedPart.includes(product.productId))
        ) {
          deletedProductIds.push(product.productId);
          return {
            ...product,
            action: "D"
          };
        }
        return product;
      });
      // setproducts(updatedProducts);
      // await updateOnly(productsTemp);
      clearMaterialNotExtendedTracking(deletedProductIds);
    }
    let invalidParts: any = [];
    let productsExtract = [...productsTemp]
    invalidParts = productsExtract.filter((product: any) => !product.isValid).map(item => item['productId']);
    let allProducts: any = [];
    if (isEnquirySaved) {

      if (enquiryData && enquiryData.length > 0) {
        allProducts = enquiryData.reduce((acc: any, enquiry: any) => {
          return [...acc, ...enquiry.products];
        }, []);
      } else {
        productsTemp = productsTemp.filter((product: any) => product.isValid);
      }
      if (invalidParts && invalidParts.length > 0) {
        for (const product of allProducts) {
          if (invalidParts.includes(product.productId) && product.materialGroup == '') {
            // productsTemp = productsTemp;
          } else if (product.isValid === false) {
            productsTemp = productsTemp.filter((p: any) => p.productId !== product.productId);
          }
        }
      } else {
        productsTemp = productsTemp.filter((product: any) => product.isValid);
      }
    } else {
      productsTemp = productsTemp.filter((product: any) => product.isValid);
    }
    productsTemp = productsTemp.filter((product: any) => product.invalidMaterialGroup !== '');
    if (
      productsTemp &&
      Array.isArray(productsTemp) &&
      productsTemp.length > 0
    ) {
      let emptyRefNo = false;
      let emptyQuantity = false;
      const hasAnyAddToEnquiry = products.every((product: any) => product.isAddToEnquiry);
      productsTemp = productsTemp.map((item: any) => {
        // Changed on merging problem parts added  && item.isValid
        if (selectedAccessType === "Tyres" && !hasAnyAddToEnquiry) {
        } else {
          if (item && item.materialGroup && isAddToEnquiry !== false) {
            if (
              !brandRefNumbers[`${enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`]}`] ||
              !brandRefNumbers[`${enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`]}`].trim() && item.isValid
            ) {
              emptyRefNo = true;
            }
          }
        }

        if (selectedAccessType === "Tyres" && !hasAnyAddToEnquiry) {
          // refNo = brandRefNumbers['2195'];
        } else {
          if (referenceNumber === "" && isAddToEnquiry !== false) {
            emptyRefNo = true;
          }
        }
        // if (/^AFG\d{4}$/.test(referenceNumber) && shouldCheckAvailability) {
        //   setreferenceNumber('');
        //   emptyRefNo = true;
        // }
        if (!parseInt(item.quantity)) {
          emptyQuantity = item.productId;
        }
        // Changed on merging problem parts added  && item.isValid

        if (item && item.materialGroup) {
          item["enquiryReferenceNumber"] =
            brandRefNumbers[
            `${enquiryMapping[`${formatMaterialGroup(item?.materialGroup)}`]}`
            ];
          item["deliveryBlockReason"] =
            deliveryBlockReason[
              `${enquiryMapping[
              `${formatMaterialGroup(item?.materialGroup)}`
              ]}`
            ]?.deliveryBlockReason || '';
          item["deliveryBlockReasonCode"] = item?.materialGroup
            ? deliveryBlockReason[
              `${enquiryMapping[
              `${formatMaterialGroup(item.materialGroup)}`
              ]}`
            ]?.deliveryBlockReasonCode
            : '';
          item["masterReferenceNumber"] = referenceNumber !== '' ? referenceNumber : tempRef;
        } else {
          item["enquiryReferenceNumber"] = '';
          item["deliveryBlockReason"] = '';
          item["deliveryBlockReasonCode"] = '';
        } item["masterReferenceNumber"] = referenceNumber !== '' ? referenceNumber : tempRef;
        return item;
      });
      if (emptyRefNo) {
        setOpenSnackbarType("error");
        setOpenErrorSnackbar(true);
        setSuccessMessage(`All reference numbers are mandatory`);
        handleopenCloseSnackbar(true);
        return;
      }
      if (emptyQuantity) {
        setOpenSnackbarType("error");
        setOpenErrorSnackbar(true);
        setSuccessMessage(
          `Quantity of product ${emptyQuantity} should be greater than zero`
        );
        handleopenCloseSnackbar(true);
        return;
      }
      if (
        customerTierType &&
        customerTierType.toLowerCase() === "int. business" &&
        has2431 &&
        has2428 &&
        !sessionStorage.getItem('orderCreatedBy')
      ) {
        setOpenSnackbar(true);
        setOpenErrorSnackbar(true);
        setSuccessMessage("Please select Order Created By");
        setLoading(false);
        return;
      }
      setproducts(JSON.parse(JSON.stringify(productsTemp)));
      let preventGetCall = false;
      if (!isEnquirySaved) {
        data = await dispatch(createEnquiry(customerTierType, customerAccountType, referenceNumber !== '' ? referenceNumber : tempRef, productsTemp, annexureEnquiry === 'true' ? true : false, sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ? firstName + ' ' + lastName : firstName, sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ? webApplicationLoginId : b2cUserId, enquirySessionId));
        sessionStorage.setItem('subEnquiryId', JSON.stringify(data && data.data && data.data.subEnquiries && data.data.subEnquiries));
        setSubEnquiriesData(data && data.data && data.data.subEnquiries && data.data.subEnquiries);
      } else {
        let filteredItemNos: any = []
        let superseeded: any = productsTemp.filter((p: any) => p.isSuperseeded)

        const isSuperseededExist = (item: any) => {
          let issuperseededexist: any = superseeded.find((s: any) => s.supercessionMaterial === item.productId && parseInt(s.nsp) > 0);
          if (issuperseededexist && parseInt(issuperseededexist?.nsp) > 0) {
            return true
          } else {
            return false
          }
        }
        productsTemp.map((item: any) => {
          if (withDeletion) {
            // setIsQuantityUpdated(true) // Aded this condition to make place order disabled again if product got deleted
            if (item['selected']) {
              filteredItemNos.push({
                productId: item.productId,
                itemNumber: item.nowEnquiryItemNumber || item.hrs24EnquiryItemNumber || item.airEnquiryItemNumber
              })
              item["action"] = "D"
              item["isManualDelete"] = true;
            }
          }

          // Changed on merging problem parts added next 3 lines
          if (item.isValid === false && item.materialGroup === '') {
            item["action"] = "D"
          }

          if (zeroProducts && zeroProducts.length > 0 && isAvailabiityChecked) {
            if ((parseFloat(item.nsp) === 0 || parseFloat(item.nsp) === 0.00) && !item.isMaterialNotExtended && !isSuperseededExist(item)) {
              item.action = "D";
              item.isZeroPrice = true;
            }
          }
          if (item.isMaterialNotExtended) {
            item["action"] = "D";
            // item["isValid"] = false;
          }
          if (item.isProcurementPart && item.nowAvailability && parseInt(item.nowAvailability) !== 0 && !withDeletion) {
            item["action"] = "C";
          }
          if (
            item.isProcurementPart &&
            parseInt(item.airAvailability || 0) === 0
          ) {
            if (isSuperseededExist(item)) {
              item["action"] = "C";
            } else {
              item["action"] = "D";
            }

            item["airAvailabilityChecked"] = false;
          }
          // item["nowAvailabilityChecked"] = false;
          // item["hrs24AvailabilityChecked"] = false;
          // item["airAvailabilityChecked"] = false;
          if (item.nowAvailabilityChecked) {
            item["productCost"] = 0;
          }
          // >>>>>>>>>>>>>>>>>>>> 24 HRS CODE <<<<<<<<<<<<<<<
          if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && item.hrs24AvailabilityChecked) {
            item["productCost"] = 0;
          }
          // if (item.accessTyres) {
          //   item.airAvailabilityChecked = false
          // }
          //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
          if (item.airAvailabilityChecked) {
            item["productCost"] = 0;
          }
          return item
        })
        productsTemp = productsTemp.filter((item: any) => {
          let isNotDeleted = true
          filteredItemNos.map((part: any) => {
            if (item.isSuperseeded && item.supercessionMaterial == part.productId &&
              (part.itemNumber == item.nowEnquiryItemNumber ||
                part.itemNumber == item.nowEnquiryItemNumber)) {
              isNotDeleted = false
            }
          })
          return isNotDeleted
        })
        let updationData: any = {};
        let insertData: any = [];

        let productsTempNew: any = productsTemp;

        // Filter the productsTempNew array
        productsTempNew = productsTempNew.filter((product: any) => {
          // product.orgId = "";
          if (invalidParts && invalidParts.length > 0) {
            // Check if the product's sequence number exists in invalidParts
            const seqExistsInInvalidParts = invalidParts.some((part: any) => part.seq === product.seq);
            // If the sequence number exists in invalidParts, apply filter
            if (seqExistsInInvalidParts) {
              return (product.action !== 'D' && !product.isProcurementPart) || (product.action !== 'D' && !product.isZeroPrice);
            } else {
              // If the sequence number doesn't exist in invalidParts, retain the item
              return true;
            }
          } else {
            return product;
          }
        });

        // let productsTempNew: any = productsTemp;
        // productsTempNew = productsTempNew.filter((product: any) => product.action !== 'D' && !product.isProcurementPart);
        productsTempNew.map((singleProduct: any) => {
          if (singleProduct["id"]) {
            if (updationData[singleProduct["id"]]) {
              updationData[singleProduct["id"]].push(singleProduct);
            } else {
              updationData[singleProduct["id"]] = [singleProduct];
            }
          } else {
            if (singleProduct.materialGroup && singleProduct.isValid) {
              insertData.push(singleProduct)
            }
          }
        });
        let finalData: any = [];
        Object.keys(updationData).map((singlekey: any) => {
          const currentEnquiry = (enquiryData ?? []).find((enquiry: any) =>
            enquiry?.products?.some(
              (product: any) => product?.id === updationData[singlekey]?.[0]?.id
            )
          );
          let tc: any = getEstimatedTotal(isAvailabiityChecked, true, withDeletion);
          finalData.push({
            id: singlekey,
            masterReferenceNumber: referenceNumber !== '' ? referenceNumber : tempRef,
            products: updationData[singlekey],
            // totalCost: changeCheckBox ? getEstimatedTotal(true, withDeletion) : estTotal,
            totalCost: getEstimatedTotal(isAvailabiityChecked, true, withDeletion),
            netOrderValue: parseInt(tc) == 0 ? 0 : getnetOrderValue(currentEnquiry, true, withDeletion)
          });
        });
        let enquiryDetailsQueueCheckData: any;
        if (checkAvailabilityButtonText.toLowerCase() !== CHECK_AVAILABILITY_BUTTON_TEXT.NORMAL.toLowerCase()) {
          //Trigger verification queued check before attempting update
          enquiryDetailsQueueCheckData = await dispatch(verifyEnquiryQueueCheck(customerTierType, enquiryData[0].B2bEnquiryId, enquiryData[0].customerId));
          //Error enquiryDetailsQueueCheckData.message.status == "E"
          if ((enquiryDetailsQueueCheckData && enquiryDetailsQueueCheckData.error && typeof enquiryDetailsQueueCheckData.error === 'object' && enquiryDetailsQueueCheckData.error.items && enquiryDetailsQueueCheckData.error.items.length > 0) || (enquiryDetailsQueueCheckData && enquiryDetailsQueueCheckData.error && Array.isArray(enquiryDetailsQueueCheckData.error) && enquiryDetailsQueueCheckData.error?.length > 0 && enquiryDetailsQueueCheckData.error[0].items && enquiryDetailsQueueCheckData.error[0].items.length > 0) || (enquiryDetailsQueueCheckData.message && enquiryDetailsQueueCheckData.message.status && enquiryDetailsQueueCheckData.message.status == "E")) {
            setOpenSnackbarType("error");
            setOpenErrorSnackbar(true);
            setSuccessMessage(enquiryDetailsQueueCheckData && enquiryDetailsQueueCheckData.error && typeof enquiryDetailsQueueCheckData.error === 'object' && enquiryDetailsQueueCheckData.error.items && enquiryDetailsQueueCheckData.error.items.length > 0 ? 'Verify Enquiry Failed'
              : enquiryDetailsQueueCheckData && enquiryDetailsQueueCheckData.error && Array.isArray(enquiryDetailsQueueCheckData.error) && enquiryDetailsQueueCheckData.error?.length > 0 && enquiryDetailsQueueCheckData.error[0].items && enquiryDetailsQueueCheckData.error[0].items.length > 0 ? 'Verify Enquiry Failed' : enquiryDetailsQueueCheckData?.message?.message ? enquiryDetailsQueueCheckData?.message?.message : 'Verify Enquiry Failed');
            handleopenCloseSnackbar(true);
            setplaceorderEnabled(false);
            if ((enquiryDetailsQueueCheckData && enquiryDetailsQueueCheckData.error && typeof enquiryDetailsQueueCheckData.error === 'object' && enquiryDetailsQueueCheckData.error.items && enquiryDetailsQueueCheckData.error.items.length > 0) || (enquiryDetailsQueueCheckData && enquiryDetailsQueueCheckData.error && Array.isArray(enquiryDetailsQueueCheckData.error) && enquiryDetailsQueueCheckData.error?.length > 0 && enquiryDetailsQueueCheckData.error[0].items && enquiryDetailsQueueCheckData.error[0].items.length > 0)) {
              setCheckAvailabilityButtonText(CHECK_AVAILABILITY_BUTTON_TEXT.NORMAL);
              setisAvailabiityChecked(false);
              setorderQueued(false);
              let verificationData: any = [];
              let hasConfirmationData = true;
              if (enquiryDetailsQueueCheckData && enquiryDetailsQueueCheckData.error && typeof enquiryDetailsQueueCheckData.error === 'object' || enquiryDetailsQueueCheckData.error?.length > 0) {
                if (Array.isArray(enquiryDetailsQueueCheckData.error) && enquiryDetailsQueueCheckData?.error?.length > 0) {
                  enquiryDetailsQueueCheckData.error.map((data: any) => {
                    verificationData.push({ verifiedData: data });
                  })
                } else if (typeof enquiryDetailsQueueCheckData.error === 'object') {
                  verificationData.push({ verifiedData: enquiryDetailsQueueCheckData.error });
                }
              }
              verifyEnquiryDataToEditMode(verificationData, enquiryData, withDeletion, true, true, isAddToEnquiry)
            }
            return;
          }


          //Queued enquiryDetailsQueueCheckData.message.message === "verification queued"
          else if (enquiryDetailsQueueCheckData && enquiryDetailsQueueCheckData.message && enquiryDetailsQueueCheckData.message.message && typeof enquiryDetailsQueueCheckData.message.message === 'string' && enquiryDetailsQueueCheckData.message.message.toLowerCase() == "verification queued") {
            setOpenSnackbarType("error");
            setOpenErrorSnackbar(true);
            setIsQueue(true);
            setSuccessMessage(sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ?
              'Enquiry has been submitted for verification and will take few minutes to get completed. You can check its status by selecting “Queued Enquiries” in the Order-Enquiry List.'
              : 'Enquiry queued for verification, press the verification button after 1 min');
            handleopenCloseSnackbar(true);
            setplaceorderEnabled(false);
            return;
          }
          //In Progress enquiryDetailsQueueCheckData.message.message === "verification in progress"
          else if (enquiryDetailsQueueCheckData && enquiryDetailsQueueCheckData.message && enquiryDetailsQueueCheckData.message.message && typeof enquiryDetailsQueueCheckData.message.message === 'string' && enquiryDetailsQueueCheckData.message.message.toLowerCase() == "verification in progress") {
            setOpenSnackbarType("error");
            setOpenErrorSnackbar(true);
            setSuccessMessage('Enquiry verification in progress, press the verification button after 1 min.');
            setIsQueue(true);
            setCheckAvailabilityButtonText(CHECK_AVAILABILITY_BUTTON_TEXT.PROGRESS);
            handleopenCloseSnackbar(true);
            setplaceorderEnabled(false);
            return;
          }
          //In Progress enquiryDetailsQueueCheckData.message.message === "enquiry changed"
          else if (enquiryDetailsQueueCheckData && enquiryDetailsQueueCheckData.message && enquiryDetailsQueueCheckData.message.message && typeof enquiryDetailsQueueCheckData.message.message === 'string' && enquiryDetailsQueueCheckData.message.message.toLowerCase() == "enquiry changed") {
            setOpenSnackbarType("error");
            setOpenErrorSnackbar(true);
            setSuccessMessage('Enquiry changed, press the verification button after 10 seconds');
            setIsQueue(false);
            setCheckAvailabilityButtonText(CHECK_AVAILABILITY_BUTTON_TEXT.PROGRESS);
            handleopenCloseSnackbar(true);
            setplaceorderEnabled(false);
            return;
          }
          //Success enquiryDetailsQueueCheckData.message.message === "verification completed"
          else if (enquiryDetailsQueueCheckData && enquiryDetailsQueueCheckData.message && enquiryDetailsQueueCheckData.message.message && typeof enquiryDetailsQueueCheckData.message.message === 'string' && enquiryDetailsQueueCheckData.message.message.toLowerCase() == "verification completed") {
            setIsQueue(false);
            setCheckAvailabilityButtonText(CHECK_AVAILABILITY_BUTTON_TEXT.NORMAL);
            //should be removed and format should be updated on api side
            let verificationData: any = []
            let hasConfirmationData = true;
            if (enquiryDetailsQueueCheckData && Array.isArray(enquiryDetailsQueueCheckData.data)) {
              enquiryDetailsQueueCheckData.data.map((item: any) => {
                if (item && item.confirmations && Array.isArray(item.confirmations) && item.confirmations.length > 0) {
                  verificationData.push({
                    verifiedData: item
                  })
                } else {
                  hasConfirmationData = false;
                }
              })
            }
            if (hasConfirmationData) {
              //should be removed and format should be updated on api side
              preventGetCall = true;
              let logData: any = await dispatch(getEnquiryDetails(customerTierType,
                enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].B2bEnquiryId ? enquiryData[0].B2bEnquiryId : data.data.masterId,
                (enquiryAction === "view" && orderType !== "Cancelled") ? true : false, false
              ));

              // await dispatch(getOrderLogs(enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].B2bEnquiryId ? enquiryData[0].B2bEnquiryId : data.data.masterId))
              if (logData && logData.message && logData.message.status === "E") {
                setTimeout(() => {
                  setOpenSnackbarType("error");
                  setOpenErrorSnackbar(true);
                  setSuccessMessage(logData && logData.message && logData.message.message && logData.message.message);
                  handleopenCloseSnackbar(true);
                }, 2000)
                setIsDisableOrderLogButton(true);
              } else {

                let rmpro: any = await getRemovedProducts(logData?.data?.data);
                setInvalidParts(rmpro && rmpro.length > 0 ? rmpro : logData?.data?.data[0].removedProducts ? logData?.data?.data[0].removedProducts : []);
                setRemovedProductsLength(rmpro && rmpro.length > 0 ? rmpro.length : logData?.data?.data[0].removedProducts?.length)

                // setRemovedProductsLength(logData?.data?.data[0].removedProducts?.length)
                // setInvalidParts(logData?.data?.data[0].removedProducts ? logData?.data?.data[0].removedProducts : []);
                await getOrderLogsData(logData?.data);
                setIsDisableOrderLogButton(false);
              }
              setGetLatestOrderCount(false);
              // calldeleteAPI is only ever true for an explicit "Check Availability and Price"
              // click (never the automatic per-keystroke verify a live Tyre search triggers), so
              // a successful verify here should mark the enquiry checked even if there are still
              // unresolved (isAddToEnquiry === false) Tyre-search rows sitting in the grid —
              // otherwise price/stock for the rest of the enquiry never surfaces.
              if (calldeleteAPI || selectedAccessType === "Parts" || (isTyrePartsSearchSuccessFully === true && isTyrePartsAddedtoGrid === true) || products.some((p: any) => p.isAddToEnquiry === false)) {
                setisAvailabiityChecked(true);
              }
              setDisableQuotation(false);
              setorderQueued(false);
              setisAvailabiityCheckedAtTime(new Date());
              setIsTimmerExpired(false); // Reset the expired flag to allow timer restart
              verifyEnquiryDataToEditMode(verificationData, logData.data.data, withDeletion, true, null, isAddToEnquiry)
              setSuccessMessage(enquiryDetailsQueueCheckData.message.message);
              setOpenErrorSnackbar(false);
              handleopenCloseSnackbar(true);
              if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer")) {
                setSelectedDeliveryTypeError(false);
              }
              return;
            } else {
              setOpenSnackbarType("error");
              setOpenErrorSnackbar(true);
              setSuccessMessage('Enquiry verification in progress, press the verification button after 1 min.');
              handleopenCloseSnackbar(true);
              setplaceorderEnabled(false);
              return;
            }
          }
          else {
            setOpenSnackbarType("error");
            setOpenErrorSnackbar(true);
            setSuccessMessage(typeof enquiryDetailsQueueCheckData.message.message === 'string' ? enquiryDetailsQueueCheckData.message.message : typeof enquiryDetailsQueueCheckData.message.message === 'object' ? enquiryDetailsQueueCheckData.message.message && enquiryDetailsQueueCheckData.message.message.messageText : 'Verify Enquiry failed');
            setCheckAvailabilityButtonText(CHECK_AVAILABILITY_BUTTON_TEXT.PROGRESS);
            handleopenCloseSnackbar(true);
            setplaceorderEnabled(false);
            return;
          }
        }
        let data1: any;
        let upData: any;
        if (invalidParts && invalidParts.length === 0) {
          upData = await dispatch(
            updateEnquiry(customerTierType, !shipToPartyFeatureAccess ? '' : customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && deliveryType === "SELF-PIC" ? firstAddress.shiftToPartyCustomerNumber : multipleAddressData, enquiryData[0].B2bEnquiryId, finalData, true, insertData, enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].enquiryNumber, enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].b2bLostSalesReportId ? enquiryData[0].b2bLostSalesReportId : getUniqueTimestamp(), null, null, null, null, null, annexureEnquiry === 'true' ? true : false
            )
          );
        }
        // if (data && data.data) {
        data1 = await dispatch(
          updateEnquiry(customerTierType, !shipToPartyFeatureAccess ? '' : customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && deliveryType === "SELF-PIC" ? firstAddress.shiftToPartyCustomerNumber : multipleAddressData, enquiryData[0].B2bEnquiryId, finalData, false, insertData, enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].enquiryNumber, enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].b2bLostSalesReportId ? enquiryData[0].b2bLostSalesReportId : getUniqueTimestamp(), null, null, null, null, null, annexureEnquiry === 'true' ? true : false
          )
        );
        // }
        // if (data && data.data) {
        // data1 = await dispatch(
        //   updateEnquiry(customerTierType, !shipToPartyFeatureAccess ? '' : customerTierType && customerTierType.toLowerCase() === "workshop" && deliveryType === "SELF-PIC" ? firstAddress.shiftToPartyCustomerNumber : multipleAddressData, enquiryData[0].B2bEnquiryId, finalData, false, insertData, enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].enquiryNumber, enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].b2bLostSalesReportId ? enquiryData[0].b2bLostSalesReportId : getUniqueTimestamp()
        //   )
        // );
        // }
        if (!(data1 && data1.data && Array.isArray(data1.data))) {
          setOpenSnackbarType("error");
          setOpenErrorSnackbar(true);
          setSuccessMessage(data1 && data1.error && typeof data1.error === 'string' ? data1.error : data1?.message && data1?.message?.message && typeof data1?.message?.message === 'string' ? data1?.message?.message : `Order Enquiry Update Failed`);
          handleopenCloseSnackbar(true);
          return
        }
      }
      if (
        ((data && data.data && data.data.masterId) ||
          (isEnquirySaved && enquiryData[0].B2bEnquiryId)) && !preventGetCall
      ) {
        const allAddedToEnquiry =
          productsTemp?.length > 0 &&
          productsTemp.every((p: any) => p.isAddToEnquiry === true);
        if (isCustomerUser() && shouldCheckAvailability && !isAddToEnquiry && allAddedToEnquiry) {
          setIsEnquiryStarted(true);
        }
        await dispatch(setEnquiryId(enquiryData &&
          Array.isArray(enquiryData) &&
          enquiryData.length > 0 &&
          enquiryData[0].B2bEnquiryId
          ? enquiryData[0].B2bEnquiryId
          : data.data.masterId));
        let savedData: any;
        savedData = await dispatch(getEnquiryDetails(customerTierType,
          enquiryData &&
            Array.isArray(enquiryData) &&
            enquiryData.length > 0 &&
            enquiryData[0].B2bEnquiryId
            ? enquiryData[0].B2bEnquiryId
            : data.data.masterId,
          (enquiryAction === "view" && orderType !== "Cancelled") ? true : false, false
        ));
        if (
          savedData &&
          savedData.data &&
          savedData.data.data &&
          savedData.data.data[0]
        ) {
          let rmpro: any = await getRemovedProducts(savedData?.data?.data);
          setInvalidParts(rmpro && rmpro.length > 0 ? rmpro : savedData.data.data[0].removedProducts ? savedData.data.data[0].removedProducts : []);
          setRemovedProductsLength(rmpro && rmpro.length > 0 ? rmpro.length : savedData?.data?.data[0].removedProducts?.length)
          // setRemovedProductsLength(savedData.data.data[0]?.removedProducts?.length)
          // setInvalidParts(savedData.data.data[0].removedProducts ? savedData.data.data[0].removedProducts : []);
          await getOrderLogsData(savedData?.data);
          setenquiryData(savedData?.data?.data);
          setGetVerifyData(savedData);
          if (invalidParts.length > 0 && sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') {
            sendEmailToMMForInvalidParts(invalidParts, savedData.data.data)
          }
          if (!isEnquirySaved) {
            setisUpdateMode(true);
            setisEnquirySaved(true);
            // requestPriceAccess();
            setActualProductLength(savedData.data.data[0].products.length)
          }
          if (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') {
            await enquiryDataToEditMode(savedData.data.data, false, withDeletion);
          }
          if (!shouldCheckAvailability) {
            enquiryDataToEditMode(savedData.data.data, false, withDeletion);
            if (withDeletion) {
              setIsDelted(true)
            }
            setSuccessMessage(
              isEnquirySaved
                ? `Order Enquiry Updated successfully ${savedData.data.data[0] &&
                savedData.data.data[0].B2bEnquiryId
                }`
                : `Order Enquiry saved successfully ${savedData.data.data[0] &&
                savedData.data.data[0].B2bEnquiryId
                }`
            );
            if (importOes) {
              await dispatch(setEnquiryId(savedData.data.data[0].B2bEnquiryId));
              return savedData.data.data[0].B2bEnquiryId;
            }
            setOpenErrorSnackbar(false);
            handleopenCloseSnackbar(true);
            if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer")) {
              setSelectedDeliveryTypeError(false);
            }
          }
        } else {
          setOpenSnackbarType("error");
          setOpenErrorSnackbar(true);
          setSuccessMessage(
            `Order Enquiry ${!isEnquirySaved ? "Creation" : "Update"} Failed`
          );
          setOpenErrorSnackbar(false);
          handleopenCloseSnackbar(true);
          if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer")) {
            setSelectedDeliveryTypeError(false);
          }
        }
        if (
          shouldCheckAvailability &&
          ((savedData &&
            savedData.data &&
            savedData.data.data[0] &&
            savedData.data.data[0].B2bEnquiryId) ||
            (enquiryData && enquiryData[0].B2bEnquiryId))
        ) {
          isChangeCheckBox(false);
          sessionStorage.setItem('iprice', '');
          setprocuredPart([]);
          let updatedData: any;
          if ((sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') && !enquiryData) {
            updatedData = await updateOnly(products, undefined, undefined, savedData.data.data);
          }
          let availData: any = await dispatch(
            verifyEnquiry(customerTierType,
              (enquiryData &&
                Array.isArray(enquiryData) &&
                enquiryData[0].B2bEnquiryId
                ? enquiryData[0].B2bEnquiryId
                : savedData &&
                savedData.data &&
                savedData.data.data[0] &&
                savedData.data.data[0].B2bEnquiryId), enquirySessionId, isAddToEnquiry
            )
          );
          setVerificationData(availData);
          sessionStorage.setItem('reset-the-orderlog-count', "false")
          let data: any = await dispatch(getEnquiryDetails(customerTierType,
            enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].B2bEnquiryId ? enquiryData[0].B2bEnquiryId : savedData && savedData.data && savedData.data.data[0] && savedData.data.data[0].B2bEnquiryId,
            (enquiryAction === "view" && orderType !== "Cancelled") ? true : false, false
          ));
          // await dispatch(getOrderLogs(enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].B2bEnquiryId ? enquiryData[0].B2bEnquiryId : savedData && savedData.data && savedData.data.data[0] && savedData.data.data[0].B2bEnquiryId))
          if (data && data.message && data.message.status === "E") {
            setTimeout(() => {
              setOpenSnackbarType("error");
              setOpenErrorSnackbar(true);
              setSuccessMessage(data && data.message && data.message.message && data.message.message);
              handleopenCloseSnackbar(true);
            }, 2000)
            setIsDisableOrderLogButton(true);
          } else {
            let rmpro: any = await getRemovedProducts(data?.data?.data);
            setInvalidParts(rmpro && rmpro.length > 0 ? rmpro : data?.data?.data[0].removedProducts ? data?.data?.data[0].removedProducts : []);
            setRemovedProductsLength(rmpro && rmpro.length > 0 ? rmpro.length : data?.data?.data[0].removedProducts?.length)
            // setInvalidParts(data?.data?.data[0].removedProducts ? data?.data?.data[0].removedProducts : []);
            // setRemovedProductsLength(data?.data?.data[0].removedProducts?.length)
            await getOrderLogsData(data?.data);
            setIsDisableOrderLogButton(false);
          }
          setGetLatestOrderCount(false);
          if (
            availData &&
            availData.data &&
            Array.isArray(availData.data) &&
            availData.data.length > 0
          ) {
            setMaterialNotExtendedPart([]);
            setIsMaterialNotExtendedExist(false);
            if (availData.message.status !== 'I') {
              setCheckAvailabilityButtonText(CHECK_AVAILABILITY_BUTTON_TEXT.NORMAL)
              setisAvailabiityCheckedAtTime(new Date());
              setIsTimmerExpired(false); // Reset the expired flag to allow timer restart
              // Capture Material Not Extended flags even on an overall-successful response —
              // a not-yet-added part's one-time flag could still be embedded in here.
              captureMaterialNotExtendedIds(availData.data);
              verifyEnquiryDataToEditMode(availData.data, savedData.data.data, null, null, null, isAddToEnquiry, productsTemp);
              setSuccessMessage(`Availability and Price successfully fetched`);
              setOpenErrorSnackbar(false);
              handleopenCloseSnackbar(true);
              if (isUpdateEnquiry === "true") {
                sessionStorage.setItem('sendMailIsUpdateEnquiry', "true");
              } else {
                sessionStorage.setItem('sendMailIsUpdateEnquiry', "");
              }
              // calldeleteAPI is only ever true for an explicit "Check Availability and Price"
              // click (never the automatic per-keystroke verify a live Tyre search triggers), so
              // a successful verify here should mark the enquiry checked even if there are still
              // unresolved (isAddToEnquiry === false) Tyre-search rows sitting in the grid —
              // otherwise price/stock for the rest of the enquiry never surfaces.
              if (calldeleteAPI || selectedAccessType === "Parts" || (isTyrePartsSearchSuccessFully === true && isTyrePartsAddedtoGrid === true) || products.some((p: any) => p.isAddToEnquiry === false)) {
                setisAvailabiityChecked(true);
              }
              setDisableQuotation(false);

              if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer")) {
                setSelectedDeliveryTypeError(false);
              }
              if (calldeleteAPI) {
                // This verify succeeded, but a part flagged Material Not Extended during an
                // earlier live Tyre search (and never re-flagged since) may now be added —
                // surface it since the user just explicitly asked to Check Availability.
                revealCapturedMaterialNotExtendedParts();
              }
            } else {
              //Set Check Availability Button to show verification queued if check data is not verified.
              setCheckAvailabilityButtonText(CHECK_AVAILABILITY_BUTTON_TEXT.QUEUED)
              setOpenSnackbarType("error");
              setOpenErrorSnackbar(true);
              setSuccessMessage(sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ?
                'Enquiry has been submitted for verification and will take few minutes to get completed. You can check its status by selecting “Queued Enquiries” in the Order-Enquiry List.'
                : 'Enquiry queued for verification, press the verification button after 1 min');
              handleopenCloseSnackbar(true);
              setplaceorderEnabled(false);
            }
          } else {
            enquiryDataToEditMode(savedData?.data?.data, true, false, false);
            if (availData && availData.error && Array.isArray(availData.error) && availData.error.length > 0) {
              setSuccessMessage(availData.statusText && typeof availData.statusText === 'object' && typeof availData.statusText.data === 'object' ? availData.statusText.data.message && availData.statusText.data.message.message && typeof availData.statusText.data.message.message === 'object' && availData.statusText.data.message.message.messageText : 'Verify enquiry failed');
            } else {
              setSuccessMessage(typeof availData.error === 'string' ? availData.error : typeof availData.error === 'object' ? (availData.error && availData.error.messageId ? availData.error.messageId : 'Verify enquiry failed') : 'Verify enquiry failed');
            }
            setOpenSnackbarType("error");
            setOpenErrorSnackbar(true);
            handleopenCloseSnackbar(true);
            // Verify genuinely failed (may be a real Material Not Extended / Procurement Block
            // failure, or a technical failure) — don't leave a prior successful check's
            // "verified" UI state (timer, Place Order, Order Log) showing as still valid.
            setisAvailabiityChecked(false);
            setplaceorderEnabled(false);
            // SAP only reports Material Not Extended once, so capture it from every failure —
            // even during a live Tyre search's automatic verify — but only ever DISPLAY it via
            // revealCapturedMaterialNotExtendedParts() below, and only when the user explicitly
            // clicked Check Availability and Price (calldeleteAPI).
            if (availData && availData.error && Array.isArray(availData.error) && availData.error.length > 0) {
              captureMaterialNotExtendedIds(availData);
            }
            // Only treat this as a pricing/business-rule failure (Material Not Extended,
            // Procurement Block, etc.) worth parsing into the grid when this was a genuine
            // "Check Availability and Price" click (calldeleteAPI) AND every part in the
            // enquiry is actually committed (isAddToEnquiry !== false). During a live Tyre
            // search's automatic verify, or while any Tyre-search result is still unresolved,
            // a verify failure is just shown as the generic failure message above — nothing
            // gets parsed/flagged for those uncommitted rows.
            if (
              calldeleteAPI &&
              productsTemp.every((p: any) => p.isAddToEnquiry !== false) &&
              availData && availData.error && Array.isArray(availData.error) && availData.error.length > 0 && sessionStorage.getItem('userType') !== 'sre'
            ) {
              verifyEnquiryDataToEditMode(availData, savedData.data.data, null, null, null, isAddToEnquiry, productsTemp);
            }
            if (calldeleteAPI) {
              revealCapturedMaterialNotExtendedParts();
            }
          }
        }
      } else if (data && data.error) {
        setOpenSnackbarType("error");
        setOpenErrorSnackbar(true);
        setSuccessMessage(
          typeof data.message === 'string'
            ? data.message
            : typeof data.error === 'string'
              ? data.error
              : "Unable to create the enquiry."
        );
        handleopenCloseSnackbar(true);
        return;
      }
    } else {
      setOpenSnackbarType("error");
      setOpenErrorSnackbar(true);
      setSuccessMessage(`No valid parts are present`);
      handleopenCloseSnackbar(true);
      return;
    }
    if (!shouldCheckAvailability) {
      setplaceorderEnabled(false);
      setisAvailabiityChecked(false);

    }
  };

  const isError = () => {
    const productsTemp: any[] = JSON.parse(JSON.stringify(products));
    if (annexureEnquiry === 'true') {
      const allHaveErrorAndGreyed = productsTemp.every(
        (item: any) => item.error !== "" && item.isRowGreyed === true
      );
      if (allHaveErrorAndGreyed) {
        return true
      } else false
    } else {
      const hasStockError = productsTemp.some(
        (item: any) =>
          typeof item.stockError === "string" && item.stockError.trim().length > 1
      );
      return hasStockError;
    }

  }
  const requestQuotation = async (comments: any, validUntilDate: any) => {
    if (sessionStorage.getItem('userType') === 'FSE') {
      let date: any = moment(validUntilDate).format('YYYY-MM-DDTHH:mm:ss[Z]')
      // moment(isAvailabiityCheckedAtTime).tz('Asia/Dubai').format('YYYY-MM-DD HH:mm:ss');
      sessionStorage.setItem("validUntilDate", date);
      updateOnly(products, comments, true);
    } else {
      updateOnly(products, comments, true);
    }
  }


  const loadQueueQuotation = () => {
    dispatch(verifyQuotationQueueCheck(enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].enquiryNumber, enquiryData[0].B2bEnquiryId, sapCustomerId));
  }

  const updateOnly = async (productsData?: any, comment?: any, quotation?: any, enquiryInfo?: any, zeroParts?: any, isTyresAddtoEnquiry: any = false) => {
    let productsTemp: any;

    if ((sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') && enquiryInfo && enquiryInfo.length > 0) {
      let enquiryInfoProducts: Array<any> = []
      let i = 0
      while (i < enquiryInfo.length) {
        enquiryInfoProducts = [...enquiryInfoProducts, ...enquiryInfo[i].products]
        i++;
      }
      productsTemp = JSON.parse(JSON.stringify(enquiryInfoProducts));
    } else {
      productsTemp = JSON.parse(JSON.stringify(productsData));
    }

    let superseeded: any = productsTemp.filter((p: any) => p.isSuperseeded)

    const isSuperseededExist = (item: any) => {
      let issuperseededexist: any = superseeded.find((s: any) => s.supercessionMaterial === item.productId && parseInt(s.nsp) > 0);
      if (issuperseededexist && parseInt(issuperseededexist?.nsp) > 0) {
        return true
      } else {
        return false
      }
    }
    let refNo: any;
    productsTemp = productsTemp.filter((product: any) => product.isValid);
    // let emptyRefNo = false;
    let emptyQuantity = false;
    const hasAnyAddToEnquiry = products.some((product: any) => product.isAddToEnquiry);
    productsTemp = productsTemp.map((item: any) => {
      // Problem pats conflcit resolved
      // if ((customerTierType && customerTierType.toLowerCase() === 'tbl dealer' || customerTierType === "Dealer") && selectedAccessType === "Tyres" && !hasAnyAddToEnquiry) {
      // } else {
      //   if (item && item.materialGroup) {
      //     if (
      //      !brandRefNumbers[`${enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`]}`] ||
      // !brandRefNumbers[`${enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`]}`].trim() && item.isValid
      //     ) {
      //       emptyRefNo = true;
      //     }
      //   }
      // }
      // if ((customerTierType && customerTierType.toLowerCase() === 'tbl dealer' || customerTierType === "Dealer") && selectedAccessType === "Tyres" && !hasAnyAddToEnquiry) {
      //   // refNo = brandRefNumbers['2195'];
      // } else {
      //   if (referenceNumber === "") {
      //     emptyRefNo = true;
      //   }
      // }

      // if (referenceNumber === "") {
      //   emptyRefNo = true;
      // }
      if (!parseInt(item.quantity) && !isTyresAddtoEnquiry) {
        emptyQuantity = item.productId;
      }
      if (item.isMaterialNotExtended) {
        item.action = "D";
        // item["isValid"] = false;
      } else if (!isTyresAddtoEnquiry) {
        item.action = "C";
      }
      if (item.isProcurementPart && item.nowAvailability && parseInt(item.nowAvailability) !== 0 && !isTyresAddtoEnquiry) {
        item["action"] = "C";
      }
      if (
        item.isProcurementPart &&
        parseInt(item.airAvailability || 0) === 0
      ) {
        if (isSuperseededExist(item)) {
          item["action"] = "C";
        } else {
          item["action"] = "D";
        }

        item["airAvailabilityChecked"] = false;
      }
      //  Commented due to zeroprice popup issue fixes and this needs to be done on place order -- 18/05/2026
      // if (zeroParts && zeroParts.length > 0 && isAvailabiityChecked) {
      // if ((parseFloat(item.nsp) === 0 || parseFloat(item.nsp) === 0.00) && !item.isMaterialNotExtended && !isSuperseededExist(item) && !isTyresAddtoEnquiry) {
      //   item.action = "D";
      //   item.isZeroPrice = true;
      // }
      // }

      item['masterReferenceNumber'] = referenceNumber !== '' ? referenceNumber : tempRef;

      item["enquiryReferenceNumber"] =
        brandRefNumbers[
        `${enquiryMapping[`${formatMaterialGroup(item?.materialGroup)}`]}`
        ];
      item["deliveryBlockReason"] =
        deliveryBlockReason[
          `${enquiryMapping[
          `${formatMaterialGroup(item?.materialGroup)}`
          ]}`
        ]?.deliveryBlockReason || '';
      item["deliveryBlockReasonCode"] = item?.materialGroup
        ? deliveryBlockReason[
          `${enquiryMapping[
          `${formatMaterialGroup(item.materialGroup)}`
          ]}`
        ]?.deliveryBlockReasonCode
        : '';
      return item
    })

    if ((sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') && !isTyresAddtoEnquiry) {
      productsTemp = productsTemp.map((item: any) => {
        if (item.isMaterialNotExtended && !isTyresAddtoEnquiry) {
          item.action = "D";
          // item["isValid"] = false;
        } else {
          item.action = "C";
        }
        if (item.isProcurementPart && item.nowAvailability && parseInt(item.nowAvailability) !== 0 && !isTyresAddtoEnquiry) {
          item["action"] = "C";
        }
        if (
          item.isProcurementPart &&
          parseInt(item.airAvailability || 0) === 0
        ) {
          if (isSuperseededExist(item)) {
            item["action"] = "C";
          } else {
            item["action"] = "D";
          }

          item["airAvailabilityChecked"] = false;
        }
        // if (item.accessTyres) {
        //   item["airAvailabilityChecked"] = false;
        // }
        return item;
      });
    }
    // if (emptyRefNo) {
    //   setOpenSnackbarType("error");
    //   setOpenErrorSnackbar(true);
    //   setSuccessMessage(`All reference numbers are mandatory`);
    //   handleopenCloseSnackbar(true);
    //   return;
    // }
    if (emptyQuantity) {
      setOpenSnackbarType("error");
      setOpenErrorSnackbar(true);
      setSuccessMessage(
        `Quantity of product ${emptyQuantity} should be greater that zero`
      );
      handleopenCloseSnackbar(true);
      return;
    }
    let updationData: any = {};
    let insertData: any = [];


    let productsTempNew: any = productsTemp;
    // Filter the productsTempNew array
    productsTempNew = productsTempNew.filter((product: any) => {
      // product.orgId = "";
      let invalid: any = [...invalidParts]
      if (invalid && invalid.length > 0) {
        // Check if the product's sequence number exists in invalidParts
        const seqExistsInInvalidParts = invalidParts.some((part: any) => part.seq === product.seq);
        // If the sequence number exists in invalidParts, apply filter
        if (seqExistsInInvalidParts) {
          return (product.action !== 'D' && !product.isProcurementPart) || (product.action !== 'D' && !product.isZeroPrice);
        } else {
          // If the sequence number doesn't exist in invalidParts, retain the item
          return true;
        }
      } else {
        return product;
      }
    });
    productsTempNew.map((singleProduct: any) => {
      if (singleProduct["id"]) {
        if (updationData[singleProduct["id"]]) {
          updationData[singleProduct["id"]].push(singleProduct);
        } else {
          updationData[singleProduct["id"]] = [singleProduct];
        }
      } else {
        insertData.push(singleProduct)
      }
    });
    let finalData: any = [];
    Object.keys(updationData).map((singlekey: any) => {
      // let tc = changeCheckBox ? getEstimatedTotal(true) : estTotal;
      const currentEnquiry = (enquiryData ?? []).find((enquiry: any) =>
        enquiry?.products?.some(
          (product: any) => product?.id === updationData[singlekey]?.[0]?.id
        )
      );
      let tc: any = getEstimatedTotal(true, true);
      finalData.push({
        id: singlekey,
        masterReferenceNumber: referenceNumber !== '' ? referenceNumber : tempRef,
        products: updationData[singlekey],
        // totalCost: changeCheckBox ? getEstimatedTotal(true) : estTotal,
        totalCost: getEstimatedTotal(true, true),
        verifiedOn: isAvailabiityCheckedAtTime,
        netOrderValue: parseInt(tc) == 0 ? 0 : getnetOrderValue(currentEnquiry, true)
      })
    })
    if (quotation) {
      let statusSuccess: any
      let masterID: any
      let quotationData: any = await dispatch(updateEnquiry(customerTierType, !shipToPartyFeatureAccess ? '' : customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && deliveryType === "SELF-PIC" ? firstAddress.shiftToPartyCustomerNumber : multipleAddressData, enquiryData[0].B2bEnquiryId, finalData, false, insertData, enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].enquiryNumber, enquiryData[0].b2bLostSalesReportId ? enquiryData[0].b2bLostSalesReportId : getUniqueTimestamp(), true, true, comment, b2bUserId, null, annexureEnquiry === 'true' ? true : false));
      if (quotationData && quotationData.data && quotationData.data[0] && quotationData.data[0]["quotationsRequestDetails"] && quotationData.data[0]["quotationsRequestDetails"] && quotationData.data[0]["quotationsRequestDetails"] && quotationData.data[0]["quotationsRequestDetails"]["success"]) {
        statusSuccess = quotationData.data[0]["quotationsRequestDetails"]["success"],
          masterID = quotationData.data[0]["quotationsRequestDetails"]["B2bEnquiryId"]
        setMasterIDData(masterID);
        setStatusSuccessChecked(statusSuccess);
        // dispatch(verifyQuotationQueueCheck(enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].enquiryNumber, enquiryData[0].B2bEnquiryId, sapCustomerId));
      } else if (!(quotationData && quotationData.data && quotationData.data[0] && quotationData.data[0]["quotationsRequestDetails"] && quotationData.data[0]["quotationsRequestDetails"] && quotationData.data[0]["quotationsRequestDetails"] && quotationData.data[0]["quotationsRequestDetails"]["success"])) {
        setOpenSnackbar(true)
        setOpenErrorSnackbar(true)
        setSuccessMessage("Error to request for quotation")
        setShowRequestQuotationDialog(false);
        setTimeout(() => {
          setOpenSnackbar(false)
          setOpenErrorSnackbar(false)
        }, 2000)
      }
    } else {
      if (enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0) {
        await dispatch(updateEnquiry(customerTierType,
          !shipToPartyFeatureAccess ? '' : customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && deliveryType === "SELF-PIC" ? firstAddress.shiftToPartyCustomerNumber : multipleAddressData,
          enquiryData[0].B2bEnquiryId,
          finalData,
          true,
          insertData, enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].enquiryNumber,
          enquiryData[0].b2bLostSalesReportId ? enquiryData[0].b2bLostSalesReportId : getUniqueTimestamp(),
          true, null, null, null, null,
          annexureEnquiry === 'true' ? true : false));
        await dispatch(updateEnquiry(customerTierType,
          !shipToPartyFeatureAccess ? '' : customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && deliveryType === "SELF-PIC" ? firstAddress.shiftToPartyCustomerNumber : multipleAddressData,
          enquiryData[0].B2bEnquiryId,
          finalData,
          false,
          insertData, enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].enquiryNumber,
          enquiryData[0].b2bLostSalesReportId ? enquiryData[0].b2bLostSalesReportId : getUniqueTimestamp(),
          true, null, null, null, null, annexureEnquiry === 'true' ? true : false));
        setIsQuantityUpdated(false);
      } else if (enquiryInfo && Array.isArray(enquiryInfo) && enquiryInfo.length > 0) {
        await dispatch(updateEnquiry(customerTierType, !shipToPartyFeatureAccess ? '' : customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && deliveryType === "SELF-PIC" ? firstAddress.shiftToPartyCustomerNumber : multipleAddressData, enquiryInfo[0].B2bEnquiryId, finalData, false, insertData, enquiryInfo[0].enquiryNumber, enquiryInfo[0].b2bLostSalesReportId ? enquiryInfo[0].b2bLostSalesReportId : getUniqueTimestamp(), null, null, null, null, null, annexureEnquiry === 'true' ? true : false));
        setIsQuantityUpdated(false);
      }
      if (!isTyresAddtoEnquiry) return
    }
    // if(statusSuccessChecked === true){
    //   // setSuccessMessage("Quotation Created Successfully");
    //   // handleopenCloseSnackbar(true);
    // }
    if (isTyresAddtoEnquiry) {
      let savedData: any = await dispatch(getEnquiryDetails(customerTierType, enquiryData?.[0]?.B2bEnquiryId || enquiryInfo?.[0]?.B2bEnquiryId, (enquiryAction === "view" && orderType !== "Cancelled") ? true : false, false));
      enquiryDataToEditMode(savedData?.data?.data, true, false, false);

      let rmpro: any = await getRemovedProducts(savedData?.data?.data);
      setInvalidParts(rmpro && rmpro.length > 0 ? rmpro : savedData?.data?.data[0].removedProducts ? savedData?.data?.data[0].removedProducts : []);
      setRemovedProductsLength(rmpro && rmpro.length > 0 ? rmpro.length : savedData?.data?.data[0].removedProducts?.length)
      // setInvalidParts(savedData?.data?.data[0].removedProducts ? savedData?.data?.data[0].removedProducts : []);
      await getOrderLogsData(savedData?.data);
      // setRemovedProductsLength(savedData?.data?.data[0].removedProducts?.length)
      setenquiryData(savedData?.data?.data);
      setGetVerifyData(savedData);
      if (isTyresAddtoEnquiry) {
        setisAvailabiityChecked(false);
        setisAvailabiityCheckedAtTime(null);
      }
      // requestPriceAccess();
    }
  };

  // // ONCHANGE OF SELECT DELIVERY TYPE
  // const onChangeDeliveryType = (e: any) => {
  //     setDeliveryType(e.target.value);
  //     if (e.target.value === "" || e.target.value.trim() === "") {
  //         setSelectedDeliveryTypeError(true);
  //     }
  //     else {
  //         setSelectedDeliveryTypeError(false);
  //     }
  // }

  // VALIDATIONS FOR DELIVERY TYPE 
  const validateDeliveryType = () => {
    let isValidationSucess: boolean = true;
    setIsValid(true);
    if (deliveryType == undefined) {
      setSelectedDeliveryTypeError(true);
      setOpenSnackbarType("error");
      setOpenErrorSnackbar(true);
      handleopenCloseSnackbar(true);
      setSuccessMessage(`Please Select Delivery Type`);
      setIsValid(false);
      isValidationSucess = false;
    }
    else {
      setOpenErrorSnackbar(false);
      handleopenCloseSnackbar(false);
      setSelectedDeliveryTypeError(false);
    }
    if (isValidationSucess) {
      setOpenErrorSnackbar(false);
      handleopenCloseSnackbar(false);
      setSelectedDeliveryTypeError(false);
      placeOrderHandler();
    }
  }

  // const getCounter = () => {
  //   if (isAvailabiityCheckedAtTime) {
  //     const now = moment(new Date());
  //     const start = moment(new Date(isAvailabiityCheckedAtTime));
  //     const duration: any = moment.duration(start.diff(now));
  //     const minutes: any = Math.abs(duration.asMinutes());

  //     if (!isAvailabiityCheckedAtTime || (minutes && minutes > 5)) {
  //       return (
  //         <>
  //           <br />
  //           <span className="text-danger px-2">(Availability Expired)</span>
  //         </>
  //       );
  //     } else {
  //       return (
  //         <>
  //           <br />
  //           {isTimmerExpired === true ? "" :
  //             <span>
  //               <p
  //                 className="pt-1 px-2"
  //                 style={{ fontSize: "12px", color: "#6c757d" }}
  //               >
  //                 Please submit your order in{" "}
  //                 <span
  //                   style={{
  //                     backgroundColor: "#212529",
  //                     background: "#5a5a5a",
  //                     color: "#fff",
  //                     padding: "2px 10px",
  //                     borderRadius: "4px",
  //                     fontWeight: "bold",
  //                   }}
  //                 >
  //                   <Countdown
  //                     date={isAvailabiityCheckedAtTime.getTime() + 300000}
  //                     renderer={renderer}
  //                   />
  //                 </span>
  //               </p>
  //             </span>
  //           }
  //         </>
  //       );
  //     }
  //   } else {
  //     return null;
  //   }
  // };

  const getCounterFSE = () => {
    if (isAvailabiityCheckedAtTime) {
      var now = moment(new Date());
      var start = moment(new Date(isAvailabiityCheckedAtTime));
      var duration: any = moment.duration(start.diff(now));
      var minutes: any = Math.abs(duration.asMinutes());
      if (
        !isAvailabiityCheckedAtTime ||
        (minutes && minutes > 60)
      ) {
        return <>
          <br />
          <span className="text-danger px-2">
            (Availability Expired)
          </span>
        </>
      } else {
        return <>
          <br />
          <span>
            {/* (Please submit your order in <Countdown date={isAvailabiityCheckedAtTime.getTime() + 3.6e+6} renderer={renderer} />) */}
            <p className="pt-1 px-2" style={{ fontSize: '12px', color: '#6c757d' }}>
              Please submit your order in{' '}
              <span
                style={{
                  backgroundColor: '#212529',
                  background: '#5a5a5a',
                  color: '#fff',
                  padding: '2px 10px',
                  borderRadius: '4px',
                  fontWeight: 'bold',
                }}
              >
                <Countdown
                  date={isAvailabiityCheckedAtTime.getTime() + 3.6e+6}
                  renderer={renderer}
                />
              </span>
            </p>
          </span>
        </>
      }
    } else {
      return null
    }
  }

  const sendEmailObj = (zeroparts: any) => {
    let list: any = [];
    zeroparts && zeroparts.map((part: any) => {
      const brandKey = enquiryMapping[formatMaterialGroup(part.materialGroup)];

      list.push({
        productId: part.productId,
        supercessionMaterial: part.supercessionMaterial ? part.supercessionMaterial : '',
        brand: getNewBrand(brandKey),
        productIdDescription: part.productIdDescription,
        orgId: customerTierType === "int. business"
          ? (sessionStorage.getItem("orderCreatedBy") === "MA" ? "2431" : "2428")
          : "2195",
        price: "0",
        enquiredQty: part.quantity
      });
    });

    let data: any = {
      "webApplicationLoginId": sessionStorage.getItem('webApplicationLoginId'),
      "partNumberList": list,
      "sessionDetails": {
        "clientIPAddress": sessionStorage.getItem('clientIp'),
        "webApplicationLoginId": sessionStorage.getItem('webApplicationLoginId'),
      },
      "dealerCode": "test01",
      "userName": firstName,
      "userId": b2cUserId,
      "enquirySessionId": `b2bLSR${enquirySessionId}`,
      "customerType": customerTierType,
      "enquiryId": enquiryData &&
        Array.isArray(enquiryData) &&
        enquiryData.length > 0 &&
        enquiryData[0].B2bEnquiryId,
      "customerId": sessionStorage.getItem('userType') === 'FSE' ? sessionStorage.getItem("selectedSapCustomerId") : sessionStorage.getItem('customerId'),
      "customerName": sessionStorage.getItem('userType') === 'FSE' ? sessionStorage.getItem("CompanyName") : sessionStorage.getItem('customerName')
    }
    if (sessionStorage.getItem('userType') === 'FSE') {
      data.userRole = 'FSE'
    }
    return data;
  }

  const placeOrderHandler = async () => {
    if (invalidParts && invalidParts.length > 0) {
      await setIscallAPI(true)
    }
    let est = getEstimatedTotal(isAvailabiityChecked, true);

    if (Number(est) === 0) {
      setOpenSnackbarType("error");
      setOpenErrorSnackbar(true);
      setSuccessMessage(`No valid parts are present`);
      handleopenCloseSnackbar(true);
      return;
    }
    setLoading(true);
    if (!orderQueued) {
      var now = moment(new Date());
      var start = moment(
        isAvailabiityCheckedAtTime
          ? new Date(isAvailabiityCheckedAtTime)
          : new Date()
      );
      var duration: any = moment.duration(start.diff(now));
      var minutes: any = Math.abs(duration.asMinutes());
      if (sessionStorage.getItem('userType') === 'FSE') {
        if (
          !isAvailabiityCheckedAtTime ||
          (minutes && minutes > 60)
        ) {
          setOpenSnackbarType("error");
          setOpenErrorSnackbar(true);
          setLoading(false);
          setSuccessMessage(
            "Availability Expired: Please check availability again"
          );
          handleopenCloseSnackbar(true);
          return;
        }
      } else {
        if (
          !isAvailabiityCheckedAtTime ||
          (minutes && minutes > 5)
        ) {
          setOpenSnackbarType("error");
          setOpenErrorSnackbar(true);
          setLoading(false);
          setSuccessMessage(
            "Availability Expired: Please check availability again"
          );
          handleopenCloseSnackbar(true);
          return;
        }
      }

      let productsTemp = JSON.parse(
        JSON.stringify(products)
      );
      // if (procuredPart && procuredPart.length > 0) {
      //   productsTemp = productsTemp.filter(
      //     (product: any) => !product.isProcurementPart
      //   );
      //   setproducts([...productsTemp]);
      // }
      if (materialNotExtendedPart && materialNotExtendedPart.length > 0) {
        productsTemp = productsTemp.filter(
          (product: any) => !product.isMaterialNotExtended
        );
        setproducts([...productsTemp]);
      }
      // if (zeroProducts && zeroProducts.length > 0) {
      //   productsTemp = productsTemp.filter(
      //     (product: any) => parseInt(product.nsp) !== 0
      //   );
      //   setproducts([...productsTemp]);
      // }
      let superseeded: any = productsTemp.filter((p: any) => p.isSuperseeded)

      const isSuperseededExist = (item: any) => {
        let issuperseededexist: any = superseeded.find((s: any) => s.supercessionMaterial === item.productId && parseInt(s.nsp) > 0);
        if (issuperseededexist && parseInt(issuperseededexist?.nsp) > 0) {
          return true
        } else {
          return false
        }
      }

      productsTemp = productsTemp.filter(
        (product: any) => product.isValid
      );
      let emptyRefNo = false;
      let emptyQuantity = false;
      let itemsSelected = false;
      productsTemp = productsTemp.map((item: any) => {
        if (item && item.materialGroup) {
          if (
            item && item.materialGroup && !brandRefNumbers[`${enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`]}`] ||
            !brandRefNumbers[`${enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`]}`].trim()
          ) {
            emptyRefNo = true;
          }
        }
        if (referenceNumber === "") {
          emptyRefNo = true;
        }

        let superseeded: any = productsTemp.filter((p: any) => p.isSuperseeded)

        const isSuperseededExist = (item: any) => {
          let issuperseededexist: any = superseeded.find((s: any) => s.supercessionMaterial === item.productId && parseInt(s.nsp) > 0);
          if (issuperseededexist && parseInt(issuperseededexist?.nsp) > 0) {
            return true
          } else {
            return false
          }
        }
        if ((parseFloat(item.nsp) === 0 || parseFloat(item.nsp) === 0.00) && !item.isMaterialNotExtended && !isSuperseededExist(item)) {
          item.action = "D";
          item.isZeroPrice = true;
        }

        // if ((item.nowAvailabilityChecked && item.nowAvailability > 0) || (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && item.hrs24AvailabilityChecked && item.hrs24Availability > 0) || (item.airAvailabilityChecked && item.airAvailability > 0)) {
        if ((item.nowAvailabilityChecked && item.nowAvailability > 0)
          || (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && item.hrs24AvailabilityChecked && item.hrs24Availability > 0)
          || (item.airAvailabilityChecked && item.airAvailability > 0)) {
          itemsSelected = true;
        }
        if (!parseInt(item.quantity)) {
          emptyQuantity = item.productId;
        }

        item["enquiryReferenceNumber"] =
          brandRefNumbers[
          `${enquiryMapping[`${formatMaterialGroup(item?.materialGroup)}`]}`
          ];
        item["deliveryBlockReason"] =
          deliveryBlockReason[
            `${enquiryMapping[
            `${formatMaterialGroup(item?.materialGroup)}`
            ]}`
          ]?.deliveryBlockReason || '';
        item["deliveryBlockReasonCode"] = item?.materialGroup
          ? deliveryBlockReason[
            `${enquiryMapping[
            `${formatMaterialGroup(item.materialGroup)}`
            ]}`
          ]?.deliveryBlockReasonCode
          : '';

        item["masterReferenceNumber"] = referenceNumber;
        return item;
      });
      if (emptyRefNo) {
        setOpenSnackbarType("error");
        setOpenErrorSnackbar(true);
        setLoading(false);
        setSuccessMessage(
          `All reference numbers are mandatory`
        );
        handleopenCloseSnackbar(true);
        return;
      }
      if (emptyQuantity) {
        setOpenSnackbarType("error");
        setOpenErrorSnackbar(true);
        setLoading(false);
        setSuccessMessage(
          `Quantity of product ${emptyQuantity} should be greater that zero`
        );
        handleopenCloseSnackbar(true);
        return;
      }
      if (!itemsSelected) {
        setOpenSnackbarType("error");
        setOpenErrorSnackbar(true);
        setLoading(false);
        setSuccessMessage(
          `Please select atleast one item with quantity greater than 0 to proceed.`
        );
        handleopenCloseSnackbar(true);
        return;
      }

      // let superseeded: any = productsTemp.filter((p: any) => p.isSuperseeded)

      productsTemp = productsTemp?.map((item: any) => {
        enquiryData?.map((subenquiry: any) => {
          if (
            subenquiry &&
            subenquiry.products &&
            Array.isArray(subenquiry.products)
          ) {
            subenquiry.products.map((productSub: any) => {
              if (
                (productSub.productId && productSub.productId.toLowerCase() === item.productId.toLowerCase()) ||
                subenquiry["make"] && subenquiry["make"].toLowerCase() ===
                enquiryMapping[
                  `${formatMaterialGroup(item.materialGroup)}`
                ].toLowerCase()
              ) {
                item["enquiryNumber"] =
                  subenquiry.enquiryNumber;
                item["id"] = subenquiry.id;
                item["action"] =
                  item.isZeroPrice ||
                    (
                      item.error &&
                      item.isRowGreyed
                    ) ||
                    (
                      item.isProcurementPart &&
                      parseInt(item.airAvailability || 0) === 0 &&
                      !isSuperseededExist(item)
                    )
                    ? "D"
                    : "C";
                // item["action"] = (item.error && item.isRowGreyed && !item.error.toLowerCase().includes("low stock")) || (item.isProcurementPart && item.airAvailability && parseInt(item.airAvailability) !== 0 && parseInt(item.nowAvailability) === 0 && !isSuperseededExist(item)) ? "D" : "C";
                item["productCost"] = 0;
                if (item.nowAvailabilityChecked) {
                  item["productCost"] +=
                    (item.nowAvailability
                      ? parseFloat(item.nowAvailability)
                      : 0) *
                    (item.nsp ? parseFloat(item.nsp) : 0);
                }
                // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 24 HRS CODE <<<<<<<<<<<<<<<<<<<<<<<<<
                if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && item.hrs24AvailabilityChecked) {
                  item["productCost"] +=
                    (item.hrs24Availability
                      ? parseFloat(item.hrs24Availability)
                      : 0) *
                    (item.nsp ? parseFloat(item.nsp) : 0);
                }
                // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
                if (item.airAvailabilityChecked) {
                  // if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer" || ((customerTierType.toLowerCase() === "tbl dealer" || customerTierType.toLowerCase() === "dealer") && item.accessTyres))) {
                  //   item["airAvailability"] = 0;
                  //   item["aop"] = 0;
                  //   item["airAvailabilityChecked"] = false
                  // }
                  if (item.isProcurementPart && item.airAvailability !== 0) {
                    item["airAvailabilityChecked"] = false
                  }
                  item["productCost"] +=
                    (item.airAvailability && customerTierType && customerTierType.toLowerCase() !== "workshop" && customerTierType.toLowerCase() !== "tpcdealer"
                      ? parseFloat(item.airAvailability)
                      : 0) *
                    (item.aop && customerTierType && customerTierType.toLowerCase() !== "workshop" && customerTierType.toLowerCase() !== "tpcdealer" ? parseFloat(item.aop) : 0);
                }
              }
            });
          }
        });
        return item;
      });
      if (zeroProducts && zeroProducts.length > 0) {
        let data: any = sendEmailObj(zeroProducts);
        await dispatch(sendZeroProductsEmail(data));
      }

      let updationData: any = {};


      let productsTempNew: any = productsTemp;

      // Filter the productsTempNew array
      productsTempNew = productsTempNew.filter((product: any) => {
        // product.orgId = "";
        if (invalidParts && invalidParts.length > 0) {
          // Check if the product's sequence number exists in invalidParts
          const seqExistsInInvalidParts = invalidParts.some((part: any) => part.seq === product.seq);
          // If the sequence number exists in invalidParts, apply filter
          if (seqExistsInInvalidParts) {
            return product.action !== 'D' && !product.isProcurementPart;
          } else {
            // If the sequence number doesn't exist in invalidParts, retain the item
            return true;
          }
        } else {
          return product;
        }
      });


      productsTempNew.map((singleProduct: any) => {
        if (singleProduct["id"]) {
          if (updationData[singleProduct["id"]]) {
            updationData[singleProduct["id"]].push(
              singleProduct
            );
          } else {
            updationData[singleProduct["id"]] = [
              singleProduct,
            ];
          }
        }
      });

      let finalData: any = [];
      Object.keys(updationData).map((singlekey: any) => {
        // let tc = changeCheckBox ? getEstimatedTotal(true) : estTotal;
        const currentEnquiry = (enquiryData ?? []).find((enquiry: any) =>
          enquiry?.products?.some(
            (product: any) => product?.id === updationData[singlekey]?.[0]?.id
          )
        );
        let tc: any = getEstimatedTotal(isAvailabiityChecked, true);
        finalData.push({
          id: singlekey,
          masterReferenceNumber: referenceNumber,
          products: updationData[singlekey],
          // totalCost: changeCheckBox ? getEstimatedTotal(true) : estTotal,
          totalCost: getEstimatedTotal(isAvailabiityChecked, true),
          netOrderValue: parseInt(tc) == 0 ? 0 : getnetOrderValue(currentEnquiry, true)
        });
      });
      await dispatch(
        updateEnquiry(customerTierType, !shipToPartyFeatureAccess ? '' : customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && deliveryType === "SELF-PIC" ? firstAddress.shiftToPartyCustomerNumber : multipleAddressData,
          enquiryData[0].B2bEnquiryId,
          finalData,
          true,
          null,
          enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].enquiryNumber,
          enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].b2bLostSalesReportId ? enquiryData[0].b2bLostSalesReportId : getUniqueTimestamp(),
          true,
          null,
          null,
          null,
          null,
          annexureEnquiry === 'true' ? true : false
        )
      );
      await dispatch(
        updateEnquiry(customerTierType, !shipToPartyFeatureAccess ? '' : customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && deliveryType === "SELF-PIC" ? firstAddress.shiftToPartyCustomerNumber : multipleAddressData,
          enquiryData[0].B2bEnquiryId,
          finalData,
          false,
          null,
          enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].enquiryNumber,
          enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].b2bLostSalesReportId ? enquiryData[0].b2bLostSalesReportId : getUniqueTimestamp(),
          true, null, null, null, null, annexureEnquiry === 'true' ? true : false
        )
      );
      // if (zeroProducts && zeroProducts.length > 0) {
      //   await dispatch(
      //     verifyEnquiry(customerTierType,
      //       enquiryData &&
      //       Array.isArray(enquiryData) &&
      //       enquiryData[0].B2bEnquiryId
      //       , enquirySessionId
      //     )
      //   );
      //   await dispatch(
      //     updateEnquiry(customerTierType,
      //       enquiryData[0].B2bEnquiryId,
      //       finalData,
      //       true,
      //       null,
      //       enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].enquiryNumber,
      //       enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].b2bLostSalesReportId ? enquiryData[0].b2bLostSalesReportId : getUniqueTimestamp(),
      //       true
      //     )
      //   );
      //   await dispatch(
      //     updateEnquiry(customerTierType,
      //       enquiryData[0].B2bEnquiryId,
      //       finalData,
      //       false,
      //       null,
      //       enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].enquiryNumber,
      //       enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].b2bLostSalesReportId ? enquiryData[0].b2bLostSalesReportId : getUniqueTimestamp(),
      //       true
      //     )
      //   );
      // }
      setLoading(true);
      let placeoRederData: any = await dispatch(
        placeOrder(customerTierType, deliveryType, enquiryData[0].B2bEnquiryId, annexureEnquiry === 'true' ? true : false, showInsufficientCreditPopup, userRole, customerAccountType, (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') ? firstName + ' ' + lastName : firstName, (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') ? webApplicationLoginId : b2cUserId, enquirySessionId, products)
      );
      const isAnyCreditInsufficient = placeoRederData?.error?.isCreditSufficient === false;
      if ((placeoRederData && placeoRederData.message.status && (placeoRederData.message.status == "I" || placeoRederData.message.status == "E")) || placeoRederData.error === '') {
        if (isAnyCreditInsufficient === true) {
          setshowBackOrderConfirmation(false);
          setShowPlaceOrderConfirmationPopup(false);
          setShowInsufficientCreditPopup(true);
          setIsInsufficientCreditExist(true);
          setLoading(false);
        } else {
          setorderQueued(placeoRederData.message.status == 'I' ? true : false);
          setOpenSnackbarType("error");
          setTimeout(() => {
            setOpenErrorSnackbar(true);
            handleopenCloseSnackbar(true);
          }, 3000);
          setLoading(false);

          const isFSE = sessionStorage.getItem('userType') === 'FSE';
          const apiMessage = placeoRederData?.message?.message;
          const status = placeoRederData?.status;

          let message = "Unable to place order";

          if (!isFSE) {
            if (apiMessage === "Your Order has been queued for verification") {
              message = "Please do not leave this page while the order is getting processed. If the order is not confirmed in 15 min then please contact Al-Futtaim sales team for support.";
            } else if (apiMessage) {
              message = apiMessage;
            } else if (status === 504 || placeoRederData?.error === '') {
              message = "Request timed out. Please try again after some time.";
            } else if (placeoRederData?.error !== '') {
              message = placeoRederData?.error || "Something went wrong while placing the order.";
            }
          } else {
            message = apiMessage || "Unable to place order";
          }

          setSuccessMessage(message);

          // setSuccessMessage(sessionStorage.getItem('userType') !== 'FSE'
          //     ? placeoRederData && placeoRederData.message && placeoRederData?.message?.message === "Your Order has been queued for verification" ? "Please do not leave this page while the order is getting processed. If the order is not confirmed in 15 min then please contact Al-Futtaim sales team for support."
          //       : placeoRederData.message.message : placeoRederData?.message?.message ? placeoRederData?.message?.message : "Unable to place order");

          setshowBackOrderConfirmation(false);
          setShowInsufficientCreditPopup(false);
          setIsInsufficientCreditExist(false);
          setShowPlaceOrderConfirmationPopup(false);
        }
        if (placeoRederData.message && placeoRederData.message.message && placeoRederData.message.message.includes("does not allow external procurement")) {
          let wordsArray = placeoRederData.message.message.split(" ")
          let indexPart = wordsArray.indexOf("material");
          let procuredPartTemp = indexPart >= 0 ? wordsArray[indexPart + 1] : [];
          setprocuredPart(procuredPartTemp)
        }
      } else if (
        placeoRederData &&
        placeoRederData.data &&
        Array.isArray(placeoRederData.data)
      ) {
        setIsEnquiryStarted(false);
        setSuccessMessage(`Order successfully placed`);
        setOpenErrorSnackbar(false);
        handleopenCloseSnackbar(true);
        setorderData(placeoRederData.data);
        setActualProductLength(products.length);
        setIsQuantityUpdated(false);
        setorderTotal(placeoRederData.data[0].orderTotal);
        handleopenCloseOrderSummary(true);
        try {
          if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer")) {
            if (customerAccountType === 'Credit') {
              await dispatch(getCreditLimit(sapCustomerId, webApplicationLoginId));
            } else {
            }
          } else if (!(customerTierType && customerTierType.toLowerCase() === "int. business")) {
            await dispatch(getCreditLimit(sapCustomerId, webApplicationLoginId));
          }
        } catch (creditLimitError) {
          // Credit limit lookup failing (e.g. no credit record for this customer type)
          // must never interrupt the Order Summary flow the user is already on.
        }
        let defaultAddress = addressData && addressData.length > 0 && addressData.find((ele: any) => ele.id === defaultAddressId);
        if (defaultAddress && defaultAddress.shiftToPartyCustomerNumber)
          setMultipleAddressData(defaultAddress.shiftToPartyCustomerNumber);
        setLoading(false);
        // history.push("/ordersummarydetails");
      }
    } else {
      let enquiryDetailsQueueCheckData: any = await dispatch(verifyEnquiryQueueCheck(customerTierType, enquiryData[0].B2bEnquiryId, enquiryData[0].customerId));
      if (enquiryDetailsQueueCheckData && enquiryDetailsQueueCheckData.message && enquiryDetailsQueueCheckData.message.status && enquiryDetailsQueueCheckData.message.status == "S" && enquiryDetailsQueueCheckData.message.message == "Order Created") {
        setSuccessMessage(`Order successfully placed`);
        setOpenErrorSnackbar(false);
        handleopenCloseSnackbar(true);
        setLoading(false);
        if (enquiryDetailsQueueCheckData && enquiryDetailsQueueCheckData.data && Array.isArray(enquiryDetailsQueueCheckData.data) && enquiryDetailsQueueCheckData.data.length > 0) {
          // setorderData(enquiryDetailsQueueCheckData.data[0].orderSummary);
          let summaryData: any = [];
          enquiryDetailsQueueCheckData.data.map((item: any) => {
            summaryData = [...summaryData, ...item.orderSummary]
          })

          let total = 0;
          enquiryDetailsQueueCheckData.data && Array.isArray(enquiryDetailsQueueCheckData.data) && enquiryDetailsQueueCheckData.data.map((item: any) => {
            if (item.brandTotal) {
              total += parseFloat(item.brandTotal)
            }
          })

          setorderTotal(total)
          setorderData(summaryData);
        }
        handleopenCloseOrderSummary(true);
        let defaultAddress = addressData && addressData.length > 0 && addressData.find((ele: any) => ele.id === defaultAddressId)
        if (defaultAddress && defaultAddress.shiftToPartyCustomerNumber)
          setMultipleAddressData(defaultAddress && defaultAddress.shiftToPartyCustomerNumber);
        try {
          if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer")) {
            if (customerAccountType === 'Credit') {
              await dispatch(getCreditLimit(sapCustomerId, webApplicationLoginId));
            } else {
            }
          } else if (!(customerTierType && customerTierType.toLowerCase() === "int. business")) {
            await dispatch(getCreditLimit(sapCustomerId, webApplicationLoginId));
          }
        } catch (creditLimitError) {
          // Same as above: never let a credit-limit lookup failure knock the
          // user off the Order Summary screen they just landed on.
        }
        setLoading(false);
        // history.push("/ordersummarydetails");
      } else {
        if (enquiryDetailsQueueCheckData.message.message.toLowerCase() == 'order placement failed') {
          setorderQueued(false)
        }
        setOpenSnackbarType("error");
        setSuccessMessage(enquiryDetailsQueueCheckData && enquiryDetailsQueueCheckData.message && enquiryDetailsQueueCheckData?.message?.message);
        handleopenCloseSnackbar(true);
        setLoading(false);
      }
    }
  }

  const getIsPlaceOrderDisabled = ({
    orderQueued,
    annexureEnquiry,
    selectedCustomerData,
    annexureMonthlyOrderLimit,
    enquiryData,
    isQuantityUpdated,
    placeorderEnabled,
    isAvailabiityChecked,
    products
  }: any): boolean => {

    const isFSE = sessionStorage.getItem('userType') === 'FSE';

    const isOrderQueuedState =
      orderQueued ||
      enquiryData?.[0]?.status?.toLowerCase() === 'order placement queued';

    // ---- Annexure conditions ----
    if (annexureEnquiry === 'true') {

      const isAnnexureLimitExceeded =
        isFSE
          ? selectedCustomerData?.annexureMonthlyOrderLimit === false
          : annexureMonthlyOrderLimit === false;

      if (isAnnexureLimitExceeded) return true;

      // ✅ Selling price calculation
      const totalSellingPrice = parseFloat(
        getSellingPrice(
          getEstimatedTotal(isAvailabiityChecked, true),
          isSellingPriceData,
          markupPercentage
        )
      );
      const maxAllowedOrderValue = isFSE
        ? parseFloat(Number(selectedCustomerData?.annexureMonthlyOrderLimitConfig?.maxAllowedOrderValue).toFixed(2))
        : parseFloat(Number(annexureMonthlyOrderLimitConfig?.maxAllowedOrderValue).toFixed(2));

      const isMaxOrderValueExceeded =
        maxAllowedOrderValue !== undefined &&
        totalSellingPrice > maxAllowedOrderValue;

      if (isMaxOrderValueExceeded) return true;
    }

    const isQuotation =
      enquiryData?.[0]?.isQuotation === true;

    if (isOrderQueuedState) return false;

    if (isQuantityUpdated || isQuotation) return true;

    if (placeorderEnabled && isAvailabiityChecked && products?.length) return false;

    return true;
  };

  const getPlaceOrderTooltipMessage = ({
    isAvailabiityChecked,
    products,
    annexureEnquiry,
    selectedCustomerData,
    annexureMonthlyOrderLimitConfig,
    isSellingPriceData,
    markupPercentage,
    getEstimatedTotal,
    getSellingPrice,
    isDisplay
  }: any): string => {


    if ((!isAvailabiityChecked || !products?.length) && !isDisplay) {
      return `Please do 'Check Availability and Price' to place the order`;
    }

    const isFSE = sessionStorage.getItem('userType') === 'FSE';

    // Only for annexure
    if (annexureEnquiry === 'true') {
      const totalSellingPrice = parseFloat(
        getSellingPrice(
          getEstimatedTotal(isAvailabiityChecked, true),
          isSellingPriceData,
          markupPercentage
        )
      );

      const maxAllowedOrderValue = isFSE
        ? parseFloat(Number(selectedCustomerData?.annexureMonthlyOrderLimitConfig?.maxAllowedOrderValue).toFixed(2))
        : parseFloat(Number(annexureMonthlyOrderLimitConfig?.maxAllowedOrderValue).toFixed(2));

      if (
        maxAllowedOrderValue !== undefined &&
        totalSellingPrice > maxAllowedOrderValue
      ) {
        return `Order value (${Number(totalSellingPrice).toLocaleString()}) exceeds allowed limit (${Number(maxAllowedOrderValue).toLocaleString()})`;
      }
    }

    return "";
  };


  const ConfirmButtonUpdateAPI = async () => {
    setLoading(true);
    if (!orderQueued) {
      var now = moment(new Date());
      var start = moment(
        isAvailabiityCheckedAtTime
          ? new Date(isAvailabiityCheckedAtTime)
          : new Date()
      );
      var duration: any = moment.duration(start.diff(now));
      var minutes: any = Math.abs(duration.asMinutes());
      if (sessionStorage.getItem('userType') === 'FSE') {
        if (
          !isAvailabiityCheckedAtTime ||
          (minutes && minutes > 60)
        ) {
          setOpenSnackbarType("error");
          setOpenErrorSnackbar(true);
          setLoading(false);
          setSuccessMessage(
            "Availability Expired: Please check availability again"
          );
          handleopenCloseSnackbar(true);
          return;
        }
      } else {
        if (
          !isAvailabiityCheckedAtTime ||
          (minutes && minutes > 5)
        ) {
          setOpenSnackbarType("error");
          setOpenErrorSnackbar(true);
          setLoading(false);
          setSuccessMessage(
            "Availability Expired: Please check availability again"
          );
          handleopenCloseSnackbar(true);
          return;
        }
      }

      let productsTemp = JSON.parse(
        JSON.stringify(products)
      );
      if (zeroProducts && zeroProducts.length > 0) {
        productsTemp = productsTemp.filter(
          (product: any) => parseInt(product.nsp) !== 0
        );
        setproducts([...productsTemp]);
      }
      productsTemp = productsTemp.filter(
        (product: any) => product.isValid
      );
      let emptyRefNo = false;
      let emptyQuantity = false;
      let itemsSelected = false;
      productsTemp = productsTemp.map((item: any) => {
        if (item && item.materialGroup) {
          if (
            item && item.materialGroup && !brandRefNumbers[`${enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`]}`] ||
            !brandRefNumbers[`${enquiryMapping[`${formatMaterialGroup(item.materialGroup)}`]}`].trim()
          ) {
            emptyRefNo = true;
          }
        }
        if (referenceNumber === "") {
          emptyRefNo = true;
        }
        if ((item.nowAvailabilityChecked && item.nowAvailability > 0) || (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && item.hrs24AvailabilityChecked && item.hrs24Availability > 0) || (item.airAvailabilityChecked && item.airAvailability > 0)) {
          itemsSelected = true;
        }
        if (!parseInt(item.quantity)) {
          emptyQuantity = item.productId;
        }

        item["enquiryReferenceNumber"] =
          brandRefNumbers[
          `${enquiryMapping[`${formatMaterialGroup(item?.materialGroup)}`]}`
          ];
        item["deliveryBlockReason"] =
          deliveryBlockReason[
            `${enquiryMapping[
            `${formatMaterialGroup(item?.materialGroup)}`
            ]}`
          ]?.deliveryBlockReason || '';
        item["deliveryBlockReasonCode"] = item?.materialGroup
          ? deliveryBlockReason[
            `${enquiryMapping[
            `${formatMaterialGroup(item.materialGroup)}`
            ]}`
          ]?.deliveryBlockReasonCode
          : '';
        item["masterReferenceNumber"] = referenceNumber;
        return item;
      });
      if (emptyRefNo) {
        setOpenSnackbarType("error");
        setOpenErrorSnackbar(true);
        setLoading(false);
        setSuccessMessage(
          `All reference numbers are mandatory`
        );
        handleopenCloseSnackbar(true);
        return;
      }
      if (emptyQuantity) {
        setOpenSnackbarType("error");
        setOpenErrorSnackbar(true);
        setLoading(false);
        setSuccessMessage(
          `Quantity of product ${emptyQuantity} should be greater that zero`
        );
        handleopenCloseSnackbar(true);
        return;
      }
      if (!itemsSelected) {
        setOpenSnackbarType("error");
        setOpenErrorSnackbar(true);
        setLoading(false);
        setSuccessMessage(
          `Please select atleast one item with quantity greater than 0 to proceed.`
        );
        handleopenCloseSnackbar(true);
        return;
      }
      productsTemp = productsTemp?.map((item: any) => {
        enquiryData?.map((subenquiry: any) => {
          if (
            subenquiry &&
            subenquiry.products &&
            Array.isArray(subenquiry.products)
          ) {
            subenquiry.products.map((productSub: any) => {
              if (
                (productSub.productId && productSub.productId.toLowerCase() === item.productId.toLowerCase()) ||
                subenquiry["make"] && subenquiry["make"].toLowerCase() ===
                enquiryMapping[
                  `${formatMaterialGroup(item.materialGroup)}`
                ].toLowerCase()
              ) {
                item["enquiryNumber"] =
                  subenquiry.enquiryNumber;
                item["id"] = subenquiry.id;
                item["action"] = "C";
                item["productCost"] = 0;
                if (item.nowAvailabilityChecked) {
                  item["productCost"] +=
                    (item.nowAvailability
                      ? parseFloat(item.nowAvailability)
                      : 0) *
                    (item.nsp ? parseFloat(item.nsp) : 0);
                }
                // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 24 HRS CODE <<<<<<<<<<<<<<<<<<<<<<<<<
                if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && item.hrs24AvailabilityChecked) {
                  item["productCost"] +=
                    (item.hrs24Availability
                      ? parseFloat(item.hrs24Availability)
                      : 0) *
                    (item.nsp ? parseFloat(item.nsp) : 0);
                }
                // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
                if (item.airAvailabilityChecked) {
                  // if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") || ((customerTierType.toLowerCase() === "tbl dealer" || customerTierType.toLowerCase() === "dealer") && item.accessTyres)) {
                  //   item["airAvailability"] = 0;
                  //   item["aop"] = 0;
                  //   item["airAvailabilityChecked"] = false
                  // }
                  item["productCost"] +=
                    (item.airAvailability && customerTierType && customerTierType.toLowerCase() !== "workshop" && customerTierType.toLowerCase() !== "tpcdealer"
                      ? parseFloat(item.airAvailability)
                      : 0) *
                    (item.aop && customerTierType && customerTierType.toLowerCase() !== "workshop" && customerTierType.toLowerCase() !== "tpcdealer" ? parseFloat(item.aop) : 0);
                }
              }
            });
          }
        });
        return item;
      });

      if (zeroProducts && zeroProducts.length > 0) {
        let data: any = sendEmailObj(zeroProducts);
        await dispatch(sendZeroProductsEmail(data));
      }

      let updationData: any = {};
      productsTemp.map((singleProduct: any) => {
        if (singleProduct["id"]) {
          if (updationData[singleProduct["id"]]) {
            updationData[singleProduct["id"]].push(
              singleProduct
            );
          } else {
            updationData[singleProduct["id"]] = [
              singleProduct,
            ];
          }
        }
      });

      let finalData: any = [];
      Object.keys(updationData).map((singlekey: any) => {
        // let tc = changeCheckBox ? getEstimatedTotal(true) : estTotal;
        const currentEnquiry = (enquiryData ?? []).find((enquiry: any) =>
          enquiry?.products?.some(
            (product: any) => product?.id === updationData[singlekey]?.[0]?.id
          )
        );
        let tc: any = getEstimatedTotal(isAvailabiityChecked, true);
        finalData.push({
          id: singlekey,
          masterReferenceNumber: referenceNumber,
          products: updationData[singlekey],
          // totalCost: changeCheckBox ? getEstimatedTotal(true) : estTotal,
          totalCost: getEstimatedTotal(isAvailabiityChecked, true),
          netOrderValue: parseInt(tc) == 0 ? 0 : getnetOrderValue(currentEnquiry, true)
        });
      });
      await dispatch(
        updateEnquiry(customerTierType, !shipToPartyFeatureAccess ? '' : customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && deliveryType === "SELF-PIC" ? firstAddress.shiftToPartyCustomerNumber : multipleAddressData,
          enquiryData[0].B2bEnquiryId,
          finalData,
          true,
          null,
          enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].enquiryNumber,
          enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].b2bLostSalesReportId ? enquiryData[0].b2bLostSalesReportId : getUniqueTimestamp(),
          true,
          null,
          null,
          null,
          true,
          annexureEnquiry === 'true' ? true : false
        )
      );
      setLoading(false);
      setShowConfirmDialogPopup(true);
    } else {
      let enquiryDetailsQueueCheckData: any = await dispatch(verifyEnquiryQueueCheck(customerTierType, enquiryData[0].B2bEnquiryId, enquiryData[0].customerId));
      if (enquiryDetailsQueueCheckData && enquiryDetailsQueueCheckData.message && enquiryDetailsQueueCheckData.message.status && enquiryDetailsQueueCheckData.message.status == "S" && enquiryDetailsQueueCheckData.message.message == "Order Created") {
        setSuccessMessage(`Order successfully placed`);
        setOpenErrorSnackbar(false);
        handleopenCloseSnackbar(true);
        setLoading(false);
        if (enquiryDetailsQueueCheckData && enquiryDetailsQueueCheckData.data && Array.isArray(enquiryDetailsQueueCheckData.data) && enquiryDetailsQueueCheckData.data.length > 0) {
          // setorderData(enquiryDetailsQueueCheckData.data[0].orderSummary);
          let summaryData: any = [];
          enquiryDetailsQueueCheckData.data.map((item: any) => {
            summaryData = [...summaryData, ...item.orderSummary]
          })

          let total = 0;
          enquiryDetailsQueueCheckData.data && Array.isArray(enquiryDetailsQueueCheckData.data) && enquiryDetailsQueueCheckData.data.map((item: any) => {
            if (item.brandTotal) {
              total += parseFloat(item.brandTotal)
            }
          })

          setorderTotal(total)
          setorderData(summaryData);
        }
        setShowConfirmDialogPopup(true);
        let defaultAddress = addressData && addressData.length > 0 && addressData.find((ele: any) => ele.id === defaultAddressId)
        if (defaultAddress && defaultAddress.shiftToPartyCustomerNumber)
          setMultipleAddressData(defaultAddress && defaultAddress.shiftToPartyCustomerNumber);
        try {
          if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer")) {
            if (customerAccountType === 'Credit') {
              await dispatch(getCreditLimit(sapCustomerId, webApplicationLoginId));
            } else {
            }
          } else if (!(customerTierType && customerTierType.toLowerCase() === "int. business")) {
            await dispatch(getCreditLimit(sapCustomerId, webApplicationLoginId));
          }
        } catch (creditLimitError) {
          // Don't let a failed credit-limit lookup disrupt the confirm-order flow.
        }
        setLoading(false);
        setShowConfirmDialogPopup(true);
      } else {
        if (enquiryDetailsQueueCheckData.message.message.toLowerCase() == 'order placement failed') {
          setorderQueued(false)
        }
        setOpenSnackbarType("error");
        setSuccessMessage(enquiryDetailsQueueCheckData && enquiryDetailsQueueCheckData.message && enquiryDetailsQueueCheckData?.message?.message);
        handleopenCloseSnackbar(true);
        setLoading(false);
      }
      setLoading(false);
    }
  }


  const openCloseChooseCustomer = async () => {
    let jsonData: any = [];
    let newProducts: any = products?.filter((item: any) => item.isValid) || [];
    await resetData();
    await setproducts([]);
    await setInvalidParts([]);
    newProducts.forEach((data: any) => {
      jsonData.push({
        productId: data.productId,
        quantity: data.quantity,
      });
    });
    if (jsonData.length > 0) {
      if ((isOESOEM || iamMap.current) && annexureEnquiry !== 'true') {
        await commonInsertionLogicIAMMapping(jsonData, false, false, customerTierType, true);
      } else {
        await commonInsertionLogic(jsonData, false, false, customerTierType, true);
      }
    }

    setOpenChooseCustomerDialog(false);
  };


  const handleOrderLogPopup = () => {
    setOpenOrderLogPopup(true);
  }

  const openCloseOrderLogPopup = () => {
    setOpenOrderLogPopup(false);
  }

  const handleShippingAddDialog = () => {
    setOpenShippingAddDialog(true);
  }

  const openCloseShippingAddSelectionDialog = (address?: any) => {
    if (address) {
      setAddressData([...newAddressData, address])
      let e = { target: { value: address.shiftToPartyCustomerNumber } }
      handleChangeAddress(e)
    }

    setOpenShippingAddDialog(false);
  }

  const handleChooseCustomer = () => {
    setOpenChooseCustomerDialog(true);
  }

  const requestQuotationHandler = async () => {
    if (!orderQueued) {
      var now = moment(new Date());
      var start = moment(
        isAvailabiityCheckedAtTime
          ? new Date(isAvailabiityCheckedAtTime)
          : new Date()
      );
      var duration: any = moment.duration(start.diff(now));
      var minutes: any = Math.abs(duration.asMinutes());
      if (sessionStorage.getItem('userType') === 'FSE') {
        if (
          !isAvailabiityCheckedAtTime ||
          (minutes && minutes > 60)
        ) {
          setOpenSnackbarType("error");
          setOpenErrorSnackbar(true);
          setLoading(false);
          setSuccessMessage(
            "Availability Expired: Please check availability again"
          );
          handleopenCloseSnackbar(true);
          return;
        }
      } else {
        if (
          !isAvailabiityCheckedAtTime ||
          (minutes && minutes > 5)
        ) {
          setOpenSnackbarType("error");
          setOpenErrorSnackbar(true);
          setSuccessMessage(
            "Availability Expired: Please check availability again"
          );
          handleopenCloseSnackbar(true);
          return;
        }
      }
      let productsTemp = JSON.parse(
        JSON.stringify(products)
      );
      // if (procuredPart && procuredPart.length > 0) {
      //   productsTemp = productsTemp.filter(
      //     (product: any) => !product.isProcurementPart
      //   );
      //   setproducts([...productsTemp]);
      // }
      if (materialNotExtendedPart && materialNotExtendedPart.length > 0) {
        productsTemp = productsTemp.filter(
          (product: any) => !product.isMaterialNotExtended
        );
        setproducts([...productsTemp]);
        setActualProductLength(productsTemp.length);
      }
      if (zeroProducts && zeroProducts.length > 0) {
        productsTemp = productsTemp.filter(
          (product: any) => parseInt(product.nsp) !== 0
        );
        setproducts([...productsTemp]);
        setActualProductLength(productsTemp.length);
      }

      productsTemp = productsTemp.filter(
        (product: any) => product.isValid
      );
      let airOrder: any = false;
      productsTemp.map((item: any) => {
        if (item.airAvailabilityChecked && item.airAvailability > 0) {
          airOrder = true;
        }
      });

      setIsBackorder(airOrder);
      let emptyRefNo = false;
      let emptyQuantity = false;
      let itemsSelected = false;
      productsTemp = productsTemp.map((item: any) => {
        // Problem pats conflcit resolved
        if (item && item.materialGroup) {
          brandRefNumbers[`${enquiryMapping[`${formatMaterialGroup(item?.materialGroup)}`]}`];
          if (
            !brandRefNumbers[`${enquiryMapping[`${formatMaterialGroup(item?.materialGroup)}`]}`] ||
            !brandRefNumbers[`${enquiryMapping[`${formatMaterialGroup(item?.materialGroup)}`]}`].trim() && item.isValid
          ) {
            emptyRefNo = true;
          }
        }
        if (referenceNumber === "") {
          emptyRefNo = true;
        }
        if ((item.nowAvailabilityChecked && item.nowAvailability > 0) || (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && item.hrs24AvailabilityChecked && item.hrs24Availability > 0) || (item.airAvailabilityChecked && item.airAvailability > 0)) {
          itemsSelected = true;
        }
        if (!parseInt(item.quantity)) {
          emptyQuantity = item.productId;
        }
        item["masterReferenceNumber"] = referenceNumber;
        item["enquiryReferenceNumber"] =
          brandRefNumbers[
          `${enquiryMapping[`${formatMaterialGroup(item?.materialGroup)}`]}`
          ];
        item["deliveryBlockReason"] =
          deliveryBlockReason[
            `${enquiryMapping[
            `${formatMaterialGroup(item?.materialGroup)}`
            ]}`
          ]?.deliveryBlockReason || '';

        item["deliveryBlockReasonCode"] = item?.materialGroup
          ? deliveryBlockReason[
            `${enquiryMapping[
            `${formatMaterialGroup(item.materialGroup)}`
            ]}`
          ]?.deliveryBlockReasonCode
          : '';
        return item;
      });
      if (emptyRefNo) {
        setOpenSnackbarType("error");
        setOpenErrorSnackbar(true);
        setSuccessMessage(
          `All reference numbers are mandatory`
        );
        handleopenCloseSnackbar(true);
        return;
      }
      if (emptyQuantity) {
        setOpenSnackbarType("error");
        setOpenErrorSnackbar(true);
        setSuccessMessage(
          `Quantity of product ${emptyQuantity} should be greater that zero`
        );
        handleopenCloseSnackbar(true);
        return;
      }
      if (!itemsSelected) {
        setOpenSnackbarType("error");
        setOpenErrorSnackbar(true);
        setSuccessMessage(
          `Please select atleast one item with quantity greater than 0 to proceed.`
        );
        handleopenCloseSnackbar(true);
        return;
      }
      if (zeroProducts && zeroProducts.length > 0) {
        let data: any = sendEmailObj(zeroProducts);
        await dispatch(sendZeroProductsEmail(data));
      }

      // let updationData: any = {};
      // productsTemp.map((singleProduct: any) => {
      //   if (singleProduct["id"]) {
      //     if (updationData[singleProduct["id"]]) {
      //       updationData[singleProduct["id"]].push(
      //         singleProduct
      //       );
      //     } else {
      //       updationData[singleProduct["id"]] = [
      //         singleProduct,
      //       ];
      //     }
      //   }
      // });

      // let finalData: any = [];
      // Object.keys(updationData).map((singlekey: any) => {
      //   // let tc = changeCheckBox ? getEstimatedTotal(true) : estTotal;
      //   let tc: any = getEstimatedTotal(isAvailabiityChecked, true);
      //   finalData.push({
      //     id: singlekey,
      //     masterReferenceNumber: referenceNumber,
      //     products: updationData[singlekey],
      //     // totalCost: changeCheckBox ? getEstimatedTotal(true) : estTotal,
      //     totalCost: getEstimatedTotal(isAvailabiityChecked, true),
      //     netOrderValue: parseInt(tc) == 0 ? 0 : getnetOrderValue(updationData[singlekey], true)
      //   });
      // });
      // await dispatch(
      //   updateEnquiry(customerTierType,
      //     enquiryData[0].B2bEnquiryId,
      //     finalData,
      //     true,
      //     null,
      //     enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].enquiryNumber,
      //     enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].b2bLostSalesReportId ? enquiryData[0].b2bLostSalesReportId : getUniqueTimestamp(),
      //     true
      //   )
      // );
      // await dispatch(
      //   updateEnquiry(customerTierType,
      //     enquiryData[0].B2bEnquiryId,
      //     finalData,
      //     false,
      //     null,
      //     enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].enquiryNumber,
      //     enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].b2bLostSalesReportId ? enquiryData[0].b2bLostSalesReportId : getUniqueTimestamp(),
      //     true
      //   )
      // );
    }
    setShowRequestQuotationDialog(true);
    setStatusSuccessChecked(false)
  }

  // const handleTecDoc = async (enquiryId: any) => {
  //   if (isUpdateMode && enquiryId) {
  //     if (isEnquirySaved && enquiryId && sessionStorage.getItem('userType') === 'FSE') {
  //       sessionStorage.setItem('isUpdate', 'true')
  //     }
  //     await dispatch(setEnquiryId(enquiryId));
  //     history.push("oescatalogue")
  //   } else {
  //     await dispatch(setEnquiryId('create'));
  //     history.push("oescatalogue")
  //   }
  //   // if ((products.length > 0)) {
  //   //   // setproducts([...products,{productId:"1222233"}])
  //   //   setOes(true)
  //   // } else {
  //   //   <a href="https://web.stg.tecalliance.net/alfuttaim-catalog/en/home"></a>
  //   //   //window.open("https://web.stg.tecalliance.net/alfuttaim-catalog/en/home");
  //   //   history.push("oescatalogue")
  //   //   setOes(false)
  //   // }
  // }
  const showDownloadEnquiry = sessionStorage.getItem('userType') === 'FSE' ? true : !sessionStorage.getItem('restrictFeat')?.includes(RESTRICTED_ACCESS.DOWNLOAD_ENQUIRY_EXCEL);
  const showPlaceOrder = sessionStorage.getItem('userType') === 'sre' ? false : sessionStorage.getItem('userType') === 'FSE' ? true : !sessionStorage.getItem('restrictFeat')?.includes(RESTRICTED_ACCESS.PLACE_ORDER);
  const showStockEnquiry = sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ? true : !sessionStorage.getItem('restrictFeat')?.includes(RESTRICTED_ACCESS.STOCK_ENQUIRY);
  const showUpdateEnquiry = sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ? true : !sessionStorage.getItem('restrictFeat')?.includes(RESTRICTED_ACCESS.UPDATE_ENQUORY);
  // const tblDealerAccess = getFeatureAccesses && getFeatureAccesses.length > 0
  //   ? getFeatureAccesses
  //   : profileDetails?.data?.data?.customerInfo?.featureAccesses || [];
  const [selectedAccessType, setSelectedAccessType] = React.useState<any>("Parts");
  const [openTBLDealerImg, setOpenTBLDealerImg] = React.useState<any>(false);
  const [selectedPartImages, setSelectedPartImages] = React.useState<any>([]);
  const [selectedPartNumber, setSelectedPartNumber] = React.useState<any>("");
  const [filteredParts, setFilteredParts] = React.useState<any>([]);
  const randomFourDigit = Math.floor(1000 + Math.random() * 9000); // Generates a 4-digit number
  let tempRef: any = annexureEnquiry === 'true' ? "" : `AFG${randomFourDigit}`;

  useEffect(() => {
    let data: any = Array.isArray(getTBLPartsDetails && getTBLPartsDetails.data && getTBLPartsDetails.data[0] && getTBLPartsDetails.data[0].parts) &&
      getTBLPartsDetails && getTBLPartsDetails.data && getTBLPartsDetails.data[0] && getTBLPartsDetails.data[0].parts.map((part: any) => {
        return part
      })
    const initialCheckedState: any = {};
    if (data) {
      data.forEach((row: any) => {
        initialCheckedState[row.partNumber] = true;
      });
      setCheckedRows(initialCheckedState);
    }
  }, [getTBLPartsDetails])

  const handleSelectAllChange = (e: any) => {
    const isChecked = e.target.checked;
    const newCheckedState: any = {};
    tyreParts.forEach((row: any) => {
      newCheckedState[row.partNumber] = isChecked;
    });
    setCheckedRows(newCheckedState);
  };

  const handleTyrePartSelect = (partNumber: any) => {
    setCheckedRows((prevState: any) => ({
      ...prevState,
      [partNumber]: !prevState[partNumber],
    }));
  }

  const handleSubmit = async () => {
    if (selectedAccessType === "Parts" || (isTyrePartsSearchSuccessFully === true && isTyrePartsAddedtoGrid === true) || products.some((p: any) => p.isAddToEnquiry === false)) {
      setisAvailabiityChecked(true);
    }
    setAddedTyreParts(true);
    setShowDropdown(false);
    setSearchBypartNumber('');

    if (/^AFG\d{4}$/.test(referenceNumber)) {
      setreferenceNumber('');
    }
    let updatedTyreParts: any;

    updatedTyreParts = tyreParts.filter(
      (item: any) => checkedRows[item.partNumber] !== false
    );

    // Update the tyreParts state
    setTyreParts(updatedTyreParts);

    // const hasAnyAddToEnquiry = products.some((product: any) => product.isAddToEnquiry);
    // if (!hasAnyAddToEnquiry) {
    //   setreferenceNumber('');
    //   setbrandRefNumbers({
    //     "2001": "",
    //     "2002": "",
    //     "2003": "",
    //     "2380": "",
    //     "2195": "",
    //   });
    // }
    // 1️⃣ Build a new products array by mapping over the old one
    const abandonedTyreProductIds: any[] = [];
    const updatedProducts = products.map((product: any) => {
      // try to find a matching update
      const updatedItem = updatedTyreParts.find(
        (u: any) => u.partNumber === product.productId && !product.isAddToEnquiry
      );
      // 2️⃣ If it’s in updatedTyreParts AND was not yet added to enquiry,
      //    pull in the new quantity and flip isAddToEnquiry → true
      if (updatedItem && !product.isAddToEnquiry) {
        return {
          ...product,
          quantity: updatedItem.quantity,
          isAddToEnquiry: true,
        };
      }

      // 3️ Else, if it’s still not added to enquiry and
      //    *not* in updatedTyreParts, mark it for deletion. isMaterialNotExtended: false —
      //    this is an abandoned search result (e.g. a series the user searched, then moved
      //    on from without adding), not a genuine MNE removal.
      if (!product.isAddToEnquiry && !updatedItem && product.accessTyres) {
        abandonedTyreProductIds.push(product.productId);
        return {
          ...product,
          selected: true,
          action: "D",
          isMaterialNotExtended: false,
        };
      }

      // 4️⃣ Otherwise, leave it untouched
      return product;
    });

    setproducts(updatedProducts);
    clearMaterialNotExtendedTracking(abandonedTyreProductIds);
    updateOnly(updatedProducts, null, null, null, null, true);
    setisAvailabiityChecked(false);
    setplaceorderEnabled(false);
    setIsTyrePartsAddedtoGrid(true);
    setOpenEnquiry(true);
  };

  // ON CHANGE OF DELIVERY TYPE 
  const changeDeliveryType = () => {
    handleopenCloseConfirmPopup(true);
  }

  const checkOrderLogs = async () => {
    handleOrderLogPopup();
  }

  useEffect(() => {
    featureAccessibility = sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ?
      getCustomerDetailsBySapId?.data?.accessParameter?.[0]?.featureAccessibility :
      profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.accessParameter && profileDetails.data.data.accessParameter.featureAccessibility
    // if (featureAccessibility && featureAccessibility.length > 0 && userType === 'User') {
    dispatch(storeSelectedCustomerData(getCustomerDetailsBySapId?.data));
    if (featureAccessibility && featureAccessibility.length > 0) {
      if (userType === 'User') {
        let featureAccessibilityAddress = featureAccessibility.filter((ele: any) => {
          return ele && ele.featureCode == "SELECT_DEFAULT_ADDRESS"
        });
        if (featureAccessibilityAddress && featureAccessibilityAddress.length > 0) {
          if (featureAccessibilityAddress[0].value == false) {
            let arr: any = [];
            let defaultAddress: any = addressData && addressData.length > 0 && addressData.find((ele: any) => ele.id === defaultAddressId);
            setIsAdminSetDefaultAddress(true);
            arr.push(defaultAddress);
            setAddressData(arr);
          }
        }
      }
      const iamMappingFeature = featureAccessibility?.find((ele: any) => ele.featureCode === "IAM_MAP");
      if (iamMappingFeature?.value === true && annexureEnquiry !== 'true') {
        iamMap.current = true;
        setIsOESOEM(true);
      } else if (iamMappingFeature?.value === false) {
        iamMap.current = false;
        setIsOESOEM(false);
      }
    }
  }, [featureAccessibility, userType, getCustomerDetailsBySapId, profileDetails]);


  const isAccess = () => {
    if ((customerTierType && customerTierType.toLowerCase() === "dealer") || (customerTierType && customerTierType.toLowerCase() === "tbl dealer") || (customerTierType && customerTierType.toLowerCase() === "government") || (customerTierType && customerTierType.toLowerCase() === "fleet") || (customerTierType && customerTierType.toLowerCase() === "int. business")) {
      return true
    } else {
      return false
    }
  }

  const handleOpenEnquiryGridImage = (item: any) => {
    const image = Array.isArray(item?.imageUrls) && item.imageUrls.length > 0
      ? item.imageUrls
      : [];
    if (image.length > 0) {
      const partNumber = item && item.partNumber ? item.partNumber : item && item.productId ? item.productId : "";
      setSelectedPartImages(image);
      setSelectedPartNumber(partNumber);
      setOpenTBLDealerImg(true);
    }

  };

  const handleClosedEnquiryGridImage = () => {
    setOpenTBLDealerImg(false);
    setSelectedPartImages([]);
  };

  const handleOpenModal = (item: any) => {
    const image = Array.isArray(item?.imageUrls) && item.imageUrls.length > 0
      ? item.imageUrls
      : [];
    const partNumber = item && item.partNumber ? item.partNumber : item && item.productId ? item.productId : "";
    setSelectedPartImages(image);
    setSelectedPartNumber(partNumber);
    setOpenTBLDealerImg(true);
  };

  const handleCloseModal = () => {
    setOpenTBLDealerImg(false);
    setSelectedPartImages([]);
  };

  // const generateReferenceNumber = (ismain?: any) => {
  //   const randomFourDigit = Math.floor(1000 + Math.random() * 9000); // Generates a 4-digit number
  //   let value = `AFG${randomFourDigit}`;
  //   if (ismain) {
  //     setreferenceNumber(brandRefNumbers['2195']);
  //   } else {
  //     setbrandRefNumbers({
  //       "2001": value ? value : "",
  //       "2002": value ? value : "",
  //       "2003": value ? value : "",
  //       "2380": value ? value : "",
  //       "2195": value ? value : "",
  //     });
  //   }
  //   // setreferenceNumber(`Test${randomFourDigit}`)
  //   return `AFG${randomFourDigit}`;
  // };

  // useEffect(() => {
  //   const handleClickOutside = (event: any) => {
  //     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //       setShowDropdown(false);
  //     }
  //   };
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);

  const handleSearch = async (value: string, isAddToEnquiry: any) => {
    if (value && value.length > 2) {
      // Get customer tier type
      // const customerTierType = (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre')
      //   ? getCustomerDetailsBySapId?.data?.customerTierType
      //   : get(profileDetails, 'data.data.customerInfo.customerTierType', '');

      // const customerTypeAccess = (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre')
      //   ? [getCustomerDetailsBySapId?.data?.customerTierType]
      //   : [];

      // Check if should validate OES brand access
      // const shouldCheckOESAccess = isTBLAccess()


      // (
      //   customerTierType === 'TBL Dealer' ||
      //   customerTypeAccess.includes("TBL Dealer") ||
      //   customerTierType === 'Dealer' ||
      //   customerTypeAccess.includes("Dealer")
      // ) || oesBrandAccess;

      // Check OES brand access if applicable
      // if (shouldCheckOESAccess) {
      //   let hasOESBrand = false;
      //   if (sessionStorage.getItem('userType') === 'FSE') {
      //     // Check in brandAccess for FSE
      //     const brandAccess = getCustomerDetailsBySapId?.data?.controlAccessOfBrand;
      //     if (Array.isArray(brandAccess)) {
      //       hasOESBrand = brandAccess.some(
      //         brand => brand.salesOrganization === "2195" && brand.make === "OES"
      //       );
      //     }
      //   } else {
      //     // Check in salesOrganization for Customer users
      //     const salesOrganizationArray = profileDetails?.data?.data?.customerInfo?.controlAccessOfBrand;
      //     hasOESBrand = Array.isArray(salesOrganizationArray) &&
      //       salesOrganizationArray.some(
      //         org => org.salesOrganization === "2195" && org.make === "OES"
      //       );
      //   }

      //   // If user doesn't have OES brand access, show error
      //   if (!isTBLAccess()) {
      //     setShowDropdown(false);
      //     setFilteredParts([]);
      //     setTyreParts([]);
      //     // Show error message via snackbar
      //     setOpenSnackbarType("error");
      //     setOpenErrorSnackbar(true);
      //     setSuccessMessage("Please contact Al-Futtaim Sales Team to enable Tyre search for you.");
      //     handleopenCloseSnackbar(true);
      //     return;
      //   }
      // }
      if (!isTBLAccess()) {
        setShowDropdown(false);
        setFilteredParts([]);
        setTyreParts([]);
        // Show error message via snackbar
        setOpenSnackbarType("error");
        setOpenErrorSnackbar(true);
        setSuccessMessage("Please contact Al-Futtaim Sales Team to enable Tyre search for you.");
        handleopenCloseSnackbar(true);
        return;
      }

      const partsArray = getTBLPartsDetails?.data?.[0]?.parts ?? [];
      let tyreParts = products.filter((item: any) => item?.materialGroup && item?.materialGroup?.includes('AMPTB'));

      // Check if the entered value exists in the partsArray
      const valueExists = partsArray.some((part: any) => part.partNumber.toLowerCase().includes(value.trim().toLowerCase()));

      if (!valueExists) {
        setShowDropdown(false); // Don't show dropdown for no results
        setFilteredParts([]);
        setTyreParts([]);
        // Show no results message via snackbar
        setOpenSnackbarType("info");
        setOpenErrorSnackbar(true);
        setSuccessMessage("No articles matched your search. Please try a different keyword.");
        handleopenCloseSnackbar(true);
        return;
      }

      const uniquePartsNumber: any = [];
      const uniquePartsDetails: any = [];

      partsArray.forEach((part: any) => {
        if (!uniquePartsNumber.includes(part.partNumber)) {
          part.quantity = 1;
          part.imageUrls = part.imageUrls;
          part.stockPercentage = part.stockPercentage;
          part.error = '';
          uniquePartsNumber.push(part.partNumber);
          uniquePartsDetails.push(part);
        }
      });

      let obj: any = {};
      const searchPrefix = value.trim().toLowerCase();
      const filtered = uniquePartsDetails.filter((part: any) => {
        if (part.partNumber.toLowerCase().includes(searchPrefix)) {
          obj[part.partNumber] = true;
          return part;
        }
      });

      setFilteredParts(filtered);
      setTyreParts(filtered);
      setCheckedRows(obj);

      const containsImageUrls = filtered.every(
        (item: any) => item.imageUrls && Array.isArray(item.imageUrls)
      );

      let newPartsArray = containsImageUrls
        ? filtered.map((item: any) => ({
          ...item,
          productId: item.partNumber,
          imageUrls: item.imageUrls,
          stockPercentage: item.stockPercentage
        }))
        : filtered.map((item: any) => ({
          productId: item.partNumber,
          quantity: item.quantity,
          imageUrls: item.imageUrls,
          stockPercentage: item.stockPercentage
        }));

      if (tyreParts.length + newPartsArray.length > 99) {
        setOpenSnackbarType("error");
        setOpenErrorSnackbar(true);
        setSuccessMessage(`You can upload a maximum of only ${MAX_TYRE_PARTS} valid Tyre Parts`);
        handleopenCloseSnackbar(true);
        return;
      }

      // New Tyre search: parts left over from the previous search that were never
      // "Add to Order Enquiry"-ed no longer belong in the enquiry. Mark them for deletion
      // (action "D") and push that through updateOnly — the same mechanism used when the
      // user clicks "Add to Order Enquiry" — instead of the delete-invalid-parts API.
      const staleTyreParts = products.filter((p: any) => p.accessTyres === true && p.isAddToEnquiry === false);
      if (staleTyreParts.length > 0) {
        const productsWithStaleMarked = products.map((p: any) =>
          // isMaterialNotExtended: false — this is an abandoned search result being cleaned
          // up, not a genuine MNE removal; sending both together makes the backend log it as
          // a real removed part even though it was never added to the enquiry.
          p.accessTyres === true && p.isAddToEnquiry === false
            ? { ...p, action: "D", selected: true, isMaterialNotExtended: false }
            : p
        );
        setproducts(productsWithStaleMarked);
        clearMaterialNotExtendedTracking(staleTyreParts.map((p: any) => p.productId));
        if (isEnquirySaved) {
          await updateOnly(productsWithStaleMarked, null, null, null, null, true);
        }
      }

      setproducts(newPartsArray);
      // Only show dropdown AFTER all validation passes and we have data
      setShowDropdown(true);
      if ((isOESOEM || iamMap.current) && annexureEnquiry !== 'true') {
        commonInsertionLogicIAMMapping(newPartsArray, null, null, null, null, isAddToEnquiry, newPartsArray);
      } else {
        commonInsertionLogic(newPartsArray, null, null, null, null, isAddToEnquiry, newPartsArray);
      }
      // await commonInsertionLogic(newPartsArray, null, null, null, null, isAddToEnquiry, newPartsArray);
      setIsTyrePartsAddedtoGrid(false);
      setIsQuantityUpdated(true);
    }
  };

  function getDDLCode(title: any, ddl: any) {
    let array: any;
    if (ddl && ddl.length > 0) {
      array = ddl.filter((d: any) => d?.title === title)
    }
    if (array && array.length > 0) return array[0].value
  }

  const validateQuantity = (newQuantity: string, stockQty: string) => {
    if (newQuantity === '') {
      return '';
    }
    if (Number(newQuantity) <= 0) {
      return 'Quantity must be greater than 0'
    };
    if (Number(newQuantity) > Number(stockQty)) {
      return `Cannot exceed stock quantity of ${stockQty}`
    };
    return '';
  };

  const isErrorExists = () => {
    if (annexureEnquiry === 'true') {
      const productsTemp: any[] = JSON.parse(JSON.stringify(products));
      return productsTemp.some((item: any) => {
        return item.error !== "" || item.isRowGreyed === true;
      });
    } else return false
  };


  const validateOrderEnqBtn = () => {
    const isValid = tyreParts.some((item: any) => Number(item.quantity) > Number(item.stockQty));
    setIsQuantityIssue(isValid);
  };
  useEffect(() => {
    validateOrderEnqBtn();
  }, [tyreParts]);

  const handleQuantityChange = (event: React.ChangeEvent<HTMLInputElement>, partNumber: string, stockQty: string) => {
    const newQuantity = event.target.value;
    const errorMessage = validateQuantity(newQuantity, stockQty);
    setTyreParts((prevTyreParts: any[]) =>
      prevTyreParts.map((tyre) =>
        tyre.partNumber === partNumber ? { ...tyre, quantity: newQuantity, stockQty, error: errorMessage } : tyre
      )
    );
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setSearchBypartNumber(searchBypartNumber);
    setShowDropdown(true);
    const filtered = Array.isArray(getTBLPartsDetails && getTBLPartsDetails.data && getTBLPartsDetails.data[0].parts) && getTBLPartsDetails && getTBLPartsDetails.data && getTBLPartsDetails.data[0].parts.filter((part: any) => {
      const searchPrefix = searchBypartNumber.trim().toLowerCase().slice(0, 3);
      if (part.partNumber.toLowerCase().startsWith(searchPrefix)) {
        return part
      }
    });
    setFilteredParts(filtered);
    setTyreParts(filtered);
    setOpenStyleMenu(true);
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    if (tyreParts && tyreParts.length > 0 && anchorEl) {
      setAnchorEl(anchorEl);
    }
  }, [tyreParts, anchorEl]);

  // const getTotalCount = () => {
  //   let count: any = 0;
  //   if (products && products.length > 0 && invalidParts && invalidParts.length > 0 && isAvailabiityChecked) {
  //     count = products.length + invalidParts.length;
  //   } else if (products && products.length > 0) {
  //     count = products.length;
  //   } else {
  //     count = 0
  //   }
  //   return count;
  // }

  const handleChange = (event: any) => {
    sessionStorage.setItem('viewEnquiry', "");
    setSelectedAccessType(event.target.value);
    setSearchBypartNumber('');
    setTyreParts([]);
    sessionStorage.setItem('isAddedFromDashboard', 'false');
    if (selectedAccessType === "Parts" && event.target.value === "Tyres") {
      setAddedTyreParts(true);
    } else {
      setAddedTyreParts(false);
    }
    if (event.target.value === "Parts" && referenceNumber === '') {
      setisAvailabiityChecked(false);
      setisAvailabiityCheckedAtTime(null);
      setplaceorderEnabled(false);
    }
    if (event.target.value === "Parts") {
      // Switching away from Tyres to Parts means any Tyre-search result that was never
      // "Add to Order Enquiry"-ed (isAddToEnquiry === false) is abandoned — delete it
      // (action "D") instead of leaving it to linger in the grid/enquiry.
      const unresolvedTyreParts = products.filter((p: any) => p.accessTyres === true && p.isAddToEnquiry === false);
      if (unresolvedTyreParts.length > 0) {
        const productsWithDeleted = products.map((p: any) =>
          // isMaterialNotExtended: false — abandoned search result, not a genuine MNE removal.
          p.accessTyres === true && p.isAddToEnquiry === false ? { ...p, action: "D", selected: true, isMaterialNotExtended: false } : p
        );
        setproducts(productsWithDeleted);
        clearMaterialNotExtendedTracking(unresolvedTyreParts.map((p: any) => p.productId));
        if (isEnquirySaved) {
          updateOnly(productsWithDeleted, null, null, null, null, true);
        }
      }
    }
    if (showDropdown) {
      // Switching search type while the Tyre Search results dropdown is still open
      // means the current dropdown selection was never run through Price check &
      // availability, so any previously verified state/timer must not carry over.
      setisAvailabiityChecked(false);
      setisAvailabiityCheckedAtTime(null);
      setplaceorderEnabled(false);
      setShowDropdown(false);
    }
    setIsTyrePartsAddedtoGrid(false);
    setIsTyrePartsSearchSuccessFully(false);
  };

  // useEffect(() => {
  //   if (annexureEnquiry === "true") {
  //     dispatch(getAllAnnexureList());
  //   }
  // }, [annexureEnquiry]);

  // useEffect(() => {
  //   if (selectedAccessType === "Tyres") {
  //     setSelectedAccessType(true)
  //   } else {
  //     setSelectedAccessType(false)
  //   }
  // }, [selectedAccessType]);

  const getTotalCount = () => {
    let count = 0;

    const filteredProducts = products.filter((product: any) => {
      return (
        (product.isAddToEnquiry === true || product.isAddToEnquiry === undefined) &&  // Ensuring isAddToEnquiry is true
        !invalidParts.some((invalid: any) =>
          invalid.seq === product.seq && invalid.productId === product.productId
        )
      );
    });

    count = filteredProducts.length + invalidParts.length;
    return count;
  };

  function isTpcWorkshop() {
    if (
      (customerTierType &&
        (customerTierType.toLowerCase() === "workshop" ||
          customerTierType.toLowerCase() === "tpcdealer")) ||
      (customerTypeAccess.includes("workshop") || customerTypeAccess.includes("tpcdealer"))
    ) {
      return true;
    }
    return false;
  }


  const headerContent = React.useMemo(() => {

    const isColumnVisible = (colName: string) => {

      if (enquiryAction === 'view') {
        return true
      }
      const priceColumns = [
        'NSP (Incl. VAT)',
        'RSP',
        'Amt',
        'NSP (Excl. VAT)',
        'BOP'
      ];

      const availabilityColumns = [
        'NOW',
        'BO',
        '24Hrs'
      ];


      const checkVisibility = (colList?: string[], targetName?: string) => {
        if (Array.isArray(colList)) {
          if (!colList || colList.length === 0) return true;
          return colList.includes(targetName || '');
        }
        return true;
      };

      // Price columns
      if (priceColumns.includes(colName)) {
        return checkVisibility(columnPreferences?.priceColumnVisibility, colName);
      }

      // Availability columns
      if (availabilityColumns.includes(colName)) {
        return checkVisibility(columnPreferences?.availabilityColumnVisibility, colName);
      }

      // Default columns
      return checkVisibility(columnPreferences?.visibleColumns, colName);
    }

    return (
      <TableHead className="">
        <TableRow className="tableRowPanelsCreateEnquiry">
          <TableCell className="w-60p pr-0">
            <input type="checkbox"
              disabled={customerTierType && customerTierType === "Dealer" &&
                (((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") && (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true) && !isSPRModifyData) ? true : false)}
              checked={isSelectedAll}
              onChange={() => {
                if (enquiryAction !== "view") {
                  let productsTemp: any = JSON.parse(
                    JSON.stringify(products)
                  );
                  productsTemp = productsTemp.map((item: any) => {
                    item.selected = !isSelectedAll;
                    return item;
                  });
                  setproducts([...productsTemp]);
                  setisSelectedAll(!isSelectedAll);
                }
              }}
            />
          </TableCell>
          <TableCell className="">
            <div style={{ display: "flex", alignItems: "center" }}>
              <h6 className="blueLabelTable mt-1">Part No.</h6>
              <IconButton className="px-2" onClick={handleToggleSearch} size="small">
                <SearchIcon className="mt-0" style={{ color: '#00a4d6', fontSize: '16px' }} />
              </IconButton>
            </div>
            <div className="blueLabelTable-enquiryHeader mt-2">Part Name &amp; Desc</div>
          </TableCell>
          <TableCell className="">
            <h6 className="blueLabelTable mb-4 mt-1">Brand</h6>
          </TableCell>
          <TableCell>
            <span>
              <h6 className="blueLabelTable-Quantity mb-2">
                Quantity
              </h6>
            </span>
            <div className="row" style={{ margin: 0 }}>
              <div
                className={
                  sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ||
                    (customerTierType && customerTierType.toLowerCase() === 'tbl dealer')
                    ? 'col-3 greyLabelTable text-center font-16 font-weight-900 text-444'
                    : 'col-4 greyLabelTable text-center font-16 font-weight-900 text-444'
                }
                style={{ paddingLeft: "1px", paddingRight: "8px", fontWeight: 900, font: "16px" }}
              >
                Qty
              </div>
              <div
                className={
                  sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ||
                    (customerTierType && customerTierType.toLowerCase() === 'tbl dealer')
                    ? 'col-3 greyLabelTable text-center font-16 font-weight-900 text-444'
                    : 'col-4 greyLabelTable text-center font-16 font-weight-900 text-444'
                }
                style={sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ? { paddingLeft: "15px", paddingRight: "15px", fontWeight: 900, font: "16px" } : { paddingLeft: "12px", paddingRight: "12px", fontWeight: 900, font: "16px" }}
              >
                Avl
              </div>
              {(sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') && (
                <Tooltip title="Stock on hand" placement="top">
                  <div
                    className="col-3 greyLabelTable text-center font-16 font-weight-900 text-444"
                    style={{ paddingLeft: "14px", paddingRight: "12px", fontWeight: 900, font: "16px" }}
                  >
                    SOH
                  </div>
                </Tooltip>
              )}
              {annexureEnquiry !== 'true' &&
                ((customerTierType && customerTierType.toLowerCase() === 'tbl dealer') ||
                  customerTierType === "Dealer") &&
                isTBLAccess() && (
                  <div
                    className={
                      sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ||
                        (customerTierType &&
                          customerTierType.toLowerCase() === 'tbl dealer' &&
                          isTBLAccess())
                        ? 'col-3 greyLabelTable text-center font-16 font-weight-900 text-444'
                        : 'col-4 greyLabelTable text-center font-16 font-weight-900 text-444'
                    }
                    style={{ paddingLeft: "12px", paddingRight: "10px", fontWeight: 900, font: "16px" }}
                  >
                    MOQ
                  </div>
                )}
            </div>
          </TableCell>
          {(sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') && getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.customerTierType === "Government" || getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.customerTierType === "Fleet" ?
            (isColumnVisible('Price') && isColumnVisible('RSP')) && (
              <TableCell className="font-10 font-weight-700 text-444"><h6>
                <h6 className=".blueLabelTable-enquiryHeader mt-2"></h6>&nbsp;</h6>RSP </TableCell> // added mb-3 here
            )
            : ''
          }
          {isColumnVisible('Price') && isColumnVisible('NSP (Incl. VAT)') && (
            <TableCell className="font-10 font-weight-700 text-444"><h6>
              <h6 className="blueLabelTable-enquiryHeader mt-2"></h6>&nbsp;</h6>NSP (Incl. VAT)</TableCell>
          )}
          {isColumnVisible('Price') && isColumnVisible('Amt') && (
            <TableCell className="font-10 font-weight-700 text-444"><h6>
              <h6 className="blueLabelTable-enquiryHeader mt-2"></h6>&nbsp;</h6>Amt</TableCell>
          )}
          {isColumnVisible('Price') && isColumnVisible('NSP (Excl. VAT)') && (
            <TableCell className="font-10 font-weight-700 text-444"><h6>
              <h6 className="blueLabelTable-enquiryHeader mt-2"></h6>&nbsp;</h6>NSP (Excl. VAT)</TableCell>
          )}
          {annexureEnquiry === 'true' || window.location.pathname.includes('annexure') ? null : annexureEnquiry !== 'true' && isColumnVisible('BOP') && isColumnVisible('Price') && (
            <TableCell className="font-10 font-weight-700 text-444"><h6>
              <h6 className="blueLabelTable-enquiryHeader mt-2"></h6>&nbsp;</h6>BOP</TableCell>
          )}
          {annexureEnquiry === 'true' || window.location.pathname.includes('annexure') ? null : ((customerTierType && customerTierType.toLowerCase() === 'tbl dealer' || customerTierType === "Dealer") && isTBLAccess()) && annexureEnquiry !== 'true' && (
            <TableCell className="font-10 font-weight-700 text-444"><h6>
              <h6 className="blueLabelTable-enquiryHeader mt-2"></h6>&nbsp;</h6>Year</TableCell>
          )}
          {isColumnVisible('Availability') && (
            <TableCell className="mw-150p">
              <h6 className="blueLabelTable mb-2">Availability</h6>
              <div className="row no-gutters">
                {isColumnVisible('NOW') && (
                  <div className="col-4 greyLabelTable">
                    <input type="checkbox"
                      // isErrorExists() ? true : 
                      disabled={customerTierType && customerTierType === "Dealer" &&
                        (((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") && (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true) && !isSPRModifyData) ? true : false)}
                      value={checkedAllNow}
                      onChange={() => {
                        if (enquiryAction !== "view") {
                          let productsTemp: any = JSON.parse(
                            JSON.stringify(products)
                          );
                          productsTemp = productsTemp.map(
                            (item: any) => {
                              const hasError = item.error !== undefined && item.error !== '';
                              if (hasError && item.isRowGreyed === true) {
                                // Don't update the checkbox (leave as is or explicitly set false)
                                item.nowAvailabilityChecked = false;
                              } else {
                                item.nowAvailabilityChecked = !!!checkedAllNow;
                              }
                              return item;
                            }
                          );
                          setproducts([...productsTemp]);
                          setcheckedAllNow(!checkedAllNow);
                        }
                      }}
                      className="checkbox small-check mr-1"
                    // size="small"
                    />
                    Now
                  </div>
                )}
                {isColumnVisible('24Hrs') && (
                  <>
                    {customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") ?
                      <div className="col-4 greyLabelTable">
                        <input type="checkbox"
                          value={checked24hrs}
                          onChange={() => {
                            if (enquiryAction !== "view") {
                              let productsTemp: any = JSON.parse(
                                JSON.stringify(products)
                              );
                              productsTemp = productsTemp.map(
                                (item: any) => {
                                  item.hrs24AvailabilityChecked =
                                    !!!checked24hrs;
                                  return item;
                                }
                                // (item: any) => {
                                //   item.hrs24AvailabilityChecked =
                                //     !!!checked24hrs;
                                //   return item;
                                // }
                              );
                              setproducts([...productsTemp]);
                              setChecked24hrs(!checked24hrs);
                            }
                          }}
                          className="checkbox small-check mr-1"
                        // size="small"
                        />
                        24hrs
                      </div>
                      : ""}</>
                )}

                {isColumnVisible('BO') && (
                  <>
                    {annexureEnquiry !== 'true' && (
                      <div className="col-4 greyLabelTable">
                        <input type="checkbox"
                          disabled={customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") || customerTierType === "Dealer" &&
                            (((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") && (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true) && !isSPRModifyData) ? true : false)}
                          value={checkedAllBO}
                          onChange={() => {
                            if (enquiryAction !== "view") {
                              let productsTemp: any = JSON.parse(
                                JSON.stringify(products)
                              );
                              productsTemp = productsTemp.map(
                                (item: any) => {
                                  // if (item.accessTyres !== true) {
                                  item.airAvailabilityChecked =
                                    !!!checkedAllBO;
                                  // }
                                  return item;
                                }
                              );
                              setproducts([...productsTemp]);
                              setcheckedAllBO(!checkedAllBO);
                            }
                          }}
                          className="checkbox small-check mr-1"
                        // size="small"
                        />
                        BO
                      </div>
                    )}</>
                )}

              </div>
            </TableCell>
          )}
          {isColumnVisible('Dimension') && (
            <TableCell className="">
              <h6 className="blueLabelTable mb-2">Dimension</h6>
              <div className="greyLabelTable">
                L x W x H(mm) | W(gm)
              </div>
            </TableCell>
          )}
          {isColumnVisible('Volume') && (
            <TableCell className="">
              <h6 className="blueLabelTable mb-2">Volume</h6>
              <div className="greyLabelTable">(Per Unit)</div>
            </TableCell>
          )} </TableRow>
      </TableHead>
    );
  }, [columnPreferences, products, annexureEnquiry, rowSummaryGlobalData]);

  return (
    <Fragment>
      {((enquiryInfo && enquiryInfo.loading) || (favoritesList && favoritesList.loading)) && <FullscreenLoader />}
      {loading && <FullscreenLoader />}
      {(getCustomerDetailsBySapId && getCustomerDetailsBySapId.loading) && <FullscreenLoader />}

      <Snackbar
        open={openSnackbar}
        type={openErrorSnackbar ? 'error' : ''}
        message={successMessage}
        handleopenClose={() => {
          handleopenCloseSnackbar(false);
          setOpenSnackbarType("");
        }}
      />
      {sessionStorage.setItem('enquiry-current-status', isUpdateMode
        ? enquiryAction === "view"
          ? "View"
          : "Update"
        : "New")}
      {openOrderSummary === false &&
        <div className="d-flex align-items-center">
          <h2 className="page-title">
            <span>
              {isUpdateMode
                ? enquiryAction === "view"
                  ? "View"
                  : "Update"
                : "New"}{" "}
              {annexureEnquiry === "true" ? "Annexure/Core Product Enquiry" : "Order Enquiry"} {" "}
              {isEnquirySaved && (
                <span className="font-size-13">
                  {isUpdateMode &&
                    enquiryData &&
                    enquiryData[0] &&
                    `(${enquiryData[0].B2bEnquiryId})`}
                  {sessionStorage.setItem("Current-Enquiry-No", isUpdateMode &&
                    enquiryData &&
                    enquiryData[0] &&
                    enquiryData[0].B2bEnquiryId)}
                </span>
              )}
            </span>
          </h2>
          <div className="ml-auto d-flex align-items-center">
            <AnnouncementIcon />
            <NotificationIcon />
          </div>
        </div>}
      {
        customerTierType &&
          customerTierType.toLowerCase() === "int. business" ? (
          <>
            {has2431 && has2428 ? (
              <div className='px-0 ml-0'>
                <div className="d-flex align-items-center mb-2 px-4 py-2">

                  <h6
                    className="page-title mb-0 mr-4"
                    style={{ fontSize: "15px" }}
                  >
                    Order Created By *
                  </h6>

                  <RadioGroup
                    row
                    aria-labelledby="order-created-by-label"
                    value={orderCreatedBy}
                    onChange={(event: any) => {
                      setOrderCreatedBy(event.target.value);

                      sessionStorage.setItem('orderCreatedBy', event.target.value);
                      sessionStorage.setItem('finalOrderCreated', event.target.value);
                    }}
                  >
                    <FormControlLabel
                      className="font-size-15 mb-0"
                      value="AA"
                      control={<Radio color="primary" />}
                      label="Arch Auto"
                    />
                    <FormControlLabel
                      className="font-size-15 mb-0 mr-3"
                      value="MA"
                      control={<Radio color="primary" />}
                      label="Multi Auto"
                    />

                  </RadioGroup>

                </div>
              </div>
            ) : has2431 ? (
              <div className="tandcHeading row px-2 mt-2 mb-2 ml-0">
                Order Created By :
                <span className="tandcHeading-font-type ml-1">Multi Auto</span>
              </div>
            ) : has2428 ? (
              <div className="tandcHeading row px-2 mt-2 mb-2 ml-0">
                Order Created By :
                <span className="tandcHeading-font-type ml-1">Arch Auto</span>
              </div>
            ) : null}
          </>
        ) : null
      }
      {(sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') ?
        <>
          {openOrderSummary === false ?
            <div className="m-2 row">
              <div className="row mt-2">
                <div className="tandcText m-2 row">
                  {/* <div className="tandcHeading row px-2">Selected Customer - <span className="tandcHeading-font ml-1">{getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.companyName ? getCustomerDetailsBySapId.data.companyName : "-"}</span> {" "} */}
                  <div className="tandcHeading row px-2">Customer : <span className="tandcHeading-font-type ml-1">{getChoosenCustomerName ? getChoosenCustomerName : "-"}</span> {" "}
                    <span className="tandcHeading-font-type ml-1">
                      {getChoosenCustomerSapCustomerId ?
                        // `(${getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.sapCustomerId ? getCustomerDetailsBySapId.data.sapCustomerId : "-"})`}
                        `(${getChoosenCustomerSapCustomerId ? getChoosenCustomerSapCustomerId : "-"})` : ""}
                    </span></div>
                </div>
                {/* need to update here TPC DEALER  */}
                {annexureEnquiry !== 'true' && getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.customerTierType && (getCustomerDetailsBySapId.data.customerTierType.toLowerCase() === "workshop" || getCustomerDetailsBySapId.data.customerTierType.toLowerCase() === "tbl dealer" || getCustomerDetailsBySapId.data.customerTierType.toLowerCase() === "tpcdealer") || (sessionStorage.getItem('customerTypeofCustomer') === "workshop" || sessionStorage.getItem('customerTypeofCustomer') === "tpcdealer" || sessionStorage.getItem('customerTypeofCustomer') === "tbl dealer") ?
                  <>
                    {getSelectedOrderType === "CASH" || getSelectedOrderType === "CRD" ?
                      <>
                        <div className="tandcHeading row px-4 mt-2">Order Type : <span className="tandcHeading-font-type ml-1">{getSelectedOrderType === "CRD" ? "Credit" : getSelectedOrderType === "CASH" ? "Cash" : "-"}</span> {" "}
                        </div>
                        <div className="tandcHeading row px-4 mt-2">Sales Office : <span className="tandcHeading-font-type ml-1">{" "}{getSelectedOfficeTitle ? getSelectedOfficeTitle : "-"}</span> {" "}
                        </div>
                      </> : ""}
                  </>
                  : ""}

                {annexureEnquiry !== 'true' && getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.customerTierType && getCustomerDetailsBySapId.data.customerTierType.toLowerCase() === "int. business" || sessionStorage.getItem('customerTypeofCustomer') === 'int. business' ?
                  <>
                    {getOrderCreatedBy === "AA" || getOrderCreatedBy === "MA" ?
                      <>
                        <div className="tandcHeading row px-4 mt-2">Order Created By :
                          <span
                            className=" ml-1"
                            style={{
                              fontWeight: "bold",
                              color: getOrderCreatedBy === "AA" ? "#008000" : "#FF0000",
                            }}
                          >
                            {getOrderCreatedBy === "MA" ? "Multi Auto" : getOrderCreatedBy === "AA" ? "Arch Auto" : "-"}
                          </span>
                          {" "}
                        </div>
                      </>
                      : ""}
                  </>
                  : ""}
                {(sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') && !isUpdateMode && !enquiryData ?
                  <Button
                    className="mt-0"
                    disabled={(((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") && (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true) && !isSPRModifyData) ? true : false)}>
                    <span className="font-size-13 button-font-changes" onClick={(e) => {
                      if (sessionStorage.getItem('userType') === 'FSE' || userType === "FSE" || sessionStorage.getItem('userType') === 'sre') {
                        setOnClickOfChangeButton(true);
                        handleChooseCustomer();
                        // handleChooseCustomerIWSFSEDialog();
                        setLoading(true);
                        let data: any = dispatch(getFSECustomerList(annexureEnquiry === 'true' ? 'customersWithAnnexureAccess' : 'customerListOnFsePortalForEnquiry'));
                        dispatch(getCustomerDetailsByCustomerID(getChoosenCustomerSapCustomerId));
                        if (data && data.error) {
                          setOpenSnackbar(true)
                          setOpenErrorSnackbar(true)
                          setSuccessMessage(data && data.error);
                          setLoading(false);
                        } else {
                          setOpenSnackbar(false)
                          setOpenErrorSnackbar(false)
                          setLoading(false);
                        }
                        setLoading(false);
                        e.stopPropagation(); dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
                      } else {
                        e.stopPropagation(); dispatch(getUniqueEnquirySessionId(getUniqueTimestamp())); history.push('/createenquiry');
                      }
                    }}>Change </span>
                  </Button>
                  : ''}
              </div>
            </div>
            : ""}
        </>
        : ""}
      {
        annexureEnquiry === 'true' && !window.location.pathname.includes('ordersummary') && !window.location.pathname.includes('viewenquiry') && ((selectedCustomerData &&
          selectedCustomerData?.annexureMonthlyOrderLimitConfig) || (annexureMonthlyOrderLimitConfig)) && (
          <div className="row mb-3">
            <div className="col-12">
              <div>
                {sessionStorage.getItem('userType') === 'FSE' ? (
                  <>
                    <div className="font-size-15 mb-2">
                      <span className="font-weight-bold">Maximum allowed order value for the Customer:</span>
                      <span className="ml-2">{selectedCustomerData?.annexureMonthlyOrderLimitConfig?.maxAllowedOrderValue
                        ? Number(selectedCustomerData.annexureMonthlyOrderLimitConfig.maxAllowedOrderValue).toFixed(2)
                        : "0.00"}{" "}{selectedCustomerData?.annexureMonthlyOrderLimitConfig?.currency}</span>
                    </div>
                    <div className="font-size-15">
                      <span className="font-weight-bold">Monthly Order limit for the Customer:</span>
                      <span className="ml-2">{selectedCustomerData?.annexureMonthlyOrderLimitConfig?.monthlyOrderLimit ? selectedCustomerData?.annexureMonthlyOrderLimitConfig?.monthlyOrderLimit : 0}</span>
                    </div>
                    {selectedCustomerData?.annexureMonthlyOrderLimitConfig?.monthlyOrderLimit === 0 && (
                      <div className="font-size-15 mt-2">
                        <span className="font-weight-bold text-red">Slab pricing order already utilized for this month for the Customer.</span>
                      </div>)}
                  </>
                ) : (
                  sessionStorage.getItem('userType')?.toLowerCase() !== 'sre' && (
                    <>
                      <div className="font-size-15 mb-2">
                        <span className="font-weight-bold">Maximum allowed order value for this month:</span>
                        <span className="ml-2">{annexureMonthlyOrderLimitConfig?.maxAllowedOrderValue
                          ? Number(annexureMonthlyOrderLimitConfig.maxAllowedOrderValue).toFixed(2)
                          : "0.00"}{" "}{annexureMonthlyOrderLimitConfig?.currency}</span>
                      </div>
                      <div className="font-size-15">
                        <span className="font-weight-bold">Monthly Order limit for this month:</span>
                        <span className="ml-2">{annexureMonthlyOrderLimitConfig?.monthlyOrderLimit ? annexureMonthlyOrderLimitConfig?.monthlyOrderLimit : 0}</span>
                      </div>
                      {annexureMonthlyOrderLimitConfig?.monthlyOrderLimit === 0 && (
                        <div className="font-size-15 mt-2">
                          <span className="font-weight-bold text-red">Slab pricing order already utilized for this month. Please contact FSE for manual processing.</span>
                        </div>)}
                    </>
                  )
                )}
              </div>
            </div>
          </div>
        )
      }
      {openOrderSummary === false ?
        <>
          {enquiryAction !== "view" && (
            <div className="row mt-0">
              <div className="col-12">
                <div className="cardCommon p-3">
                  <div className="d-flex align-items-center">
                    <h5 className="page-sub-title mb-2">Search Parts</h5>
                    <div className="ml-auto">
                      {/* <span className="cursor-pointer mr-2">
                        {(customerTierType && (customerTierType.toLowerCase() === 'workshop' || customerTierType.toLowerCase() === "tpcdealer")) &&
                          <IconButton className="mr-1 searchbarOptions" size="small"
                            onClick={() => {
                              setOes(true);
                              handleTecDoc(enquiryData &&
                                enquiryData[0] &&
                                enquiryData[0].B2bEnquiryId);
                            }}
                          >
                            <span className="material-icons-outlined" style={{ fontSize: "20px" }}>fact_check</span>
                            <span className="font-size-13 load-from-fav ml-1">Import From Catalogue </span>
                          </IconButton>
                        }
                      </span> */}
                      {sessionStorage.getItem('userType') !== 'FSE' && annexureEnquiry !== 'true' && sessionStorage.getItem('userType') !== 'sre' && (
                        <IconButton
                          disabled={customerTierType && customerTierType === "Dealer" &&
                            (((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") && (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true) && !isSPRModifyData) ? true : false)}
                        >
                          <ViewFavorite commonInsertionLogic={(isOESOEM || iamMap.current) && annexureEnquiry !== 'true' ? commonInsertionLogicIAMMapping : commonInsertionLogic} isQueue={isQueue} orderQueued={orderQueued} />
                        </IconButton>
                      )}
                      {annexureEnquiry === 'true' && sessionStorage.getItem('userType') !== 'sre' && (
                        <IconButton
                          disabled={customerTierType && customerTierType === "Dealer" &&
                            (((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") && (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true) && !isSPRModifyData) ? true : false)}
                        >
                          <LoadFromAnnexure commonInsertionLogic={(isOESOEM || iamMap.current) && annexureEnquiry !== 'true' ? commonInsertionLogicIAMMapping : commonInsertionLogic} isQueue={isQueue} orderQueued={orderQueued} brandPricingTier={brandPricingTier.current} />
                        </IconButton>
                      )}
                      {showImportExcel && sessionStorage.getItem('userType') !== 'sre' &&
                        <IconButton
                          disabled={isQueue || orderQueued ? true : customerTierType && customerTierType === "Dealer" &&
                            (((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") && (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true) && !isSPRModifyData) ? true : false)}>
                          <ImportDialog
                            isOpened={() => {
                              sessionStorage.setItem(
                                "tempProducts",
                                JSON.stringify(products ? products : [])
                              );
                            }}
                            commonInsertionLogic={(jsonData: any) => {
                              // if (customerTierType === "Dealer" && annexureEnquiry === "true") {
                              // commonInsertionLogicForImportAnnexure(jsonData, true);
                              // } else {
                              if ((isOESOEM || iamMap.current) && annexureEnquiry !== 'true') {
                                commonInsertionLogicIAMMapping(jsonData, true);
                              } else {
                                commonInsertionLogic(jsonData, true);
                              }
                              // commonInsertionLogic(jsonData, true);
                              // }
                            }}
                            addTyreParts={setAddedTyreParts}
                          />
                        </IconButton>
                      }
                    </div>
                  </div>
                  <>
                    {/* {(((customerTierType && customerTierType.toLowerCase() === 'tbl dealer' || customerTierType === "Dealer") && annexureEnquiry !== 'true') && Array.isArray(tblDealerAccess) && isTBLAccess() && tblDealerAccess.includes("Parts")) && */}
                    {((annexureEnquiry !== 'true') && isTBLAccess()) &&
                      <div className="col-12 w-100 p-0 pt-0">
                        <div className='d-flex justify-content-start' id="demo-radio-buttons-group-label">
                          <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue={"Tyres"}
                            name="radio-buttons-group"
                            onChange={handleChange} value={selectedAccessType}
                          >
                            <div className="row">
                              <div className={"px-3"}>
                                <FormControlLabel className={"font-size-15"}
                                  value="Parts" control={<Radio color="primary" />}
                                  label="Part Search" />
                              </div>
                              <div className={"pr-3"}>
                                <FormControlLabel className={"font-size-15"}
                                  value="Tyres" control={<Radio color="primary" />}
                                  label="Tyres, Batteries & Lubes" />
                              </div>
                            </div>
                          </RadioGroup>
                        </div>
                      </div>
                    }
                    {/* {(((customerTierType && customerTierType.toLowerCase() === 'tbl dealer' || customerTierType === "Dealer") && annexureEnquiry !== 'true') && isTBLAccess()) && */}
                    {((annexureEnquiry !== 'true') && isTBLAccess() && selectedAccessType === "Tyres") &&
                      <>
                        <FormControl variant="outlined" className="w-100">
                          <InputLabel htmlFor="tyre-search" className="pl-2" margin="dense">Tyre Search</InputLabel>
                          <OutlinedInput
                            id="tyre-search"
                            value={searchBypartNumber}
                            onKeyDown={(e: any) => {
                              if (e.key === 'Enter') {
                                sessionStorage.setItem('viewEnquiry', "");
                                // if (!isEnquirySaved) {
                                //   generateReferenceNumber(true);
                                // }
                                if (searchBypartNumber === undefined || searchBypartNumber === "") {
                                  // onClickDelete();
                                  setTyreParts([]);
                                } else {
                                  handleSearch(searchBypartNumber ? searchBypartNumber : e.target.value, false);
                                }
                                setisAvailabiityChecked(false);
                                setplaceorderEnabled(false);
                                setIsTyrePartsSearch(true);
                                setIsTyrePartsSearchSuccessFully(true);
                              }
                            }}
                            onChange={(e: any) => {
                              setSearchBypartNumber(e.target.value);
                              // if (!isEnquirySaved) {
                              //   generateReferenceNumber();
                              // }
                            }}

                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  // disabled
                                  aria-label="Tyre Search"
                                  edge="end"
                                  // disabled={searchBypartNumber === "" || searchBypartNumber === null || !searchBypartNumber || searchBypartNumber.length > 2}
                                  onClick={(e: any) => {
                                    sessionStorage.setItem('viewEnquiry', "");
                                    // if (!isEnquirySaved) {
                                    //   generateReferenceNumber(true);
                                    // }
                                    if (searchBypartNumber === undefined || searchBypartNumber === "") {
                                      // onClickDelete();
                                      setTyreParts([]);
                                    } else {
                                      handleSearch(searchBypartNumber ? searchBypartNumber : e.target.value, false);
                                    }
                                    setisAvailabiityChecked(false);
                                    setplaceorderEnabled(false);
                                    setIsTyrePartsSearch(true);
                                    setIsTyrePartsSearchSuccessFully(true);
                                  }}
                                >
                                  <SearchIcon />
                                </IconButton>
                              </InputAdornment>
                            }
                            labelWidth={80} margin="dense" className="rounded-input-dealer bd-highlight w-100 mr-2 mb-1" />
                        </FormControl>
                        {showDropdown && (
                          <div ref={dropdownRef} className="absolute top-12 left-0 w-full bg-white border shadow-lg rounded-lg overflow-hidden z-50">
                            {tyreParts?.length > 0 && (
                              <>
                                <Grid container className={`${classes.dropDownHeight} border-bottom`}>
                                  <TableContainer className={classes.tblDealerTablecontainer}>
                                    <Table stickyHeader aria-label="Parts Info">
                                      <TableHead className="w-200p">
                                        <TableRow className="tableRowPanelsCreateEnquiry p-3">
                                          <TableCell className="w-60p pr-0">
                                            <input
                                              type="checkbox"
                                              disabled={customerTierType && customerTierType === "Dealer" &&
                                                (((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") && (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true) && !isSPRModifyData) ? true : false)}
                                              checked={isAllSelected}
                                              onChange={handleSelectAllChange}
                                            />
                                          </TableCell>
                                          <TableCell className="tbl-dealer-dealer-custom-dropdown w-200p pr-0">Part Image</TableCell>
                                          <TableCell className="tbl-dealer-dealer-custom-dropdown w-200p px-3">Part Number & Description</TableCell>
                                          <TableCell className="tbl-dealer-dealer-custom-dropdown w-200p padded-column">Brand</TableCell>
                                          <TableCell className="tbl-dealer-dealer-custom-dropdown w-200p padded-column">Year</TableCell>
                                          <TableCell className="tbl-dealer-dealer-custom-dropdown w-200p pr-0">Price (Excl. VAT)</TableCell>
                                          <TableCell className="tbl-dealer-dealer-custom-dropdown w-200p pr-0">Stock</TableCell>
                                          <TableCell className="tbl-dealer-dealer-custom-dropdown w-200p padded-column-quantity pr-3">Quantity</TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {tyreParts && tyreParts.length > 0 && tyreParts.map((item: any) => {
                                          const matchedProduct = products.find(
                                            (product: any) => product.productId === item.partNumber
                                          );
                                          const batchYear = matchedProduct?.attributes?.find?.((attr: any) => attr.name === "batchYear")?.value || 'N/A';

                                          if (matchedProduct) {
                                            // --- Brand logic implementation as per your code ---
                                            const getBrandDisplay = () => {
                                              if (matchedProduct.materialGroup) {
                                                if ((matchedProduct.isParentPart || matchedProduct.isChildPart) && matchedProduct.brandName) {
                                                  return (
                                                    <>
                                                      {matchedProduct.brandName}
                                                      <div className="font-10">
                                                        {matchedProduct.type === 'OEM' ? '' :
                                                          matchedProduct.type === 'afterMarket' ? '(Aftermarket)' :
                                                            matchedProduct.type ? `(${matchedProduct.type})` : ''}
                                                      </div>
                                                    </>
                                                  );
                                                } else {
                                                  if (enquiryMapping && enquiryMapping[`${formatMaterialGroup(matchedProduct.materialGroup)}`] === 'OES' && matchedProduct && matchedProduct.oesSubBrandName !== '') {
                                                    return matchedProduct.oesSubBrandName;
                                                  }
                                                  if (enquirySubBrand && enquirySubBrand[`${formatMaterialGroup(matchedProduct.materialGroup)}`]) {
                                                    return enquirySubBrand[`${formatMaterialGroup(matchedProduct.materialGroup)}`];
                                                  }
                                                  if (matchedProduct?.subBrandName?.trim()) {
                                                    return matchedProduct.subBrandName;
                                                  }
                                                  if (customerTierType && customerTierType.toLowerCase() !== "tpcdealer") {
                                                    const mappingValue = enquiryMapping && enquiryMapping[`${formatMaterialGroup(matchedProduct.materialGroup)}`];
                                                    if (mappingValue === 'OES' && customerTierType && customerTierType.toLowerCase() !== "workshop") {
                                                      return 'ALAC';
                                                    } else {
                                                      return getNewBrand ? getNewBrand(mappingValue) : mappingValue;
                                                    }
                                                  } else {
                                                    const tpcMappingValue = enquiryMapping && enquiryMapping[`${formatMaterialGroup(matchedProduct.materialGroup)}`];
                                                    return (
                                                      <>
                                                        {getNewBrand ? getNewBrand(tpcMappingValue) : tpcMappingValue}
                                                        <div className="font-10">
                                                          {matchedProduct.type ? `(${matchedProduct.type.toUpperCase()})` : ''}
                                                        </div>
                                                      </>
                                                    );
                                                  }
                                                }
                                              } else {
                                                return (
                                                  <>
                                                    <div>{matchedProduct.brandName}</div>
                                                    <div className="font-10">
                                                      {matchedProduct.type === 'OEM' ? '' :
                                                        matchedProduct.type === 'afterMarket' ? '(Aftermarket)' :
                                                          matchedProduct.type ? `(${matchedProduct.type})` : ''}
                                                    </div>
                                                  </>
                                                );
                                              }
                                            };

                                            return (
                                              <TableRow key={item.partNumber}>
                                                <TableCell>
                                                  <input
                                                    type="checkbox"
                                                    checked={!!checkedRows[item.partNumber]}
                                                    onChange={() => handleTyrePartSelect(item.partNumber)}
                                                  />
                                                </TableCell>
                                                <TableCell>
                                                  <img
                                                    src={item.imageUrls[0]}
                                                    alt="Part"
                                                    style={{
                                                      maxHeight: '60px',
                                                      height: 'auto',
                                                      maxWidth: '60px',
                                                      width: 'auto',
                                                      cursor: 'pointer'
                                                    }}
                                                    onClick={() => { handleOpenModal(item); }}
                                                  />
                                                </TableCell>
                                                <TableCell className="invalidRowClassInvalidPart">
                                                  <div className="greyLabelTable fontsizetenew-table-view">
                                                    {item.partNumber || "-"}
                                                  </div>
                                                  <div className="greyLabelTable invalidPartText fontsizetenew">
                                                    {matchedProduct.productIdDescription || "-"}
                                                  </div>
                                                  {matchedProduct.stockPercentage > 0 && (
                                                    <>
                                                      <span className="legendItemLabel text-red pr-2">Restricted stock</span>
                                                      <Tooltip title="Restricted Stock – For enquiries about restricted stock, please contact Al-Futtaim sales team" placement="top">
                                                        <IconButton className={classes.actionButton} size="small">
                                                          <InfoIcon fontSize="inherit" />
                                                        </IconButton>
                                                      </Tooltip>
                                                    </>
                                                  )}
                                                </TableCell>
                                                <TableCell className="font-10 font-weight-700 text-444 px-5 w-200p padded-column">
                                                  {getBrandDisplay()}
                                                </TableCell>
                                                <TableCell className="px-5 w-200p padded-column">{batchYear || "-"}</TableCell>
                                                <TableCell>{matchedProduct.nspev ?
                                                  `AED ${parseFloat(getSellingPrice(matchedProduct?.nspev, isSellingPriceData, markupPercentage)).toFixed(2)}`
                                                  : "-"
                                                }</TableCell>
                                                <TableCell>
                                                  {
                                                    matchedProduct.soh && parseFloat(matchedProduct.stockPercentage) > 0
                                                      ? (
                                                        matchedProduct.soh === 1
                                                          ? 0
                                                          : Math.floor(
                                                            matchedProduct.soh - (
                                                              (matchedProduct.soh * parseFloat(matchedProduct.stockPercentage)) / 100
                                                            )
                                                          )
                                                      )
                                                      : matchedProduct.soh || "-"
                                                  }
                                                </TableCell>
                                                <TableCell
                                                  style={{
                                                    textAlign: "center",
                                                    verticalAlign: "middle",
                                                    minWidth: "80px",
                                                  }}
                                                >
                                                  <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    gap: '4px',
                                                    width: '100px'
                                                  }}>
                                                    <TextField
                                                      type="number"
                                                      size="small"
                                                      style={{
                                                        width: '80px',
                                                        textAlign: 'center',
                                                      }}
                                                      className="commonRoundedInputs"
                                                      variant="outlined"
                                                      value={item.quantity || ''}
                                                      inputProps={{
                                                        min: 0,
                                                        max:
                                                          matchedProduct.soh && parseFloat(matchedProduct.stockPercentage) > 0 && (customerTierType === 'TBL Dealer' ||
                                                            customerTypeAccess.includes("TBL Dealer"))
                                                            ? matchedProduct.soh === 1
                                                              ? 0
                                                              : Math.floor(
                                                                matchedProduct.soh - (
                                                                  (matchedProduct.soh * parseFloat(matchedProduct.stockPercentage)) / 100
                                                                )
                                                              )
                                                            : matchedProduct.soh || 0,
                                                        style: { textAlign: 'center' },
                                                      }}
                                                      onChange={(event: any) => {
                                                        const stockPercentage = parseFloat(matchedProduct.stockPercentage);
                                                        const maxAllowedQty =
                                                          matchedProduct.soh && stockPercentage > 0
                                                            ? matchedProduct.soh === 1
                                                              ? 0
                                                              : Math.floor(
                                                                matchedProduct.soh - (
                                                                  (matchedProduct.soh * stockPercentage) / 100
                                                                )
                                                              )
                                                            : matchedProduct.soh || 0;
                                                        handleQuantityChange(event, item.partNumber, maxAllowedQty);
                                                      }}
                                                    />
                                                    {item.error && (
                                                      <span style={{
                                                        color: 'red',
                                                        fontSize: '12px',
                                                        textAlign: 'center',
                                                        whiteSpace: 'nowrap',
                                                      }}>
                                                        {item.error}
                                                      </span>
                                                    )}
                                                  </div>
                                                </TableCell>
                                              </TableRow>
                                            );
                                          }
                                          return null;
                                        })}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </Grid>
                                <div className="d-flex justify-content-between mt-4 mb-4">
                                  <div className="">
                                    <h5 className="page-sub-title px-4 mt-2">
                                      Part(s) selected - {selectedCount}
                                    </h5>
                                  </div>
                                  <div style={{ paddingRight: '20px' }}>
                                    <Button
                                      disabled={
                                        selectedCount === 0 ||
                                        (customerTierType &&
                                          (customerTierType === "Dealer" || customerTierType.toLowerCase() === "tbl dealer") &&
                                          (isQuantityIssue ||
                                            ((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") &&
                                              (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true) &&
                                              !isSPRModifyData)
                                          ) ? true : false
                                        )
                                      }
                                      className="addOrderEnqButton"
                                      size="small"
                                      onClick={handleSubmit}
                                      variant="contained"
                                      color="primary"
                                    >
                                      Add to Order Enquiry
                                    </Button>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        )}
                        <Dialog open={openTBLDealerImg} onClose={handleCloseModal} maxWidth="md" fullWidth>
                          <DialogTitle>
                            <Grid container justifyContent="space-between" alignItems="center">
                              <div className="shift-to-party-page-title">{selectedPartNumber}</div>
                              <IconButton onClick={handleCloseModal}><Close /></IconButton>
                            </Grid>
                          </DialogTitle>
                          <DialogContent>
                            <Carousel
                              indicators={true}
                              interval={3000}
                              prevIcon={
                                <ArrowBackIcon
                                  style={{
                                    color: '#fff',
                                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                    borderRadius: '50%',
                                    width: '45px',
                                    height: '45px',
                                    padding: '5px'
                                  }}
                                />
                              }
                              nextIcon={
                                <ArrowForwardIcon
                                  style={{
                                    color: '#fff',
                                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                    borderRadius: '50%',
                                    width: '45px',
                                    height: '45px',
                                    padding: '5px'
                                  }}
                                />
                              }
                              prevLabel=""
                              nextLabel="">
                              {selectedPartImages?.map((url: any, index: any) => (
                                <Carousel.Item key={index}>
                                  <img
                                    src={url}
                                    alt={`Slide ${index + 1}`}
                                    style={{
                                      width: '100%',
                                      height: '400px',
                                      objectFit: 'contain',
                                      transition: 'transform 0.3s ease-in-out'
                                    }}
                                  />
                                </Carousel.Item>
                              ))}
                            </Carousel>
                          </DialogContent>
                        </Dialog>
                      </>
                    }
                  </>
                  {customerTierType && (customerTierType.toLowerCase() === "tbl dealer" || customerTierType === "Dealer") && (
                    <>
                      {(customerTierType && customerTierType.toLowerCase() === 'tbl dealer' || annexureEnquiry === "" && customerTierType === "Dealer") && selectedAccessType === "Parts" &&
                        <>
                          <TextField
                            disabled={customerTierType && customerTierType === "Dealer" &&
                              (((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") && (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true) && !isSPRModifyData) ? true : false)}
                            onChange={(e) => setproductId(e.target.value)}
                            autoFocus
                            inputRef={ref => inputRefs.push(ref)}
                            onPaste={(e) => {
                              sessionStorage.setItem('viewEnquiry', "");
                              let clipData: any = e.clipboardData.getData("Text");
                              let crlf: any =
                                String.fromCharCode(13) + String.fromCharCode(10);
                              let clipRows: any = clipData.split(String.fromCharCode(13));
                              let jsonData: any = [];
                              for (let iRow: any = 0; iRow < clipRows.length - 1; iRow++) {
                                let productId = clipRows[iRow].split(
                                  String.fromCharCode(9)
                                )[0];
                                var quantity = isNumeric(
                                  clipRows[iRow].split(String.fromCharCode(9))[1]
                                )
                                  ? clipRows[iRow].split(String.fromCharCode(9))[1]
                                  : 1;
                                jsonData.push({
                                  productId: productId.replace(/(\r\n|\n|\r)/gm, ""),
                                  quantity: quantity && quantity.toString() && quantity.toString().slice(0, 5),
                                });
                              }
                              if (
                                jsonData &&
                                Array.isArray(jsonData) &&
                                jsonData.length > 0
                              )
                                if ((isOESOEM || iamMap.current) && annexureEnquiry !== 'true') {
                                  commonInsertionLogicIAMMapping(jsonData);
                                } else {
                                  commonInsertionLogic(jsonData);
                                }
                              setOpenEnquiry(true)
                              // commonInsertionLogic(jsonData);
                              setOpenEnquiry(true);
                            }}
                            value={productId}
                            onKeyDown={(e: any) => {
                              sessionStorage.setItem('viewEnquiry', "");
                              const event = e;
                              if (e.keyCode == 13) {
                                if (productId && productId.trim()) {
                                  inputRefs[1].focus();
                                  event.preventDefault();
                                }
                                // if (productId && productId.trim()) {
                                //   commonInsertionLogic([
                                //     {
                                //       productId: productId.trim(),
                                //       quantity:
                                //         quantity &&
                                //           parseInt(quantity) &&
                                //           parseInt(quantity) >= 1
                                //           ? parseInt(quantity)
                                //           : 1,
                                //     },
                                //   ]);
                                // }
                              }
                              setOpenEnquiry(true)
                            }}
                            size="small"
                            className="col-sm-12 col-md-6 col-ml-7 col-xl-8 pr-3 commonRoundedInputs common-input-font-size"
                            label="Search By Part Number"
                            variant="outlined"
                          />
                          <TextField
                            disabled={customerTierType && customerTierType === "Dealer" &&
                              (((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") && (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true) && !isSPRModifyData) ? true : false)}
                            type="text"
                            id="quantity"
                            inputRef={ref => inputRefs.push(ref)}
                            onChange={(e) => {
                              let value = e.target.value && parseInt(e.target.value) && /^[+]?\d+([.]\d+)?$/.test(e.target.value) &&
                                parseInt(e.target.value) >= 1
                                ? parseInt(e.target.value)
                                : "";
                              setquantity(value);
                            }}
                            onKeyDown={(e: any) => {
                              if (e.keyCode == 13) {
                                if (productId && productId.trim()) {
                                  if ((isOESOEM || iamMap.current) && annexureEnquiry !== 'true') {
                                    commonInsertionLogicIAMMapping(([
                                      {
                                        productId: productId.trim(),
                                        quantity:
                                          quantity &&
                                            parseInt(quantity) &&
                                            parseInt(quantity) >= 1
                                            ? parseInt(quantity)
                                            : 1,
                                      },
                                    ])
                                    );
                                  } else {
                                    commonInsertionLogic(([
                                      {
                                        productId: productId.trim(),
                                        quantity:
                                          quantity &&
                                            parseInt(quantity) &&
                                            parseInt(quantity) >= 1
                                            ? parseInt(quantity)
                                            : 1,
                                      },
                                    ]));

                                  }
                                  // commonInsertionLogic([
                                  //   {
                                  //     productId: productId.trim(),
                                  //     quantity:
                                  //       quantity &&
                                  //         parseInt(quantity) &&
                                  //         parseInt(quantity) >= 1
                                  //         ? parseInt(quantity)
                                  //         : 1,
                                  //   },
                                  // ]);
                                  inputRefs[0].focus();
                                }
                              }
                            }}
                            value={quantity}
                            size="small"
                            className="col-sm-6 col-md-3 col-ml-2 col-xl-2 pr-3 commonRoundedInputs common-input-font-size"
                            label="Quantity"
                            inputProps={{ maxLength: 5 }}
                            variant="outlined"
                          />
                          <Button
                            disabled={customerTierType && customerTierType === "Dealer" &&
                              (((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") && (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true) && !isSPRModifyData) ? true : false)}
                            className="col-sm-6 col-md-3 col-ml-3 col-xl-2 font-12 addOrderEnqButton"
                            size="small"
                            onClick={async () => {
                              setOpenEnquiry(true)
                              setplaceorderEnabled(false);
                              if (productId && productId.trim()) {
                                if ((isOESOEM || iamMap.current) && annexureEnquiry !== 'true') {
                                  commonInsertionLogicIAMMapping([
                                    {
                                      productId: productId.trim(),
                                      quantity:
                                        quantity &&
                                          parseInt(quantity) &&
                                          parseInt(quantity) >= 1
                                          ? parseInt(quantity)
                                          : 1,
                                    },
                                  ]);
                                } else {
                                  commonInsertionLogic([
                                    {
                                      productId: productId.trim(),
                                      quantity:
                                        quantity &&
                                          parseInt(quantity) &&
                                          parseInt(quantity) >= 1
                                          ? parseInt(quantity)
                                          : 1,
                                    },
                                  ]);
                                }
                                // commonInsertionLogic([
                                //   {
                                //     productId: productId.trim(),
                                //     quantity:
                                //       quantity &&
                                //         parseInt(quantity) &&
                                //         parseInt(quantity) >= 1
                                //         ? parseInt(quantity)
                                //         : 1,
                                //   },
                                // ]);
                              }
                              setisAvailabiityChecked(false);
                            }}
                            variant="contained"
                            color="primary"
                          >
                            Add to Order Enquiry
                          </Button>
                        </>
                      }
                    </>
                  )}
                  {(customerTierType === "Dealer") && (
                    <>
                      {(annexureEnquiry === "true") && (
                        <>
                          <TextField
                            disabled={
                              ((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") &&
                                accessData?.data?.isRequestPlacedForEnquiry === true &&
                                !isSPRModifyData)
                            }
                            onChange={(e) => setproductId(e.target.value)}
                            autoFocus
                            inputRef={(ref) => inputRefs.push(ref)}
                            onPaste={(e) => {
                              sessionStorage.setItem("viewEnquiry", "");
                              let clipData = e.clipboardData.getData("Text");
                              let clipRows = clipData.split(String.fromCharCode(13));
                              let jsonData: any = [];
                              for (let i = 0; i < clipRows.length - 1; i++) {
                                let [pid, qty] = clipRows[i].split(String.fromCharCode(9));
                                jsonData.push({
                                  productId: pid.replace(/(\r\n|\n|\r)/gm, ""),
                                  quantity: isNumeric(qty) ? qty.toString().slice(0, 5) : 1,
                                });
                              }
                              if (jsonData.length) {
                                if ((isOESOEM || iamMap.current) && annexureEnquiry !== 'true') {
                                  commonInsertionLogicIAMMapping(jsonData);
                                }
                                else {
                                } commonInsertionLogic(jsonData);
                              }
                            }
                            }
                            value={productId}
                            onKeyDown={(e) => {
                              if (e.keyCode === 13 && productId?.trim()) {
                                // if (!isAnnexurePart(productId)) {
                                //   setOpenSnackbarType("error");
                                //   setOpenErrorSnackbar(true);
                                //   setSuccessMessage("We couldn’t find this part number in the Annexure list. Please review your input.");
                                //   handleopenCloseSnackbar(true);
                                //   return;
                                // }
                                if ((isOESOEM || iamMap.current) && annexureEnquiry !== 'true') {
                                  commonInsertionLogicIAMMapping([
                                    {
                                      productId: productId.trim(),
                                      quantity: quantity && parseInt(quantity) >= 1 ? parseInt(quantity) : 1,
                                    },
                                  ]);
                                } else {
                                  commonInsertionLogic([
                                    {
                                      productId: productId.trim(),
                                      quantity: quantity && parseInt(quantity) >= 1 ? parseInt(quantity) : 1,
                                    },
                                  ]);
                                }
                                // commonInsertionLogic([
                                //   {
                                //     productId: productId.trim(),
                                //     quantity: quantity && parseInt(quantity) >= 1 ? parseInt(quantity) : 1,
                                //   },
                                // ]);
                                inputRefs[0]?.focus();
                              }
                              setOpenEnquiry(true)
                            }}
                            size="small"
                            className="col-sm-12 col-md-6 col-ml-7 col-xl-8 pr-3 commonRoundedInputs common-input-font-size"
                            label="Search By Part Number"
                            variant="outlined"
                          />

                          <TextField
                            disabled={
                              ((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") &&
                                accessData?.data?.isRequestPlacedForEnquiry === true &&
                                !isSPRModifyData)
                            }
                            type="text"
                            id="quantity"
                            inputRef={(ref) => inputRefs.push(ref)}
                            onChange={(e) => {
                              let val = parseInt(e.target.value);
                              setquantity(val >= 1 ? val : "");
                            }}
                            onKeyDown={(e) => {
                              if (e.keyCode === 13 && productId?.trim()) {
                                if ((isOESOEM || iamMap.current) && annexureEnquiry !== 'true') {
                                  commonInsertionLogicIAMMapping([
                                    {
                                      productId: productId.trim(),
                                      quantity: quantity && parseInt(quantity) >= 1 ? parseInt(quantity) : 1,
                                    },
                                  ]);
                                } else {
                                  commonInsertionLogic([
                                    {
                                      productId: productId.trim(),
                                      quantity: quantity && parseInt(quantity) >= 1 ? parseInt(quantity) : 1,
                                    },
                                  ]);
                                }

                                inputRefs[0]?.focus();
                              }
                            }}
                            value={quantity}
                            size="small"
                            className="col-sm-6 col-md-3 col-ml-2 col-xl-2 pr-3 commonRoundedInputs common-input-font-size"
                            label="Quantity"
                            inputProps={{ maxLength: 5 }}
                            variant="outlined"
                          />

                          <Button
                            disabled={
                              ((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") &&
                                accessData?.data?.isRequestPlacedForEnquiry === true &&
                                !isSPRModifyData)
                            }
                            className="col-sm-6 col-md-3 col-ml-3 col-xl-2 font-12 addOrderEnqButton"
                            size="small"
                            onClick={() => {
                              // ── NEW: skip everything if the input is blank ─────────────────────────────
                              const trimmedId = productId?.trim() ?? "";
                              if (trimmedId === "") {
                                return; // no validation, no state changes
                              }

                              // ── existing logic (unchanged) ─────────────────────────────────────────────
                              setplaceorderEnabled(false);

                              // if (!isAnnexurePart(trimmedId)) {
                              //   setOpenSnackbarType("error");
                              //   setOpenErrorSnackbar(true);
                              //   setSuccessMessage(
                              //     "We couldn’t find this part number in the Annexure list. Please review your input."
                              //   );
                              //   handleopenCloseSnackbar(true);
                              //   return;
                              // }
                              if ((isOESOEM || iamMap.current) && annexureEnquiry !== 'true') {
                                commonInsertionLogicIAMMapping([
                                  {
                                    productId: trimmedId,
                                    quantity:
                                      quantity && parseInt(quantity) >= 1 ? parseInt(quantity) : 1,
                                  },
                                ]);
                              } else {
                                commonInsertionLogic([
                                  {
                                    productId: trimmedId,
                                    quantity:
                                      quantity && parseInt(quantity) >= 1 ? parseInt(quantity) : 1,
                                  },
                                ]);
                              }

                              setisAvailabiityChecked(false);
                              setOpenEnquiry(true);
                            }}
                            variant="contained"
                            color="primary"
                          >
                            Add to Order Enquiry
                          </Button>
                        </>
                      )}
                    </>
                  )}

                  {customerTierType && customerTierType.toLowerCase() !== "tbl dealer" && customerTierType !== "Dealer" && selectedAccessType === "Parts" && (
                    <>
                      <TextField
                        disabled={customerTierType && customerTierType === "Dealer" &&
                          (((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") && (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true) && !isSPRModifyData) ? true : false)}
                        onChange={(e) => setproductId(e.target.value)}
                        autoFocus
                        inputRef={ref => inputRefs.push(ref)}
                        onPaste={(e) => {
                          let clipData: any = e.clipboardData.getData("Text");
                          let crlf: any =
                            String.fromCharCode(13) + String.fromCharCode(10);
                          let clipRows: any = clipData.split(String.fromCharCode(13));
                          let jsonData: any = [];
                          for (let iRow: any = 0; iRow < clipRows.length - 1; iRow++) {
                            let productId = clipRows[iRow].split(
                              String.fromCharCode(9)
                            )[0];
                            var quantity = isNumeric(
                              clipRows[iRow].split(String.fromCharCode(9))[1]
                            )
                              ? clipRows[iRow].split(String.fromCharCode(9))[1]
                              : 1;
                            jsonData.push({
                              productId: productId.replace(/(\r\n|\n|\r)/gm, ""),
                              quantity: quantity && quantity.toString() && quantity.toString().slice(0, 5),
                            });
                          }
                          if (
                            jsonData &&
                            Array.isArray(jsonData) &&
                            jsonData.length > 0
                          ) {
                            if ((isOESOEM || iamMap.current) && annexureEnquiry !== 'true') {
                              commonInsertionLogicIAMMapping(jsonData);
                            } else {
                              commonInsertionLogic(jsonData);
                            }
                          }
                          setOpenEnquiry(true)
                        }}
                        value={productId}
                        onKeyDown={(e: any) => {
                          const event = e;
                          if (e.keyCode == 13) {
                            if (productId && productId.trim()) {
                              inputRefs[1].focus();
                              event.preventDefault();
                            }
                            // if (productId && productId.trim()) {
                            //   commonInsertionLogic([
                            //     {
                            //       productId: productId.trim(),
                            //       quantity:
                            //         quantity &&
                            //           parseInt(quantity) &&
                            //           parseInt(quantity) >= 1
                            //           ? parseInt(quantity)
                            //           : 1,
                            //     },
                            //   ]);
                            // }
                          }
                          setOpenEnquiry(true)
                        }}
                        size="small"
                        className="col-sm-12 col-md-6 col-ml-7 col-xl-8 pr-3 commonRoundedInputs common-input-font-size"
                        label="Search By Part Number"
                        variant="outlined"
                      />
                      <TextField
                        disabled={customerTierType && customerTierType === "Dealer" &&
                          (((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") && (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true) && !isSPRModifyData) ? true : false)}
                        type="text"
                        id="quantity"
                        inputRef={ref => inputRefs.push(ref)}
                        onChange={(e) => {
                          let value = e.target.value && parseInt(e.target.value) && /^[+]?\d+([.]\d+)?$/.test(e.target.value) &&
                            parseInt(e.target.value) >= 1
                            ? parseInt(e.target.value)
                            : "";
                          setquantity(value);
                        }}
                        onKeyDown={(e: any) => {
                          if (e.keyCode == 13) {
                            if (productId && productId.trim()) {
                              if ((isOESOEM || iamMap.current) && annexureEnquiry !== 'true') {
                                commonInsertionLogicIAMMapping([
                                  {
                                    productId: productId.trim(),
                                    quantity:
                                      quantity &&
                                        parseInt(quantity) &&
                                        parseInt(quantity) >= 1
                                        ? parseInt(quantity)
                                        : 1,
                                  },
                                ]);
                              } else {
                                commonInsertionLogic([
                                  {
                                    productId: productId.trim(),
                                    quantity:
                                      quantity &&
                                        parseInt(quantity) &&
                                        parseInt(quantity) >= 1
                                        ? parseInt(quantity)
                                        : 1,
                                  },
                                ]);
                              }

                              inputRefs[0].focus();
                            }
                          }
                        }}
                        value={quantity}
                        size="small"
                        className="col-sm-6 col-md-3 col-ml-2 col-xl-2 pr-3 commonRoundedInputs common-input-font-size"
                        label="Quantity"
                        inputProps={{ maxLength: 5 }}
                        variant="outlined"
                      />
                      <Button
                        disabled={customerTierType && customerTierType === "Dealer" &&
                          (((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") && (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true) && !isSPRModifyData) ? true : false)}
                        className="col-sm-6 col-md-3 col-ml-3 col-xl-2 font-12 addOrderEnqButton"
                        size="small"
                        onClick={async () => {
                          setisAvailabiityChecked(false);
                          setplaceorderEnabled(false);
                          if (productId && productId.trim()) {
                            if ((isOESOEM || iamMap.current) && annexureEnquiry !== 'true') {
                              commonInsertionLogicIAMMapping([
                                {
                                  productId: productId.trim(),
                                  quantity:
                                    quantity &&
                                      parseInt(quantity) &&
                                      parseInt(quantity) >= 1
                                      ? parseInt(quantity)
                                      : 1,
                                },
                              ]);
                            } else {
                              commonInsertionLogic([
                                {
                                  productId: productId.trim(),
                                  quantity:
                                    quantity &&
                                      parseInt(quantity) &&
                                      parseInt(quantity) >= 1
                                      ? parseInt(quantity)
                                      : 1,
                                },
                              ]);
                            }
                          }
                          setOpenEnquiry(true);
                        }}
                        variant="contained"
                        color="primary"
                      >
                        Add to Order Enquiry
                      </Button>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
          {/* {addedTyreParts === true && customerTierType && customerTierType.toLowerCase() === 'tbl dealer' && selectedAccessType === "Tyres" ? */}
          <div className="row mt-4">
            <div className="col-12">
              <div className="d-flex align-items-center mb-2">
                <h5 className="page-sub-title">
                  Order Enquiry Item List
                  <span className="ml-3 totalCountTextSmallest-header">
                    Total Parts {getTotalCount()}{' '}
                    <ExpandMoreIcon
                      style={{
                        cursor: getTotalCount() > 0 ? 'pointer' : '',
                        color: getTotalCount() > 0 ? undefined : '',
                      }}
                      onClick={() => {
                        if (getTotalCount() <= 0) {
                          setOpenEnquiry(false);
                          setShowSearchBar(false);
                        } else {
                          setOpenEnquiry(!openEnquiry);
                          setShowSearchBar(false);
                        }
                      }}
                    />
                  </span>
                  <input
                    value={referenceNumber}
                    disabled={customerTierType && customerTierType === "Dealer" &&
                      (((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") && (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true) && !isSPRModifyData) ? true : false)}
                    maxLength={35}
                    onChange={(e) => {
                      if (enquiryAction !== "view") {
                        const value = e.target.value || "";

                        setreferenceNumber(value);

                        setbrandRefNumbers((prev: any) => {
                          const updatedState: any = {};

                          Object.keys(prev).forEach((brandId) => {
                            updatedState[brandId] = value;
                          });
                          return updatedState;
                        });
                      }
                    }}

                    type="text"
                    className=" ml-3 referenceNumberText"
                    style={{ width: "220px" }}
                    placeholder="Your reference number"
                  />

                  {enquiryAction === "view" &&
                    enquiryData &&
                    Array.isArray(enquiryData) &&
                    enquiryData.length > 0 &&
                    ((enquiryData[0].status && enquiryData[0].status.toLowerCase() === "enquiry cancelled") || (enquiryData[0].status && enquiryData[0].status.toLowerCase() === "fully cancelled") ||
                      (enquiryData[0].status && enquiryData[0].status.toLowerCase() === "cancel")) && (
                      <span className="text-danger ml-3">
                        Order Enquiry Cancelled
                      </span>
                    )}
                </h5>
                {enquiryAction !== "view" && shouldShowAvailabilityBlock() && (
                  <>
                    <span className="mr-2 commonRoundedInputs">
                      {isAvailabiityChecked && isAvailabiityCheckedAtTime && (
                        <span className="offer px-2 pb-2 font-11 float-left">
                          <span className="px-2">
                            Verified At -{" "}
                            {moment(isAvailabiityCheckedAtTime).tz('Asia/Dubai').format('YYYY-MM-DD HH:mm:ss')}
                          </span>
                          {sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ?
                            (<>
                              {checkAvailabilityButtonText === CHECK_AVAILABILITY_BUTTON_TEXT.NORMAL && !orderQueued && getCounterFSE()}
                            </>)
                            :
                            (<>
                              {checkAvailabilityButtonText === CHECK_AVAILABILITY_BUTTON_TEXT.NORMAL && !orderQueued && getCounter()}
                            </>)
                          }
                        </span>
                      )}
                    </span>
                  </>
                )}
                <div className="ml-auto searchbarOptions">
                  {enquiryAction !== "view" && (
                    <>
                      <span className="mr-2 commonRoundedInputs">
                        {/* <TextField
                          disabled={customerTierType && customerTierType === "Dealer" &&
                            (((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") && (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true) && !isSPRModifyData) ? true : false)}
                          id="availabilityType"
                          select
                          label="Availability Type"
                          variant="outlined"
                          className="availabilityDropdown"
                          size="small"
                          value={availability}
                          onChange={handleAvailabilityChange}
                        >
                          <MenuItem key={1} value="All">
                            All
                          </MenuItem>
                          <MenuItem key={2} value="Now">
                            Now
                          </MenuItem>
                          {customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") ?
                            <MenuItem key={3} value="24">
                              24hrs
                            </MenuItem>
                            : ""}
                          <MenuItem key={4} value="BO">
                            BO
                          </MenuItem>
                        </TextField> */}
                      </span>
                      {/* <span className="mr-2 cursor-pointer"> */}
                      <IconButton
                        disabled={orderQueued || (checkAvailabilityButtonText.toLowerCase() !== CHECK_AVAILABILITY_BUTTON_TEXT.NORMAL.toLowerCase()) ? true : customerTierType && customerTierType === "Dealer" &&
                          (((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") && (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true) && !isSPRModifyData) ? true : false)}
                        className="mr-1 mt-2 pr-2" size="small"
                        onClick={() => {
                          onClickDelete();
                        }}
                      >
                        <DeleteIcon fontSize="inherit" />
                        <span className="font-size-13 load-from-fav ml-1">
                          Delete Selected
                        </span>
                      </IconButton>
                      {sessionStorage.getItem('userType') === 'FSE' && <IconButton
                        disabled={orderQueued || (checkAvailabilityButtonText.toLowerCase() !== CHECK_AVAILABILITY_BUTTON_TEXT.NORMAL.toLowerCase()) ? true : enquiryData && enquiryData[0] && enquiryData[0].isQuotation && enquiryData[0].isQuotation ? true : placeorderEnabled || (isAvailabiityChecked && products.length) ? false : true}
                        className="mr-1 mt-2" size="small"
                        onClick={async () => {
                          let hasDeletions = false;
                          let selected: any = [];
                          let productsTemp: any = JSON.parse(
                            JSON.stringify(products)
                          );
                          // isChangeCheckBox(true);
                          let superseeded: any = productsTemp.filter((p: any) => p.isSuperseeded)
                          productsTemp = productsTemp.filter(
                            (item: any) => {
                              let issuperseededexist: any = superseeded.find((s: any) => s.supercessionMaterial === item.productId && parseInt(s.nsp) > 0);
                              if (issuperseededexist && parseInt(issuperseededexist?.nsp) > 0) {
                                return true
                              } else {
                                if (parseInt(item.nowAvailability) == 0 && !issuperseededexist) {
                                  selected.push(item.productId)
                                  hasDeletions = true;
                                }
                                return parseInt(item.nowAvailability) > 0
                              }
                            }
                          );
                          if (isEnquirySaved) {
                            if (hasDeletions) {
                              setIsInvalidPartsExist(false);
                              await saveUpdateEnquiryOnDeleteUnavailbility(false, true);
                              setplaceorderEnabled(false);
                            }
                          } else {
                            setproducts([...productsTemp]);
                            dispatch(deleteLostSaleReport(customerTierType, selected, enquirySessionId))
                          }
                        }}
                      >
                        <DeleteIcon fontSize="inherit" />
                        <span className="font-size-13 load-from-fav ml-1">
                          Delete Unavailable
                        </span>
                      </IconButton>}
                      {/* </span> */}
                    </>
                  )}

                  {/* {customerTierType && customerTierType === "Dealer" && enquiryAction === "update" && requestSPData && requestSPData.status === "Approved" && requestSPData && requestSPData.expiredAfterApproval === true ? */}
                  {((customerTierType && customerTierType === "Dealer") || customerTypeAccess.includes("TBL Dealer")) && enquiryAction === "update" && showCreateChangeEnquiry ?
                    <span className="cursor-pointer pr-2 pl-2">
                      <IconButton
                        onClick={() => {
                          setshowApproveDialog(true);
                        }}
                        className="mr-1 mt-2" size="small">
                        <span className="font-size-13 re-order-button">
                          Copy & Create New Enquiry
                        </span>
                      </IconButton>
                    </span>
                    : ""}
                  {/* {customerTierType && customerTierType === "Dealer" && enquiryAction === "view" && requestSPData && requestSPData.status === "Approved" && requestSPData && requestSPData.expiredAfterApproval === true ? */}
                  {showCreateChangeEnquiry && (customerTierType && customerTierType === "Dealer") && enquiryAction === "view" && (sessionStorage.getItem('userType') !== 'FSE') ?
                    <span className="cursor-pointer pr-3">
                      <IconButton
                        onClick={() => {
                          setshowApproveDialog(true);
                        }}
                        className="mr-1 mt-2" size="small">
                        <span className="font-size-13 re-order-button">
                          Re-Order Enquiry
                        </span>
                      </IconButton>
                    </span>
                    : ""
                  }
                  {
                    showDownloadEnquiry && products.length > 0 && sessionStorage.getItem('userType') !== 'sre' &&
                    // <span className="cursor-pointer">
                    <IconButton
                      // disabled={customerTierType && customerTierType === "Dealer" &&
                      //   (((requestStatus === "New Request" || requestStatus === "KAM Review" || requestStatus === "Approved" || requestStatus === "Cancelled" || requestStatus === "Timed Out") &&
                      //     (enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "")) ? true : false)}
                      className="mr-3 mt-2" size="small" onClick={() => {
                        exportTablesToExcel()
                      }}>
                      <GetAppIcon fontSize="inherit" />
                      <span className="font-size-13 load-from-fav ml-1">
                        Export Excel
                      </span>
                    </IconButton>
                    // </span>
                  }
                  {enquiryAction !== "view" && (
                    <Tooltip
                      title="Click to refine your search."
                      placement="top"
                      enterDelay={0}         // Tooltip shows immediately on hover/focus
                      leaveDelay={2500}      // Tooltip remains visible for 2.5 seconds after mouse leave
                    >
                      <span className="px-2">
                        <IconButton
                          onClick={async () => {
                            // if (!showFilterMenu) {
                            //   if (sessionStorage.getItem('userType') === 'FSE') {
                            //     const kamEmail = sessionStorage.getItem('email');
                            //     let data: any = await profileservice.getProfile(kamEmail, 'fse');
                            //   } else {
                            //     const b2cUid: any = sessionStorage.getItem('userId');
                            //     const userType: any = sessionStorage.getItem('userType');
                            //     let data: any = await profileservice.getProfile(b2cUid, userType);
                            //   }
                            // }
                            setShowFilterMenu(!showFilterMenu)
                          }
                          }
                          style={{
                            backgroundColor: '#03A9F4', // Bright blue background
                            color: '#ffffff',           // White icon
                            borderRadius: '50%',
                            width: 30,                  // Slightly larger for prominence
                            height: 30,
                            padding: 6,
                            boxShadow: '0 4px 8px rgba(3, 169, 244, 0.6)', // subtle glowing shadow
                            transition: 'box-shadow 0.3s ease',
                          }}
                          onMouseEnter={e => e.currentTarget.style.boxShadow = '0 0 12px 3px rgba(3, 169, 244, 0.85)'}
                          onMouseLeave={e => e.currentTarget.style.boxShadow = '0 4px 8px rgba(3, 169, 244, 0.6)'}
                        >
                          <FilterListIcon style={{ fontSize: 22, color: "#fff" }} />
                        </IconButton>
                      </span>
                    </Tooltip>
                  )}
                  {
                    enquiryAction === "view" &&
                      enquiryData &&
                      Array.isArray(enquiryData) &&
                      enquiryData.length > 0 &&
                      ((enquiryData[0].status && enquiryData[0].status.toLowerCase() === "enquiry cancelled") || (enquiryData[0].status && enquiryData[0].status.toLowerCase() === "fully cancelled") ||
                        (enquiryData[0].status && enquiryData[0].status.toLowerCase() === "cancel")) ?
                      <>
                        {enquiryAction === "view" && (
                          <span className="cursor-pointer">
                            <IconButton
                              // disabled={requestStatus === "New Request"}
                              onClick={() => {
                                // history.goBack();
                                history.push("/orderenquiry");
                              }}
                              className="mr-1 mt-2" size="small">
                              <ArrowBackIosIcon fontSize="inherit" />
                              <span className="font-size-13 load-from-fav">
                                Back to List
                              </span>
                            </IconButton>
                          </span>
                        )}
                      </>
                      :
                      <>
                        {enquiryAction === "view" && showCreateChangeEnquiry && (
                          <>
                            {(customerTierType === "Dealer" && enquiryAction !== "view") && (sessionStorage.getItem('userType') !== 'FSE') ?
                              <span className="cursor-pointer pr-2 pl-2">
                                <IconButton
                                  onClick={() => {
                                    setshowApproveDialog(true);
                                  }}
                                  className="mr-1 mt-2" size="small">
                                  <span className="font-size-13 re-order-button">
                                    Copy & Create New Enquiry
                                  </span>
                                </IconButton>
                              </span>
                              : ""}
                            {sessionStorage.getItem('userType') === 'FSE' ?
                              <span className="cursor-pointer pr-2 pl-2">
                                <IconButton
                                  onClick={() => {
                                    setshowApproveDialog(true);
                                  }}
                                  className="mr-1 mt-2" size="small">
                                  <span className="font-size-13 re-order-button">
                                    Copy & Create New Enquiry
                                  </span>
                                </IconButton>
                              </span>
                              : ""}
                            <span className="cursor-pointer">
                              <IconButton
                                // disabled={requestStatus === "New Request"}
                                onClick={() => {
                                  // history.goBack();
                                  if (quotation) {
                                    history.push("/quotation");
                                  } else {
                                    // history.push("/orderenquiry");
                                    history.goBack();
                                  }
                                }}
                                className="mr-1 mt-2" size="small">
                                <ArrowBackIosIcon fontSize="inherit" />
                                <span className="font-size-13 load-from-fav">
                                  Back to List
                                </span>
                              </IconButton>
                            </span>
                          </>
                        )}
                      </>
                  }
                </div >
              </div >
              {openEnquiry && getTotalCount() > 0 && rowSummaryGlobalData && rowSummaryGlobalData.length > 0 && (
                <div className="cardCommon">
                  <TableContainer
                    component={Paper}
                    style={{
                      // borderRadius: '10px',
                      backgroundColor: '#f9fafe', // <-- UPDATED: light gray like your reference card
                      boxShadow: 'none',
                    }}
                  >
                    <Table
                      id="brandTable"
                      aria-label="Brands Info"
                      style={{
                        width: '100%',
                        tableLayout: 'fixed',
                        borderCollapse: 'collapse',
                      }}
                      className="MuiTable-root"
                    >
                      <TableHead>
                        <TableRow style={{ backgroundColor: '#ededf0ff' }}>
                          <TableCell
                            style={{
                              color: '#201e1eff',
                              fontWeight: 700,
                              fontSize: '16px',
                              paddingTop: '10px',
                              paddingRight: '12px',
                              paddingBottom: '10px',
                              paddingLeft: '24px',
                              borderBottom: '1px solid #d6d5d5ff',
                              width: '15%',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            Brands
                          </TableCell>
                          <TableCell
                            style={{
                              color: '#201e1eff',
                              fontWeight: 700,
                              fontSize: '16px',
                              padding: '10px 12px',
                              borderBottom: '1px solid #d6d5d5ff',
                              width: '15%',
                              whiteSpace: 'nowrap',
                              textAlign: 'left',
                            }}
                          >
                            Parts
                          </TableCell>
                          <TableCell
                            style={{
                              color: '#201e1eff',
                              fontWeight: 700,
                              fontSize: '16px',
                              padding: '10px 12px',
                              borderBottom: '1px solid #d6d5d5ff',
                              width: (() => {
                                const isFseOrSre = sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre';
                                if (!isFseOrSre) return '70%'; // Brands(15%) + Parts(15%) + Internal No.(70%) = 100%
                                const isAA = sessionStorage.getItem('orderCreatedBy') === 'AA';
                                // Brands(15%) + Parts(15%) + Internal No.(?) + Delivery Block Reason(15%) [+ Sales Office(15%) if AA]
                                return isAA ? '40%' : '55%';
                              })(),
                              whiteSpace: 'nowrap',
                              textAlign: 'left',
                            }}
                          >
                            Internal No.
                          </TableCell>

                          {/* Conditionally render Delivery Block Reason header for FSE */}
                          {(sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') && (
                            <TableCell
                              style={{
                                color: '#201e1eff',
                                fontWeight: 700,
                                fontSize: '16px',
                                padding: '10px 12px',
                                borderBottom: '1px solid #e0e0e0',
                                width: '15%',
                                whiteSpace: 'nowrap',
                                textAlign: 'left',
                              }}
                            >
                              Delivery Block Reason
                            </TableCell>
                          )}
                          {/* {(sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') && sessionStorage.getItem("orderCreatedBy") === 'AA' && (
                            <TableCell
                              style={{
                                color: '#201e1eff',
                                fontWeight: 700,
                                fontSize: '16px',
                                padding: '10px 12px',
                                borderBottom: '1px solid #e0e0e0',
                                width: '15%',
                                whiteSpace: 'nowrap',
                                textAlign: 'left',
                              }}
                            >
                              Sales Office
                            </TableCell>
                          )}  */}
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {rowSummaryGlobalData.map((row: any, index: number) => {
                          const brandName = row.brandNameInfo;
                          let enquiryNumber = '';

                          const verificationData = row.verificationDataInfo;

                          const isMultiEnquiryCustomer =
                            customerTierType &&
                            (
                              customerTierType === 'TBL Dealer' ||
                              customerTierType === 'Dealer' ||
                              customerTierType.toLowerCase() === 'government' ||
                              customerTierType.toLowerCase() === 'fleet'
                            );

                          if (enquiryAction === 'view' || enquiryAction === 'update') {
                            const enquirysData = enquiryInfo?.data?.data || [];
                            enquiryNumber = getEnquiryNumber(
                              enquirysData,
                              brandName,
                              isMultiEnquiryCustomer
                            );
                          }

                          const verifiedNumber = getEnquiryNumber(
                            verificationData?.data || [],
                            brandName,
                            isMultiEnquiryCustomer
                          );

                          if (verifiedNumber) {
                            enquiryNumber = verifiedNumber;
                          }

                          return (
                            <TableRow key={index} style={{ backgroundColor: '#ededf0ff' }}>
                              <TableCell
                                style={{
                                  color: '#1A1A1A',
                                  fontSize: '14px',
                                  paddingTop: '10px',
                                  paddingRight: '12px',
                                  paddingBottom: '10px',
                                  paddingLeft: '17px',
                                  borderBottom: '1px solid #d6d5d5ff',
                                }}
                              >
                                {row.brandNameInfo || '—'}
                              </TableCell>
                              <TableCell
                                style={{
                                  color: '#1A1A1A',
                                  fontSize: '14px',
                                  padding: '10px 12px 10px 20px',
                                  borderBottom: '1px solid #d6d5d5ff',
                                  whiteSpace: 'nowrap',
                                  textAlign: 'left',
                                }}
                              >
                                {row.itemCountInfo || 0}
                              </TableCell>
                              <TableCell
                                style={{
                                  color: '#1A1A1A',
                                  fontSize: '14px',
                                  padding: '10px 12px',
                                  borderBottom: '1px solid #d6d5d5ff',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  textAlign: 'left',
                                }}
                              >
                                {enquiryNumber || <span className="px-4">—</span>}
                              </TableCell>

                              {/* Conditionally render Delivery Block Reason field for FSE */}
                              {(sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') && (
                                <TableCell
                                  style={{
                                    padding: '10px 12px',
                                    borderBottom: '1px solid #d6d5d5ff',
                                  }}
                                >
                                  <TextField
                                    id={`deliveryblockreason-${row.brandCodeAsPerTheBrand}`}
                                    select
                                    fullWidth
                                    disabled={enquiryAction === 'view'}
                                    className="rounded-input-dealer pr-3"
                                    required={
                                      (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') &&
                                      customerTierType &&
                                      (
                                        customerTierType.toLowerCase() === 'workshop' ||
                                        customerTierType.toLowerCase() === 'tpcdealer'
                                      ) &&
                                      is24hrExist()
                                    }
                                    label="Delivery block reason"
                                    variant="outlined"
                                    size="small"
                                    InputLabelProps={{ style: { color: '#000000' } }}
                                    value={
                                      deliveryBlockReason[row.brandCodeAsPerTheBrand]?.deliveryBlockReason || ''
                                    }
                                    onChange={(e: any) => {
                                      if (enquiryAction !== 'view') {
                                        setDeliveryBlockReason({
                                          ...deliveryBlockReason,
                                          [row.brandCodeAsPerTheBrand]: {
                                            deliveryBlockReason: e.target.value,
                                            deliveryBlockReasonCode: getDDLCode(
                                              e.target.value,
                                              ddlValues?.data?.data?.deliveryBlockReason || []
                                            ),
                                          },
                                        });
                                      }
                                    }}
                                  >
                                    {ddlValues?.data?.data?.deliveryBlockReason?.map((ddl: any) => (
                                      <MenuItem key={ddl.title} value={ddl.title}>
                                        {ddl.title}
                                      </MenuItem>
                                    ))}
                                  </TextField>
                                </TableCell>
                              )}
                              {/* {sessionStorage.getItem("orderCreatedBy") === 'AA' && (
                                row.brandCodeAsPerTheBrand === '2380' ?
                                  <TableCell
                                    style={{
                                      padding: '10px 12px',
                                      borderBottom: '1px solid #d6d5d5ff',
                                    }}
                                  >
                                    <TextField
                                      id="salesOffice"
                                      select
                                      required
                                      error={salesOfficeError}
                                      label="Sales Office"
                                      variant="outlined"
                                      className="rounded-input-dealer pr-3"
                                      size="small"
                                      fullWidth
                                      InputLabelProps={{
                                        style: { color: '#000000' },
                                      }}
                                      value={salesOffice ? salesOffice : sessionStorage.getItem('teSalesOffice')}
                                      onChange={(e: any) => {
                                        if (enquiryAction !== "view") {
                                          setSalesOffice(e.target.value);
                                          sessionStorage.setItem('teSalesOffice', e.target.value)
                                        }
                                      }}
                                    >
                                      <MenuItem key='E45A' value='E45A'>
                                        E45A
                                      </MenuItem>
                                      <MenuItem key='E45B' value='E45B'>
                                        E45B
                                      </MenuItem>
                                    </TextField>
                                  </TableCell>
                                  :
                                  <TableCell
                                    style={{
                                      color: '#1A1A1A',
                                      fontSize: '14px',
                                      padding: '10px 12px',
                                      borderBottom: '1px solid #d6d5d5ff',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      textAlign: 'left',
                                    }}
                                  >
                                    {<span className="px-4">—</span>}
                                  </TableCell>
                              )} */}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              )}
              <div className="pt-1 pb-1">
              </div>
              <div className="cardCommon filter-panel">
                {
                  showFilterMenu && <FilterMenu
                    hideFilterMenu={hideFilterMenu}
                    profileDetails={profileDetails}
                    products={products}
                    annexureEnquiry={annexureEnquiry === 'true' ? true : false}
                    onApplyFilter={(prefs: any) => setColumnPreferences(prefs)}
                    isOESOEM={(isOESOEM || iamMap.current) && annexureEnquiry !== 'true' ? true : false}
                    isHide24hrs={isTpcWorkshop() ? false : true}
                    rowSummaryGlobalData={rowSummaryGlobalData}
                    columnPreferences={columnPreferences}
                  />
                }
                <div className={sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ? "enquiryDetails-FSE table-wrapper" : "enquiryDetails table-wrapper"} unselectable="on">
                  <TableContainer className={classes.container} style={{ maxHeight: 500 }}>
                    <Table stickyHeader className="MuiTable-root parts-list custom-table" aria-label="Parts Info" key={JSON.stringify(columnPreferences)}>
                      {headerContent}
                      <TableBody>
                        {showSearchBar && (
                          <TableRow>
                            <TableCell colSpan={100}>
                              <div
                                className="px-3"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "12px",
                                  padding: "8px 16px",
                                }}
                              >
                                {/* Search Field */}
                                <TextField
                                  value={searchByPartNo}
                                  onChange={(e) => setSearchByPartNo(e.target.value)}
                                  placeholder="Search by Part No./ Desc"
                                  variant="outlined"
                                  size="small"
                                  className="px-4"
                                  fullWidth
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <SearchIcon fontSize="small" />
                                      </InputAdornment>
                                    ),
                                    style: {
                                      borderRadius: "24px",
                                      backgroundColor: "#f4f4f4",
                                      height: "40px",
                                      fontSize: "14px",
                                      paddingLeft: "14px",
                                    },
                                  }}
                                  style={{ maxWidth: "320px" }} // Matches your UI width
                                />

                                {/* Clear All Button */}
                                <Button
                                  onClick={handleClearSearch}
                                  variant="outlined"
                                  size="small"
                                  style={{
                                    borderRadius: "24px",
                                    padding: "6px 16px",
                                    height: "40px",
                                    minWidth: "90px",
                                    textTransform: "none",
                                    fontWeight: 500,
                                  }}
                                >
                                  Clear all
                                </Button>

                                {/* Collapse Icon */}
                                <IconButton onClick={handleToggleSearch} size="small">
                                  <KeyboardArrowUpIcon fontSize="medium" />
                                </IconButton>
                              </div>
                            </TableCell>
                          </TableRow>
                        )}
                        {renderRows()} {getRenderRowsBrandInfo()}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
                {customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && (
                  <div className="container-fluid">
                    <div className="row tableBottom">
                      <div className="col-lg-2 col-md-2 col-sm-2 p-3 borderRightBottom">
                        <p className="bottomFieldNameTable">
                          Estimated Total (incl. of VAT)
                          <Tooltip title="The Estimated Total here is an approximate and may get rounded off when ordered & billed." placement="top">
                            <HelpIcon className="float-right" fontSize="small" />
                          </Tooltip>
                        </p>
                        {enquiryAction === "view" ? (
                          <p className="bottomFieldValueTable">
                            {(sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') ? `${companyCurrencyTypeByFSE}` : customerTierType === "Int. Business" ? `${companyCurrencyType}` : 'AED'} {parseFloat(getSellingPrice(getViewEstimatedTotal(), isSellingPriceData, markupPercentage)).toFixed(2)}
                          </p>
                        ) : (
                          <p className="bottomFieldValueTable ">
                            {/* AED {parseFloat(getSellingPrice(changeCheckBox ? getEstimatedTotal(true) : estTotal, isSellingPriceData, markupPercentage)).toFixed(2)} */}
                            {(sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') ? `${companyCurrencyTypeByFSE}` : customerTierType === "Int. Business" ? `${companyCurrencyType}` : 'AED'} {parseFloat(getSellingPrice(getEstimatedTotal(isAvailabiityChecked, true), isSellingPriceData, markupPercentage)).toFixed(2)}
                          </p>
                        )}
                        <p className="text-red">
                          {getPlaceOrderTooltipMessage({
                            isAvailabiityChecked,
                            products,
                            annexureEnquiry,
                            selectedCustomerData,
                            annexureMonthlyOrderLimitConfig,
                            isSellingPriceData,
                            markupPercentage,
                            getEstimatedTotal,
                            getSellingPrice,
                            isDisplay: true
                          })}
                        </p>
                      </div>

                      {enquiryAction !== "view" && !importOes && (
                        <NavigationPrompt when={!orderQueued && !isSwitchEnquiryRef.current && ((products.length > 0 && !isEnquirySaved) || (isEnquirySaved && products.length !== actualProductLength) || (isEnquirySaved && isQuantityUpdated) || (products.length > 0 && referenceNumber === ''))}>
                          {({ onConfirm, onCancel }) => (
                            <React.Fragment>
                              <Dialog
                                disableBackdropClick={true}
                                open={true}
                                fullWidth={true}
                                maxWidth={'sm'}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                              >
                                <DialogContent>
                                  <div className={classes.icon}>
                                    <WarningIcon className="delete-warning" fontSize="small" />
                                  </div>
                                  <div>
                                    <DialogContentText id="alert-dialog-description">
                                      <div className={`mt-3 ${classes.logoutText}`}>
                                        {importOes ? (<>
                                          {(isEnquirySaved && products.length !== actualProductLength) || (isEnquirySaved && isQuantityUpdated)
                                            ? `You haven't updated your Enquiry. Please update before importing parts from Catalogue`
                                            : `You haven't saved your Enquiry. Please save before importing parts from Catalogue`}
                                        </>) : (<>
                                          {(isEnquirySaved && products.length !== actualProductLength) || (isEnquirySaved && isQuantityUpdated)
                                            ? 'Your enquiry is not updated, please press Yes to Update your enquiry.'
                                            : 'Your enquiry is not saved, please press Yes to Save your enquiry.'}
                                        </>)}
                                      </div>
                                    </DialogContentText>
                                  </div>
                                </DialogContent>
                                <DialogActions>
                                  <Button
                                    className={`mx-4 ${classes.yes}`}
                                    onClick={async () => {
                                      saveUpdateEnquiry(false);
                                      onCancel();
                                    }}>Yes</Button>
                                  <Button
                                    className={`mr-4 ${classes.cancel}`}
                                    onClick={() => {
                                      // problem parts conflict resolved uncommented the code in problem parts
                                      // if (isEnquirySaved && products.length !== actualProductLength) {
                                      // } else {
                                      //   let partsList: any = products.map((item: any) => {
                                      //     return item.productId.trim();
                                      //   });
                                      //   let searchProduct: any = [];
                                      //   products.map((item: any) => {
                                      //     searchProduct.push({ productId: item.productId.trim(), quantity: item.quantity })
                                      //   })
                                      //   dispatch(searchProducts(customerTierType, partsList, enquirySessionId, firstName, sapCustomerId, b2bUserId, searchProduct));
                                      // }
                                      setproducts([]);
                                      sessionStorage.setItem("partsData", "");
                                      sessionStorage.setItem("isCopyandCreate", "");
                                      onConfirm();
                                    }}>No</Button>
                                </DialogActions>
                              </Dialog>
                            </React.Fragment>
                          )}
                        </NavigationPrompt>
                      )}
                      {enquiryAction !== "view" && importOes && (
                        <NavigationPrompt when={!orderQueued && !isSwitchEnquiryRef.current && ((products.length > 0 && !isEnquirySaved) || (isEnquirySaved && products.length !== actualProductLength) || (isEnquirySaved && isQuantityUpdated) || (products.length > 0 && referenceNumber === ''))}>
                          {({ onConfirm, onCancel }) => (
                            <React.Fragment>
                              <Dialog
                                disableBackdropClick={true}
                                open={true}
                                fullWidth={true}
                                maxWidth={'sm'}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                              >
                                <DialogContent>
                                  <div className={classes.icon}>
                                    <WarningIcon className="delete-warning" fontSize="small" />
                                  </div>
                                  <div>
                                    <DialogContentText id="alert-dialog-description">
                                      <div className={`mt-3 ${classes.logoutText}`}>
                                        {importOes ? (<>
                                          {(isEnquirySaved && products.length !== actualProductLength) || (isEnquirySaved && isQuantityUpdated)
                                            ? `You haven't updated your Enquiry. Please update before importing parts from Catalogue`
                                            : `You haven't saved your Enquiry. Please save before importing parts from Catalogue`}
                                        </>) : (<>
                                          {(isEnquirySaved && products.length !== actualProductLength) || (isEnquirySaved && isQuantityUpdated)
                                            ? 'Your enquiry is not updated, please press Yes to Update your enquiry.'
                                            : 'Your enquiry is not saved, please press Yes to Save your enquiry.'}
                                        </>)}
                                      </div>
                                    </DialogContentText>
                                  </div>
                                </DialogContent>
                                <DialogActions>
                                  <Button
                                    className={`mx-4 ${classes.yes}`}
                                    onClick={async () => {
                                      const data: any = await saveUpdateEnquiry(false);
                                      if (data) {
                                        onConfirm()
                                      } else {
                                        onCancel();
                                      }
                                    }}>
                                    {isEnquirySaved ? 'Update' : `Save`}
                                  </Button>
                                  <Button
                                    className={`mr-4 ${classes.cancel}`}
                                    onClick={() => {
                                      onCancel();
                                      sessionStorage.setItem("partsData", "");
                                      sessionStorage.setItem("isCopyandCreate", "");
                                      setproducts([]);
                                    }}>No</Button>
                                </DialogActions>
                              </Dialog>
                            </React.Fragment>
                          )}
                        </NavigationPrompt>
                      )}
                      {sessionStorage.getItem('userType') !== 'sre' && (
                        <div className="col-lg-2 col-md-2 col-sm-2 p-3 borderRightBottom">
                          <div className="">
                            <div>
                              <p className="">
                                <span className="bottomFieldNameTable text-capitalize mr-4">
                                  Delivery Type</span>
                              </p>
                              {enquiryAction === "view" && !importOes ?
                                <TextField select id="deliveryTypes"
                                  value={deliveryType}
                                  disabled
                                  label="Select Delivery Type" required variant="outlined" margin="dense"
                                  size="small" className="col-sm-12 my-2 commonRoundedInputs hiddenNo" type="number"
                                  error={selectedDeliveryTypeError || invalidSelectedDeliveryType}
                                  helperText={invalidSelectedDeliveryType && <span style={{ color: 'red' }}>Please select the customer type.</span>}
                                  onChange={(e: any) => {
                                    handleChangeDeliveryType(e)
                                  }}
                                >
                                  <MenuItem value={"DLV"}>{"Delivery"}</MenuItem>
                                  <MenuItem value={"SELF-PIC"}>{"Self Pickup"}</MenuItem>
                                </TextField>
                                :
                                <TextField select id="deliveryTypes"
                                  value={deliveryType}
                                  label="Select Delivery Type" required variant="outlined" margin="dense"
                                  disabled={customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && profileDetails?.data?.data?.customerInfo?.deliveryType === "SELF-PIC" ? true : false}
                                  size="small" className="col-sm-12 my-2 commonRoundedInputs hiddenNo" type="number"
                                  error={selectedDeliveryTypeError || invalidSelectedDeliveryType}
                                  helperText={invalidSelectedDeliveryType && <span style={{ color: 'red' }}>Please select the customer type.</span>}
                                  onChange={(e: any) => {
                                    handleChangeDeliveryType(e)
                                  }}
                                >
                                  <MenuItem value={"DLV"}>{"Delivery"}</MenuItem>
                                  <MenuItem value={"SELF-PIC"}>{"Self Pickup"}</MenuItem>
                                </TextField>}
                            </div>
                          </div>
                        </div>
                      )}

                      {/* <div className="col-lg-2 col-md-2 col-sm-2 p-3 borderRightBottom" style={{ backgroundColor: changingDeliveryTypeColor }}>
                      </div> */}
                      <div className="col-lg-2 col-md-2 col-sm-2 p-3 borderRightBottom">
                        <div className="">
                          <div>
                            <p className="">
                              {sessionStorage.getItem('userType') === 'sre' || customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && deliveryType !== "SELF-PIC" ?
                                <span className="bottomFieldNameTable text-capitalize mr-4">Shipping Address</span>
                                : <span className="bottomFieldNameTable text-capitalize mr-4">Collection Point</span>}
                            </p>
                            {customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && deliveryType === "DLV" ?
                              (
                                <>
                                  {/* {isAdminsetDefaultAddress ? (
                                    <TextField select id="multipleAddressData"
                                      disabled={
                                        // customerTierType && customerTierType === "Dealer" && enquiryAction !== "" && enquiryAction !== "" && requestStatus === "New Request" || requestStatus === "KAM Review" || requestStatus === "Approved" || requestStatus === "Cancelled" || requestStatus === "Timed Out" || enquiryAction === "view" &&
                                        enquiryData &&
                                        Array.isArray(enquiryData) &&
                                        enquiryData.length > 0 &&
                                        ((enquiryData[0].status && enquiryData[0].status.toLowerCase() === "enquiry cancelled") || (enquiryData[0].status && enquiryData[0].status.toLowerCase() === "fully cancelled") ||
                                          (enquiryData[0].status && enquiryData[0].status.toLowerCase() === "cancel")) || isViewingFromOrderHistory || enquiryData && enquiryData[0] && enquiryData[0].isQuotation && enquiryData[0].isQuotation}
                                      value={multipleAddressData}
                                      label="Select Address" required variant="outlined" margin="dense"
                                      size="small" className="col-12 my-2 commonRoundedInputs hiddenNo" type="number"
                                      onChange={handleChangeAddress}
                                    >
                                      {newAddressData && newAddressData.length > 0 && newAddressData.map((ele: any, index: any) => (
                                        <MenuItem className="border p-3" key={ele.shiftToPartyCustomerNumber} value={ele.shiftToPartyCustomerNumber}> {`${ele.streetName}, ${ele.region}, ${ele.city}, ${ele.country} ,${ele.postalCode}`} </MenuItem>
                                      ))}
                                    </TextField>
                                  ) : (
                                    <TextField select id="multipleAddressData"
                                      disabled={
                                        // customerTierType && customerTierType === "Dealer" && enquiryAction !== "" && enquiryAction !== "" && requestStatus === "New Request" || requestStatus === "KAM Review" || requestStatus === "Approved" || requestStatus === "Cancelled" || requestStatus === "Timed Out" || enquiryAction === "view" &&
                                        enquiryData &&
                                        Array.isArray(enquiryData) &&
                                        enquiryData.length > 0 &&
                                        ((enquiryData[0].status && enquiryData[0].status.toLowerCase() === "enquiry cancelled") || (enquiryData[0].status && enquiryData[0].status.toLowerCase() === "fully cancelled") ||
                                          (enquiryData[0].status && enquiryData[0].status.toLowerCase() === "cancel")) || isViewingFromOrderHistory || enquiryData && enquiryData[0] && enquiryData[0].isQuotation && enquiryData[0].isQuotation}
                                      value={multipleAddressData}
                                      label="Select Address" required variant="outlined" margin="dense"
                                      size="small" className="col-12 my-2 commonRoundedInputs hiddenNo" type="number"
                                      onChange={handleChangeAddress}
                                    >
                                      {addressData && addressData.length > 0 && addressData.map((ele: any, index: any) => (
                                        <MenuItem className="border p-3" key={ele.shiftToPartyCustomerNumber} value={ele.shiftToPartyCustomerNumber}> {`${ele.streetName}, ${ele.region}, ${ele.city}, ${ele.country} ,${ele.postalCode}`} </MenuItem>
                                      ))}
                                    </TextField>
                                  )} */}
                                  {shipToPartyFeatureAccess ? (
                                    <TextField select id="multipleAddressData"
                                      disabled={
                                        // customerTierType && customerTierType === "Dealer" && enquiryAction !== "" && enquiryAction !== "" && requestStatus === "New Request" || requestStatus === "KAM Review" || requestStatus === "Approved" || requestStatus === "Cancelled" || requestStatus === "Timed Out" || enquiryAction === "view" &&
                                        enquiryData &&
                                        Array.isArray(enquiryData) &&
                                        enquiryData.length > 0 &&
                                        ((enquiryData[0].status && enquiryData[0].status.toLowerCase() === "enquiry cancelled") || (enquiryData[0].status && enquiryData[0].status.toLowerCase() === "fully cancelled") ||
                                          (enquiryData[0].status && enquiryData[0].status.toLowerCase() === "cancel")) || isViewingFromOrderHistory || enquiryData && enquiryData[0] && enquiryData[0].isQuotation && enquiryData[0].isQuotation}
                                      value={multipleAddressData}
                                      label="Select Address" required variant="outlined" margin="dense"
                                      size="small" className="col-12 my-2 commonRoundedInputs hiddenNo" type="number"
                                      onChange={handleChangeAddress}
                                    >
                                      {newAddressData && newAddressData.length > 0 && newAddressData.map((ele: any, index: any) => (
                                        <MenuItem className="border p-3" key={ele.shiftToPartyCustomerNumber} value={ele.shiftToPartyCustomerNumber}>
                                          {`${ele.shiftToPartyCustomerNumber}, ${ele.transportationZone ? `${ele.transportationZone},` : ''} ${ele.location ? `${ele.location},` : ele.companyName ? `${ele.companyName},` : ''} ${ele.city ? `${ele.city},` : ''} ${ele.streetName ? ele.streetName : ''}`}
                                          {/* {`${ele.shiftToPartyCustomerNumber}, ${ele.transportationZone }, ${ele.location ? ele.location : ele.companyName}, ${ele.city} ,${ele.streetName}`} */}
                                        </MenuItem>
                                      ))}
                                      {(sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') && (
                                        <MenuItem value={"OtherAddress"} onClick={(e) => {
                                          handleShippingAddDialog();
                                        }}> Other Address </MenuItem>
                                      )}
                                    </TextField>) : (
                                    <>
                                      <p className="bottomFieldValueTable">
                                        {address ? address : "-"}
                                      </p>
                                    </>
                                  )}
                                </>
                              )
                              :
                              <TextField select id="collectionAddressData"
                                value={collectionAddressData}
                                label="Select Address" required variant="outlined" margin="dense"
                                size="small" className="col-12 my-2 commonRoundedInputs hiddenNo" type="number"
                                onChange={handleChangeAddress}
                              >
                                {collectionPoints && collectionPoints.length > 0 && collectionPoints.map((ele: any) => (
                                  <MenuItem className="border p-3" key={ele.defineTPCounter} value={ele.defineTPCounter}> {ele.defineTPCounter ? ele.defineTPCounter : ""}, {" "} {ele.area ? ele.area : ""}, {" "} {ele.landlinePhone ? "Landline No :" : ""} {" "} {ele.landlinePhone ? ele.landlinePhone : ""} </MenuItem>
                                ))}
                                {/* <MenuItem value={"OtherAddress"} onClick={(e) => {
                                  handleShippingAddDialog();
                                }}> Other Address </MenuItem> */}
                              </TextField>}
                          </div>
                        </div>
                      </div>
                      {customerTierType && customerTierType.toLowerCase() !== "workshop" && customerTierType.toLowerCase() !== "tpcdealer" ?
                        <>
                          <p className="bottomFieldNameTable">Shipping Address</p>
                          <>
                            {/* {isAdminsetDefaultAddress ? (
                              <TextField select id="multipleAddressData"
                                disabled={history.location.pathname == "/viewenquiry" ? true :
                                  // customerTierType && customerTierType === "Dealer" && enquiryAction !== "" && enquiryAction !== "" && requestStatus === "New Request" || requestStatus === "KAM Review" || requestStatus === "Approved" || requestStatus === "Cancelled" || requestStatus === "Timed Out" || enquiryAction === "view" &&
                                  enquiryData &&
                                  Array.isArray(enquiryData) &&
                                  enquiryData.length > 0 &&
                                  ((enquiryData[0].status && enquiryData[0].status.toLowerCase() === "enquiry cancelled") || (enquiryData[0].status && enquiryData[0].status.toLowerCase() === "fully cancelled") ||
                                    (enquiryData[0].status && enquiryData[0].status.toLowerCase() === "cancel")) || isViewingFromOrderHistory || enquiryData && enquiryData[0] && enquiryData[0].isQuotation && enquiryData[0].isQuotation}
                                value={multipleAddressData}
                                label="Select Address" required variant="outlined" margin="dense"
                                size="small" className="col-lg-12 col-md-12 col-sm-12 my-2 commonRoundedInputs hiddenNo" type="number"
                                onChange={handleChangeAddress}
                              >
                                {newAddressData && newAddressData.length > 0 && newAddressData.map((ele: any, index: any) => (
                                  <MenuItem className="border p-3" key={ele.shiftToPartyCustomerNumber} value={ele.shiftToPartyCustomerNumber}> {`${ele.streetName}, ${ele.region}, ${ele.city}, ${ele.country} ,${ele.postalCode}`} </MenuItem>
                                ))}
                              </TextField>
                            ) : (
                              <TextField select id="multipleAddressData"
                                disabled={history.location.pathname == "/viewenquiry" ? true :
                                  // customerTierType && customerTierType === "Dealer" && enquiryAction !== "" && enquiryAction !== "" && requestStatus === "New Request" || requestStatus === "KAM Review" || requestStatus === "Approved" || requestStatus === "Cancelled" || requestStatus === "Timed Out" || enquiryAction === "view" &&
                                  enquiryData &&
                                  Array.isArray(enquiryData) &&
                                  enquiryData.length > 0 &&
                                  ((enquiryData[0].status && enquiryData[0].status.toLowerCase() === "enquiry cancelled") || (enquiryData[0].status && enquiryData[0].status.toLowerCase() === "fully cancelled") ||
                                    (enquiryData[0].status && enquiryData[0].status.toLowerCase() === "cancel")) || isViewingFromOrderHistory || enquiryData && enquiryData[0] && enquiryData[0].isQuotation && enquiryData[0].isQuotation}
                                value={multipleAddressData}
                                label="Select Address" required variant="outlined" margin="dense"
                                size="small" className="col-lg-12 col-md-12 col-sm-12 my-2 commonRoundedInputs hiddenNo" type="number"
                                onChange={handleChangeAddress}
                              >
                                {addressData && addressData.length > 0 && addressData.map((ele: any, index: any) => (
                                  <MenuItem className="border p-3" key={ele.shiftToPartyCustomerNumber} value={ele.shiftToPartyCustomerNumber}> {`${ele.streetName}, ${ele.region}, ${ele.city}, ${ele.country} ,${ele.postalCode}`} </MenuItem>
                                ))}
                              </TextField>
                            )} */}
                            {shipToPartyFeatureAccess ? (
                              <TextField select id="multipleAddressData"
                                disabled={
                                  // customerTierType && customerTierType === "Dealer" && enquiryAction !== "" && enquiryAction !== "" && requestStatus === "New Request" || requestStatus === "KAM Review" || requestStatus === "Approved" || requestStatus === "Cancelled" || requestStatus === "Timed Out" || enquiryAction === "view" &&
                                  enquiryData &&
                                  Array.isArray(enquiryData) &&
                                  enquiryData.length > 0 &&
                                  ((enquiryData[0].status && enquiryData[0].status.toLowerCase() === "enquiry cancelled") || (enquiryData[0].status && enquiryData[0].status.toLowerCase() === "fully cancelled") ||
                                    (enquiryData[0].status && enquiryData[0].status.toLowerCase() === "cancel")) || isViewingFromOrderHistory || enquiryData && enquiryData[0] && enquiryData[0].isQuotation && enquiryData[0].isQuotation}
                                value={multipleAddressData}
                                label="Select Address" required variant="outlined" margin="dense"
                                size="small" className="col-12 my-2 commonRoundedInputs hiddenNo" type="number"
                                onChange={handleChangeAddress}
                              >
                                {newAddressData && newAddressData.length > 0 && newAddressData.map((ele: any, index: any) => (
                                  <MenuItem className="border p-3" key={ele.shiftToPartyCustomerNumber} value={ele.shiftToPartyCustomerNumber}> {`${ele.shiftToPartyCustomerNumber}, ${ele.transportationZone ? ele.transportationZone : ''}, ${ele.location ? ele.location : ele.companyName ? ele.companyName : ''}, ${ele.city ? ele.city : ''} ,${ele.streetName ? ele.streetName : ''}`} </MenuItem>
                                ))}
                              </TextField>) : (
                              <>
                                <p className="bottomFieldValueTable">
                                  {address ? address : "-"}
                                </p>
                              </>
                            )}
                          </>
                        </>
                        : ""}
                      <div className="col-lg-6 col-md-6 col-sm-12 p-3 pb-0 borderBottom d-flex justify-content-end" >
                        {
                          customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && getIsAirAvalibityExistCount() > 0 ?
                            <p className="pt-2 bottomFieldMessage">
                              {`Note: For ordering item quantities in BO (Back Order), please contact your nearest Al Futtaim Trade Point Counter at ${dlEmails}`}
                            </p> : ""
                        }
                      </div>
                    </div>
                  </div>
                )}
                {isAccess() && (
                  <div className="container-fluid">
                    <div className="row tableBottom">
                      <div className="col-lg-3 col-md-3 col-sm-6 p-3 borderRightBottom">
                        <p className="bottomFieldNameTable">
                          Estimated Total (incl. of VAT)
                          <Tooltip title="The Estimated Total here is an approximate and may get rounded off when ordered & billed." placement="top">
                            <HelpIcon className="float-right" fontSize="small" />
                          </Tooltip>
                        </p>
                        {enquiryAction === "view" ? (
                          <p className="bottomFieldValueTable">
                            {(sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') ? `${companyCurrencyTypeByFSE}` : customerTierType && customerTierType.toLowerCase() === "int. business" ? `${companyCurrencyType}` : 'AED'} {parseFloat(getSellingPrice(getViewEstimatedTotal(), isSellingPriceData, markupPercentage)).toFixed(2)}
                          </p>
                        ) : (
                          <p className="bottomFieldValueTable ">
                            {(sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') ? `${companyCurrencyTypeByFSE}` : customerTierType && customerTierType.toLowerCase() === "int. business" ? `${companyCurrencyType}` : 'AED'} {parseFloat(getSellingPrice(getEstimatedTotal(isAvailabiityChecked, true), isSellingPriceData, markupPercentage)).toFixed(2)}
                            {/* AED {parseFloat(getSellingPrice(changeCheckBox ? getEstimatedTotal(true) : estTotal, isSellingPriceData, markupPercentage)).toFixed(2)} */}
                          </p>
                        )}
                        <p className="text-red">
                          {getPlaceOrderTooltipMessage({
                            isAvailabiityChecked,
                            products,
                            annexureEnquiry,
                            selectedCustomerData,
                            annexureMonthlyOrderLimitConfig,
                            isSellingPriceData,
                            markupPercentage,
                            getEstimatedTotal,
                            getSellingPrice,
                            isDisplay: true
                          })}
                        </p>
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-6 p-3 borderRightBottom">
                        <div className="d-flex">
                          <div>
                            {
                              customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && deliveryType === "DLV" ?
                                <>
                                  <p className="bottomFieldNameTable">Shipping Address</p>
                                  <p className="bottomFieldValueTable">
                                    {address ? address : "-"}
                                  </p>
                                </>
                                :
                                deliveryType === "SELF-PIC" ?
                                  <>
                                    <p className="bottomFieldNameTable">Collection Point</p>
                                    <p className="bottomFieldValueTable">
                                      {collectionPoints && collectionPoints.length > 0 && collectionPoints.map((ele: any) => {
                                        return <p> {ele.defineTPCounter ? ele.defineTPCounter : ""}, {" "} {ele.area ? ele.area : ""}, {" "} {ele.landlinePhone ? "Landline No :" : ""} {" "} {ele.landlinePhone ? ele.landlinePhone : ""} </p>
                                      })}
                                    </p>
                                  </>
                                  :
                                  <>
                                    {/* <p className="bottomFieldNameTable">Shipping Address</p>
                                      <p className="bottomFieldValueTable">
                                        {address ? address : "-"}
                                      </p> */}
                                  </>
                            }
                          </div>
                        </div>
                        {customerTierType && customerTierType.toLowerCase() !== "workshop" && customerTierType.toLowerCase() !== "tpcdealer" ?
                          <>
                            <p className="bottomFieldNameTable">Shipping Address</p>
                            {shipToPartyFeatureAccess ? (
                              <TextField select id="deliveryTypes"
                                disabled={history.location.pathname == "/viewenquiry" ? true :
                                  enquiryData &&
                                  Array.isArray(enquiryData) &&
                                  enquiryData.length > 0 &&
                                  ((enquiryData[0].status && enquiryData[0].status.toLowerCase() === "enquiry cancelled") || (enquiryData[0].status && enquiryData[0].status.toLowerCase() === "fully cancelled") ||
                                    (enquiryData[0].status && enquiryData[0].status.toLowerCase() === "cancel")) || isViewingFromOrderHistory || enquiryData && enquiryData[0] && enquiryData[0].isQuotation && enquiryData[0].isQuotation}
                                value={multipleAddressData}
                                label="Select Address" required variant="outlined" margin="dense"
                                size="small" className="col-lg-12 col-md-12 col-sm-12 my-2 commonRoundedInputs hiddenNo" type="number"
                                onChange={handleChangeAddress}
                              >
                                {newAddressData && newAddressData.length > 0 && newAddressData.map((ele: any, index: any) => (
                                  <MenuItem className="border p-3" key={ele.shiftToPartyCustomerNumber} value={ele.shiftToPartyCustomerNumber}>
                                    {`${ele.shiftToPartyCustomerNumber}, ${ele.transportationZone ? `${ele.transportationZone},` : ''} ${ele.location ? `${ele.location},` : ele.companyName ? `${ele.companyName},` : ''} ${ele.city ? `${ele.city},` : ''} ${ele.streetName ? ele.streetName : ''}`}
                                    {/* {`${ele.shiftToPartyCustomerNumber}, ${ele.transportationZone ? ele.transportationZone : ''}, ${ele.location ? ele.location : ele.companyName ? ele.companyName : ''}, ${ele.city ? ele.city : ''} ,${ele.streetName ? ele.streetName : ''}`} */}
                                  </MenuItem>
                                ))}
                                {(sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') && (
                                  <MenuItem value={"OtherAddress"} onClick={(e) => {
                                    handleShippingAddDialog();
                                  }}> Other Address </MenuItem>
                                )}

                              </TextField>
                            ) : (
                              <>
                                <p className="bottomFieldValueTable">
                                  {address ? address : "-"}
                                </p>
                              </>
                            )}
                          </> : ""}
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12 p-3 pb-0 borderBottom d-flex justify-content-end">
                        {isTpcDealer === true ?
                          <p className="pt-2 bottomFieldMessage-confirm-order">
                            {`To follow up on the status of your Confirmed Order, please contact your nearest Trade Point Counter at  (${TPCRegionDetails && TPCRegionDetails.email ? TPCRegionDetails.email : ""}) or (${TPCRegionDetails && TPCRegionDetails.Phone ? TPCRegionDetails.Phone : ""}).`}
                          </p>
                          : ''}
                      </div>
                    </div >
                  </div >
                )
                }
                {/* {sessionStorage.getItem('userType') !== 'FSE' ? */}
                <div className="col-12 container-fluid borderTop">
                  <div className="row tableBottom">
                    {!isShowSPR() || currentTier === "" || annexureEnquiry === 'true' || sessionStorage.getItem('userType') === 'sre' ?
                      <div className={(sessionStorage.getItem('userType') !== "FSE" && sessionStorage.getItem('userType') !== 'sre' && customerTierType && customerTierType.toLowerCase() === "government") || (sessionStorage.getItem('userType') !== "FSE" && customerTierType && customerTierType.toLowerCase()) === "fleet" ? "col-lg-2 col-md-2 col-sm-12 p-3 borderTop" : sessionStorage.getItem('userType') === 'FSE' ? "col-lg-2 col-md-2 col-sm-6 p-3 borderTop" : sessionStorage.getItem('userType') === "FSE" && customerTierType && customerTierType === "Government" || customerTierType && customerTierType === "Fleet" ? "col-lg-4 col-md-4 col-sm-9 p-3 borderTop" : "col-lg-3 col-md-3 col-sm-8 p-3 borderTop"}>
                      </div> :
                      <div className={(sessionStorage.getItem('userType') !== "FSE" && customerTierType && customerTierType.toLowerCase() === "government") || (sessionStorage.getItem('userType') !== "FSE" && customerTierType && customerTierType.toLowerCase()) === "fleet" ? "col-lg-2 col-md-2 col-sm-12 p-3 borderTop" : sessionStorage.getItem('userType') === 'FSE' ? "col-lg-2 col-md-2 col-sm-6 p-3 borderTop" : sessionStorage.getItem('userType') === "FSE" && customerTierType && customerTierType === "Government" || customerTierType && customerTierType === "Fleet" ? "col-lg-4 col-md-4 col-sm-9 p-3 borderTop" : "col-lg-3 col-md-3 col-sm-8 p-3"}>
                        {customerTierType && customerTierType.toLowerCase() === "dealer" && userType === 'Admin' ?
                          <Button
                            className={`ml-2 font-size-11 ${(isAvailabiityChecked && products.length > 0) || (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true)
                              ? "actionButtomButtomsBlue"
                              : "actionButtomButtomsGrey text-black"
                              }`}
                            disabled={enquiryAction === "view" || orderQueued ? true : accessData && accessData.data && accessData.data.currentTier === "Silver" || ((accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === false) && (accessData && accessData.data && accessData.data.ableToPlaceSpecialRequest === false)) || ((requestStatus && requestStatus !== "inPrgress") && accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true)}
                            // old disabled
                            // disabled={((placeorderEnabled && isAvailabiityChecked && products.length > 0 && getEstimatedTotal(isAvailabiityChecked) >= 35000
                            //   && accessData && accessData.data && accessData.data.ableToPlaceSpecialRequest === false)
                            //   || (accessData && accessData.data && accessData.data.currentTier === "Silver") && (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === false))
                            // }
                            onClick={async () => {
                              let total: any = await getEstimatedTotal(isAvailabiityChecked);
                              if (total < 35000) {
                                setIsEstimatedTotalIsLess(true)
                                return true
                              }
                              // if (procuredPart && procuredPart.length > 0) {
                              //   setHideZeroMessage(true);
                              //   openZeroPricePopup(true);
                              //   return true;
                              // }
                              if (materialNotExtendedPart && materialNotExtendedPart.length > 0) {
                                setHideZeroMessage(true);
                                openZeroPricePopup(true);
                                return true;
                              }
                              if ((viewSpecialPriceDetails && viewSpecialPriceDetails.data && viewSpecialPriceDetails.data.data && viewSpecialPriceDetails.data.data.data && viewSpecialPriceDetails.data.data.data[0] && viewSpecialPriceDetails.data.data.data[0].status !== "Cancelled") && isSPRModifyData) {
                                let data: any = await dispatch(getViewRequestStatusAPI(enquiryData && Array.isArray(enquiryData) && enquiryData[0].B2bEnquiryId ? enquiryData[0].B2bEnquiryId : ""))

                                if (data && data.data.length !== 0) {
                                  history.push("editrequestspecialprice")
                                }
                                return true
                              }
                              if (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true && enquiryAction !== "") {
                                dispatch(getViewRequestStatusAPI(enquiryData && Array.isArray(enquiryData) && enquiryData[0].B2bEnquiryId ? enquiryData[0].B2bEnquiryId : ""))
                                history.push('/viewrequeststatus')
                                return true;
                              }
                              let hasDeletions = false;
                              let selected: any = [];
                              let newArr: any = [];
                              let productsTemp: any = JSON.parse(
                                JSON.stringify(products)
                              );
                              productsTemp.filter(
                                (p: any) => {
                                  if (p.nowAvailabilityChecked === false && p.airAvailabilityChecked === false) {
                                    selected.push(p.productId)
                                    hasDeletions = true;
                                  } else {
                                    newArr.push(p);
                                  }
                                }
                              );
                              await setproducts([...newArr]);
                              await dispatch(selectedParts(newArr, parseFloat(getSellingPrice(getViewEstimatedTotal(), isSellingPriceData, markupPercentage)).toFixed(2), enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].B2bEnquiryId ? enquiryData[0].B2bEnquiryId : ""));
                              if (isEnquirySaved) {
                                if (hasDeletions) {
                                  await saveUpdateEnquiry(false, true, newArr);
                                  parseFloat(getSellingPrice(getViewEstimatedTotal(), isSellingPriceData, markupPercentage)).toFixed(2)
                                  history.push('/requestspecialprice');
                                } else {
                                  parseFloat(getSellingPrice(getViewEstimatedTotal(), isSellingPriceData, markupPercentage)).toFixed(2)
                                  history.push('/requestspecialprice');
                                }
                              }
                            }}
                            color="primary"
                            variant="contained"
                          >
                            Request Special Price
                          </Button> : null
                        }
                      </div>
                    }
                    {sessionStorage.getItem('userType') !== 'FSE' && sessionStorage.getItem('userType') !== 'sre' && customerTierType && customerTierType.toLowerCase() === 'tbl dealer' ?
                      <div className={"p-2 borderBottom px-5"}></div> :
                      sessionStorage.getItem('userType') === 'FSE' ?
                        <>
                          {annexureEnquiry === "true" ? "" :
                            <div className={"p-2 borderBottom"}>
                              <Button
                                className={`ml-2 mt-3 font-size-11 ${(placeorderEnabled && isAvailabiityChecked && products.length > 0 && !orderQueued)
                                  ? "actionButtomButtomsBlue"
                                  : "actionButtomButtomsBlue actionButtomButtomsBlueDisabled"
                                  }`}
                                disabled={orderQueued || isDisableQuotation || isQuantityUpdated || isDeleted || enquiryData && enquiryData[0] && enquiryData[0].isQuotation && enquiryData[0].isQuotation ? true : placeorderEnabled && isAvailabiityChecked && products.length ? false : true}
                                color="primary"
                                variant="contained"
                                onClick={() => {
                                  if (isAvailabiityChecked && sessionStorage.getItem('userType') === 'FSE' && customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer") && is24hrExist()) {
                                    requestQuotationHandler();
                                  } else {
                                    requestQuotationHandler();
                                  }
                                  // setShowRequestQuotationDialog(true);
                                }}
                              >
                                Request Quotation
                              </Button>
                            </div>
                          }
                        </>
                        :
                        <></>
                    }

                    {!isShowSPR() || currentTier === "" || sessionStorage.getItem('userType') === 'sre' ?
                      <div className={(sessionStorage.getItem('userType') !== "FSE" && customerTierType && customerTierType.toLowerCase() === "government") || (sessionStorage.getItem('userType') !== "FSE" && customerTierType && customerTierType.toLowerCase()) === "fleet" ? "p-3 " : sessionStorage.getItem('userType') === 'FSE' ? "" : sessionStorage.getItem('userType') === "FSE" && customerTierType && customerTierType === "Government" || customerTierType && customerTierType === "Fleet" ? "" : customerTierType && customerTierType === "Workshop" ? "" : customerTierType && customerTierType === "tpcdealer" ? "" : customerTierType && customerTierType.toLowerCase() === 'tbl dealer' ? "" : customerTierType && customerTierType === "Dealer" ? "" : "col-lg-3 col-md-3 col-sm-3 p-3 borderRightBottom"}>
                      </div> :
                      <div className={(sessionStorage.getItem('userType') !== "FSE" && customerTierType && customerTierType.toLowerCase() === "government") || (sessionStorage.getItem('userType') !== "FSE" && customerTierType && customerTierType.toLowerCase()) === "fleet" ? "p-3 " : sessionStorage.getItem('userType') === 'FSE' ? "" : sessionStorage.getItem('userType') === "FSE" && customerTierType && customerTierType === "Government" || customerTierType && customerTierType === "Fleet" ? "" : customerTierType && customerTierType === "Workshop" ? "" : customerTierType && customerTierType === "tpcdealer" ? "" : customerTierType && customerTierType.toLowerCase() === 'tbl dealer' ? "" : customerTierType && customerTierType === "Dealer" ? "" : customerTierType && customerTierType === "tpcdealer" ? "" : "col-lg-2 col-md-2 col-sm-2 p-3 borderRightBottom"}>
                        {
                          customerTierType && customerTierType === "Dealer" && accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true && (requestStatus === "New Request" || requestStatus === "KAM Review" || requestStatus === "Approved" || requestStatus === "Cancelled" || requestStatus === "Timed Out" || requestStatus === "Rejected") ?
                            <div className="d-flex mt-2">
                              {accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true && enquiryAction !== "" ?
                                <Button
                                  // disabled={!_.get(accessData, 'data.isRequestPlacedForEnquiry', false)}
                                  disabled={accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === false}
                                  className="bottomFieldNameTable-view-price cursor-pointer"
                                  onClick={async () => {
                                    // saveUpdateEnquiry(true);
                                    dispatch(getViewRequestStatusAPI(enquiryData && Array.isArray(enquiryData) && enquiryData[0].B2bEnquiryId ? enquiryData[0].B2bEnquiryId : ""))
                                    history.push('/viewrequeststatus')
                                  }}> View Request Status</Button>
                                : ""}
                            </div> : null
                        }

                      </div>
                    }
                    {sessionStorage.getItem('userType') === "FSE" || sessionStorage.getItem('userType') === 'sre' || annexureEnquiry === 'true' ? "" :
                      <>
                        {customerTierType && customerTierType === "Government" || customerTierType && customerTierType === "Fleet" ?
                          <div className="p-3">
                            <Button
                              className={`ml-2 mt-1 font-size-11 ${(placeorderEnabled && isAvailabiityChecked && products.length > 0)
                                ? "actionButtomButtomsBlue"
                                : "actionButtomButtomsBlue actionButtomButtomsBlueDisabled"
                                }`}
                              disabled={orderQueued || isDisableQuotation || isQuantityUpdated || isDeleted || enquiryData && enquiryData[0] && enquiryData[0].isQuotation && enquiryData[0].isQuotation ? true : placeorderEnabled && isAvailabiityChecked && products.length ? false : true}
                              color="primary"
                              variant="contained"
                              onClick={() => {
                                requestQuotationHandler();
                                // setShowRequestQuotationDialog(true);
                              }}
                            >
                              Request Quotation
                            </Button>
                          </div> : null}
                      </>
                    }
                    <div className="borderBottom">
                      {(
                        <div className="d-flex justify-content-end p-3 pb-0">
                          <NavigationPrompt when={!orderQueued && ((products.length > 0 && !isEnquirySaved) || (isEnquirySaved && products.length !== actualProductLength) || (isEnquirySaved && isQuantityUpdated) || (products.length > 0 && referenceNumber === ''))}>
                            {({ onConfirm, onCancel }) => (
                              <React.Fragment>
                                <Dialog
                                  disableBackdropClick={true}
                                  open={true}
                                  fullWidth={true}
                                  maxWidth={'sm'}
                                  aria-labelledby="alert-dialog-title"
                                  aria-describedby="alert-dialog-description"
                                >
                                  <DialogContent>
                                    <div className={classes.icon}>
                                      <WarningIcon className="delete-warning" fontSize="small" />
                                    </div>
                                    <div>
                                      <DialogContentText id="alert-dialog-description">
                                        <div className={`mt-3 ${classes.logoutText}`}>
                                          {
                                            (isEnquirySaved && products.length !== actualProductLength) || (isEnquirySaved && isQuantityUpdated)
                                              ? 'Your enquiry is not updated, please press Yes to Update your enquiry.'
                                              : 'Your enquiry is not saved, please press Yes to Save your enquiry.'
                                          }
                                        </div>
                                      </DialogContentText>
                                    </div>
                                  </DialogContent>
                                  <DialogActions>
                                    <><Button
                                      className={`mx-4 `}
                                      onClick={async () => {
                                        saveUpdateEnquiry(false);
                                        onCancel();
                                      }}>Yes</Button>
                                      <Button
                                        className={`mr-4 ${classes.cancel}`}
                                        onClick={() => {
                                          // problem parts conflcit resolved, un commented onclick function in current change the below code is commented
                                          // if (isEnquirySaved && products.length !== actualProductLength) {
                                          // } else {
                                          //   let partsList: any = products.map((item: any) => {
                                          //     return item.productId.trim();
                                          //   });
                                          //   let searchProduct: any = [];
                                          //   products.map((item: any) => {
                                          //     searchProduct.push({ productId: item.productId.trim(), quantity: item.quantity })
                                          //   })
                                          //   dispatch(searchProducts(customerTierType, partsList, enquirySessionId, firstName, sapCustomerId, b2bUserId, searchProduct));
                                          // }
                                          sessionStorage.setItem("partsData", "");
                                          sessionStorage.setItem("isCopyandCreate", "");
                                          setproducts([]);
                                          onConfirm();
                                        }}>No</Button></>
                                  </DialogActions>
                                </Dialog>
                              </React.Fragment>
                            )}
                          </NavigationPrompt>
                          {sessionStorage.setItem('Order-log-UnReadCount', getOrderLogsDetails && getOrderLogsDetails.data && getOrderLogsDetails.data.length > 0 && getOrderLogsDetails.data[0].unReadCount && getOrderLogsDetails && getOrderLogsDetails.data && getOrderLogsDetails.data.length > 0 && getOrderLogsDetails.data[0].unReadCount)}
                          {sessionStorage.setItem('Order-log-ReadCount', getOrderLogsDetails && getOrderLogsDetails.data && getOrderLogsDetails.data.length > 0 && getOrderLogsDetails.data[0].readCount && getOrderLogsDetails && getOrderLogsDetails.data && getOrderLogsDetails.data.length > 0 && getOrderLogsDetails.data[0].readCount)}
                          {(annexureEnquiry === "true" && sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') ? <> <div className="p-3"></div><div className="p-3"></div> <div className="p-3"></div><div className="p-3"></div> </> :
                            (annexureEnquiry === "true" && sessionStorage.getItem('userType') !== 'FSE' && sessionStorage.getItem('userType') !== 'sre') ? <> <div className="p-3"></div> </> :
                              <div className={"mr-3"}>
                                {resetOrderLogCount === "false" && getOrderLogsDetails && getOrderLogsDetails.data && getOrderLogsDetails.data.length > 0 && getOrderLogsDetails.data[0].unReadCount && getOrderLogsDetails && getOrderLogsDetails.data && getOrderLogsDetails.data.length > 0 && getOrderLogsDetails.data[0].unReadCount !== 0 && getLatestOrderCount === false ?
                                  <>
                                    {getOrderLogsDetails && getOrderLogsDetails.data && getOrderLogsDetails.data.length > 0 && getOrderLogsDetails.data[0].unReadCount && getOrderLogsDetails && getOrderLogsDetails.data && getOrderLogsDetails.data.length > 0 && getOrderLogsDetails.data[0].unReadCount !== 0 ?
                                      <Tooltip title="Please do Check Availability & Price to check the updated logs." placement="top">
                                        <Badge
                                          badgeContent={
                                            enquiryData &&
                                              enquiryData[0] &&
                                              enquiryData[0].B2bEnquiryId
                                              ? getOrderLogCount(getOrderLogsDetails)
                                              : null
                                          }
                                          color="error"
                                        >
                                          <Button
                                            className={`ml-1 font-size-11 ${enquiryAction === "view" ? "actionButtonForOrderLog" : (placeorderEnabled && isAvailabiityChecked && products.length > 0 && !orderQueued)
                                              ? "actionButtonForOrderLog"
                                              : "actionButtonForOrderLog actionButtomButtomsBlueDisabled"
                                              }`}
                                            // disabled={enquiryAction === "view" ? false : orderQueued || isDisableQuotation || isQuantityUpdated || isDeleted || procuredPartExist || enquiryData && enquiryData[0] && enquiryData[0].isQuotation && enquiryData[0].isQuotation ? true : placeorderEnabled && isAvailabiityChecked && products.length ? false : true}
                                            disabled={enquiryAction === "view" ? false : getOrderLogsDetails && getOrderLogsDetails.data && getOrderLogsDetails.data.length > 0 ? false : isAvailabiityChecked && products.length > 0 ? false : true}
                                            variant="contained"
                                            onClick={async () => {
                                              checkOrderLogs();
                                              // let data: any = await dispatch(getOrderLogsLatestCount(enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].B2bEnquiryId));
                                              let data: any = await dispatch(getEnquiryDetails(customerTierType,
                                                enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].B2bEnquiryId,
                                                (enquiryAction === "view" && orderType !== "Cancelled" && !quotation) ? true : false, quotation ? true : false, true
                                              ));
                                              await getOrderLogsData(data?.data);
                                              let rmpro: any = await getRemovedProducts(data?.data?.data);
                                              setInvalidParts(rmpro && rmpro.length > 0 ? rmpro : data?.data?.data[0].removedProducts ? data?.data?.data[0].removedProducts : []);
                                              setRemovedProductsLength(rmpro && rmpro.length > 0 ? rmpro.length : data?.data?.data[0].removedProducts?.length)

                                              // setInvalidParts(data?.data?.data[0].removedProducts ? data?.data?.data[0].removedProducts : []);
                                              // setRemovedProductsLength(data?.data?.data[0].removedProducts?.length)

                                              // if (data && data.message && data.message.status === "E") {
                                              //   setTimeout(() => {
                                              //     setOpenSnackbarType("error");
                                              //     setOpenErrorSnackbar(true);
                                              //     setSuccessMessage(data && data.message && data.message.message && data.message.message);
                                              //     handleopenCloseSnackbar(true);
                                              //   }, 2000)
                                              // }
                                            }}
                                          >
                                            Order Log
                                          </Button>
                                        </Badge>
                                      </Tooltip>
                                      :
                                      <Badge badgeContent={getOrderLogCount(getOrderLogsDetails)} color="error">
                                        <Button
                                          className={`ml-1 font-size-11 ${enquiryAction === "view" ? "actionButtonForOrderLog" : (placeorderEnabled && isAvailabiityChecked && products.length > 0 && !orderQueued)
                                            ? "actionButtonForOrderLog"
                                            : "actionButtonForOrderLog actionButtomButtomsBlueDisabled"
                                            }`}
                                          // disabled={enquiryAction === "view" ? false : orderQueued || isDisableQuotation || isQuantityUpdated || isDeleted || procuredPartExist || enquiryData && enquiryData[0] && enquiryData[0].isQuotation && enquiryData[0].isQuotation ? true : placeorderEnabled && isAvailabiityChecked && products.length ? false : true}
                                          disabled={enquiryAction === "view" ? false : getOrderLogsDetails && getOrderLogsDetails.data && getOrderLogsDetails.data.length > 0 && getOrderLogsDetails.data[0].unReadCount && getOrderLogsDetails.data[0].unReadCount !== 0 ? false : isAvailabiityChecked && products.length > 0 ? false : true}
                                          variant="contained"
                                          onClick={async () => {
                                            checkOrderLogs();
                                            let data: any = await dispatch(getEnquiryDetails(customerTierType,
                                              enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].B2bEnquiryId,
                                              (enquiryAction === "view" && orderType !== "Cancelled" && !quotation) ? true : false, quotation ? true : false, true
                                            ));
                                            await getOrderLogsData(data?.data);

                                            let rmpro: any = await getRemovedProducts(data?.data?.data);
                                            setInvalidParts(rmpro && rmpro.length > 0 ? rmpro : data?.data?.data[0].removedProducts ? data?.data?.data[0].removedProducts : []);
                                            setRemovedProductsLength(rmpro && rmpro.length > 0 ? rmpro.length : data?.data?.data[0].removedProducts?.length)

                                            // setInvalidParts(data?.data?.data[0].removedProducts ? data?.data?.data[0].removedProducts : []);
                                            // setRemovedProductsLength(data?.data?.data[0].removedProducts?.length) // let data: any = await dispatch(getOrderLogsLatestCount(enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].B2bEnquiryId));
                                          }}
                                        >
                                          Order Log
                                        </Button>
                                      </Badge>
                                    }
                                  </>
                                  :
                                  <>
                                    <Badge badgeContent={orderLogBadgeCount} color="error">
                                      <Button
                                        className={`ml-2 font-size-11 ${enquiryAction === "view" ? "actionButtonForOrderLog" : (placeorderEnabled && isAvailabiityChecked && products.length > 0)
                                          ? "actionButtonForOrderLog"
                                          : "actionButtonForOrderLog actionButtomButtomsBlueDisabled"
                                          }`}
                                        // disabled={enquiryAction === "view" ? false : orderQueued || isDisableQuotation || isQuantityUpdated || isDeleted || procuredPartExist || enquiryData && enquiryData[0] && enquiryData[0].isQuotation && enquiryData[0].isQuotation ? true : placeorderEnabled && isAvailabiityChecked && products.length ? false : true}
                                        disabled={enquiryAction === "view" ? false : isAvailabiityChecked && products.length > 0 ? false : true}
                                        variant="contained"
                                        onClick={async () => {
                                          checkOrderLogs();
                                          let data: any = await dispatch(getEnquiryDetails(customerTierType,
                                            enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].B2bEnquiryId,
                                            (enquiryAction === "view" && orderType !== "Cancelled" && !quotation) ? true : false, quotation ? true : false, true
                                          ));
                                          await getOrderLogsData(data?.data);
                                          // setOrderLogBadgeCount(0);

                                          let rmpro: any = await getRemovedProducts(data?.data?.data);
                                          setInvalidParts(rmpro && rmpro.length > 0 ? rmpro : data?.data?.data[0].removedProducts ? data?.data?.data[0].removedProducts : []);
                                          setRemovedProductsLength(rmpro && rmpro.length > 0 ? rmpro.length : data?.data?.data[0].removedProducts?.length)

                                          // setInvalidParts(data?.data?.data[0].removedProducts ? data?.data?.data[0].removedProducts : []);
                                          // setRemovedProductsLength(data?.data?.data[0].removedProducts?.length)  // let data: any = await dispatch(getOrderLogsLatestCount(enquiryData && Array.isArray(enquiryData) && enquiryData.length > 0 && enquiryData[0].B2bEnquiryId));
                                        }}
                                      >
                                        Order Log
                                      </Button>
                                    </Badge>
                                  </>
                                }
                              </div>
                          }
                          {
                            showUpdateEnquiry && <Button
                              onClick={async () => {
                                // Delete any unresolved (isAddToEnquiry === false) Tyre-search
                                // rows on Save/Update Order Enquiry too — same cleanup the
                                // Check Availability and Price button already does.
                                saveUpdateEnquiry(false, null, null, null, true);
                              }}
                              className={`mr-2 font-size-11 ${products.length > 0 && !orderQueued && !isQueue
                                ? "actionButtomButtomsBlue"
                                : "actionButtomButtomsBlue actionButtomButtomsBlueDisabled"
                                }`}
                              variant="contained"
                              color="primary"
                              disabled={isQueue ? true : isEnquirySaved && (isQuantityUpdated || products.length !== actualProductLength || isAvailabiityChecked) ? true :
                                customerTierType && customerTierType === "Dealer" &&
                                (((enquiryAction === "update" || enquiryAction === "view" || enquiryAction !== "") && (accessData && accessData.data && accessData.data.isRequestPlacedForEnquiry === true) && !isSPRModifyData) ? true : false)
                                || checkAvailabilityButtonText !== CHECK_AVAILABILITY_BUTTON_TEXT.NORMAL &&
                                enquiryData &&
                                Array.isArray(enquiryData) &&
                                enquiryData.length > 0 &&
                                ((enquiryData[0].status && enquiryData[0].status.toLowerCase() === "enquiry cancelled") || (quotation) || (enquiryData[0].status && enquiryData[0].status.toLowerCase() === "fully cancelled") ||
                                  (enquiryData[0].status && enquiryData[0].status.toLowerCase() === "cancel")) || isViewingFromOrderHistory || orderType === "Cancelled" || enquiryData && enquiryData[0] && enquiryData[0].isQuotation && enquiryData[0].isQuotation === true}
                            >
                              {isEnquirySaved
                                ? "Update Order Enquiry"
                                : "Save Order Enquiry"}
                            </Button>
                          }
                          {
                            showStockEnquiry &&
                            <>
                              <Button
                                className={`mr-2 font-size-11 ${products.length > 0 && !orderQueued
                                  ? "actionButtomButtomsBlue"
                                  : "actionButtomButtomsBlue actionButtomButtomsBlueDisabled"
                                  }`}
                                onClick={async () => {
                                  if ((enquiryAction !== 'view') && (enquiryAction !== 'update') && (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') && sessionStorage.getItem("orderCreatedBy") === 'AA' && customerTierType === "Int. Business" && salesOffice === "" && rowSummaryGlobalData.some((item: any) => item.brandCodeInfo === "TE")) {
                                    setSalesOfficeError(true);
                                    setOpenSnackbarType("error");
                                    setOpenErrorSnackbar(true);
                                    setSuccessMessage(
                                      `Please select sales office.`
                                    );
                                    handleopenCloseSnackbar(true);
                                  } else {
                                    setSalesOfficeError(false);
                                    setSearchBypartNumber('');
                                    setShowDropdown(false);
                                    saveUpdateEnquiry(true, null, null, null, true);
                                    setIsDelted(false)
                                  }
                                }}
                                color="primary"
                                variant="contained"
                                disabled={isError() ? true : history.location.pathname == "/viewenquiry" ? true :
                                  // customerTierType && customerTierType === "Dealer" && enquiryAction !== "" && enquiryAction !== "" && requestStatus === "New Request" || requestStatus === "KAM Review" || requestStatus === "Approved" || requestStatus === "Cancelled" || requestStatus === "Timed Out" || enquiryAction === "view" &&
                                  enquiryData &&
                                  Array.isArray(enquiryData) &&
                                  enquiryData.length > 0 &&
                                  ((enquiryData[0].status && enquiryData[0].status.toLowerCase() === "enquiry cancelled") || (enquiryData[0].status && enquiryData[0].status.toLowerCase() === "fully cancelled") ||
                                    (enquiryData[0].status && enquiryData[0].status.toLowerCase() === "cancel")) || isViewingFromOrderHistory || enquiryData && enquiryData[0] && enquiryData[0].isQuotation && enquiryData[0].isQuotation}
                              >
                                {checkAvailabilityButtonText}
                              </Button>
                              <EstimationPromtDialog
                                open={isEstimatedTotalIsLess}
                                text={`Estimated Total is lower than the minimum value required to place a Special Price Request. To avail this, please add an additional AED ${(parseFloat("35000") - parseFloat(getViewEstimatedTotal())).toFixed(2)} value of parts to the order-enquiry.`}
                                handleopenClose={() => {
                                  setIsEstimatedTotalIsLess(false)
                                }} />

                              {!isTpcDealer && showPlaceOrder &&
                                <Tooltip
                                  title={getPlaceOrderTooltipMessage({
                                    isAvailabiityChecked,
                                    products,
                                    annexureEnquiry,
                                    selectedCustomerData,
                                    annexureMonthlyOrderLimitConfig,
                                    isSellingPriceData,
                                    markupPercentage,
                                    getEstimatedTotal,
                                    getSellingPrice,
                                    isDisplay: false
                                  })}
                                  placement="top"
                                >
                                  {/* <Tooltip title={isAvailabiityChecked && products.length ? '' : `Please do 'Check Availability and Price' to place the order`} placement="top"> */}
                                  <span>
                                    <Button
                                      onClick={() => {
                                        if (shipToPartyFeatureAccess) {
                                          if (
                                            (multipleAddressData == undefined || multipleAddressData == "") &&
                                            (collectionAddressData == undefined || collectionAddressData == "")
                                          ) {
                                            setOpenSnackbarType("error");
                                            setOpenErrorSnackbar(true);
                                            setSuccessMessage("Please select shipping address to proceed.");
                                            handleopenCloseSnackbar(true);
                                            return;
                                          }
                                        }

                                        setIsEnquiryStarted(false);

                                        if (
                                          customerTierType &&
                                          (customerTierType.toLowerCase() === "workshop" ||
                                            customerTierType.toLowerCase() === "tpcdealer")
                                        ) {
                                          setSelectedDeliveryTypeError(false);
                                          validateDeliveryType();
                                          return;
                                        }

                                        if (sessionStorage.getItem("userType") === "FSE" && !orderQueued) {
                                          setShowPlaceOrderConfirmationPopup(true);
                                          setIsInsufficientCredit(false);
                                          setShowInsufficientCreditPopup(false);
                                        } else {
                                          // FIX: For non-FSE (Customer) users, check back order items before placing order
                                          if (!orderQueued) {
                                            let isAirOrder = false;
                                            const validProductsForCheck = JSON.parse(JSON.stringify(products)).filter(
                                              (product: any) => product.isValid && !product.isSuperseeded
                                            );
                                            validProductsForCheck.forEach((item: any) => {
                                              if (item.airAvailabilityChecked && item.airAvailability > 0) {
                                                isAirOrder = true;
                                              }
                                            });
                                            console.log("[BackOrder Check - Customer] isAirOrder:", isAirOrder, "BO items:", validProductsForCheck.filter((p: any) => p.airAvailabilityChecked && p.airAvailability > 0).map((p: any) => p.productId));
                                            if (isAirOrder) {
                                              setshowBackOrderConfirmation(true);
                                            } else {
                                              placeOrderHandler();
                                            }
                                          } else {
                                            placeOrderHandler();
                                          }
                                        }
                                      }}
                                      className={`mr-2 font-size-11 ${placeorderEnabled && isAvailabiityChecked && products.length > 0
                                        ? "actionButtomButtomsBlue"
                                        : "actionButtomButtomsBlue actionButtomButtomsBlueDisabled"
                                        }`}
                                      disabled={getIsPlaceOrderDisabled({
                                        orderQueued,
                                        annexureEnquiry,
                                        selectedCustomerData,
                                        annexureMonthlyOrderLimit,
                                        enquiryData,
                                        isQuantityUpdated,
                                        placeorderEnabled,
                                        isAvailabiityChecked,
                                        products
                                      })}
                                      // disabled={orderQueued || (enquiryData && enquiryData.length > 0 && enquiryData[0].status && enquiryData[0].status.toLowerCase() === 'order placement queued') ? false : (annexureEnquiry === 'true' && (selectedCustomerData?.annexureMonthlyOrderLimit === false || annexureMonthlyOrderLimit === false)) ? true : isQuantityUpdated || enquiryData && enquiryData[0] && enquiryData[0].isQuotation && enquiryData[0].isQuotation ? true : placeorderEnabled && isAvailabiityChecked && products.length ? false : true}
                                      variant="contained"
                                      color="primary"
                                    >

                                      {orderQueued || (enquiryData && enquiryData.length > 0 && enquiryData[0].status && enquiryData[0].status.toLowerCase() === 'order placement queued') ? "Order in progress" : "Place Order"}
                                    </Button>
                                  </span>
                                </Tooltip>
                              }
                              {isTpcDealer === true &&
                                <Tooltip title={isAvailabiityChecked && products.length ? '' : `Please do 'Check Availability and Price' to place the order`} placement="top">
                                  <span>
                                    <Button
                                      onClick={() => {
                                        ConfirmButtonUpdateAPI();
                                      }}
                                      className={`mr-2 font-size-11 ${placeorderEnabled && isAvailabiityChecked && products.length > 0
                                        ? "actionButtomButtomsBlue"
                                        : "actionButtomButtomsBlue actionButtomButtomsBlueDisabled"
                                        }`}
                                      disabled={orderQueued || (enquiryData && enquiryData.length > 0 && enquiryData[0].status && enquiryData[0].status.toLowerCase() === 'order placement queued') ? false : isQuantityUpdated || procuredPartExist || enquiryData && enquiryData[0] && enquiryData[0].isQuotation && enquiryData[0].isQuotation ? true : placeorderEnabled && isAvailabiityChecked && products.length ? false : true}
                                      variant="contained"
                                      color="primary"
                                    >
                                      {orderQueued || (enquiryData && enquiryData.length > 0 && enquiryData[0].status && enquiryData[0].status.toLowerCase() === 'order placement queued') ? "Order in progress" : "Confirm Order"}
                                    </Button>
                                  </span>
                                </Tooltip>
                              }
                            </>
                          }
                          <ConfirmDialogEnquiry
                            open={showConfirmDialogPopup}
                            ConfirmButtonUpdateAPI={ConfirmButtonUpdateAPI}
                            openRequestSnackbar={openSnackbar}
                            enquiryId={enquiryData &&
                              Array.isArray(enquiryData) &&
                              enquiryData.length > 0 &&
                              enquiryData[0].B2bEnquiryId
                              ? enquiryData[0].B2bEnquiryId
                              : ""}
                            handleopenCloseSnackbar={handleopenCloseSnackbar}
                            handleopenClose={(data: any, open: any) => {
                              setShowConfirmDialogPopup(data ? true : false)
                            }}
                          />
                        </div >
                      )}
                    </div >
                    {/* Request special price popup */}
                    {
                      (customerTierType && customerTierType.toLowerCase() === 'tbl dealer' || customerTierType === "Dealer") ?
                        <Dialog open={openTBLDealerImg} onClose={handleClosedEnquiryGridImage} maxWidth="md" fullWidth>
                          <DialogTitle>
                            <Grid container justifyContent="space-between" alignItems="center">
                              <div className="shift-to-party-page-title">{selectedPartNumber}</div>
                              <IconButton onClick={handleClosedEnquiryGridImage}><Close /></IconButton>
                            </Grid>
                          </DialogTitle>
                          <DialogContent>
                            <Carousel
                              indicators={true}
                              interval={3000}
                              prevIcon={
                                <ArrowBackIcon
                                  style={{
                                    color: '#fff',
                                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                    borderRadius: '50%',
                                    width: '45px',
                                    height: '45px',
                                    padding: '5px'
                                  }}
                                />
                              }
                              nextIcon={
                                <ArrowForwardIcon
                                  style={{
                                    color: '#fff',
                                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                    borderRadius: '50%',
                                    width: '45px',
                                    height: '45px',
                                    padding: '5px'
                                  }}
                                />
                              }
                              prevLabel=""
                              nextLabel="">
                              {selectedPartImages?.map((url: any, index: any) => (
                                <Carousel.Item key={index}>
                                  <img
                                    src={url}
                                    alt={`Slide ${index + 1}`}
                                    style={{
                                      width: '100%',
                                      height: '400px',
                                      objectFit: 'contain',
                                      transition: 'transform 0.3s ease-in-out'
                                    }}
                                  />
                                </Carousel.Item>
                              ))}
                            </Carousel>
                          </DialogContent>
                        </Dialog>
                        : ''
                    }
                    <div className="col-lg-6 col-md-6 col-sm-12 p-3 pb-0 borderBottom d-flex justify-content-end">
                      {(
                        <>
                          <div>
                            <React.Fragment>
                              <Dialog
                                disableBackdropClick={true}
                                open={!orderQueued && openSpecialPrice}
                                fullWidth={true}
                                maxWidth={'sm'}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                                onClose={handleCloseSpecialPrice}
                              >
                                <DialogContent>
                                  <div className={classes.icon}>
                                    <WarningIcon className="delete-warning" fontSize="small" />
                                  </div>
                                  <div>
                                    <DialogContentText id="alert-dialog-description">
                                      <div className={`mt-3 ${classes.logoutText}`}>
                                        {
                                          (isEnquirySaved && products.length !== actualProductLength) || (isEnquirySaved && isQuantityUpdated)
                                            ? 'Your enquiry is not updated, please press Yes to Update your enquiry.'
                                            : 'Your enquiry is not saved, please press Yes to Save your enquiry.'
                                        }
                                      </div>
                                    </DialogContentText>
                                  </div>
                                </DialogContent>
                                <DialogActions>
                                  <><Button
                                    className={`mx-4 `}
                                    onClick={async () => {
                                      saveUpdateEnquiry(false);
                                      handleCloseSpecialPrice();
                                    }}>Yes</Button>
                                    <Button
                                      className={`mr-4 ${classes.cancel}`}
                                      onClick={() => {
                                        if (isEnquirySaved && products.length !== actualProductLength) {
                                        } else {
                                          let partsList: any = products.map((item: any) => {
                                            return item.productId.toString().trim();
                                          });
                                          let searchProduct: any = [];
                                          products.map((item: any) => {
                                            searchProduct.push({ productId: item.productId.toString().trim(), quantity: item.quantity })
                                          })
                                          dispatch(searchProducts(customerTierType, partsList, enquirySessionId, firstName, sapCustomerId, b2bUserId, searchProduct));
                                        }
                                        handleCloseSpecialPrice();
                                      }}>No</Button></>
                                </DialogActions>
                              </Dialog>
                            </React.Fragment>
                          </div>
                          {showStockEnquiry &&
                            <>
                            </>
                          }
                        </>
                      )}
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 p-3 pb-0 borderBottom d-flex ">
                      {(
                        <>
                          <NavigationPrompt when={!orderQueued && ((products.length > 0 && !isEnquirySaved) || (isEnquirySaved && products.length !== actualProductLength) || (isEnquirySaved && isQuantityUpdated) || (products.length > 0 && referenceNumber === ''))}>
                            {({ onConfirm, onCancel }) => (
                              <React.Fragment>
                                <Dialog
                                  disableBackdropClick={true}
                                  open={true}
                                  fullWidth={true}
                                  maxWidth={'sm'}
                                  aria-labelledby="alert-dialog-title"
                                  aria-describedby="alert-dialog-description"
                                >
                                  <DialogContent>
                                    <div className={classes.icon}>
                                      <WarningIcon className="delete-warning" fontSize="small" />
                                    </div>
                                    <div>
                                      <DialogContentText id="alert-dialog-description">
                                        <div className={`mt-3 ${classes.logoutText}`}>
                                          {
                                            (isEnquirySaved && products.length !== actualProductLength) || (isEnquirySaved && isQuantityUpdated)
                                              ? 'Your enquiry is not updated, please press Yes to Update your enquiry.'
                                              : 'Your enquiry is not saved, please Save your enquiry.'
                                          }
                                        </div>
                                      </DialogContentText>
                                    </div>
                                  </DialogContent>
                                  <DialogActions>
                                    <><Button
                                      className={`mx-4 `}
                                      onClick={async () => {
                                        // if (isEnquirySaved) {
                                        //   updateOnly(products);
                                        // } else {
                                        await saveUpdateEnquiry(false);
                                        sessionStorage.setItem("openChosseCustomer", "");
                                        setisAvailabiityChecked(false);
                                        setisAvailabiityCheckedAtTime(null);
                                        setIsTimmerExpired(false); // Reset the expired flag to allow timer restart
                                        setplaceorderEnabled(false);
                                        // }
                                        onCancel();
                                      }}>Yes</Button>
                                      <Button
                                        className={`mr-4 ${classes.cancel}`}
                                        onClick={() => {
                                          // problem parts conflcit resolved, un commented onclick function in current change the below code is commented
                                          // if (isEnquirySaved && products.length !== actualProductLength) {
                                          // } else {
                                          //   let partsList: any = products.map((item: any) => {
                                          //     return item.productId.trim();
                                          //   });
                                          //   let searchProduct: any = [];
                                          //   products.map((item: any) => {
                                          //     searchProduct.push({ productId: item.productId.trim(), quantity: item.quantity })
                                          //   })
                                          //   dispatch(searchProducts(customerTierType, partsList, enquirySessionId, firstName, sapCustomerId, b2bUserId, searchProduct));
                                          // }
                                          sessionStorage.setItem("partsData", "");
                                          sessionStorage.setItem("isCopyandCreate", "");
                                          setSelectedAccessType(isTBLAccess() ? "Tyres" : "Parts")
                                          onConfirm();
                                          sessionStorage.setItem("openChosseCustomer", "true");
                                          if (location.pathname === '/createenquiry' || location.pathname === '/annexurecreateenquiry') {
                                            dispatch(setCustomerChoosePopup());
                                          }
                                          // if (sessionStorage.getItem("openChosseCustomer") === "true") {
                                          //   handleChooseCustomer();
                                          // }
                                        }}>No</Button></>
                                  </DialogActions>
                                </Dialog>
                              </React.Fragment>
                            )}
                          </NavigationPrompt>
                        </>
                      )}
                    </div>
                  </div >
                  <>
                  </>
                  {
                    !isShowSPR() || currentTier === "" || annexureEnquiry === 'true' ?
                      "" :
                      <>
                        {
                          customerTierType && customerTierType.toLowerCase() === "dealer" && enquiryAction !== "" ?
                            <div className="row col-12 tableBottom">
                              {accessData && accessData.data && accessData.data.ableToPlaceSpecialRequest === false && (
                                <>
                                  {/* {showReorderEnquiry === false ? */}
                                  <div className="col-12 row">
                                    <span className="row col-12 mt-2 bottomFieldNameTable pr-4">Request Special Price Access Denied Reason : {" "} <p className="row px-4 denied-reason">
                                      {accessData && accessData.data && accessData.data.accessDeniedReason ? accessData.data.accessDeniedReason : ""}
                                    </p></span>
                                  </div>
                                  {/* : ""} */}
                                </>
                              )}
                            </div>
                            : ""}
                      </>
                  }
                </div >
                {/* : ''} */}
              </div >
              <div className="legendItemCreateEnquiry legendItemspr m-2 mt-3">
                <span className="dot"></span>
                <span className="legendItemLabel mr-4 ml-2">Discounted Price</span>
                {customerTierType && customerTierType.toLowerCase() === "dealer" && isShowSPR() && currentTier !== "" && (
                  <>
                    <span className="dot-blue"></span>
                    <span className="legendItemLabel mr-4 ml-2">Special Price</span>
                    <span className="dot-red"></span>
                    <span className="legendItemLabel mr-4 ml-2">Special price Not Approved/Not Offered</span>
                  </>
                )}
                <Tooltip title="Material cannot be procured from external supplier" placement="top">
                  <span>
                    <span className="dot-procurement"></span>
                    <span className="legendItemLabel mr-4 ml-2">Material blocked for Procurement</span>
                  </span>
                </Tooltip>
              </div>
              <div className="tandcText m-2">
                <p className="tandcHeading">Terms & Conditions</p>
                <p className="tandcBody">
                  The parties agree that that in the event of Value Added Tax (VAT) being levied or introduced by the government authorities in the jurisdiction where the [Vendor] is incorporated and/or tax resident the [Vendor] reserves the right to charge VAT at the prevailing VAT rate in respect of any supply made under this Agreement. The [Purchaser] shall pay the amount of any such VAT as an addition to the invoice value. The [Vendor] shall provide to the [Purchaser] the documentation required by the applicable VAT legislation to permit the [Purchaser] to claim an input VAT deduction on its VAT return.
                </p>
                <p className={`tandcBody mt-2 ${classes.textRight}`}>
                  يوافق الطرفان على أنه في حال فرض أو تطبيق ضريبة القيمة المضافة (VAT) من قِبَل السلطات الحكومية في الولاية القضائية التي يكون [البائع] مؤسّساً / مُقيماً دافعاً للضرائب بها، يحتفظ [البائع] بالحق في فرض ضريبة القيمة المضافة بمعدّلها السائد فيما يتعلق بأي عملية توريد بموجب هذه الاتفاقية. ويدفع [المشتري] مبلغ ضريبة القيمة المضافة تلك كإضافة إلى قيمة الفاتورة. ويقوم [البائع] بتزويد [المشتري] بالمستندات المطلوبة بموجب تشريع ضريبة القيمة المضافة المعمول به للسماح لـ [المشتري] بالمطالبة بخصم ضريبة القيمة المضافة المُدخلة في إقراره الضريبي
                </p>
              </div>
            </div >
          </div >
          <div className="col-12">
          </div>
          {openShippingAddDialog && <ShippingAddSelectionDialog addressData={newAddressData} b2bUserId={getCustomerDetailsBySapId && getCustomerDetailsBySapId.data && getCustomerDetailsBySapId.data.sapCustomerId} openShippingAddDialog={openShippingAddDialog} newAddressData={newAddressData} openCloseShippingAddSelectionDialog={openCloseShippingAddSelectionDialog} />}
          {openChooseCustomerDialog && <ChooseCustomerDialog annexurePartAdded={annexureEnquiry === 'true' ? true : false} openChooseCustomerDialog={openChooseCustomerDialog} openCloseChooseCustomer={openCloseChooseCustomer} isOrderEnquiryCreated={isOrderEnquiryCreated} onClickOfChangeButton={onClickOfChangeButton} isQuantityUpdated={isQuantityUpdated} isEnquirySaved={isEnquirySaved} />}
          {
            openOrderLogPopup &&
            <OrderLogDialog openOrderLogPopup={openOrderLogPopup}
              openCloseOrderLogPopup={openCloseOrderLogPopup} isOrderEnquiryCreated={isOrderEnquiryCreated}
              onClickOfChangeButton={onClickOfChangeButton} isQuantityUpdated={isQuantityUpdated}
              isEnquirySaved={isEnquirySaved} getLatestOrderCount={getLatestOrderCount} setGetLatestOrderCount={setGetLatestOrderCount} sendOrderLogsEmail={sendOrderLogsEmail}
            />
          }
          {/* <OrderSummaryDialog
            open={openOrderSummary && orderData}
            orderData={orderData}
            orderTotal={orderTotal}
            getEstimatedTotal={getEstimatedTotal}
            handleopenClose={(data: any) => {
              history.push("/orderhistory");
              handleopenCloseOrderSummary(false);
            }}
          /> */}
          <RequestQuotationDialog
            open={showRequestQuotationDialog}
            isBackOrder={isBackOrder}
            openRequestSnackbar={openSnackbar}
            requestQuotation={requestQuotation}
            handleopenCloseSnackbar={handleopenCloseSnackbar}
            setOpenSnackbarType={setOpenSnackbarType}
            setOpenErrorSnackbar={setOpenErrorSnackbar}
            openErrorSnackbar={openErrorSnackbar}
            masterIDData={masterIDData}
            setSuccessMessage={setSuccessMessage}
            statusSuccessChecked={statusSuccessChecked}
            requestQuotationStatusChecked={requestQuotationStatusChecked}
            handleopenClose={(data: any, open: any) => {
              setShowRequestQuotationDialog(data ? true : false)
            }}
            loadQueueQuotation={loadQueueQuotation}
          />
          <ExpiredDialog
            open={showApproveDialog}
            setOpenSnackbar={setOpenSnackbar}
            setSuccessMessage={setSuccessMessage}
            products={products}
            setCopyCreateEnquiry={setCopyCreateEnquiry}
            checkSessionStorage={checkSessionStorage}
            setViewigFromOrderHistory={setViewigFromOrderHistory}
            resetData={resetData}
            userMasterId={userMasterId}
            enquiryData={enquiryData}
            isAnnexureEnquiry={annexureEnquiry === 'true' ? true : false}
            handleopenCloseSnackbar={handleopenCloseSnackbar}
            handleopenClose={(data: any) => {
              setshowApproveDialog(data ? true : false)
            }}
          />
          <ExpiredDialog24Hrs
            open={showExpired24Hrs}
            userMasterId={userMasterId}
            products={products}
            enquiryData={enquiryData}
            checkSessionStorage={checkSessionStorage}
            resetData={resetData}
            setOpenSnackbar={setOpenSnackbar}
            setSuccessMessage={setSuccessMessage}
            handleopenCloseSnackbar={handleopenCloseSnackbar}
            handleopenClose={(data: any) => {
              setShowExpired24Hrs(data ? true : false)
            }}
          />
          <DeleteDialog
            open={confirmDialog}
            text="Please select the Delivery Type."
            handleopenClose={(data: any) => {
              if (data === 'delete')
                if (!data) {
                  handleopenCloseConfirmPopup(false);
                }
            }} />

          <Dialog className="pb-0"
            open={openDialog}
            onClose={handleCloseDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth="sm"
          >
            <MakePaymentDialog setSuccessMessage={setSuccessMessage}
              setOpenErrorSnackbar={setOpenErrorSnackbar}
              openErrorSnackbar={openErrorSnackbar}
              handleopenCloseSnackbar={handleopenCloseSnackbar} setOpenDialog={handleCloseDialog}
            />
          </Dialog> -
          <React.Fragment>
            <Dialog
              open={showBackOrderConfirmation}
              fullWidth={true}
              onClose={() => {
                setshowBackOrderConfirmation(false)
              }}
              maxWidth={'sm'}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >

              <DialogContent>
                <div className={classes.icon}>
                  <WarningIcon className="delete-warning" fontSize="small" />
                </div>
                <div>
                  <DialogContentText id="alert-dialog-description">
                    <div className={`mt-3 ${classes.logoutText}`}>
                      Your order-enquiry basket has <span className="text-danger">BACK ORDER</span> items. Are you sure you want to proceed with order placement?
                    </div>
                  </DialogContentText>
                </div>
              </DialogContent>
              <DialogActions>
                <Button
                  className={`mx-4 ${classes.yes}`}
                  onClick={async () => {
                    setLoading(true);

                    if (isInsufficientCredit === true) {
                      setshowBackOrderConfirmation(false);
                      setShowPlaceOrderConfirmationPopup(false);
                      setShowInsufficientCreditPopup(true);
                      setLoading(false);
                      return;
                    }

                    setshowBackOrderConfirmation(false);

                    if (
                      customerTierType &&
                      (customerTierType.toLowerCase() === "workshop" ||
                        customerTierType.toLowerCase() === "tpcdealer")
                    ) {
                      setSelectedDeliveryTypeError(false);
                      validateDeliveryType();
                    } else {
                      placeOrderHandler();
                    }

                    setLoading(false);
                  }}

                >Yes</Button>
                <Button
                  className={`mr-4 ${classes.cancel}`}
                  onClick={() => {
                    setshowBackOrderConfirmation(false)
                  }}>No</Button>
              </DialogActions>
            </Dialog>
          </React.Fragment>
          <React.Fragment>
            <Dialog
              open={showInsufficientCreditPopup}
              fullWidth={true}
              onClose={() => {
                setShowInsufficientCreditPopup(false)
              }}
              maxWidth={'sm'}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >

              <DialogContent>
                <div className={classes.icon}>
                  <WarningIcon className="delete-warning" fontSize="small" />
                </div>
                <div>
                  <DialogContentText id="alert-dialog-description">
                    <div className={`mt-2 ${classes.logoutText}`}>
                      Order will be blocked due to insufficient Credit. You can still go ahead and place the Order.
                    </div>
                  </DialogContentText>
                </div>
              </DialogContent>
              <DialogActions>
                <Button
                  className={`mx-4 ${classes.yes}`}
                  onClick={async () => {
                    setLoading(true);
                    if (customerTierType && (customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === "tpcdealer")) {
                      setSelectedDeliveryTypeError(false);
                      validateDeliveryType()
                    } else {
                      if (sessionStorage.getItem('userType') === 'FSE' && !orderQueued) {
                        setShowInsufficientCreditPopup(false);
                        setShowPlaceOrderConfirmationPopup(false);
                        setLoading(false);
                        placeOrderHandler();
                      } else {
                        placeOrderHandler();
                      }
                    }
                    setShowInsufficientCreditPopup(false);
                    setLoading(false);
                  }}>Proceed</Button>
                <Button
                  className={`mr-4 ${classes.cancel}`}
                  onClick={() => {
                    setShowInsufficientCreditPopup(false)
                  }}>Cancel</Button>
              </DialogActions>
            </Dialog>
          </React.Fragment>
          <React.Fragment>
            <Dialog
              open={showPlaceOrderConfirmationPopup}
              fullWidth={true}
              onClose={() => {
                setShowPlaceOrderConfirmationPopup(false)
              }}
              maxWidth={'sm'}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogContent>
                <div style={{ display: "flex", alignItems: "flex-start" }}>
                  <div style={{ flexShrink: 0, margin: "25px 20px 20px 0" }}>
                    <WarningIcon className="delete-warning" fontSize="small" />
                  </div>
                  <div style={{ minWidth: 0 }}>
                    <DialogContentText id="alert-dialog-description">
                      <div className={`mt-3 mb-3 ${classes.logoutText}`}>
                        Order is getting placed for <span className="tandcHeading-font-type">({getChoosenCustomerName ? getChoosenCustomerName : "-"}) {" "}</span>
                        and for the shipping address <span className="tandcHeading-font-type">({getSelectedAddress()}) </span>
                        <span className={`${classes.logoutText}`}>.Would you like to place an order for the above customer?</span>
                      </div>
                    </DialogContentText>
                  </div>
                </div>
              </DialogContent>
              <DialogActions>
                <Button
                  className={`mx-4 ${classes.yes}`}
                  onClick={async () => {
                    setLoading(true);

                    if (isInsufficientCredit === true) {
                      setShowPlaceOrderConfirmationPopup(false);
                      setShowInsufficientCreditPopup(true);
                      setLoading(false);
                      return;
                    }

                    let isAirOrder = false;

                    let productsTemp = JSON.parse(JSON.stringify(products));

                    productsTemp = productsTemp.filter(
                      (product: any) => product.isValid && !product.isSuperseeded
                    );

                    productsTemp.forEach((item: any) => {
                      if (item.airAvailabilityChecked && item.airAvailability > 0) {
                        isAirOrder = true;
                      }
                    });

                    setShowPlaceOrderConfirmationPopup(false);

                    if (isAirOrder && !orderQueued) {
                      setshowBackOrderConfirmation(true);
                    } else {
                      placeOrderHandler();
                    }

                    setLoading(false);
                  }}
                >Yes</Button>
                <Button
                  className={`mr-4 ${classes.cancel}`}
                  onClick={() => {
                    setShowPlaceOrderConfirmationPopup(false);
                    setshowBackOrderConfirmation(false);
                  }}>No</Button>
              </DialogActions>
            </Dialog>
          </React.Fragment>
          <React.Fragment>
            <Dialog
              open={isZeroPricePopup && ((zeroProducts && zeroProducts.length > 0 && !hideZeroMessage) || (materialNotExtendedPart && materialNotExtendedPart.length > 0) || (procuredPart && procuredPart.length > 0))}
              fullWidth={true}
              onClose={() => {
                openZeroPricePopup(false)
              }}
              maxWidth={'sm'}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogContent>
                {/* <div className={classes.icon}>
                  <WarningIcon className="delete-warning" fontSize="small" />
                </div> */}
                <div id="alert-dialog-description">
                  {/* <DialogContentText id="alert-dialog-description"> */}
                  {zeroProducts && zeroProducts.length > 0 && !hideZeroMessage && (
                    <div className={`mt-3 ${classes.enquiryPop}`}>
                      <div className={classes.iconMaterial}>
                        <WarningIcon className="delete-warning" fontSize="small" />
                      </div>
                      <div className={`${classes.logoutText}`}>
                        It seems there are Parts with Zero price that will be auto-deleted when placing the order.<br />
                        You will receive an email with the list of Part(s) with Zero price.
                      </div>
                    </div>
                  )}
                  {materialNotExtendedPart && materialNotExtendedPart.length > 0 && (
                    <div className={`mt-3 ${classes.enquiryPop}`}>
                      <div className={classes.iconMaterial}>
                        <WarningIcon className="delete-warning" fontSize="small" />
                      </div>
                      <div className={`${classes.logoutText}`}>
                        <span className="text-red">"Material Not Extended Parts" identified in the Order Enquiry are as below:</span><br />
                        <div className="pt-2">
                          {materialNotExtendedPart && Array.isArray(materialNotExtendedPart) && materialNotExtendedPart.length > 0 && materialNotExtendedPart.map((p: any, i: any) => (
                            <span className="file-close-color">
                              {p}{materialNotExtendedPart.length !== i + 1 ? ', ' : ''}{' '}
                            </span>
                          )
                          )}
                          <CopyToClipboard text={String(materialNotExtendedPart)}
                            onCopy={() => setCopy(true)}>
                            <Tooltip title={isCopy ? 'Copied' : 'Click to copy'} placement="top">
                              <img src="./contentCopy.svg" className="ml-3 w-19px" />
                            </Tooltip>
                          </CopyToClipboard>
                          <span className="mt-1 ml-1">(Copy Parts to clipboard).</span>
                          <IconButton
                            className="ml-2 file-close-color" size="small" onClick={() => exportToExcelMaterialData()}>
                            <GetAppIcon fontSize="inherit" />
                            <span className="font-size-14 file-close-color ml-1">
                              Export To Excel
                            </span>
                          </IconButton>
                        </div>
                        <div className="pt-2">
                          You will not be able to "Verify Enquiry" until these parts are removed. Please do 'Check Availability and Price' again.<br />
                        </div>
                      </div>
                    </div>
                  )}
                  {procuredPart && procuredPart.length > 0 && (
                    <div className={`mt-3 ${classes.enquiryPop}`} >
                      <div className={classes.iconMaterial}>
                        <WarningIcon className="delete-warning" fontSize="small" />
                      </div>
                      <div className={`${classes.logoutText}`}>
                        <span className="text-red">"Parts blocked for Procurement" identified in the Order Enquiry are as below:</span><br />
                        <div className="pt-2">
                          {procuredPart && Array.isArray(procuredPart) && procuredPart.length > 0 && procuredPart.map((p: any, i: any) => (
                            <span className="file-close-color">
                              {p}{procuredPart.length !== i + 1 ? ', ' : ''}{' '}
                            </span>
                          )
                          )}
                          <CopyToClipboard text={String(procuredPart)}
                            onCopy={() => setCopy(true)}>
                            <Tooltip title={isCopy ? 'Copied' : 'Click to copy'} placement="top">
                              <img src="./contentCopy.svg" className="ml-3 w-19px" />
                            </Tooltip>
                          </CopyToClipboard>
                          <span className="mt-1 ml-1">(Copy Parts to clipboard).</span>

                          <IconButton
                            className="mr-3 file-close-color" size="small" onClick={() => exportToExcelData()}>
                            <GetAppIcon fontSize="inherit" />
                            <span className="font-size-14 file-close-color ml-1">
                              Export To Excel
                            </span>
                          </IconButton>
                        </div>

                        {/* <div className="pt-2">
                            You will not be able to "Place Order" until those parts are removed. After removing "Procurement Blocked" parts you will need to Check Availability and Price again.<br />
                            Do you want to remove the Procurement Blocked parts?
                          </div> */}
                      </div>
                    </div>
                  )}
                  {/* </DialogContentText> */}
                </div>
              </DialogContent>
              <DialogActions>
                {(procuredPart && procuredPart.length > 0) || (materialNotExtendedPart && materialNotExtendedPart.length > 0) ? (
                  <>
                    <Button
                      className={`mx-4 ${classes.yes}`}
                      onClick={async () => {
                        openZeroPricePopup(false)
                        setCopy(false);
                        setHideZeroMessage(false);
                        if (procuredPart && procuredPart.length > 0) {
                          openZeroPricePopup(false);
                          setplaceorderEnabled(false);
                          if (selectedAccessType === "Parts" || (isTyrePartsSearchSuccessFully === true && isTyrePartsAddedtoGrid === true) || products.some((p: any) => p.isAddToEnquiry === false)) {
                            setisAvailabiityChecked(true);
                          }
                          setorderQueued(false);
                          setisAvailabiityCheckedAtTime(new Date());
                          setIsTimmerExpired(false); // Reset the expired flag to allow timer restart
                        }
                        if (materialNotExtendedPart && materialNotExtendedPart.length > 0) {
                          openZeroPricePopup(false);
                          setplaceorderEnabled(false);
                          setisAvailabiityChecked(false);
                          setorderQueued(false);
                          // Actually remove the "Material Not Extended" parts (action "D") instead of
                          // just dismissing the popup — otherwise the next Check Availability and
                          // Price / Verify Enquiry call keeps failing on the same parts.
                          const productsWithoutMaterialNotExtended = products.map((p: any) =>
                            p.isMaterialNotExtended || materialNotExtendedPart.includes(p.productId)
                              ? { ...p, action: "D", selected: true }
                              : p
                          );
                          setproducts(productsWithoutMaterialNotExtended);
                          if (isEnquirySaved) {
                            await updateOnly(productsWithoutMaterialNotExtended, null, null, null, null, true);
                          }
                          setMaterialNotExtendedPart([]);
                        }
                      }}>Close</Button>
                  </>
                ) :
                  <>
                    {zeroProducts && zeroProducts.length > 0 && !hideZeroMessage && (
                      <Button
                        className={`mx-4 ${classes.yes}`}
                        onClick={() => {
                          openZeroPricePopup(false)
                          if (selectedAccessType === "Parts" || (isTyrePartsSearchSuccessFully === true && isTyrePartsAddedtoGrid === true) || products.some((p: any) => p.isAddToEnquiry === false)) {
                            setisAvailabiityChecked(true);
                          }
                          setorderQueued(false);
                          setisAvailabiityCheckedAtTime(new Date());
                          setIsTimmerExpired(false); // Reset the expired flag to allow timer restart
                        }}>Ok</Button>
                    )}
                  </>
                }
              </DialogActions>
            </Dialog>
          </React.Fragment>
          <React.Fragment>
            <Dialog
              open={annexureErrorPopUp}
              fullWidth={true}
              onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                  setOpenAnnexureErrorPopup(false);
                }
              }}
              maxWidth={'sm'}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogContent>
                {/* <div className={classes.icon}>
                  <WarningIcon className="delete-warning" fontSize="small" />
                </div> */}
                <div id="alert-dialog-description">
                  <div className={`mt-3 ${classes.enquiryPop}`}>
                    <div className={classes.iconMaterial}>
                      <WarningIcon className="delete-warning" fontSize="small" />
                    </div>
                    <div className={`${classes.logoutText}`}>
                      <span className="text-red">
                        Unfortunately, we do not have enough stock of the items listed below to match your preferred price.
                      </span><br />
                      <div className="pt-2">
                        {
                          products
                            .filter((item: any) => item.popupError === true)
                            .map((item: any) => item.productId)
                            .join(', ')
                        }
                      </div>
                      <div className="pt-2 text-dark-blue">
                        Please contact Al-Futtaim sales team to enquire about the availability of additional stock.
                      </div>
                    </div>
                  </div>
                </div>
              </DialogContent>
              <DialogActions>
                <Button
                  className={`mx-4 ${classes.yes}`}
                  onClick={() => {
                    const flaggedProducts =
                      (products || []).filter((item: any) => item.popupError === true);

                    const enqDetails = flaggedProducts.map((item: any) => ({
                      partNumber: item.productId,
                      brandNumber: Number(item.orgId) ?? null,
                      brandName: item.annexureDetails?.brand
                        ?? item.oesSubBrandName
                        ?? '',
                      requestedQty: item.quantity ?? 0,
                      avlQty: item.nowAvailability ? item.nowAvailability : 0,
                    }));

                    const payload = {
                      adminId: adminId,
                      b2bUserId: (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') ? b2bUserIdFSESelectedCustomer : b2bUserId,
                      enquiryByUserType: userType === 'Admin' ? 'Admin' : 'User',
                      enqNo: enquiryData && enquiryData[0] && enquiryData[0].B2bEnquiryId,
                      sapCustomerId: sapCustomerId,
                      enqDetails,
                    };
                    dispatch(sendEmailInvalidAnnexureQuantity(payload));
                    setOpenAnnexureErrorPopup(false);
                  }}
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          </React.Fragment>
        </> : <>
          {
            <OrderSummary
              open={openOrderSummary && orderData}
              orderData={orderData}
              orderTotal={orderTotal}
              getEstimatedTotal={getEstimatedTotal}
              handleopenClose={(data: any) => {
                history.push("/orderhistory");
                handleopenCloseOrderSummary(false);
              }}
            />}</>
      }
      <LeaveEnquiryPopup
        open={showExitPopup}
        onSubmit={handleExitSubmit}
        loading={exitLoading}
      />
    </Fragment >
  );
};

export default Dashboard;
